import React, { useState, useEffect } from 'react';

// ========================================
// BOUTIQUE LOCATOR MAP COMPONENT
// ========================================

const BOUTIQUE_DATA = [
  {"name":"CLAUDETTE\'S TRAVELING BOUTIQUE","address":"39447 HALLELUJAH CT","city":"SOLDOTNA","state":"AK","zip":"99669","lat":60.49968,"lng":-150.924228,"owner":"CLAUDETTE BARBER","phone":"907-394-2164","email":"claudettebarber@gmail.com"},
  {"name":"PORTFOLIO","address":"3030 DENALI STREET SUITE 6","city":"ANCHORAGE","state":"AK","zip":"99503","lat":61.192976,"lng":-149.876982,"owner":"LAUREN BLANCHETT","phone":"907-563-5289","email":"laurenblanchett@gmail.com"},
  {"name":"URBACH\'S","address":"P.O BOX 249","city":"SEWARD","state":"AK","zip":"99664","lat":60.25281,"lng":-149.402123,"owner":"SUSAN URBACH","phone":"907-224-3088","email":"urbachs.alaska@gmail.com"},
  {"name":"AT HOME FURNISHINGS","address":"2921 18TH STREET SOUTH","city":"BIRMINGHAM","state":"AL","zip":"35209","lat":33.479514,"lng":-86.791588,"owner":"BOBBIE","phone":"205-879-3510","email":"athomefashion10@gmail.com"},
  {"name":"ELITE BOUTIQUE","address":"4800 WHITESBURG DRIVE","city":"HUNTSVILLE","state":"AL","zip":"35802","lat":34.693478,"lng":-86.570175,"owner":"STACEY MADEY","phone":"256-880-0160"},
  {"name":"HATTIE LEES BOUTIQUE","address":"2635 MARTIN ST. S","city":"PELL CITY","state":"AL","zip":"35128","lat":33.554256,"lng":-86.276654,"owner":"JOANN BAIN","phone":"205-814-1515","email":"hattieleesboutique@gmail.com"},
  {"name":"M&F STORES CORPORATION","address":"380 FAIRHOPE AVE","city":"FAIRHOPE","state":"AL","zip":"36532","lat":30.522764,"lng":-87.903489,"owner":"BARBARA","phone":"334-928-5564","email":"customerservice@mfcasuals.com"},
  {"name":"MONKEY\'S UNCLE","address":"382 GUNTER AVE","city":"GUNTERSVILLE","state":"AL","zip":"35976","lat":34.359895,"lng":-86.293103,"owner":"MICHAEL DYER","phone":"256-486-3773","email":"michaeljoedyer@aol.com"},
  {"name":"SHOEFISTICATED","address":"101-B MAIN STREET W","city":"HARTSELLE","state":"AL","zip":"35640","lat":34.444176,"lng":-86.933515,"owner":"KALLEIGH THOMAS","phone":"256-773-1080 S","email":"info@shoefisticated.com"},
  {"name":"BEVERLY\'S B GAUDY B SIMPLE","address":"620 CENTRAL AVE SUITE C","city":"HOT SPRINGS","state":"AR","zip":"71901","lat":34.511008,"lng":-93.054313,"owner":"BETH","phone":"501-680-3337","email":"bgaudybsimple@gmail.com"},
  {"name":"BEVERLY\'S CASUAL SHOP","address":"620 CENTRAL AVE SUITE 1C","city":"HOT SPRINGS","state":"AR","zip":"71901","lat":34.511008,"lng":-93.054313,"owner":"BEVERLY STROOPE","phone":"501-624-1838","email":"spabev@gmail.com"},
  {"name":"BEYOND COTTON","address":"11220 N. RODNEY PARHAM RD #10","city":"LITTLE ROCK","state":"AR","zip":"72212","lat":34.77286,"lng":-92.398337,"owner":"NANCY","phone":"501-221-9195","email":"susan@beyondcotton.com"},
  {"name":"CAPTURED MOMENTS","address":"2604 W 28TH ST","city":"PINE BLUFF","state":"AR","zip":"71603","lat":34.200997,"lng":-92.02932,"owner":"LINDA RAULS","phone":"870-535-0130","email":"lindarauls@hotmail.com"},
  {"name":"DRAGONFLY BOUTIQUE","address":"3925 HWY 7 NORTH STE F","city":"HOT SPRINGS VILLAGE","state":"AR","zip":"71909","lat":34.639501,"lng":-93.058312,"owner":"TAMMY","phone":"501-385-8378","email":"dragonflyboutiquehsv@gmail.com"},
  {"name":"LAGNIAPPE","address":"811 W GRAND AVE","city":"HOT SPRINGS","state":"AR","zip":"71913","lat":34.501585,"lng":-93.066084,"owner":"MARCIA DOBBS","phone":"501-623-7299","email":"hslagniappe@gmail.com"},
  {"name":"MARCO ENT DBA MARTINS","address":"914 N HERVEY ST","city":"HOPE","state":"AR","zip":"71801","lat":33.676453,"lng":-93.600918,"owner":"GREG MARTIN","phone":"870-777-2777","email":"greg@martinstore.com"},
  {"name":"PEACEFUL HEART BOUTIQUE","address":"1076 HOMETOWN COMMONS","city":"MOUNTAIN HOME","state":"AR","zip":"72653","lat":36.357913,"lng":-92.335422,"owner":"SANDI WEBB","phone":"870-701-5057","email":"peacefulheartboutique@gmail.com"},
  {"name":"PINKADILLY","address":"624 HOSPITAL DR","city":"MOUNTAIN HOME","state":"AR","zip":"72653","lat":36.342736,"lng":-92.396208,"owner":"DEBBIE SWAN","phone":"870-508-1046","email":"dswan@baxterregional.org"},
  {"name":"RAGS N CALICO","address":"3215 S 74TH ST","city":"FORT SMITH","state":"AR","zip":"72903","lat":35.350592,"lng":-94.34987,"owner":"TERRY SCHOEPPE","phone":"479-221-8136","email":"ragsncal@yahoo.com"},
  {"name":"SHELLY\'S SHOES ETC","address":"115 N JEFFERSON AVE","city":"EL DORADO","state":"AR","zip":"71730","lat":33.212279,"lng":-92.662705,"owner":"SHELLY OWENS","phone":"870-875-1233","email":"shellysshoesetc@hotmail.com"},
  {"name":"STELLA\'S GIRL","address":"114 N MAIN","city":"MONTICELLO","state":"AR","zip":"71671","lat":33.615262,"lng":-92.064119,"owner":"LAURA WAGNON","phone":"870-820-1761","email":"stellasgirl61@yahoo.com"},
  {"name":"THE FASHION BOUTIQUE","address":"306 WEST MAIN ST","city":"CLARKSVILLE","state":"AR","zip":"72830","lat":35.471283,"lng":-93.466049,"owner":"JAN STORMENT","phone":"479-754-8118","email":"jbs1323@hotmail.com"},
  {"name":"168 RETAIL","address":"1861 E DRAKE DR","city":"TEMPE","state":"AZ","zip":"85283","lat":33.355488,"lng":-111.908841,"owner":"ELISA DAVIS","phone":"480-518-4896","email":"elisalee@cox.net"},
  {"name":"DAHLING ITS YOU","address":"1835 W SR89A #2","city":"SEDONA","state":"AZ","zip":"86336","lat":34.731355,"lng":-112.432303,"owner":"ALISHA HANSEN","phone":"928-282-1003 S","email":"ali@bennali.com"},
  {"name":"DIVA WOMENS WEAR","address":"8787 N. SCOTTSDALE ROAD #224","city":"SCOTTSDALE","state":"AZ","zip":"85253","lat":33.565961,"lng":-111.9243,"owner":"GAIL","phone":"480-948-8777","email":"Gail@divawomensapparel.com"},
  {"name":"EILEENS OF TUCSON","address":"4811 E GRANT RD SUITE 157","city":"TUCSON","state":"AZ","zip":"85712","lat":32.251821,"lng":-110.890534,"owner":"BARB GAFFNEY","phone":"520-297-5608 s","email":"barb.eileens@gmail.com"},
  {"name":"LAUGHING MOUNTAIN","address":"PO BOX 341","city":"JEROME","state":"AZ","zip":"86331","lat":34.748589,"lng":-112.108626,"owner":"JUDI SCRIVNER","phone":"928-634-8764","email":"judiscrivner@gmail.com"},
  {"name":"PANTERRA GALLERY","address":"PO BOX 743","city":"BISBEE","state":"AZ","zip":"85603","lat":31.44815,"lng":-109.92841,"owner":"MARALYCE FEREE","phone":"520-432-3320","email":"panterragallery@gmail.com"},
  {"name":"QUE BONITA","address":"6934 E. TANQUE VERDE RD","city":"TUCSON","state":"AZ","zip":"85715","lat":32.250111,"lng":-110.843966,"owner":"CARMEN","phone":"520-721-1998","email":"quebonitatucson@gmail.com"},
  {"name":"THE CROWES NEST","address":"PO BOX 1986","city":"TUBAC","state":"AZ","zip":"85646","lat":31.62655,"lng":-111.05629,"owner":"ANN","phone":"520-398-2727","email":"cnesttubac@gmail.com"},
  {"name":"TIGER LILY\'S BOUTIQUE","address":"10614 E. KIVA AVE","city":"MESA","state":"AZ","zip":"85209","lat":33.377664,"lng":-111.605688,"owner":"KRISTA HANSEN","phone":"218-547-3727","email":"90mtgirl@gmail.com"},
  {"name":"TROCADERO DE TUBAC","address":"P.O BOX 274","city":"TUMACACORI","state":"AZ","zip":"85640","lat":31.5687,"lng":-111.05231,"owner":"BRYNDA","phone":"1-520-398-3390","email":"bryndazuber@yahoo.com"},
  {"name":"ABUNDANCE","address":"13606 VENTURA BLVD","city":"SHERMAN OAKS","state":"CA","zip":"91423","lat":34.147908,"lng":-118.429618,"owner":"MICHELE","phone":"818-990-6128","email":"abundances@aol.com"},
  {"name":"ALEX\'S FASHION CENTER","address":"214 MARINE AVENUE","city":"NEWPORT BEACH","state":"CA","zip":"92662","lat":33.606394,"lng":-117.889709,"owner":"ROSE","phone":"949-723-1267","email":"anchor1rose@yahoo.com"},
  {"name":"BAZAAR DEL MUNDO","address":"4133 TAYLOR STREET","city":"SAN DIEGO","state":"CA","zip":"92110","lat":32.757288,"lng":-117.197794,"owner":"JESSICA","phone":"619-296-4989","email":"jessica@bazaardelmundo.com"},
  {"name":"BLENDERS","address":"538 12TH ST","city":"PASO ROBLES","state":"CA","zip":"93446","lat":35.626367,"lng":-120.693047,"owner":"LORI","phone":"805-238-5554","email":"blenders2@sbcglobal.net"},
  {"name":"CIRCA","address":"PO BOX 47","city":"MENDOCINO","state":"CA","zip":"95460","lat":39.319949,"lng":-123.734377,"owner":"MARY RICARD","phone":"707-937-0100","email":"circa@mcn.org"},
  {"name":"CITY LIGHTS STREETWEAR","address":"PO BOX 41328","city":"LONG BEACH","state":"CA","zip":"90853","lat":33.756024,"lng":-118.201101,"owner":"ANGELA JAKUM","phone":"626-664-7606","email":"sales@citylightsstreetwear.com"},
  {"name":"EARTHY TREASURES","address":"882 WHARFSIDE RD","city":"SAN MATEO","state":"CA","zip":"94404","lat":37.559339,"lng":-122.288923,"owner":"HEIDE HOWARD","phone":"650-759-0651","email":"etfostercity@gmail.com"},
  {"name":"EVE & ME","address":"1700 MC HENRY AVE. #23","city":"MODESTO","state":"CA","zip":"95350","lat":37.66251,"lng":-120.942062,"owner":"EVE / SUE","phone":"209-521-5966","email":"eveandme@att.net"},
  {"name":"EVENT NETWORK","address":"9606 AERO DRIVE # 1000","city":"SAN DIEGO","state":"CA","zip":"92123","lat":32.809827,"lng":-117.120979,"owner":"ANN SEGARINI","phone":"858-222-8953","email":"emily.dicenso@eventnetwork.com"},
  {"name":"EVERYWEAR","address":"415 HEALDSBURG AVE","city":"HEALDSBURG","state":"CA","zip":"95448","lat":38.612449,"lng":-122.87142,"owner":"PAUL ROCHA","phone":"707-433-5265","email":"pauroc@sbcglobal.net"},
  {"name":"FASHION STREET","address":"103 DOUD ARCADE OCEAN AVE","city":"CARMEL","state":"CA","zip":"93921","lat":36.604286,"lng":-121.869841,"owner":"NATALIE KAISER","phone":"831-624-8868","email":"njohnson2121@hotmail.com"},
  {"name":"FRANKLY FABULOUS","address":"1890 W EL NORTE PARKWAY","city":"ESCONDIDO","state":"CA","zip":"92026","lat":33.147563,"lng":-117.111494,"owner":"CYNTHIA STEIGER","phone":"760-401-3354","email":"csteiger@cox.net"},
  {"name":"FRENCHY\'S","address":"136 N PALM CANYON DR","city":"PALM SPRINGS","state":"CA","zip":"92262","lat":33.823755,"lng":-116.546974,"owner":"DENISE WONG","phone":"760-325-5686","email":"1015boyer@msn.com"},
  {"name":"GRAPES & IVY","address":"4232 FOWLER LN, ST 101","city":"DIAMOND SPRINGS","state":"CA","zip":"95619","lat":38.693716,"lng":-120.813563,"owner":"JOAN CARR","phone":"530-514-0962","email":"grapenivy@gmail.com"},
  {"name":"IN FULL SWING","address":"5937 COLLEGE AVE","city":"OAKLAND","state":"CA","zip":"94618","lat":37.847981,"lng":-122.251837,"owner":"SHARON","phone":"510-654-5144","email":"shop@infullswing.com"},
  {"name":"KATHYS DRESS SHOP","address":"PO BOX 1124","city":"JULIAN","state":"CA","zip":"92036","lat":33.07347,"lng":-116.58901,"owner":"KATHY ENLOE","phone":"760-765-0119","email":"kathy.enloe@gmail.com"},
  {"name":"KILDEE CLOTHING","address":"606 N LAS POSAS RD","city":"CAMARILLO","state":"CA","zip":"93010","lat":34.222352,"lng":-119.067887,"owner":"KEVIN & SANDY KILDEE","phone":"805-482-2124","email":"kevinkildee@gmail.com"},
  {"name":"LOUISES PLACE","address":"280 FOREST AVENUE","city":"LAGUNA BEACH","state":"CA","zip":"92651","lat":33.542846,"lng":-117.782621,"owner":"MAGGIE","phone":"949-494-0260","email":"makimarkarian@gmail.com"},
  {"name":"LULU\'S","address":"78075 MAIN STREET STE 103","city":"LA QUINTA","state":"CA","zip":"92253","lat":33.677424,"lng":-116.302132,"owner":"LULU COFER","phone":"760-777-9119","email":"lulucofer@gmail.com"},
  {"name":"LUZ LUNA","address":"527 MAIN ST.","city":"HALF MOON BAY","state":"CA","zip":"94019","lat":37.463006,"lng":-122.42886,"owner":"LUZ","phone":"650-240-6550","email":"luzlunaimports@gmail.com"},
  {"name":"MARITA\'S","address":"551 LIGHTHOUSE AVE","city":"PACIFIC GROVE","state":"CA","zip":"93950","lat":36.620672,"lng":-121.917041,"owner":"MARITA","phone":"831-655-3390","email":"mjohn1019@aol.com"},
  {"name":"MIB CLOTHING","address":"2031 CESSNA DR","city":"VACAVILLE","state":"CA","zip":"95688","lat":38.389748,"lng":-121.959324,"owner":"CARSON","phone":"1-707-481-2555","email":"carson@mibclothing.com"},
  {"name":"NATASHA","address":"1231 STATE STREET","city":"SANTA BARBARA","state":"CA","zip":"93101","lat":34.423997,"lng":-119.705719,"owner":"NATASHA","phone":"805-965-4542","email":"natashaboutique@verizon.net"},
  {"name":"NEW MOON","address":"791 MAIN STREET","city":"CAMBRIA","state":"CA","zip":"93428","lat":35.567095,"lng":-121.099335,"owner":"MONIE","phone":"805-927-4466","email":"moniehh3@yahoo.com"},
  {"name":"NOVICA UNITED INC.","address":"2716 OCEAN PARK BLVD, STE-1030","city":"SANTA MONICA","state":"CA","zip":"90405","lat":34.01783,"lng":-118.455906,"phone":"816-587-5880","email":"inbound@novica.com"},
  {"name":"PECHANGA RESORT & CASINO","address":"45000 PECHANGA PARKWAY","city":"TEMECULA","state":"CA","zip":"92592","lat":33.45621,"lng":-117.106702,"owner":"YVONNE LATHAM","phone":"951-770-8661","email":"ylatham@pechanga.com"},
  {"name":"PISMO COLLECTION","address":"505 FIVE CITIES DR","city":"PISMO BEACH","state":"CA","zip":"93449","lat":35.135088,"lng":-120.62456,"owner":"ADRIAN HERNANDEZ","phone":"805-556-0329","email":"pismoadrian@gmail.com"},
  {"name":"PLUS BY DESIGN","address":"21622 LASSEN ST","city":"CHATSWORTH","state":"CA","zip":"91311","lat":34.250123,"lng":-118.600648,"owner":"ALLEGRA KEENE","phone":"818-223-8853","email":"allegrakeene@yahoo.com"},
  {"name":"POPPY","address":"911 EMBARCADERO","city":"MORRO BAY","state":"CA","zip":"93442","lat":35.367126,"lng":-120.853898,"owner":"SOPHIA TOLLE","phone":"805-771-9750","email":"sophia@poppywoman.com"},
  {"name":"ROMANCING THE RANGE","address":"38 MAIN ST","city":"SUTTER CREEK","state":"CA","zip":"95685","lat":38.393086,"lng":-120.802621,"owner":"RENEE FREEMAN","phone":"209-267-9137","email":"romancintherange@yahoo.com"},
  {"name":"RUE DE MIMO","address":"1514 MISSION STREET","city":"SOUTH PASADENA","state":"CA","zip":"91030","lat":34.115677,"lng":-118.15166,"owner":"CINDY SOLER","phone":"626-441-2690","email":"ruedemimo@gmail.com"},
  {"name":"SHASTA REFLECTIONS","address":"1131 SPRING MEADOWS ROAD","city":"MCCLOUD","state":"CA","zip":"96057","lat":41.217749,"lng":-122.131482,"owner":"ELFI GEUTHE","phone":"530-964-3288","email":"geuthe@frontiernet.net"},
  {"name":"SILK MOON","address":"195 N MAIN STREET","city":"SEBASTOPOL","state":"CA","zip":"95472","lat":38.403106,"lng":-122.824569,"owner":"MELANIE GOODPASTURE","phone":"707-824-4300","email":"cecily.silkmoon@gmail.com"},
  {"name":"SONDRA\'S OF LAKE ARROWHEAD","address":"PO BOX 1162","city":"LAKE ARROWHEAD","state":"CA","zip":"92352","lat":34.25883,"lng":-117.18763,"owner":"SONDRA / DIANE","phone":"909-336-2990","email":"sondralh@verizon.net"},
  {"name":"SUE\'S HALLMARK & BOUTIQUE","address":"2639 FOOTHILL BLVD","city":"LA CRESCENTA","state":"CA","zip":"91214","lat":34.222122,"lng":-118.236288,"owner":"SUE FRIEDRICH","phone":"805-644-2331","email":"sueshmk1731@gmail.com"},
  {"name":"SUNNYSIDE COTTAGE","address":"599 MONTECITO CTR","city":"SANTA ROSA","state":"CA","zip":"95409","lat":38.474905,"lng":-122.673249,"owner":"DEBBIE","phone":"707-525-1893","email":"sunnysidecottage@msn.com"},
  {"name":"TEXTURE","address":"716 MONTANA AVE","city":"SANTA MONICA","state":"CA","zip":"90403","lat":34.027068,"lng":-118.501312,"owner":"JANE WALKER","phone":"310-393-0707","email":"textureonmontana@gmail.com"},
  {"name":"THE CLOTHES MINE","address":"60 MAIN STREET #2","city":"SUTTER CREEK","state":"CA","zip":"95685","lat":38.393791,"lng":-120.802797,"owner":"JAMES","phone":"209-267-0417","email":"james@theclothesmine.com"},
  {"name":"THE COTTON CLUB","address":"2331 J STREET","city":"SACRAMENTO","state":"CA","zip":"95816","lat":38.575531,"lng":-121.474683,"owner":"KERI FURRY","phone":"916-442-2990","email":"cottonclub24j@gmail.com"},
  {"name":"THE PLACE","address":"2336 A MAIN STREET","city":"CAMBRIA","state":"CA","zip":"93428","lat":35.564348,"lng":-121.081031,"owner":"KATHY OPPEL","phone":"805-927-1195","email":"ckpines@earthlink.net"},
  {"name":"TOTAL LOOK","address":"450 1ST STREET E #F","city":"SONOMA","state":"CA","zip":"95476","lat":38.292821,"lng":-122.456138,"owner":"BARBARA MEZZETTA","phone":"707-996-8103","email":"thetotallook@gmail.com"},
  {"name":"VICKIE KAY\'S","address":"2898 STATE ST # A","city":"CARLSBAD","state":"CA","zip":"92008","lat":33.160683,"lng":-117.349603,"owner":"SEY","phone":"760-729-6033","email":"vickiekaysyu@gmail.com"},
  {"name":"VIOLET BOUTIQUE","address":"241 FOREST AVE","city":"LAGUNA BEACH","state":"CA","zip":"92651","lat":33.542348,"lng":-117.782861,"owner":"VIOLET","phone":"949-637-3111 S","email":"violetinlaguna@gmail.com"},
  {"name":"WHIM. BE BEAUTIFUL!","address":"10784 BAKER DOWNS","city":"PENN VALLEY","state":"CA","zip":"95946","lat":39.191465,"lng":-121.187867,"owner":"KELLY","phone":"530-559-7025 O","email":"whimbebeautiful@gmail.com"},
  {"name":"YAZA","address":"1535 SOLANO AVENUE","city":"BERKELEY","state":"CA","zip":"94707","lat":37.891231,"lng":-122.28639,"owner":"NAMGYAL","phone":"510-529-4223","email":"info@shopyaza.com"},
  {"name":"ACCESSORIES WITH A FLAIR","address":"801 8TH AVE #4","city":"GREELEY","state":"CO","zip":"80631","lat":40.424464,"lng":-104.691036,"owner":"LINDA WINTER","phone":"970-351-6448","email":"lindaw.accessorieswithaflair@gmail.com"},
  {"name":"BABY DOE\'S CLOTHING","address":"1116 WASHINGTON AVENUE","city":"GOLDEN","state":"CO","zip":"80401","lat":39.755523,"lng":-105.221879,"owner":"NANCY TAYLOR MASON","phone":"303-279-8100","email":"info@babydoesclothing.com"},
  {"name":"BLUE EYED BEAR BTQ","address":"LOWELL E HICKS","city":"SOUTH FORK","state":"CO","zip":"81154","lat":37.638307,"lng":-106.597775,"owner":"LINDA","phone":"719-850-0527 c","email":"lcarolh55@gmail.com"},
  {"name":"BUCKSKIN TRADING COMPANY","address":"506 6TH STREET","city":"GEORGETOWN","state":"CO","zip":"80444","lat":39.706308,"lng":-105.696515,"owner":"ROBIN MCWAIN","phone":"303-569-2050","email":"thebuckskintradingcompany@gmail.com"},
  {"name":"CARLY\'S BOUTIQUE","address":"7401 GRANDVIEW","city":"ARVADA","state":"CO","zip":"80002","lat":39.799733,"lng":-105.079194,"owner":"LORI DRIENKA","phone":"303-463-6565","email":"carlysboutiquearvada@gmail.com"},
  {"name":"COLORADO HAIR","address":"2695 NORTH PARK DR STE 103","city":"LAFAYETTE","state":"CO","zip":"80026","lat":40.025608,"lng":-105.147799,"owner":"MARCELLA DYKES","phone":"303-257-5070","email":"lookoutmarci@yahoo.com"},
  {"name":"COLORADO SYMPHONY GUILD SHOP","address":"6500 W MANSFIELD AVE VILLA 28","city":"DENVER","state":"CO","zip":"80235","lat":39.642962,"lng":-105.070825,"owner":"MONICA OWEN","phone":"720-318-8575","email":"monicaowen@comcast.net"},
  {"name":"EVERGREEN CLOTHING","address":"28025 HWY 74","city":"EVERGREEN","state":"CO","zip":"80439","lat":39.633348,"lng":-105.318301,"owner":"JIM SHERWOOD","phone":"303-679-9200","email":"evergreenclothingco@icloud.com"},
  {"name":"FLOWERS BY MARCIA","address":"202 PARK AVE","city":"KREMMLING","state":"CO","zip":"80459","lat":40.058708,"lng":-106.393024,"owner":"MARCIA WYATT","phone":"970-724-1185","email":"flowersbymarcia@gmail.com"},
  {"name":"GLENWOOD HOT SPRINGS","address":"401 N. RIVER","city":"GLENWOOD SPRINGS","state":"CO","zip":"81601","lat":39.549494,"lng":-107.322845,"owner":"PATRICK ODDAN","phone":"970-947-2955","email":"poddan@hotspringspool.com"},
  {"name":"HOME MADE","address":"590 MAIN ST","city":"MEEKER","state":"CO","zip":"81641","lat":40.037213,"lng":-107.913561,"owner":"KAITLYN","phone":"970-210-4138","email":"homemadeinmeeker@gmail.com"},
  {"name":"JEN\'S PLACE BTQ & GIFT SHOP","address":"2514 W COLORADO AVE","city":"COLORADO SPRINGS","state":"CO","zip":"80904","lat":38.847753,"lng":-104.863069,"owner":"TAMI GLASCOCK","phone":"719-635-9560","email":"jensplace@outlook.com"},
  {"name":"LOLLY\'S HALLMARK SHOP","address":"2030 35TH AVENUE UNIT E","city":"GREELEY","state":"CO","zip":"80634","lat":40.405566,"lng":-104.73303,"owner":"LOLLY MACRUN","phone":"970-356-3929"},
  {"name":"LUXE DESIGNS BOUTIQUE","address":"24 S GRAND AVE","city":"MONTROSE","state":"CO","zip":"81401","lat":38.476127,"lng":-107.880743,"owner":"ELLENA WENGER","phone":"970-650-5893","email":"luxedesignsboutique@gmail.com"},
  {"name":"MADD STYLE","address":"2601 S LEMAY AVE #10","city":"FORT COLLINS","state":"CO","zip":"80525","lat":40.551356,"lng":-105.059525,"owner":"CHRIS","phone":"719-321-2714","email":"benskowex@gmail.com"},
  {"name":"MONA LISA","address":"402  7TH ST","city":"GLENWOOD SPRINGS","state":"CO","zip":"81601","lat":39.547591,"lng":-107.323138,"owner":"LISA","phone":"970-945-0990","email":"sixcranes@hotmail.com"},
  {"name":"PARKER PANACHE","address":"19561 E MAIN STREET","city":"PARKER","state":"CO","zip":"80138","lat":39.518528,"lng":-104.763503,"owner":"BRENDA ZDANOWICZ","phone":"720-851-5121","email":"parkerpanache@gmail.com"},
  {"name":"PEEZIE MARIE","address":"78930 US HWY 40","city":"WINTER PARK","state":"CO","zip":"80482","lat":39.917698,"lng":-105.784696,"owner":"VICKYE FISCHER","phone":"970-726-8494","email":"peeziemarie@yahoo.com"},
  {"name":"PIRAMIDE CLOTHING COMPANY","address":"PO BOX 246","city":"MANITOU SPRINGS","state":"CO","zip":"80829","lat":38.853366,"lng":-104.927452,"owner":"THOMAS FALLON","phone":"719-685-5912","email":"piramidenf@msn.com"},
  {"name":"RAZMATAZ","address":"335 SOUTH UNION AVNUE","city":"PUEBLO","state":"CO","zip":"81003","lat":38.262671,"lng":-104.615955,"owner":"MEGAN MILLER","phone":"719-544-3721","email":"razmatazmegan@live.com"},
  {"name":"SILK ROAD","address":"1065 S. GAYLORD STREET","city":"DENVER","state":"CO","zip":"80209","lat":39.697177,"lng":-104.961907,"owner":"KARLA","phone":"303-669-9646","email":"info@shopsilkroad.com"},
  {"name":"STEAMBOAT RANCHWEAR","address":"38300 KLEIN RD","city":"STEAMBOAT SPRINGS","state":"CO","zip":"80487","lat":40.471453,"lng":-106.931525,"owner":"MARIANNE SASAK","phone":"970-879-5214","email":"stmbtranchwear@aol.com"},
  {"name":"SUSAN\'S FLOWERS & ARTISAN BTQ","address":"453 MAIN STREET","city":"CARBONDALE","state":"CO","zip":"81623","lat":39.400383,"lng":-107.211545,"owner":"SUSAN BARR","phone":"970-963-5754","email":"susan@susan4flowers.com"},
  {"name":"TARA\'S BOUTIQUE","address":"341 MAIN STREET","city":"DELTA","state":"CO","zip":"81416","lat":38.742159,"lng":-108.071027,"owner":"LAURA TARR","phone":"970-874-3317","email":"lauratarr63@yahoo.com"},
  {"name":"THE LOVE SHOP","address":"251 FRONT ST. , STE-13","city":"MONUMENT","state":"CO","zip":"80132","lat":39.092741,"lng":-104.874471,"owner":"THERESA WILLIAMS","phone":"719-598-3348","email":"theresa.loveshop@gmail.com"},
  {"name":"THE MAD MOOSE","address":"900 MORAINE AVENUE","city":"ESTES PARK","state":"CO","zip":"80517","lat":40.364656,"lng":-105.544104,"owner":"MAUREEN MCCANN","phone":"970-586-2776","email":"maureen@madmoose.com"},
  {"name":"THERES NO PLACE LIKE HOME","address":"822 MAIN AVE","city":"DURANGO","state":"CO","zip":"81301","lat":37.272637,"lng":-107.880788,"owner":"DEBORAH DEMME","phone":"970-385-7300","email":"deborah@theresnoplacelikehomeinc.com"},
  {"name":"UNIVERSITY OF COLORADO HOSP","address":"12605 E 16TH AVE","city":"AURORA","state":"CO","zip":"80045","lat":39.74249,"lng":-104.841691,"owner":"CHARLEESE","phone":"720-848-1396","email":"charleese.calkins@uchealth.org"},
  {"name":"VICKI\'S BOUTIQUE","address":"5253 ADAHI ROAD","city":"INDIAN HILLS","state":"CO","zip":"80454","lat":39.621941,"lng":-105.259539,"owner":"VICKI NELSON","phone":"720-771-6599 c","email":"vnelson@q.com"},
  {"name":"WARM HUGS MIXES & GIFTS","address":"809 10TH STREET","city":"GREELEY","state":"CO","zip":"80631","lat":40.422716,"lng":-104.69146,"owner":"SUZANNE SEREFF","phone":"970-353-3447","email":"suzanne@warmhugsmixes.com"},
  {"name":"WHEEL HOUSE GIFTS","address":"1525 S PEARL ST","city":"DENVER","state":"CO","zip":"80210","lat":39.688824,"lng":-104.980545,"owner":"JODY FIDLER","phone":"203-233-4567","email":"info@wheelhousegifts.com"},
  {"name":"WITT\'S FAMILY STORE","address":"P.O BOX 216","city":"FLAGLER","state":"CO","zip":"80815","lat":39.29305,"lng":-103.06716,"owner":"ARTHENA WITT","phone":"719-765-4573"},
  {"name":"A POCKETFUL OF POSIES","address":"386 MAIN ST","city":"MIDDLETOWN","state":"CT","zip":"06457","lat":41.559711,"lng":-72.649058,"owner":"BILL/DOTTIE","phone":"860-343-0123","email":"dottiesmith500@gmail.com"},
  {"name":"ANNABEL GREEN","address":"28 CANNON RD","city":"WILTON","state":"CT","zip":"06897","lat":41.217627,"lng":-73.425375,"owner":"WENDY MANES- VALERI","phone":"203-761-8955","email":"wendy@annabelgreen.com"},
  {"name":"CAROL\'S CREATIONS","address":"344 WASHINGTON AVE","city":"NORTH HAVEN","state":"CT","zip":"06473","lat":41.406761,"lng":-72.844764,"owner":"CAROL HEINS","phone":"203-239-1861","email":"carolscreations9@aol.com"},
  {"name":"COUNTRY SHOP","address":"684 BOSTON POST RD","city":"MADISON","state":"CT","zip":"06443","lat":41.279338,"lng":-72.596934,"owner":"KIM / MISSY","phone":"203-318-0368","email":"countryshopmadison@yahoo.com"},
  {"name":"EVERGREEN FINE CRAFTS","address":"21 BOSTON ST","city":"GUILFORD","state":"CT","zip":"06437","lat":41.282351,"lng":-72.678998,"owner":"SHARON SILVESTRINC","phone":"203-453-4324","email":"evergreen12ct@aol.com"},
  {"name":"FOREIGN CARGO","address":"17 N MAIN STREET","city":"KENT","state":"CT","zip":"06757","lat":41.725882,"lng":-73.476586,"owner":"JEFFREY KENNEDY","phone":"860-927-3900","email":"jeffkennedy246@earthlink.net"},
  {"name":"LARK LLC","address":"4 WATER ST","city":"CHESTER","state":"CT","zip":"06412","lat":41.403163,"lng":-72.450337,"owner":"KAREN CORCELLI","phone":"860-322-4256","email":"karencorcelli50@gmail.com"},
  {"name":"NANCY O","address":"103 DANBURY ROAD","city":"RIDGEFIELD","state":"CT","zip":"06877","lat":41.292868,"lng":-73.494239,"owner":"NANCY O CONNELL","phone":"203-431-2266","email":"info@shopnancyo.com"},
  {"name":"SPLASH LLC","address":"1010 MAIN ST","city":"BRANFORD","state":"CT","zip":"06405","lat":41.281937,"lng":-72.811711,"owner":"KAREN RAGONE","phone":"203-488-1632","email":"k.ragonesesplash@gmail.com"},
  {"name":"THE HOOT","address":"86 STORRS ROAD, STE-A","city":"WILLIMANTIC","state":"CT","zip":"06226","lat":41.73182,"lng":-72.200149,"owner":"KATHY CHESMER","phone":"860-456-2775","email":"contact@hootgifts.com"},
  {"name":"UNO ALLA VOLTA, LLC.","address":"242 BRANFORD RD.","city":"NORTH BRANFORD","state":"CT","zip":"06471","lat":41.321891,"lng":-72.772015,"owner":"ASHLEY IMLEJ X 241","phone":"203-871-1000","email":"ashley@unoallavolta.com"},
  {"name":"BETHANY SEA CREST, INC.","address":"PO BOX 1005","city":"BETHANY BEACH","state":"DE","zip":"19930","lat":38.54178,"lng":-75.05379,"owner":"ASHER","phone":"302-539-7621","email":"seacrestgifts@gmail.com"},
  {"name":"COOL SPRING COTTAGE","address":"2017 SAVANNAH CIRCLE","city":"LEWES","state":"DE","zip":"19958","lat":38.763966,"lng":-75.151374,"owner":"JUDY DEMENO","phone":"302-542-7022 c","email":"judydemeno@hotmail.com"},
  {"name":"PINEAPPLE PRINCESS SWIMWEAR","address":"301 REHOBOTH AVE","city":"REHOBOTH BEACH","state":"DE","zip":"19971","lat":38.715905,"lng":-75.086271,"owner":"DONNA HITCH","phone":"302-227-8705","email":"pineappleprincessswimwear@yahoo.com"},
  {"name":"SOUTHERN EXPOSURE","address":"1200 COASTAL HWY BOX442","city":"FENWICK ISLAND","state":"DE","zip":"19944","lat":38.461605,"lng":-75.052338,"owner":"BRIAN OR KIRSTAN COLLINS","phone":"302-539-8606","email":"sebeachlife@yahoo.com"},
  {"name":"TREASURE ISLAND FASHIONS","address":"30244 CEDAR NECK RD","city":"OCEAN VIEW","state":"DE","zip":"19970","lat":38.569778,"lng":-75.081224,"owner":"KEN","phone":"302-539-6597","email":"tifashions939@aol.com"},
  {"name":"ACCESSORIES & MORE","address":"4839 OAK POINTE WAY","city":"SARASOTA","state":"FL","zip":"34233","lat":27.283405,"lng":-82.454462,"owner":"JANET A CARR","phone":"941-922-9298","email":"jcarr35392@aol.com"},
  {"name":"ALLIE\'S BOUTIQUE","address":"14700 TAMIAMI TRAIL N #21","city":"NAPLES","state":"FL","zip":"34110","lat":26.305035,"lng":-81.803604,"owner":"CINDY SEALS","phone":"239-260-1662","email":"cin2fla123@gmail.com"},
  {"name":"ANGELS BY THE SEA","address":"308 FLAGLER AVE","city":"NEW SMYRNA BEACH","state":"FL","zip":"32169","lat":29.038744,"lng":-80.899956,"owner":"SARAH TIMMS","phone":"386-427-1977","email":"deepbluewater2832@yahoo.com"},
  {"name":"ANTHONY\'S","address":"5000 GEORGIA  AVE","city":"WEST PALM BEACH","state":"FL","zip":"33405","lat":26.668286,"lng":-80.058517,"owner":"POPE ANTHONY","phone":"561-588-7336","email":"pope@anthonysfla.com"},
  {"name":"A\'TU INTERNATIONAL JEWELRY","address":"3900 CLARK RD BLDG O","city":"SARASOTA","state":"FL","zip":"34233","lat":27.268962,"lng":-82.491953,"owner":"COLEEN CONNELLY","phone":"941-923-7038","email":"cmconnelly831@gmail.com"},
  {"name":"BABE\'S SHOES & APPAREL","address":"2537 S FLORIDA  AVENUE","city":"LAKELAND","state":"FL","zip":"33803","lat":28.01421,"lng":-81.958398,"owner":"FAYE","phone":"863-683-6900","email":"faye@babesinlakeland.com"},
  {"name":"BEACH HOUSE BOUTIQUE","address":"1120 S FEDERAL HWY","city":"BOYNTON BEACH","state":"FL","zip":"33435","lat":26.517844,"lng":-80.05824,"owner":"JANET","phone":"561-770-7113","email":"beachhousegiftboutique@gmail.com"},
  {"name":"BERRI LYNN\'S","address":"326 N PARK AVE","city":"WINTER PARK","state":"FL","zip":"32789","lat":28.599896,"lng":-81.350885,"owner":"BERRI","phone":"407-622-2229","email":"berrimorris@yahoo.com"},
  {"name":"BIJOU\'S BOUTIQUE","address":"2501 EDGEWATER DRIVE","city":"ORLANDO","state":"FL","zip":"32804","lat":28.573718,"lng":-81.389249,"owner":"BIJOU RIERSON","phone":"407-841-9728","email":"bijourierson@gmail.com"},
  {"name":"BIJOUX","address":"1200 W. RETTA ESPLANDE - L 31","city":"PUNTA GORDA","state":"FL","zip":"33950","lat":26.927708,"lng":-82.063503,"owner":"MIMI ALBRIGHT","phone":"941-456-6464 C","email":"bijouxgiftstore@gmail.com"},
  {"name":"BONITA BAY  CLUB SPORTS","address":"26681 COUNTRY CLUB DRIVE","city":"BONITA SPRINGS","state":"FL","zip":"34134","lat":26.349629,"lng":-81.812083,"owner":"REBECCA HUNTER","phone":"239-495-0200","email":"Rebeccah@bonitabayclub.net"},
  {"name":"CARIBONGO","address":"1041 CANAL STREET","city":"THE VILLAGES","state":"FL","zip":"32162","lat":28.907816,"lng":-81.974435,"owner":"FRANK MESSENGER","phone":"352-750-6147","email":"fmessenger7@hotmail.com"},
  {"name":"CARLISLE GIFTS","address":"3713 BAHIA VISTA ST","city":"SARASOTA","state":"FL","zip":"34232","lat":27.323918,"lng":-82.494848,"owner":"SHANNON ROSS","phone":"941-955-4009","email":"sross@carlislegifts.com"},
  {"name":"CEDAR STREET BOUTIQUE","address":"11875 CEDAR ST","city":"DUNNELLON","state":"FL","zip":"34431","lat":29.050567,"lng":-82.46529,"owner":"NANCY MYERS","phone":"352-465-1460","email":"grumbleshouseantiquesandplants@gmail.com"},
  {"name":"CHEWING GUM BOUTIQUE","address":"548 41ST STREET","city":"MIAMI","state":"FL","zip":"33140","lat":25.813986,"lng":-80.129511,"owner":"BETTY BEHAR","phone":"305-672-3008"},
  {"name":"COTTON WORLD","address":"162 ST. GEORGE ST #12","city":"SAINT AUGUSTINE","state":"FL","zip":"32084","lat":29.893156,"lng":-81.312897,"owner":"TOMIR ZWIERZYNSKI","phone":"904-829-3148","email":"tomirzwierzynski@yahoo.com"},
  {"name":"DOCKSIDE GIFT SHOP","address":"P.O. BOX 633","city":"CRYSTAL RIVER","state":"FL","zip":"34429","lat":28.867027,"lng":-82.572703,"owner":"BARBARA","phone":"352-563-2730","email":"docksidegiftshoppe@gmail.com"},
  {"name":"EM\'Z ON FIFTH","address":"200 W 5TH AVE","city":"MOUNT DORA","state":"FL","zip":"32757","lat":28.800328,"lng":-81.64587,"owner":"CLARA SCHNEIDER","phone":"352-735-4451","email":"cnsschneider@aol.com"},
  {"name":"FASHION FAZE FL INC","address":"5859 WEST ATLANTIC AVE B4","city":"DELRAY BEACH","state":"FL","zip":"33484","lat":26.455662,"lng":-80.13728,"owner":"CANAAN WARD","phone":"561-498-1026","email":"orders@thefashionfaze.com"},
  {"name":"FASHION GROUP USA","address":"4705 N OCEAN DRIVE","city":"SEA RANCH LAKES","state":"FL","zip":"33308","lat":26.197685,"lng":-80.09685,"owner":"SUSAN RATCLIFF","phone":"954-683-9850","email":"sjratcliff@fashiongroupusa.com"},
  {"name":"FASHION LABELS OUTLET","address":"1509 SOUTH STREET, #5","city":"LEESBURG","state":"FL","zip":"34748","lat":28.802702,"lng":-81.890328,"owner":"MAXINE","phone":"352-787-5574","email":"maxinesfashionlabels@gmail.com"},
  {"name":"FUNKY MONKEY","address":"12 SW OCEOLA ST","city":"STUART","state":"FL","zip":"34994","lat":27.19921,"lng":-80.254054,"owner":"ROBIN PETERS","phone":"772-257-6856","email":"info@funkymonkeystuart.com"},
  {"name":"H.T CHITTUM & COMPANY","address":"4242 GULFSHORE BLVD N","city":"NAPLES","state":"FL","zip":"34103","lat":26.2542,"lng":-81.82268,"owner":"DEBBIE GREGORY","phone":"239-643-5150","email":"htchittum@hotmail.com"},
  {"name":"HALA\'S GIFT BOUTIQUE","address":"735 DODECANESE BLVD","city":"TARPON SPRINGS","state":"FL","zip":"34689","lat":28.155043,"lng":-82.760905,"owner":"HALA","phone":"352-584-9743","email":"halasgiftboutique@yahoo.com"},
  {"name":"HEARTS DESIRE","address":"1685 LAUREL ST. APT #6","city":"SARASOTA","state":"FL","zip":"34236","lat":27.333093,"lng":-82.536486,"owner":"VICKI C. ROLLO","phone":"941-302-1069","email":"vicki@heartsdesirefl.com"},
  {"name":"ISLAND TIME","address":"1035 N COLLIER BLVD #312","city":"MARCO ISLAND","state":"FL","zip":"34145","lat":25.955095,"lng":-81.723071,"owner":"CRISTINA ZUGRAVU","phone":"239-970-2277","email":"islandtimetees@gmail.com"},
  {"name":"IVORY COAST","address":"15 N BLVD OF PRESIDENTS","city":"SARASOTA","state":"FL","zip":"34236","lat":27.318924,"lng":-82.577852,"owner":"CLEON DIXON","phone":"941-388-1999","email":"binjaratraders@comcast.net"},
  {"name":"KAY\'S ON THE BEACH","address":"1089 BALD EAGLE DR","city":"MARCO ISLAND","state":"FL","zip":"34145","lat":25.969048,"lng":-81.727454,"owner":"JEAN HILT","phone":"239-394-0618","email":"kaysbeach@yahoo.com"},
  {"name":"LA BOUTIQUE","address":"4123 MARINER BLVD","city":"SPRING HILL","state":"FL","zip":"34609","lat":28.490506,"lng":-82.542967,"owner":"CHERYL BARRY","phone":"352-688-2560","email":"cabarry73@icloud.com"},
  {"name":"LA WOMAN PLUS SIZES","address":"10026 SPANISH ISLES BLVD ST B1","city":"BOCA RATON","state":"FL","zip":"33498","lat":26.401376,"lng":-80.205786,"owner":"VICTOR BE\'NEHEMIYA","phone":"561-883-1811","email":"info@shoplawoman.com"},
  {"name":"LALA LU","address":"1039 CANAL ST","city":"THE VILLAGES","state":"FL","zip":"32162","lat":28.90785,"lng":-81.974434,"owner":"SHANNON GONZOLEZ","phone":"352-751-2300","email":"thevillageslalalu@gmail.com"},
  {"name":"LAUGHING LIZARDS","address":"9173 W ATLANTIC AVE SUITE 102","city":"DELRAY BEACH","state":"FL","zip":"33446","lat":26.453801,"lng":-80.190722,"owner":"BILL KROLL","phone":"561-501-7454","email":"laughinglizards@aol.com"},
  {"name":"LEANI\'S POLYNESIAN SHOP INC","address":"7205 ESTERO BLVD","city":"FORT MYERS BEACH","state":"FL","zip":"33931","lat":26.41463,"lng":-81.899676,"owner":"CARRIE SMITH","phone":"239-463-2838","email":"yourfriend@leanis.com"},
  {"name":"LOLA COUTURE","address":"9811 CRESCENT VIEW DRIVE S","city":"BOYNTON BEACH","state":"FL","zip":"33437","lat":26.530709,"lng":-80.164393,"owner":"CINDY GASTRIGHT","phone":"954-557-3949","email":"mylilyscloset@aol.com"},
  {"name":"LONGBOAT RESORT WEAR","address":"5380 GULF OF MEXICO DR","city":"LONGBOAT KEY","state":"FL","zip":"34228","lat":27.506097,"lng":-82.716916,"owner":"HARVINDER MIRCHANDINI","phone":"941-383-9320","email":"simjuh@aol.com"},
  {"name":"MALGORZATA\'S","address":"2441 NW 43RD STREET","city":"GAINESVILLE","state":"FL","zip":"32606","lat":29.675453,"lng":-82.387708,"owner":"MALGORZATA DEYRUP","phone":"352-428-3477","email":"deyrup@gmail.com"},
  {"name":"MORGAN BLAINE BOUTIQUE","address":"11090 S MILITARY TRAIL","city":"BOYNTON BEACH","state":"FL","zip":"33436","lat":26.512878,"lng":-80.12219,"owner":"SANDRA KURTZER","phone":"561-732-9979","email":"morganblaine214@gmail.com"},
  {"name":"NICHOLE\'S COLLECTIONS","address":"1200 W RETTA ESPLANADE #12","city":"PUNTA GORDA","state":"FL","zip":"33950","lat":26.927708,"lng":-82.063503,"owner":"NICHOLE","phone":"941-575-1911","email":"NO EMAIL"},
  {"name":"OMG THAT\'S CHIC","address":"287 N. COLLIER BLVD","city":"MARCO ISLAND","state":"FL","zip":"34145","lat":25.944696,"lng":-81.732799,"owner":"KENDA - DALE PRIMEAUX","phone":"239-970-2102","email":"omgthatschic@gmail.com"},
  {"name":"PARIS RETRO CORP DBA INFINITY","address":"16850 JOG ROAD SUITE 103","city":"DELRAY BEACH","state":"FL","zip":"33446","lat":26.426001,"lng":-80.146669,"owner":"AARON SCHIFMAN","phone":"561-865-2779","email":"parisretrocorp@gmail.com"},
  {"name":"PATCHINGTON / BMR HOLDING LLC","address":"6399 142ND AVENUE N, SUITE 105","city":"CLEARWATER","state":"FL","zip":"33760","lat":27.901961,"lng":-82.724667,"owner":"MICHAEL LEVICH","phone":"727-536-2195X","email":"mlevich@patchington.com"},
  {"name":"PETUNIAS OF NAPLES","address":"824 5TH AVE S","city":"NAPLES","state":"FL","zip":"34102","lat":26.141526,"lng":-81.79579,"owner":"CLAUDETTE","phone":"239-530-8047 C","email":"claudette@petuniasofnaples.com"},
  {"name":"RAGS & BAGS","address":"7410 BOYNTON BEACH BLVD A-7","city":"BOYNTON BEACH","state":"FL","zip":"33437","lat":26.526435,"lng":-80.163002,"owner":"ANDREA KNOX","phone":"561-733-7735","email":"ragsandbagsfl@gmail.com"},
  {"name":"RAZZLE DAZZLE","address":"1335 CAPE CORAL PKWY E","city":"CAPE CORAL","state":"FL","zip":"33904","lat":26.562904,"lng":-81.947285,"owner":"CATHY SANGIOVANNI","phone":"239-945-7549","email":"csangiovanni1@comcast.net"},
  {"name":"SCARLET MACAW","address":"225 WEST VENICE AVE","city":"VENICE","state":"FL","zip":"34285","lat":27.099593,"lng":-82.446532,"owner":"SIMONE KILLOVEN","phone":"941-483-3500","email":"ScarletMacawVenice@gmail.com"},
  {"name":"SEA-RENITY","address":"7616 2ND AVE WEST","city":"PALMA SOLA","state":"FL","zip":"34209","lat":27.499139,"lng":-82.638472,"owner":"AMANDA ESCOBIO","phone":"941-896-2222","email":"amanda@searenityspa.com"},
  {"name":"SHUCKERS ON THE BEACH","address":"9800 S OCEAN DRIVE","city":"JENSEN BEACH","state":"FL","zip":"34957","lat":27.28743,"lng":-80.21192,"owner":"CYNTHIA CORNELL","phone":"772-229-1224","email":"inquiry@islandbeachresort.com"},
  {"name":"SIGN OF THE DOLPHIN","address":"12999 PARK BLVD","city":"SEMINOLE","state":"FL","zip":"33776","lat":27.844917,"lng":-82.818481,"owner":"LINDA WOLBERT","phone":"727-393-1400","email":"signofthedolphin@gmail.com"},
  {"name":"SISTERS UNIQUE BOUTIQUE","address":"407 W DEARBORN ST","city":"ENGLEWOOD","state":"FL","zip":"34223","lat":26.962063,"lng":-82.361499,"owner":"ARLENE BECHTOLD","phone":"941-208-5045","email":"oursisters2@gmail.com"},
  {"name":"SWEET SAGE CAFE","address":"16725 GULF BLVD","city":"REDINGTON BEACH","state":"FL","zip":"33708","lat":27.816785,"lng":-82.821416,"owner":"BARBARA BAUEBACHS","phone":"727-510-4449","email":"barbara16750@aol.com"},
  {"name":"TESORO BTQ LLC","address":"1200 TOWN CENTER DR STE 121","city":"JUPITER","state":"FL","zip":"33458","lat":26.889501,"lng":-80.115704,"owner":"CATERINA DELISO","phone":"561-917-4184","email":"tesoroboutique8@gmail.com"},
  {"name":"THE BEAD STRAND","address":"2404 SE 27th ST","city":"OCALA","state":"FL","zip":"34471","lat":29.16075,"lng":-82.104959,"owner":"MARI HELLWEGE","phone":"352-620-2323","email":"mari@thebeadstrand.com"},
  {"name":"THE RED GERANIUM","address":"605 E CENTRAL AVE","city":"WINTER HAVEN","state":"FL","zip":"33880","lat":28.022086,"lng":-81.71849,"owner":"LINDA TIDWELL","phone":"863-291-8585","email":"tcmra@aol.com"},
  {"name":"THE SECRET INGREDIENT","address":"5064 ANNUNCIATION CIRCLE #105","city":"AVE MARIA","state":"FL","zip":"34142","lat":26.337516,"lng":-81.437512,"owner":"DANEE WILLIAMS","phone":"239-284-2762","email":"contact@thesecretingredientofavemaria.com"},
  {"name":"THINGS YOU LIKE","address":"5489 NEW COVINGTON DR","city":"SARASOTA","state":"FL","zip":"34233","lat":27.273972,"lng":-82.457724,"owner":"DIANNE SUCZEWSKI","phone":"941-349-1994","email":"thingsyoulike@comcast.net"},
  {"name":"TRINKETS AND TREASURERS","address":"260 NORTHAMPTON N","city":"WEST PALM BEACH","state":"FL","zip":"33417","lat":26.718312,"lng":-80.135369,"owner":"RUTH EKIERT","phone":"561-373-4674C","email":"trinketslakeworth@hotmail.com"},
  {"name":"VENICE STATIONERS","address":"211 WEST VENICE AVE","city":"VENICE","state":"FL","zip":"34285","lat":27.099596,"lng":-82.445964,"owner":"BARBARA GIBSON","phone":"941-488-6113","email":"barbara@venicestationersfl.com"},
  {"name":"VICTORIA\'S PLACE INC","address":"3690 BONITA BEACH ROAD","city":"BONITA SPRINGS","state":"FL","zip":"34134","lat":26.330891,"lng":-81.8148,"owner":"VICTORIA","phone":"239-498-3108","email":"victoriasretailstore@gmail.com"},
  {"name":"WILDBERRIES","address":"10833 S. JOG ROAD # 192","city":"BOYNTON BEACH","state":"FL","zip":"33437","lat":26.515607,"lng":-80.149416,"owner":"PAM","phone":"561-734-6630","email":"wildberriesgifts@yahoo.com"},
  {"name":"YESTERDAY TODAY & TOMORROW","address":"427 DONNELLY STREET","city":"MOUNT DORA","state":"FL","zip":"32757","lat":28.800052,"lng":-81.644868,"owner":"VINCENT CALVO","phone":"352-735-1887","email":"vincentcalvo10@gmail.com"},
  {"name":"BELLES BOUTIQUE","address":"449 INDUSTRIAL BLVD STE 115","city":"ELLIJAY","state":"GA","zip":"30540","lat":34.687289,"lng":-84.485055,"owner":"EVA DAVIS","phone":"706-276-6699","email":"belles@etcmail.com"},
  {"name":"COLONY SERVICES","address":"620 CREEKWOOD DR","city":"MARIETTA","state":"GA","zip":"30068","lat":33.965043,"lng":-84.456415,"owner":"NEVA COLONY","phone":"770-313-1300"},
  {"name":"MAGGIE LANE","address":"103 S JEFFERSON AVE","city":"EATONTON","state":"GA","zip":"31024","lat":33.326574,"lng":-83.388202,"owner":"SARA NOLAN / JAMES","phone":"706-484-0406","email":"snolan7@aol.com"},
  {"name":"MAIN STREET GALLERY","address":"51 N MAIN ST","city":"CLAYTON","state":"GA","zip":"30525","lat":34.879241,"lng":-83.400942,"owner":"JEANNE KRONSOBLE","phone":"706-782-2440","email":"mainstgallery2@gmail.com"},
  {"name":"MOUNTAIN HUNNY","address":"641 E MAIN ST","city":"BLUE RIDGE","state":"GA","zip":"30513","lat":34.866208,"lng":-84.323414,"owner":"CONNIE GASAWAY","phone":"706-946-0597 s","email":"mountainhunnyboutique@gmail.com"},
  {"name":"PARSLEY AND SAGE","address":"808 PICKENS INDUSTRIAL DR., #A","city":"MARIETTA","state":"GA","zip":"30062","lat":33.970024,"lng":-84.523243,"phone":"678-290-9293","email":"sales@parsley-sage.com"},
  {"name":"PINK VALISE BOUTIQUE","address":"108 N BROAD STREET","city":"THOMASVILLE","state":"GA","zip":"31792","lat":30.837847,"lng":-83.980189,"owner":"TRACIE FIVEASH","phone":"229-236-7465","email":"info@thepinkvaliseboutique.com"},
  {"name":"SAVANNAH BELLE","address":"229 W BROUGHTON ST","city":"SAVANNAH","state":"GA","zip":"31401","lat":32.079487,"lng":-81.095268,"owner":"LISA BOLAK","phone":"912-232-4833","email":"lisabolak@yahoo.com"},
  {"name":"SHOE GALLERY","address":"606 HOLCOMB BRIDGE RD # 130","city":"ROSWELL","state":"GA","zip":"30076","lat":34.038367,"lng":-84.34187,"owner":"MEDORA WARE","phone":"770-642-0051","email":"mware@shoegalleryonline.com"},
  {"name":"THE CABIN SHOP","address":"710 W 7TH ST","city":"TIFTON","state":"GA","zip":"31794","lat":31.450554,"lng":-83.523755,"owner":"ANN KENNON","phone":"229-382-4750","email":"thecabinshop@gmail.com"},
  {"name":"ANGEL WINGS AND COUNTRY THINGS","address":"116 N 1ST AVENUE SUITE A","city":"WINTERSET","state":"IA","zip":"50273","lat":41.335071,"lng":-94.014739,"owner":"NICOLE KEMS","phone":"515-462-4227","email":"nicole@angelwingsandct.com"},
  {"name":"CINDY\'S BOUTIQUE","address":"114 5TH STREET","city":"WEST DES MOINES","state":"IA","zip":"50265","lat":41.570147,"lng":-93.709317,"owner":"CINDY LANE","phone":"515-229-3008","email":"msfiowa@aol.com"},
  {"name":"ELITE TRENDS","address":"206 N 12TH STREET","city":"CENTERVILLE","state":"IA","zip":"52544","lat":40.733756,"lng":-92.875248,"owner":"EMILY HANES","phone":"641-895-7630","email":"em_hanes@hotmail.com"},
  {"name":"FINE THINGS","address":"205 1ST AVE W","city":"NEWTON","state":"IA","zip":"50208","lat":41.699383,"lng":-93.054893,"owner":"JULIA","phone":"641-521-8858","email":"jubent@yahoo.com"},
  {"name":"FLUTTERBYE GIFT SHOP","address":"1002 LINCOLN ST","city":"KNOXVILLE","state":"IA","zip":"50138","lat":41.311697,"lng":-93.112167,"owner":"NANCY HATCH","phone":"641-891-7435","email":"grandmabear1950@yahoo.com"},
  {"name":"FRONTIER TRADING POST","address":"25281 HWY 34","city":"CHARITON","state":"IA","zip":"50049","lat":41.000237,"lng":-93.265097,"owner":"CINDY REYES","phone":"641-774-8225","email":"frontiertradingpost@yahoo.com"},
  {"name":"GOTTA HAVE IT","address":"315  BLUFF STREET","city":"DUBUQUE","state":"IA","zip":"52001","lat":42.496165,"lng":-90.667518,"owner":"JULIE BERSTLER","phone":"563-588-3956","email":"gottahaveitdbq@gmail.com"},
  {"name":"GYPSI ON JEFFERSON","address":"301 JEFFERSON ST. SUITE 104","city":"BURLINGTON","state":"IA","zip":"52601","lat":40.809806,"lng":-91.103133,"owner":"DOREEN ROY","phone":"319-208-1299","email":"gypsionjefferson@outlook.com"},
  {"name":"LEUTHOLDS","address":"202 N ELM STREET","city":"CRESCO","state":"IA","zip":"52136","lat":43.37374,"lng":-92.116394,"owner":"ROY & TAMMY","phone":"563-547-4041","email":"leutholds@windstream.net"},
  {"name":"MARYS GIFT SHOPPE","address":"3001 AURORA AVE","city":"SPIRIT LAKE","state":"IA","zip":"51360","lat":43.412659,"lng":-95.124994,"owner":"MARY","phone":"712-336-1643","email":"marysgiftshoppe3001@gmail.com"},
  {"name":"MR B\'S","address":"317 9TH STREET","city":"SHELDON","state":"IA","zip":"51201","lat":43.181007,"lng":-95.854021,"owner":"AMY VAN MAREL","phone":"712-324-2148","email":"ladyb317@hotmail.com"},
  {"name":"NICKELMORE - THE HALLTREE","address":"200 WEST 2ND STREET","city":"MUSCATINE","state":"IA","zip":"52761","lat":41.420526,"lng":-91.046875,"owner":"KATHY CROSLEY","phone":"563-288-0770","email":"halltreemusc@live.com"},
  {"name":"PURPLE POPPY BOUTIQUE","address":"5800 MERLE HAY RD","city":"JOHNSTON","state":"IA","zip":"50131","lat":41.666295,"lng":-93.698984,"owner":"PAULA BIERLE","phone":"515-975-4833","email":"paula@purplepoppyboutique.com"},
  {"name":"REPURPOSE IT","address":"107 W 2ND ST","city":"WASHINGTON","state":"IA","zip":"52353","lat":41.300147,"lng":-91.692233,"owner":"LESLIE ALLENDER","phone":"319-653-2287","email":"leslie@shoprepurposeit.com"},
  {"name":"REVELATION","address":"111 EAST WATER STREET","city":"DECORAH","state":"IA","zip":"52101","lat":43.303993,"lng":-91.785265,"owner":"RENEE CARLSON","phone":"563-382-6212","email":"rmnrevelation@live.com"},
  {"name":"SASSY\'S","address":"136 5TH ST","city":"WEST DES MOINES","state":"IA","zip":"50265","lat":41.570905,"lng":-93.709253,"owner":"CINDY BOEYINK","phone":"641-780-9060","email":"cmboeyink@gmail.com"},
  {"name":"SOUTHEAST IOWA REGIONAL MED CT","address":"1221 SOUTH GEAR AVE","city":"WEST BURLINGTON","state":"IA","zip":"52655","lat":40.808935,"lng":-91.173579,"owner":"LORI MERCER","phone":"319-768-3485","email":"lmercer@greatriverhealth.org"},
  {"name":"STYLE WORKS","address":"512 WASHINGTON AVE","city":"IOWA FALLS","state":"IA","zip":"50126","lat":42.519707,"lng":-93.263519,"owner":"SHERRI","phone":"641-648-3000","email":"styleworksif@gmail.com"},
  {"name":"TEXTILES INC","address":"109 S DUBUQUE STREET","city":"IOWA CITY","state":"IA","zip":"52240","lat":41.659689,"lng":-91.533381,"owner":"RITU JAIN","phone":"319-339-0410","email":"rjtextiles@gmail.com"},
  {"name":"THE FUNKY ZEBRA","address":"301 SW WALNUT ST","city":"ANKENY","state":"IA","zip":"50023","lat":41.729461,"lng":-93.60574,"owner":"CHERYL HAYES","phone":"641-328-4374","email":"chayes2805@yahoo.com"},
  {"name":"TRES TEAL","address":"319 MAIN STREET","city":"AMES","state":"IA","zip":"50010","lat":42.025324,"lng":-93.614603,"owner":"RAE VON HOLDT","phone":"515-233-8325","email":"teal.tenacious@gmail.com"},
  {"name":"VON MAUR","address":"6565 BRADY STREET","city":"DAVENPORT","state":"IA","zip":"52806","lat":41.587973,"lng":-90.570667,"owner":"JANET NOTH","phone":"563-388-2757"},
  {"name":"WEIL\'S CLOTHING","address":"114 N. 16TH STREET","city":"CLARINDA","state":"IA","zip":"51632","lat":40.670826,"lng":-94.713987,"owner":"JAMES SHORE","phone":"712-542-2213","email":"james.shore@weilsclothing.com"},
  {"name":"WESLEY ACRES/GATHERING GAB","address":"3520 GRAND AVE","city":"DES MOINES","state":"IA","zip":"50312","lat":41.583564,"lng":-93.664555,"owner":"WICKIE DAWE","phone":"515-271-6500","email":"wdawe@wesleylife.org"},
  {"name":"YANA\'S LADIES BOUTIQUE","address":"4411 220TH TRAIL","city":"AMANA","state":"IA","zip":"52203","lat":41.800198,"lng":-91.871481,"owner":"YANA CUTLER","phone":"319-622-3680","email":"clothesenc@gmail.com"},
  {"name":"ZUMI","address":"1141 42ND STREET","city":"DES MOINES","state":"IA","zip":"50311","lat":41.600043,"lng":-93.674227,"owner":"LU SPAINE","phone":"515-277-4629","email":"luspaine@gmail.com"},
  {"name":"BOARDWALK AT RIVERSTONE","address":"2157 N MAIN ST","city":"COEUR D ALENE","state":"ID","zip":"83814","lat":47.695986,"lng":-116.809247,"owner":"RACHEL STIPPICH","phone":"208-667-4665","email":"rstippich@gmail.com"},
  {"name":"FUSSY HUSSY","address":"4916 W STATE","city":"BOISE","state":"ID","zip":"83703","lat":43.650956,"lng":-116.250218,"owner":"PAULA CARSON","phone":"206-390-0078","email":"paula.fromtheheart@gmail.com"},
  {"name":"ACCENTS PLUS","address":"601 DAVIS ST","city":"EVANSTON","state":"IL","zip":"60201","lat":42.046407,"lng":-87.679821,"owner":"VIRGINIA ESCALANTE","phone":"847-864-0420","email":"vibescalante@gmail.com"},
  {"name":"ALLA MODA BOUTIQUE","address":"524 DUANE STREET","city":"GLEN ELLYN","state":"IL","zip":"60137","lat":41.875307,"lng":-88.066583,"owner":"AMIE CANTARELLA","phone":"630-547-4020","email":"allamodashopper@gmail.com"},
  {"name":"BOHEMIA","address":"135 W MAIN ST","city":"URBANA","state":"IL","zip":"61801","lat":40.112294,"lng":-88.208383,"owner":"MILEA HAYES","phone":"217-552-5664","email":"bohemiaonmain@gmail.com"},
  {"name":"BRIANNA LYNN\'S BOUTIQUE","address":"215 LIBERTY STREET","city":"MORRIS","state":"IL","zip":"60450","lat":41.357839,"lng":-88.423778,"owner":"MAUREEN HEADRICK","phone":"815-942-1514","email":"twiceasnice_morris@yahoo.com"},
  {"name":"CLOTHES BIN & GIFT SHOP","address":"304 FRANKLIN PLAZA","city":"HANOVER","state":"IL","zip":"61041","lat":42.259411,"lng":-90.287037,"owner":"SARAH NIENSTEADT","phone":"815-238-5974","email":"sbohnsack@hotmail.com"},
  {"name":"DELNOR HOSPITAL GIFT SHOP","address":"300 RANDALL ROAD","city":"GENEVA","state":"IL","zip":"60134","lat":41.88669,"lng":-88.340525,"owner":"DANNA","phone":"630-938-8120"},
  {"name":"DIRECTIONS IN CLOTHING","address":"202 E CEDAR AVE","city":"SAINT CHARLES","state":"IL","zip":"60174","lat":41.914912,"lng":-88.311664,"owner":"MAUREEN SALESKY","phone":"630-584-1997","email":"MAUREEN.SALESKY@GMAIL.COM"},
  {"name":"EARTH\'S TREASURES","address":"102 S MAIN","city":"GALENA","state":"IL","zip":"61036","lat":42.416093,"lng":-90.428479,"owner":"BRYAN SCHWARK","phone":"815-777-9005","email":"schwark@uwplatt.edu"},
  {"name":"EIGHTH AVE VILLAGER","address":"2529 BROADWAY","city":"QUINCY","state":"IL","zip":"62301","lat":39.935639,"lng":-91.374136,"owner":"JEFFREY BUNCH","phone":"217-224-2642","email":"eightave@adams.net"},
  {"name":"GARDEN GATE","address":"301 N MAIN ST - PO BOX 950","city":"MACKINAW","state":"IL","zip":"61755","lat":40.538359,"lng":-89.359357,"owner":"SAMANTHA","phone":"309-359-8734","email":"info@mackinawdepot.com"},
  {"name":"GRANNY\'S LOFT CENTRIC","address":"21 BELMONT PLACE","city":"MARYVILLE","state":"IL","zip":"62062","lat":38.740173,"lng":-89.967014,"owner":"LINDA ANDREAS","phone":"618-444-7967","email":"grannysloftcentric@gmail.com"},
  {"name":"GWK ENTERPRISES - FOUR SEASONS","address":"110 1/2 SOUTH STATE ST","city":"GENESEO","state":"IL","zip":"61254","lat":41.452671,"lng":-90.155438,"owner":"ERIN MARSHALL","phone":"309-944-6516 EM","email":"erinm@gwkenterprises.com"},
  {"name":"K HOLLIS JEWELERS","address":"2030 MAIN ST","city":"BATAVIA","state":"IL","zip":"60510","lat":41.846622,"lng":-88.340776,"owner":"KAREN","phone":"630-879-8003","email":"karen@khollisjewelers.com"},
  {"name":"KARISMA","address":"232 S. WASHINGTON ST. STE 2","city":"NAPERVILLE","state":"IL","zip":"60540","lat":41.772238,"lng":-88.14751,"owner":"GINGER MAKOWSKI","phone":"630-355-5554","email":"karismaboutique@hotmail.com"},
  {"name":"LISA\'S BOUTIQUE","address":"4173 DUNDEE","city":"NORTHBROOK","state":"IL","zip":"60062","lat":42.137385,"lng":-87.883988,"owner":"LISA NUNEZ","phone":"224-723-5065","email":"ladnunez@comcast.net"},
  {"name":"MANHATTAN FIELDS BTQ","address":"112 N PLUM","city":"HAVANA","state":"IL","zip":"62644","lat":40.300225,"lng":-90.062113,"owner":"DEBBIE URISH","phone":"309-360-8848","email":"teamurish@yahoo.com"},
  {"name":"MILLENNIUM","address":"113 E JEFFERSON AVE","city":"EFFINGHAM","state":"IL","zip":"62401","lat":39.121106,"lng":-88.541602,"owner":"KEVIN SCHAEFER","phone":"217-343-8999","email":"millennium113@outlook.com"},
  {"name":"MINGLEWOOD","address":"333 E STATE ST","city":"ROCKFORD","state":"IL","zip":"61104","lat":42.268338,"lng":-89.089238,"owner":"KAREN","phone":"815-566-6957","email":"karen@minglewood.us"},
  {"name":"MONTICELLO HOUSE AKA JOSEPHINE","address":"6101 GODFRY RD","city":"GODFREY","state":"IL","zip":"62035","lat":38.956108,"lng":-90.19078,"owner":"DIANE SMITH","phone":"618-466-7818","email":"dianelynettesmith@gmail.com"},
  {"name":"MOONDANCE","address":"2010 W ROSCOE","city":"CHICAGO","state":"IL","zip":"60618","lat":41.943438,"lng":-87.678984,"owner":"SUSAN","phone":"312-995-4749","email":"moondancechicago@gmail.com"},
  {"name":"MORTON ARBORETUM","address":"4100 ILLINOIS ROUTE 53","city":"LISLE","state":"IL","zip":"60532","lat":41.818933,"lng":-88.077726,"phone":"630-719-2455","email":"trees@mortonarb.org"},
  {"name":"PETALURA C/O B.JOY BRANDS, LLC","address":"3536 N KNOX AVE","city":"CHICAGO","state":"IL","zip":"60641","lat":41.945745,"lng":-87.743108,"owner":"KAREN BROWN","phone":"603-933-2885","email":"karen@bjoybrands.com"},
  {"name":"PRINCESS SHOPPE DKF INC","address":"1520 E JACKSON","city":"MACOMB","state":"IL","zip":"61455","lat":40.458966,"lng":-90.650296,"owner":"KATHY","phone":"309-837-2986","email":"kathy@princessshoppemacomb.com"},
  {"name":"ROXY CARMICHAEL","address":"1617A N ALPINE RD","city":"ROCKFORD","state":"IL","zip":"61107","lat":42.286862,"lng":-89.027217,"owner":"CHRISTINE LAMANTIA","phone":"815-316-7396","email":"roxycarmichael@comcast.net"},
  {"name":"STELLA BTQ","address":"2116 CENTRAL ST","city":"EVANSTON","state":"IL","zip":"60201","lat":42.064208,"lng":-87.702916,"owner":"RACHEL","phone":"847-864-5565","email":"rachel@stellaevanston.com"},
  {"name":"SUE\'S II","address":"1201 PUBLIC SQUARE","city":"BENTON","state":"IL","zip":"62812","lat":37.996571,"lng":-88.920179,"owner":"KELLY BAIN","phone":"618-439-9174","email":"auntkeyco@frontier.com"},
  {"name":"TEMPTATIONS","address":"665 VERNON AVE","city":"GLENCOE","state":"IL","zip":"60022","lat":42.133322,"lng":-87.758751,"owner":"IDA OR LINDA","phone":"847-242-0600","email":"temptationsglencoe@gmail.com"},
  {"name":"THE LITTLE TRAVELER","address":"PO BOX 271","city":"GENEVA","state":"IL","zip":"60134","lat":41.88753,"lng":-88.30535,"owner":"LESLIE WATERSON","phone":"630-232-4200","email":"info@littletraveler.com"},
  {"name":"VENI VIDI VAL","address":"25 S LAGRANGE RD.","city":"LAGRANGE","state":"IL","zip":"60525","lat":41.815027,"lng":-87.869336,"owner":"VALERIE EVANS","phone":"708-354-3686","email":"venividival@sbcglobal.net"},
  {"name":"WEAR DID U GET THAT","address":"66 N WILLIAMS ST","city":"CRYSTAL LAKE","state":"IL","zip":"60014","lat":42.242855,"lng":-88.317684,"owner":"STEPHANIE ORMSBY","phone":"815-455-7500","email":"weardidugetthat@gmail.com"},
  {"name":"WEETA\'S BOUTIQUE","address":"P.O.BOX 2218","city":"OTTAWA","state":"IL","zip":"61350","lat":41.34559,"lng":-88.84258,"owner":"KATHY FOX","phone":"815-434-1587","email":"weetasboutique@gmail.com"},
  {"name":"WHAT TO WEAR","address":"921 S ARBOR VITAE, STE-104","city":"EDWARDSVILLE","state":"IL","zip":"62025","lat":38.812983,"lng":-89.963662,"owner":"JILL","phone":"618-655-0222","email":"w2wandmore@yahoo.com"},
  {"name":"ZANNA DUNES","address":"909 MAIN STREET","city":"ANTIOCH","state":"IL","zip":"60002","lat":42.478064,"lng":-88.095869,"owner":"JOSIE GEDZYK","phone":"224-788-5033","email":"stopyourself77@att.net"},
  {"name":"ABSOLUTELY APPAREL","address":"509 S HUNTINGTON ST","city":"SYRACUSE","state":"IN","zip":"46567","lat":41.417135,"lng":-85.748056,"owner":"PIA THYSTRUP","phone":"574-457-8887","email":"pia@advboat.com"},
  {"name":"ALEX\'S APPAREL","address":"103 N MAIN","city":"MONTICELLO","state":"IN","zip":"47960","lat":40.745169,"lng":-86.761729,"owner":"JEFF / JOHN","phone":"574-583-2539","email":"alexsapparel@gmail.com"},
  {"name":"BOUTIQUE 33","address":"33 E PINE ST","city":"ZIONSVILLE","state":"IN","zip":"46077","lat":39.949917,"lng":-86.261012,"owner":"JUDY REVIS","phone":"317-776-4088","email":"jarevis@outlook.com"},
  {"name":"ELLA JUNE\'S","address":"13 WEST MAIN ST","city":"GREENFIELD","state":"IN","zip":"46140","lat":39.784904,"lng":-85.769833,"owner":"LORETTA CANTER","phone":"317-491-5153","email":"llcanter1028@gmail.com"},
  {"name":"FLIRT BOUTIQUE","address":"625 MAIN ST","city":"ROCHESTER","state":"IN","zip":"46975","lat":41.067487,"lng":-86.215634,"owner":"PAM ROMINE","phone":"574-224-4759","email":"flirtrochester@gmail.com"},
  {"name":"GRETEL\'S","address":"1530 WIN HENTSCHEL BLVD","city":"WEST LAFAYETTE","state":"IN","zip":"47906","lat":40.464496,"lng":-86.934951,"owner":"GRETEL KULUPKA","phone":"765-464-8970","email":"gretel@gretelsfinegifts.com"},
  {"name":"J. L. HIRSCH COMPANY","address":"8 WEST MAIN STREET","city":"POSEYVILLE","state":"IN","zip":"47633","lat":38.169647,"lng":-87.783449,"owner":"SUSAN WEATHERHOLT","phone":"812-874-2719","email":"jlhirschco@yahoo.com"},
  {"name":"JOSEPHINE\'S & IRVINGTON","address":"5620 E WASHINGTON ST","city":"INDIANAPOLIS","state":"IN","zip":"46219","lat":39.770958,"lng":-86.071366,"owner":"LISA BENNETT","phone":"317-602-5442","email":"lisa@josephinesinirvington.com"},
  {"name":"LAURA INC","address":"1502 W SYCAMORE","city":"KOKOMO","state":"IN","zip":"46901","lat":40.48697,"lng":-86.14852,"owner":"DEANA SEWELL","phone":"765-452-7171","email":"deasewell@yahoo.com"},
  {"name":"LILYPAD","address":"2317 E STATE RD 14","city":"ROCHESTER","state":"IN","zip":"46975","lat":41.062067,"lng":-86.182657,"owner":"ANGELA ALEXANDER","phone":"755-498-6356","email":"aalexander6356@gmail.com"},
  {"name":"MAJOR HOSPITAL GIFT SHOP","address":"2451 INTELLIPLEX DR","city":"SHELBYVILLE","state":"IN","zip":"46176","lat":39.56052,"lng":-85.785352,"owner":"LINDA BACON","phone":"317-421-5676","email":"lbacon@majorhospital.org"},
  {"name":"MYERS DINNER THEATRE","address":"108 WATER STREET","city":"HILLSBORO","state":"IN","zip":"47949","lat":40.106672,"lng":-87.160307,"owner":"DONNA MYERS","phone":"765-376-0495 C","email":"myersdt@myersdt.com"},
  {"name":"PURR-FECTLY UNIQUE","address":"1112 BRUBAKER ST","city":"WARSAW","state":"IN","zip":"46580","lat":41.249855,"lng":-85.848786,"owner":"SUSAN KARCZEWSKI","phone":"574-268-8109","email":"purrjewelry@comcast.net"},
  {"name":"RIVERVIEW HEALTH","address":"385 WESTFIELD RD","city":"NOBLESVILLE","state":"IN","zip":"46060-1425","lat":40.046876,"lng":-86.023335,"owner":"MELINDA NASH","phone":"317-776-7236","email":"mnash@riverview.org"},
  {"name":"SCHON BOUTIQUE","address":"316 N. WABASH AVE","city":"EVANSVILLE","state":"IN","zip":"47712","lat":37.981197,"lng":-87.594219,"owner":"KELLEY BORMAN","phone":"812-213-8828","email":"schonboutique@hotmail.com"},
  {"name":"SIEBERT\'S","address":"532 MAIN STREET","city":"JASPER","state":"IN","zip":"47546","lat":38.391204,"lng":-86.930269,"owner":"JANE SIEBERT","phone":"812-482-5514","email":"sieberts@fullnet.com"},
  {"name":"STELLA\'S FASHION-OL GRANARY","address":"10081 BUTTERNUT","city":"MIDDLEBURY","state":"IN","zip":"46540","lat":41.720296,"lng":-85.660585,"owner":"STELLA","phone":"630-661-0921","email":"stellac5353@gmail.com"},
  {"name":"THE ARTFUL GARDEN","address":"118 S MAIN STREET","city":"CROWN POINT","state":"IN","zip":"46307","lat":41.417342,"lng":-87.363994,"owner":"ELIZABETH MESSING","phone":"219-662-0900","email":"artfulgarden@sbcglobal.net"},
  {"name":"THE SECRET INGREDIENT","address":"5631 N ILLINOIS STREET","city":"INDIANAPOLIS","state":"IN","zip":"46208","lat":39.855898,"lng":-86.159529,"owner":"PAM ELLIS","phone":"317-253-6632","email":"pamelaellis.fashion@gmail.com"},
  {"name":"WATER\'S EDGE","address":"5 RIDGE RD","city":"MUNSTER","state":"IN","zip":"46321","lat":41.563761,"lng":-87.525106,"owner":"CAROLYN","phone":"708-895-2554","email":"weponds@comcast.net"},
  {"name":"WOLDRUFF\'S INC.","address":"129 SOUTH MAIN ST","city":"GOSHEN","state":"IN","zip":"46526","lat":41.585349,"lng":-85.835082,"owner":"BECKY","phone":"574-534-5088","email":"apparelpurchasing@woldruffs.com"},
  {"name":"A NEW U SALON & BOUTIQUE","address":"1323 W DOUGLAS AVE","city":"WICHITA","state":"KS","zip":"67213","lat":37.683622,"lng":-97.356099,"owner":"SUE HARTMAN","phone":"316-265-6907","email":"anewusb@hotmail.com"},
  {"name":"CLASSY LADY BOUTIQUE","address":"220 N. DOUGLAS","city":"ELLSWORTH","state":"KS","zip":"67439","lat":38.730372,"lng":-98.230319,"owner":"GEORGINA BATES","phone":"785-472-2277","email":"geebates@sbcglobal.net"},
  {"name":"HARRIETT ANN\'S FASHIONS","address":"9747 E 21ST ST N #133","city":"WICHITA","state":"KS","zip":"67206","lat":37.723181,"lng":-97.225261,"owner":"LISA REITER","phone":"316-686-8673","email":"harriettanns@yahoo.com"},
  {"name":"HELLO BEAUTIFUL","address":"205 S MAIN","city":"PRATT","state":"KS","zip":"67124","lat":37.644927,"lng":-98.739634,"owner":"JERI","phone":"620-546-3523","email":"hellobeautiful205@gmail.com"},
  {"name":"JANET\'S BRIDAL AND BOUTIQUE","address":"1010 VAN BUREN","city":"HUGOTON","state":"KS","zip":"67951","lat":37.171641,"lng":-101.351598,"owner":"JANET STUTZ","phone":"620-544-8796","email":"JanetsBridalandBoutique@outlook.com"},
  {"name":"K LANE\'S & CO FASHION BOUTIQUE","address":"602 S TYLER ROAD","city":"WICHITA","state":"KS","zip":"67209","lat":37.673484,"lng":-97.443258,"owner":"KAREN TAYLOR","phone":"316-558-8840","email":"klanesandco@gmail.com"},
  {"name":"PAST & PRESENTS","address":"15020 W. 87TH ST","city":"LENEXA","state":"KS","zip":"66215","lat":38.971202,"lng":-94.759985,"owner":"MELINDA GIBSON","phone":"913-599-1727","email":"pastandpresentsmg@hotmail.com"},
  {"name":"PAWNEE VALLEY GIFT SHOP","address":"923 CARROLL AVE","city":"LARNED","state":"KS","zip":"67550","lat":38.183755,"lng":-99.107584,"owner":"CAROLYN HAAS","phone":"620-285-9124","email":"cjhaas@cox.net"},
  {"name":"REFINE","address":"1009 MAIN ST.","city":"HAYS","state":"KS","zip":"67601","lat":38.872074,"lng":-99.330687,"owner":"BRIANNE","phone":"785-621-4909","email":"refine@ruraltel.net"},
  {"name":"TEAL LOTUS","address":"7924 SANTA FE DRIVE","city":"OVERLAND PARK","state":"KS","zip":"66204","lat":38.984827,"lng":-94.671874,"owner":"TRISH GOODFRIEND","phone":"913-333-0422","email":"trish@teallotus.com"},
  {"name":"THE MARKET SHOP","address":"101 S SANTA FE AVE","city":"SALINA","state":"KS","zip":"67401","lat":38.840361,"lng":-97.608903,"owner":"JIM LOADER","phone":"785-823-8588","email":"themarketshop@cox.net"},
  {"name":"BLUEGRASS TRADITIONS","address":"207 N MAIN ST","city":"VERSAILLES","state":"KY","zip":"40383","lat":38.054491,"lng":-84.730296,"owner":"MADONNA","phone":"859-873-0003","email":"sgoebel@nitrousainc.com"},
  {"name":"CHARLOTTE\'S ON MAIN","address":"113 E 6TH ST","city":"HOPKINSVILLE","state":"KY","zip":"42240","lat":36.866778,"lng":-87.487443,"owner":"CRYSTAL FERREIRA","phone":"502-303-3075","email":"ceedsllc22@gmail.com"},
  {"name":"JUST JANE MERLE NORMAN","address":"107 WEST FLAGET","city":"BARDSTOWN","state":"KY","zip":"40004","lat":37.810507,"lng":-85.466864,"owner":"JANE CUDDY","phone":"502-827-2177","email":"JCJUSTJANE@GMAIL.COM"},
  {"name":"MERLE NORMAN","address":"125 EAST MAIN","city":"CAMPBELLSVILLE","state":"KY","zip":"42718","lat":37.341127,"lng":-85.344351,"owner":"SHERRY - MGR","phone":"270-789-1743","email":"PAM649@WINDSTREAM.NET"},
  {"name":"MIDWAY BOUTIQUE","address":"PO BOX 3863","city":"MIDWAY","state":"KY","zip":"40347","lat":38.145835,"lng":-84.718028,"owner":"JEANETTE KEATON","phone":"859-808-0715c","email":"keatonjeanette10@gmail.com"},
  {"name":"PAPERDOLLS","address":"901 N MAIN STREET","city":"LONDON","state":"KY","zip":"40741","lat":37.133694,"lng":-84.090656,"owner":"JUDIE HOUSE","phone":"606-877-4106","email":"paperdollsapparel@gmail.com"},
  {"name":"PEACOCK ON THIRD","address":"122 N 3RD STREET","city":"BARDSTOWN","state":"KY","zip":"40004","lat":37.810193,"lng":-85.466607,"owner":"KATHERINE BOWLING","phone":"502-348-2330","email":"peacockonthird@gmail.com"},
  {"name":"THE ELEGANT TOUCH","address":"228 E MAIN STREET","city":"CAMPBELLSVILLE","state":"KY","zip":"42718","lat":37.340986,"lng":-85.343854,"owner":"ROBERTA MOORE","phone":"270-469-6144","email":"rymoore465@aol.com"},
  {"name":"GINA\'S MERLE NORMAN","address":"2501 BEENE BLVD","city":"BOSSIER CITY","state":"LA","zip":"71111","lat":32.558972,"lng":-93.713313,"owner":"GINA","phone":"903-720-1007","email":"ginasmerlenorman.bossiercity@gmail.com"},
  {"name":"HOUSE OF FASHION","address":"200 EAST 7TH STREET","city":"THIBODAUX","state":"LA","zip":"70301","lat":29.793256,"lng":-90.818593,"owner":"CATHERINE MORVANT","phone":"985-447-3003","email":"houseoffashioninc@att.net"},
  {"name":"HUDSON HOUSE","address":"3118 GILBERT DR","city":"SHREVEPORT","state":"LA","zip":"71104","lat":32.481606,"lng":-93.737547,"owner":"JAN AND JOE HUDSON","phone":"318-865-2151","email":"hudson3118@aol.com"},
  {"name":"LITTLE TOWN APPAREL","address":"1116 COOLIDGE BLVD","city":"LAFAYETTE","state":"LA","zip":"70503","lat":30.204683,"lng":-92.017432,"owner":"MARY JANE JOHNSON","phone":"337-268-9499","email":"littletownapparel@gmail.com"},
  {"name":"MAIN STREET BOUTIQUE","address":"125 N MAIN STREET","city":"SPRINGHILL","state":"LA","zip":"71075","lat":33.004808,"lng":-93.461435,"owner":"JUDY","phone":"318-539-4570","email":"No Email"},
  {"name":"THE CHIFFAROBE","address":"221 LEE LANE","city":"COVINGTON","state":"LA","zip":"70433","lat":30.475727,"lng":-90.091864,"owner":"NANCY FORREST","phone":"985-327-7300","email":"cdnclothing@gmail.com"},
  {"name":"THE ENCHANTED GARDEN","address":"2429 LINE AVE","city":"SHREVEPORT","state":"LA","zip":"71104","lat":32.488503,"lng":-93.745901,"owner":"DEB BECKMAN","phone":"318-227-1213","email":"debcockrell@yahoo.com"},
  {"name":"ADORE BOUTIQUE","address":"1062 PLEASANT ST","city":"WORCESTER","state":"MA","zip":"01602","lat":42.278145,"lng":-71.848769,"owner":"AZAR","phone":"508-797-0001","email":"azar@boutiqueadore.com"},
  {"name":"BLUSHING BEE NATURALS","address":"787 MAIN STREET","city":"HOLDEN","state":"MA","zip":"01520","lat":42.341791,"lng":-71.844336,"owner":"KATHY LEAL","phone":"508-829-2332","email":"blushingbnaturals@gmail.com"},
  {"name":"BRIGHAM AND WOMEN\'S FAULKNER H","address":"1153 CENTRE STREET","city":"JAMAICA PLAIN","state":"MA","zip":"02130","lat":42.301399,"lng":-71.128081,"owner":"JANI MARGOLIN","phone":"617-983-7333","email":"jmargolin1@bwh.harvard.edu"},
  {"name":"BUTTERFLY TREE BOUTIQUE","address":"505 MAIN ST","city":"MEDFIELD","state":"MA","zip":"02052","lat":42.186461,"lng":-71.306629,"owner":"MARIA PIEDRA","phone":"508-359-6781","email":"thebutterflytreestore@gmail.com"},
  {"name":"CELIA\'S BOUTQUE","address":"111 WILLIAMS ST","city":"NEW BEDFORD","state":"MA","zip":"02740","lat":41.63542,"lng":-70.92675,"owner":"CELIA","phone":"508-994-3833","email":"celiasboutique@verizon.net"},
  {"name":"COOLEY DICKINSON HOSPITAL","address":"30 LOCUST ST  - GIFT SHOP","city":"NORTHAMPTON","state":"MA","zip":"01060","lat":42.330429,"lng":-72.653729,"owner":"SUSAN NETTO","phone":"413-582-2254","email":"snetto@mgb.org"},
  {"name":"DENI\'S CLOSET INC","address":"937 MAIN RD","city":"WESTPORT","state":"MA","zip":"02790","lat":41.572899,"lng":-71.091362,"owner":"DENISE SQUILLANTE","phone":"508-636-0063","email":"deniserose11@yahoo.com"},
  {"name":"DESIGN OF MINE","address":"33 MAIN STREET","city":"GLOUCESTER","state":"MA","zip":"01930","lat":42.611786,"lng":-70.665311,"owner":"MELISSA TARR","phone":"978-491-7495","email":"designofmine66@gmail.com"},
  {"name":"ENJOY","address":"4 DEERFIELD AVE SUITE 2","city":"SHELBURNE FALLS","state":"MA","zip":"01370","lat":42.603069,"lng":-72.739711,"owner":"JOY SULLIVAN","phone":"413-687-0827","email":"hello@storeenjoy.com"},
  {"name":"EVANS ON THE COMMON","address":"18 HIGHLAND ST","city":"TOWNSEND","state":"MA","zip":"01469","lat":42.668457,"lng":-71.705029,"owner":"CHRIS OR NOELLE","phone":"978-597-5117","email":"evans@evansonthecommon.com"},
  {"name":"FATIMAS HAIR DESIGN","address":"196 MAIN STREET","city":"GLOUCESTER","state":"MA","zip":"01930","lat":42.613176,"lng":-70.661363,"owner":"FATIMA","phone":"978-281-5583","email":"fatibett@gmail.com"},
  {"name":"FRENCH TWIST","address":"244 WEST BOYLSTON ST","city":"WEST BOYLSTON","state":"MA","zip":"01583","lat":42.346393,"lng":-71.78713,"owner":"ROBERTA BORIA","phone":"774-437-9192","email":"rboria@yahoo.com"},
  {"name":"GO FISH","address":"371 COMMERCIAL ST","city":"PROVINCETOWN","state":"MA","zip":"02657","lat":42.053663,"lng":-70.183396,"owner":"KELLY BLAKE","phone":"508-487-2992","email":"kblake001@comcast.net"},
  {"name":"GRASSHOPPER SHOP","address":"36 MAIN ST","city":"CONCORD","state":"MA","zip":"01742","lat":42.460101,"lng":-71.350105,"owner":"REBECCA BILODEAU","phone":"978-369-8295","email":"beeza10@aol.com"},
  {"name":"KATALINA\'S BOUTIQUE","address":"1682 PROVIDENCE ROAD","city":"NORTHBRIDGE","state":"MA","zip":"01534","lat":42.138371,"lng":-71.645697,"owner":"KATHY TONRY","phone":"508-450-8969","email":"katalinasboutique1682@gmail.com"},
  {"name":"LA BODEGA","address":"1075 MAIN STREET","city":"BREWSTER","state":"MA","zip":"02631","lat":41.753675,"lng":-70.109269,"owner":"AMY","phone":"508-896-7340","email":"labodegacapecod@gmail.com"},
  {"name":"MIMI\'S","address":"160 FRONT ST","city":"MARION","state":"MA","zip":"027387","lat":41.703962,"lng":-70.763159,"owner":"JILL PITMAN","phone":"508-748-1800","email":"mimi160front@gmail.com"},
  {"name":"MOUNT AUBURN HOSPITAL GIFTSHOP","address":"300 MT. AUBURN ST","city":"CAMBRIDGE","state":"MA","zip":"02138","lat":42.373894,"lng":-71.134238,"owner":"KATHY RUSHE","phone":"617-575-8642","email":"kathleen.rushe@mah.harvard.edu"},
  {"name":"OCTOBER GULLS","address":"634 NORTH FALMOUTH HWY","city":"NORTH FALMOUTH","state":"MA","zip":"02556","lat":41.65091,"lng":-70.612676,"owner":"KAREN MACDONALD","phone":"508-783-4026","email":"kmacdon913@gmail.com"},
  {"name":"PATINA GREEN","address":"59 MAIN ST","city":"CONCORD","state":"MA","zip":"01742","lat":42.459504,"lng":-71.350868,"owner":"STACY MACH","phone":"978-369-1708","email":"stacymach12@outlook.com"},
  {"name":"POOJA BOUTIQUE","address":"88 FRONT STREET","city":"SCITUATE","state":"MA","zip":"02066","lat":42.194235,"lng":-70.725078,"owner":"POOJA COWING","phone":"781-378-1024","email":"fashion02066@gmail.com"},
  {"name":"PORT CARGO","address":"PO BOX 69","city":"MASHPEE","state":"MA","zip":"02649","lat":41.64844,"lng":-70.48114,"owner":"RITA MEHTA","phone":"774-228-2202","email":"ritaportcargo@hotmail.com"},
  {"name":"POTPOURRI GROUP","address":"101 BILLERICA AVE. BLDG. 2","city":"NORTH BILLERICA","state":"MA","zip":"01862","lat":42.603562,"lng":-71.279609,"owner":"PATTY KORNBLUH","phone":"978-256-4100x","email":"ddennett@potpourrigroup.com"},
  {"name":"RADA BOUTIQUE","address":"394 MAIN STREET","city":"WAKEFIELD","state":"MA","zip":"01880","lat":42.503469,"lng":-71.070051,"owner":"RADA FROHLICHSTEIN","phone":"781-224-1033","email":"radafashion@gmail.com"},
  {"name":"RAGG TIME LTD","address":"P.O. BOX 2191","city":"ORLEANS","state":"MA","zip":"02653","lat":41.7899,"lng":-70.00107,"owner":"JEAN BESSETTE","phone":"508-349-1266","email":"raggtimeltd@comcast.net"},
  {"name":"RUSSELL\'S GARDEN CENTER","address":"397 BOSTON POST ROAD","city":"WAYLAND","state":"MA","zip":"01778","lat":42.362832,"lng":-71.369125,"owner":"ELIZABETH/CARLY","phone":"508-358-2283","email":"emilym@russellsgc.com"},
  {"name":"SEA BREEZES CLOTHING","address":"556 MAIN ST","city":"HYANNIS","state":"MA","zip":"02601","lat":41.650487,"lng":-70.288964,"owner":"MARILYN P. CHAMBERS","phone":"508-775-3775","email":"mpcseabreezes@gmail.com"},
  {"name":"SELECTIONS","address":"385 BOSTON POST ROAD","city":"SUDBURY","state":"MA","zip":"01776","lat":42.360904,"lng":-71.415696,"owner":"CATHY REGENSBURGER","phone":"978-440-8119","email":"selectionsboutique@gmail.com"},
  {"name":"SOMETHING SPECIAL","address":"145 LINCOLN ROAD","city":"LINCOLN","state":"MA","zip":"01773","lat":42.414477,"lng":-71.325787,"owner":"SUSAN MORGAN","phone":"781-259-0544","email":"somespec76@yahoo.com"},
  {"name":"SUNRISE BOUTIQUE","address":"62 HIGH STREET","city":"CLINTON","state":"MA","zip":"01510","lat":42.417158,"lng":-71.685178,"owner":"CYNTHIA","phone":"978-368-0227","email":"cynsun1@aol.com"},
  {"name":"SWEATS OF ROCKPORT","address":"2152 CENTRE STREET","city":"WEST ROXBURY","state":"MA","zip":"02132","lat":42.276819,"lng":-71.160141,"owner":"JACK FRIEL","phone":"617-291-1829","email":"sweatsofrockport@aol.com"},
  {"name":"THE BLUE MARBLE","address":"150 MAIN STREET","city":"NORTHAMPTON","state":"MA","zip":"01060","lat":42.318172,"lng":-72.63055,"owner":"CATHIE WALZ","phone":"413-253-0328","email":"bluemarblegifts@aol.com"},
  {"name":"THE BRASS MONKEY","address":"85 MAIN STREET","city":"GLOUCESTER","state":"MA","zip":"01930","lat":42.612256,"lng":-70.664455,"owner":"COLLEEN LANCE","phone":"978-879-4761","email":"lance_colleen@yahoo.com"},
  {"name":"THE DEAD ZONE","address":"1198 ROUTE 28","city":"SOUTH YARMOUTH","state":"MA","zip":"02664","lat":41.665348,"lng":-70.195011,"owner":"PATRICIA MARTIN","phone":"508-760-5823","email":"thedeadzone@comcast.net"},
  {"name":"THE DRESSING ROOM","address":"293 AUBURN STREET","city":"NEWTON","state":"MA","zip":"02466","lat":42.346731,"lng":-71.247192,"owner":"SHEELAH MCNAMARA","phone":"617-965-3442","email":"dress293@aol.com"},
  {"name":"VIS-A-VIS","address":"34 MAIN ST","city":"NANTUCKET","state":"MA","zip":"02554","lat":41.283222,"lng":-70.09843,"owner":"AVIS AND HARRIS","phone":"508-228-5527","email":"info@visavisnantucket.com"},
  {"name":"WARDROBE","address":"6 SANDY HILL LANE UNIT 7","city":"PROVINCETOWN","state":"MA","zip":"02657","lat":42.058702,"lng":-70.191468,"owner":"STEVE CAREY","phone":"508-487-0307","email":"stevecareyma@hotmail.com"},
  {"name":"WILLOUGHBY\'S","address":"20F MAIN ST","city":"ROCKPORT","state":"MA","zip":"01966","lat":42.658151,"lng":-70.618631,"owner":"SHARON","phone":"978-546-9820","email":"sharonkmcdonald1@hotmail.com"},
  {"name":"WOW INC.","address":"1110 GREAT PLAIN AVE","city":"NEEDHAM","state":"MA","zip":"02492","lat":42.280014,"lng":-71.239357,"owner":"ERICA DEMARCO","phone":"617-558-1969","email":"erica@shopatwow.com"},
  {"name":"ZANNA, INC - THE SHOE BIN INC","address":"187 NORTH PLEASANT STREET","city":"AMHERST","state":"MA","zip":"01002","lat":42.378358,"lng":-72.519646,"owner":"AMY BENSON","phone":"413-253-2563","email":"Amy@zanna.com"},
  {"name":"AMANO","address":"7034 CARROLL AVE","city":"TAKOMA PARK","state":"MD","zip":"20912","lat":38.975257,"lng":-77.011367,"owner":"JANET DUNN","phone":"301-270-1140","email":"amanoinc@gmail.com"},
  {"name":"ARTISAN\'S GALLERY","address":"12147 DARNESTOWN RD","city":"GAITHERSBURG","state":"MD","zip":"20878","lat":39.118536,"lng":-77.251076,"owner":"GINGER","phone":"301-990-3219","email":"artisansgallerymd@gmail.com"},
  {"name":"BEAR CREEK TRADERS","address":"PO BOX 279","city":"MC HENRY","state":"MD","zip":"21541","lat":39.565589,"lng":-79.382332,"owner":"SHERRY","phone":"301-387-2380","email":"sherry@bearcreektraders.com"},
  {"name":"CHARISMA CLOTHING BOUTIQUE","address":"PO BOX 1155","city":"SAINT MICHAELS","state":"MD","zip":"21663","lat":38.78512,"lng":-76.22439,"owner":"BARBARA HEETHER","phone":"410-745-0352","email":"charismaboutique@verizon.net"},
  {"name":"COLLECTIONS AT KENILWORTH INC","address":"870 KENILWORTH DRIVE","city":"TOWSON","state":"MD","zip":"21204","lat":39.411786,"lng":-76.618957,"owner":"BOB HAMMANN","phone":"410-823-7973","email":"bobhammann@gmail.com"},
  {"name":"CRAZY LADYZ","address":"12319 OCEAN GATEWAY","city":"OCEAN CITY","state":"MD","zip":"21842","lat":38.340031,"lng":-75.126002,"owner":"JANICE - MD","phone":"410-213-2085","email":"jan@crazyladyz.com"},
  {"name":"ES HUBBERT & SON","address":"403 SUNBURST HIGHWAY","city":"CAMBRIDGE","state":"MD","zip":"21613","lat":38.563401,"lng":-76.066494,"owner":"LYNN C SCOTT","phone":"410-228-3474","email":"eshubbert@comcast.net"},
  {"name":"HOUSTON\'S DOCKSIDE EMPORIUM","address":"315 HIGH STREET # 101","city":"CHESTERTOWN","state":"MD","zip":"21620","lat":39.209238,"lng":-76.067391,"owner":"MICHELLE TIMMONS","phone":"410-778-9079","email":"houstonsdockside1@gmail.com"},
  {"name":"JOSEPH\'S DEPARTMENT STORE","address":"122 N WASHINGTON ST","city":"HAVRE DE GRACE","state":"MD","zip":"21078","lat":39.548389,"lng":-76.090018,"owner":"CHRISTY SILVERSTEIN","phone":"410-939-4114","email":"josephsdepartmentstore@gmail.com"},
  {"name":"LIZZY DEE","address":"31 N HARRISON ST","city":"EASTON","state":"MD","zip":"21601","lat":38.775489,"lng":-76.075065,"owner":"DARCY BERNAT","phone":"410-770-4374","email":"info@lizzydeeboutique.com"},
  {"name":"MOLLY\'S MEANDERINGS","address":"17 N MARKET ST","city":"FREDERICK","state":"MD","zip":"21701","lat":39.414765,"lng":-77.411118,"owner":"LESLIE ATANASOFF","phone":"301-668-8075","email":"mollysmeandering@aol.com"},
  {"name":"AURA OF PANACHE","address":"220 MIDDLE RIDGE ROAD","city":"BRIDGTON","state":"ME","zip":"04009","lat":44.082792,"lng":-70.713334,"owner":"KATELYN JAEGER","phone":"207-291-0184 c","email":"katelynjaeger@gmail.com"},
  {"name":"BLISS","address":"93 MAIN ST","city":"ELLSWORTH","state":"ME","zip":"04605","lat":44.54131,"lng":-68.424149,"owner":"SUSAN NORDMAN","phone":"207-689-8115","email":"s.nordman@me.com"},
  {"name":"CASTINE EMPORIUM LLC","address":"15 MAIN ST","city":"CASTINE","state":"ME","zip":"04421","lat":44.388175,"lng":-68.797145,"owner":"BONNIE POLITANO","phone":"207-326-5102","email":"CastineEmporium@gmail.com"},
  {"name":"COYOTE MOON","address":"54 MAIN STREET","city":"BELFAST","state":"ME","zip":"04915","lat":44.426846,"lng":-69.005917,"owner":"LISA","phone":"832-971-6930 c","email":"lisaf@coyotemoonmaine.com"},
  {"name":"ELIZABETH\'S","address":"124 MAIN STREET","city":"ELLSWORTH","state":"ME","zip":"04605","lat":44.54174,"lng":-68.423768,"owner":"ELIZABETH HILTS","phone":"207-667-3833 S","email":"hiltselizabeth@yahoo.com"},
  {"name":"GRASSHOPPER OF ROCKLAND","address":"400 MAIN ST","city":"ROCKLAND","state":"ME","zip":"04841","lat":44.104245,"lng":-69.109304,"owner":"JOHANNA STRASSBERG","phone":"207-596-6156","email":"grassroc@gmail.com"},
  {"name":"HATCH LLC","address":"96 MAINE ST","city":"BRUNSWICK","state":"ME","zip":"04011","lat":43.916424,"lng":-69.966175,"owner":"HANNAH","phone":"207-373-0567","email":"hatchonmaine@gmail.com"},
  {"name":"HOUSE OF LOGAN","address":"PO BOX 387","city":"BOOTH BAY HARBOR","state":"ME","zip":"04538","lat":43.85559,"lng":-69.62324,"owner":"SARAH WILCOX","phone":"207-633-2293","email":"logans@houseoflogan.com"},
  {"name":"MCH GIFT SHOP","address":"123 MEDICAL CENTER DRIVE","city":"BRUNSWICK","state":"ME","zip":"04011","lat":43.906327,"lng":-69.890184,"owner":"BARB KAY","phone":"207-373-6017","email":"barbara.kay@mainehealth.org"},
  {"name":"MOTIFS","address":"1 WAYFARER DR #101","city":"CAMDEN","state":"ME","zip":"04843","lat":44.209237,"lng":-69.060738,"phone":"207-230-8383","email":"motifs1955@gmail.com"},
  {"name":"ONE LUPINE","address":"170 PARK ST","city":"BANGOR","state":"ME","zip":"04401","lat":44.805195,"lng":-68.770668,"owner":"JODI CLAYTON","phone":"207-992-4140 S","email":"onelupine@gmail.com"},
  {"name":"SLICKS","address":"27 TOWNSEND AVENUE","city":"BOOTHBAY HARBOR","state":"ME","zip":"04538","lat":43.852169,"lng":-69.627301,"owner":"ANDREA BIELLI","phone":"207-633-7426","email":"slicksboutique@gmail.com"},
  {"name":"THE DRY DOCK","address":"24 MAIN ST","city":"STONINGTON","state":"ME","zip":"04681","lat":44.155931,"lng":-68.665055,"owner":"JANET COOK","phone":"207-367-5528","email":"drydockstonington@gmail.com"},
  {"name":"THE WHIMSY SHOP","address":"P.O BOX 1868","city":"KENNEBUNKPORT","state":"ME","zip":"04046","lat":43.35997,"lng":-70.46316,"owner":"MARY & LEE WHITE","phone":"207-233-3822","email":"mainelw@roadrunner.com"},
  {"name":"THIS IS IT / SWANN HOLIDAY INC","address":"P.O BOX 1557","city":"OGUNQUIT","state":"ME","zip":"03907","lat":43.24898,"lng":-70.59922,"owner":"KYLE SWANN","phone":"207-646-4014","email":"kyleswann73@gmail.com"},
  {"name":"VILLAGE BOUTIQUE","address":"P.O BOX 1299","city":"WELLS","state":"ME","zip":"04090","lat":43.32203,"lng":-70.58089,"owner":"JUDITH","phone":"207-409-9084","email":"jfpettinga@yahoo.com"},
  {"name":"WOMEN OF SUBSTANCE","address":"508 MAIN ST","city":"DAMARISCOTTA","state":"ME","zip":"04543","lat":44.037859,"lng":-69.511783,"owner":"LYNNE URQUHART","phone":"207-563-6809","email":"womenofsubstanceme@gmail.com"},
  {"name":"52 WEEKENDS","address":"101 WATER STREET, SUITE A","city":"BOYNE CITY","state":"MI","zip":"49712","lat":45.213659,"lng":-85.014819,"owner":"LORI HERRINGTON","phone":"231-582-9455 C","email":"52weekendsupnorth@gmail.com"},
  {"name":"ABELMAN CLOTHING","address":"327 SOUTH SOPHIE STREET","city":"BESSEMER","state":"MI","zip":"49911","lat":46.479175,"lng":-90.050516,"owner":"SUE & BOB ABELMAN","phone":"906-663-4411","email":"bob@abelmanclothing.com"},
  {"name":"ACCESSORIES BY STEPHANIE","address":"6777 WEST MAPLE RD","city":"WEST BLOOMFIELD","state":"MI","zip":"48322","lat":42.536077,"lng":-83.407084,"owner":"STEPHANIE ORAM","phone":"248-797-4673","email":"stephanie@fashionsbystef.com"},
  {"name":"AMY\'S","address":"7266 MICHIGAN AVE","city":"PIGEON","state":"MI","zip":"48755","lat":43.829874,"lng":-83.278933,"owner":"AMY GUSTER","phone":"989-453-2515","email":"gustera664@gmail.com"},
  {"name":"BARISH\'S 1913","address":"321 ASHMUN STREET","city":"SAULT SAINTE MARIE","state":"MI","zip":"49783","lat":46.499091,"lng":-84.346826,"owner":"PHIL","phone":"906-635-9885","email":"barishbrothers24@gmail.com"},
  {"name":"BLUSH","address":"6280 VASSAR","city":"GRAND BLANC","state":"MI","zip":"48439","lat":42.938141,"lng":-83.570904,"owner":"JODI","phone":"810-691-9800","email":"jvpaboib@gmail.com"},
  {"name":"CIRCARE","address":"23024 GREATER MACK AVE","city":"SAINT CLAIR SHORES","state":"MI","zip":"48080","lat":42.46432,"lng":-82.898297,"owner":"GLORIA KINNE","phone":"586-771-8510","email":"circare@sbcglobal.net"},
  {"name":"CLOTHES LOFT","address":"113 WASHINGTON STREET","city":"GRAND HAVEN","state":"MI","zip":"49417","lat":43.064517,"lng":-86.231945,"owner":"KIM","phone":"616-842-8050","email":"clothesloft1@hotmail.com"},
  {"name":"COBBLESTONE ROSE","address":"101 S ANN ARBOR","city":"SALINE","state":"MI","zip":"48176","lat":42.166302,"lng":-83.780812,"owner":"KAREN HODGSON","phone":"734-944-6202","email":"cobblestonerose@yahoo.com"},
  {"name":"COTTON BAY","address":"8 EAST EIGHTH ST","city":"HOLLAND","state":"MI","zip":"49423","lat":42.790165,"lng":-86.107019,"owner":"PAMELA PETERSON","phone":"616-394-7114","email":"pamelapete@hotmail.com"},
  {"name":"CREATIVE FASHIONS","address":"106 BATTLE ALLEY","city":"HOLLY","state":"MI","zip":"48442","lat":42.790823,"lng":-83.627084,"owner":"JEROME RASKA","phone":"248-634-5114","email":"jeromeraska@gmail.com"},
  {"name":"CROCK AND ROCKER","address":"25214 CAMPSITE DR","city":"MICHIGAMME","state":"MI","zip":"49861","lat":46.537428,"lng":-88.185617,"owner":"RUTH WARNER","phone":"906-323-6214","email":"crockandrocker@yahoo.com"},
  {"name":"DCH HOSPITAL GIFT SHOP","address":"1721 S STEPHENSON AVE","city":"IRON MOUNTAIN","state":"MI","zip":"49801","lat":45.808705,"lng":-88.050971,"owner":"VIRGINIA SANDERS","phone":"906-776-5536","email":"sanders.ginny@gmail.com"},
  {"name":"DECKED OUT","address":"7389 MAIN ST","city":"MACKINAC ISLAND","state":"MI","zip":"49757","lat":45.847862,"lng":-84.618888,"owner":"LINDSEY","phone":"989-621-6401","email":"schunk.lindsey@gmail.com"},
  {"name":"ED REHMANN & SONS","address":"151 W BROAD STREET","city":"CHESANING","state":"MI","zip":"48616","lat":43.184787,"lng":-84.115805,"owner":"NANCY REHMANN","phone":"989-845-6761","email":"nancyrehmann@outlook.com"},
  {"name":"ESCAPE SALON","address":"2075 S LINDEN","city":"FLINT","state":"MI","zip":"48532","lat":43.036921,"lng":-83.773759,"owner":"HOLLY GILMORE","phone":"810-733-3030","email":"escapesalonspa@charter.net"},
  {"name":"EVOLVE","address":"109 N 3RD ST","city":"NILES","state":"MI","zip":"49120","lat":41.829036,"lng":-86.25629,"owner":"CINDY","phone":"269-687-8865","email":"evolveinniles@yahoo.com"},
  {"name":"FRAGMENTS","address":"233 S MILFORD RD","city":"HIGHLAND","state":"MI","zip":"48357","lat":42.636567,"lng":-83.617162,"owner":"CHERYL BARNES","phone":"248-887-9392","email":"matt@fragmentsstore.com"},
  {"name":"GETZ INC.","address":"218 S FRONT STREET","city":"MARQUETTE","state":"MI","zip":"49855","lat":46.542301,"lng":-87.392988,"owner":"CAROL GETZ","phone":"906-226-3561","email":"carol@getzs.com"},
  {"name":"GIGI\'S","address":"328 SOUTH LINCOLN AVE","city":"LAKEVIEW","state":"MI","zip":"48850","lat":43.442505,"lng":-85.278168,"owner":"BRENDA FREYER","phone":"616-799-5651","email":"hello@gigistravelingboutique.com"},
  {"name":"GRINS","address":"218 STATE ST","city":"SAINT JOSEPH","state":"MI","zip":"49085","lat":42.110223,"lng":-86.481335,"owner":"KAREN CHAMPASSAK","phone":"269-982-3000","email":"marchehollander@gmail.com"},
  {"name":"HANG LOOSE","address":"136 E MAUMEE ST # 9","city":"ADRIAN","state":"MI","zip":"49221","lat":41.898751,"lng":-84.035181,"owner":"DEBBIE GAUTHIER","phone":"517-902-9549","email":"hanglooseboutique@gmail.com"},
  {"name":"HAPPY HOUSE GIFT SHOP","address":"2539 JACKSON AVE","city":"ANN ARBOR","state":"MI","zip":"48103","lat":42.279676,"lng":-83.782626,"owner":"KIM ASBURY","phone":"734-662-9635","email":"kasbury@happyhousegifts.com"},
  {"name":"HULL\'S OF FRANKFORT","address":"P.O BOX 169","city":"FRANKFORT","state":"MI","zip":"49635","lat":44.613058,"lng":-86.177255,"owner":"KENNEDY MACGIRR","phone":"231-352-4642","email":"hullsoffrankfort@gmail.com"},
  {"name":"HUMMINGBIRD BTQ","address":"16644 GARDNER RD","city":"GALIEN","state":"MI","zip":"49113","lat":41.816995,"lng":-86.47464,"owner":"DEBBIE PORTER","phone":"219-771-2849","email":"drmp50@yahoo.com"},
  {"name":"INDIAN SUMMER","address":"439 S WHITTAKER ST","city":"NEW BUFFALO","state":"MI","zip":"49117","lat":41.78913,"lng":-86.739967,"owner":"ELISE MAURO","phone":"269-469-9994","email":"indiansummer@triton.net"},
  {"name":"INDIGO MOOD","address":"8519 JEFFERSON STREET","city":"PORT AUSTIN","state":"MI","zip":"48467","lat":44.041813,"lng":-82.995843,"owner":"NOREEN HABANA","phone":"989-545-0633","email":"indigomood8@gmail.com"},
  {"name":"IVY COTTAGE GIFT SHOP","address":"4868 W POLK RD","city":"HART","state":"MI","zip":"49420","lat":43.689194,"lng":-86.401697,"owner":"MARY ANN","phone":"616-920-2000","email":"maryannhoutkooper@yahoo.com"},
  {"name":"JANNY\'S BEACH HOUSE","address":"517 PHOENIX ST","city":"SOUTH HAVEN","state":"MI","zip":"49090","lat":42.403026,"lng":-86.273553,"owner":"AMY & HOLLY","phone":"269-639-2191","email":"info@jannysbeachhouse.com"},
  {"name":"KATHY JANES","address":"112 S WASHINGTON ST","city":"HALE","state":"MI","zip":"48739","lat":44.191465,"lng":-83.930299,"owner":"KATHY ALWARD","phone":"989-728-2525","email":"kathyalward1@gmail.com"},
  {"name":"KEAN\'S STORE COMPANY","address":"406 S JEFFERSON STREET","city":"MASON","state":"MI","zip":"48854","lat":42.579135,"lng":-84.443289,"owner":"JESSICA","phone":"517-676-5144","email":"keansboutique@yahoo.com"},
  {"name":"KENNEDYS","address":"4665 CASCADE ROAD SE","city":"GRAND RAPIDS","state":"MI","zip":"49546","lat":42.946338,"lng":-85.553974,"owner":"Trish Holmes","phone":"616-956-6747","email":"KENNEDYS99@AOL.COM"},
  {"name":"KIM ROSE FASHIONS","address":"12821 S SAGINAW ST, STE-D5","city":"GRAND BLANC","state":"MI","zip":"48439","lat":42.920038,"lng":-83.620289,"owner":"KIM DINGER","phone":"810-694-3455","email":"kimrosefashions@yahoo.com"},
  {"name":"LIBINS","address":"1028 E CORK ST","city":"KALAMAZOO","state":"MI","zip":"49001","lat":42.259423,"lng":-85.568952,"owner":"BRENDA PIERCE","phone":"269-381-0746","email":"libins@sbcglobal.net"},
  {"name":"LILYPEPPER BOUTIQUE","address":"200 N. COCHRAN AVE","city":"CHARLOTTE","state":"MI","zip":"48813","lat":42.564955,"lng":-84.835896,"owner":"MICHELLE TAYLOR","phone":"517-667-1888","email":"michelle@lilypep.com"},
  {"name":"LISA ANN","address":"1305 LUDINGTON STREET","city":"ESCANABA","state":"MI","zip":"49829","lat":45.74561,"lng":-87.065688,"owner":"LISA LA LONDE","phone":"906-789-5505","email":"lisalalonde79@gmail.com"},
  {"name":"M&M BOUTIQUE","address":"23150 COOLIDGE HWY","city":"OAK PARK","state":"MI","zip":"48237","lat":42.461367,"lng":-83.181053,"owner":"REGGIE MATHIS","phone":"248-547-9494","email":"mathisreginald1950@gmail.com"},
  {"name":"MARY\'S OF BOYNE - E.J.SHOPPE","address":"108 SOUTH LAKE ST","city":"BOYNE CITY","state":"MI","zip":"49712","lat":45.213599,"lng":-85.014684,"owner":"MARY FACULAC","phone":"231-357-7104","email":"maryf@twin-valley.net"},
  {"name":"MCCLUTCHY\'S","address":"3510 S STRAITS HWY","city":"INDIAN RIVER","state":"MI","zip":"49749","lat":45.374572,"lng":-84.629193,"owner":"KATHY & SAMANTHA","phone":"231-238-7712","email":"mcclutcheys@gmail.com"},
  {"name":"MI PASSION BOUTIQUE LLC","address":"229 HURON AVE","city":"PORT HURON","state":"MI","zip":"48060","lat":42.976533,"lng":-82.424351,"owner":"ANITA VARTY","phone":"810-294-5215","email":"mipassion217@gmail.com"},
  {"name":"MID MICHIGAN MEDICAL CENTER","address":"4000 WELLNESS DRIVE","city":"MIDLAND","state":"MI","zip":"48670","lat":43.634975,"lng":-84.260572,"owner":"SUSAN DALLESSANDRO","phone":"989-615-0033","email":"sue.sdallessandro@gmail.com"},
  {"name":"MY SECRET GARDEN","address":"600 SAGINAW STREET","city":"BAY CITY","state":"MI","zip":"48708","lat":43.596121,"lng":-83.889227,"owner":"GINNIE HERRMANN","phone":"989-891-2000","email":"secretgardenbc@yahoo.com"},
  {"name":"MYERS FURS & FASHIONS","address":"136 W CHISHOLM","city":"ALPENA","state":"MI","zip":"49707","lat":45.062703,"lng":-83.433556,"owner":"ELLEN GOULD","phone":"989-354-3698","email":"myersfashions@charter.net"},
  {"name":"MYRTLE MAE\'S CHIC BOUTIQUE","address":"6464 BROADMOOR AVE SE","city":"CALEDONIA","state":"MI","zip":"49316","lat":42.846647,"lng":-85.535045,"owner":"KATHY","phone":"616-698-7283","email":"Warnerdgs@aol.com"},
  {"name":"NEIGHBORS & CO","address":"204 E EDGERTON ST","city":"HOWARD CITY","state":"MI","zip":"49329","lat":43.396884,"lng":-85.468052,"owner":"LORI","phone":"616-291-1528","email":"neighborsandco@yahoo.com"},
  {"name":"NORTH COUNTRY CORNER","address":"100 OTTOWA STREET","city":"GRAYLING","state":"MI","zip":"49738","lat":44.661765,"lng":-84.716671,"owner":"PAM BARR","phone":"989-344-6000","email":"northcc_inc@yahoo.com"},
  {"name":"NORTHERN DECOR","address":"253 S BENZIE BLVD","city":"BEULAH","state":"MI","zip":"49617","lat":44.628207,"lng":-86.095536,"owner":"KITTY","phone":"231-882-7371","email":"kittyely@sbcglobal.net"},
  {"name":"PANDORA\'S BOX","address":"855 MICHIGAN AVE","city":"BALDWIN","state":"MI","zip":"49304","lat":43.896019,"lng":-85.851766,"owner":"DARCY MALDONADO","phone":"231-745-8804","email":"colecreek_llc@hotmail.com"},
  {"name":"PASSION 4 FASHION","address":"5077 VILLAGE COMMONS","city":"WEST BLOOMFIELD","state":"MI","zip":"48322","lat":42.528117,"lng":-83.383592,"owner":"RENAE TUKEL","phone":"248-789-8502","email":"passion4fashionmi@gmail.com"},
  {"name":"PEPPERBERRIES/TIME AGAIN LLC","address":"PO BOX 40","city":"SOMERSET CENTER","state":"MI","zip":"49282","lat":42.05115,"lng":-84.41356,"owner":"LINDA MICOL","phone":"517-435-2163","email":"timeagainllc@gmail.com"},
  {"name":"PERFECT STITCH","address":"6449 INKSTER","city":"BLOOMFIELD TOWNSHIP","state":"MI","zip":"48301","lat":42.544823,"lng":-83.320876,"owner":"WANDA LINKOUS","phone":"248-3436516","email":"wandalinkous@att.net"},
  {"name":"PITKIN DRUG & GIFT SHOPPE","address":"101 W COLBY STREET","city":"WHITEHALL","state":"MI","zip":"49461","lat":43.40951,"lng":-86.348062,"owner":"BECKY NORDLUND","phone":"231-893-7674","email":"pitkindrug@frontier.com"},
  {"name":"RAPUNZELS","address":"664 MAIN STREET","city":"FRANKENMUTH","state":"MI","zip":"48734","lat":43.327328,"lng":-83.740123,"owner":"TINA","phone":"989-652-0464","email":"rapunzelsboutique2@gmail.com"},
  {"name":"RIVERWALK THREADS","address":"777 W CEDAR AVENUE STE 101","city":"GLADWIN","state":"MI","zip":"48624","lat":43.980624,"lng":-84.494983,"owner":"LACEY","phone":"989-426-6730","email":"riverwalkthreads@riverwalkplace.net"},
  {"name":"RUBINA\'S BTQ","address":"4367 MILLER ROAD","city":"FLINT","state":"MI","zip":"48507","lat":42.978767,"lng":-83.764508,"owner":"RUBINA TEVIS","phone":"810-715-9255","email":"rtevis1@aol.com"},
  {"name":"SERENDIPITY","address":"8700 W FALMOUTH ROAD","city":"MC BAIN","state":"MI","zip":"49657","lat":44.2372,"lng":-85.269951,"owner":"MICHELLE","phone":"231-357-7949","email":"serendipity.cadillac@gmail.com"},
  {"name":"STUFF & SUCH","address":"PO BOX 907","city":"ELK RAPIDS","state":"MI","zip":"49629","lat":44.89556,"lng":-85.41646,"owner":"PAT","phone":"231-264-9093","email":"stuffnsuch142@att.net"},
  {"name":"SWEET CAROLINES","address":"109 MONROE ST","city":"BROOKLYN","state":"MI","zip":"49230","lat":42.264952,"lng":-84.403797,"owner":"SARA BIEDA","phone":"517-795-0471","email":"sarajbieda@yahoo.com"},
  {"name":"TAP HOUSE BO","address":"390 RIVER ST","city":"MANISTEE","state":"MI","zip":"49660","lat":44.247657,"lng":-86.323274,"owner":"MARTHA DAVIS","phone":"616-204-5117","email":"taphousebo@gmail.com"},
  {"name":"THE CLOTHING COVE","address":"414 N MAIN","city":"MILFORD","state":"MI","zip":"48381","lat":42.591132,"lng":-83.600001,"owner":"GENISE","phone":"248-685-2500","email":"clothingcove@comcast.net"},
  {"name":"THE CORAL SASH","address":"131 N LAFAYETTE ST","city":"SOUTH LYON","state":"MI","zip":"48178","lat":42.461377,"lng":-83.651858,"owner":"KAREN BACKUS","phone":"248-573-7800","email":"karbackus@aol.com"},
  {"name":"THE LADIES ROOM","address":"110 NEWMAN STREET","city":"EAST TAWAS","state":"MI","zip":"48730","lat":44.279729,"lng":-83.490269,"owner":"LISA REVALL","phone":"989-820-1362 C","email":"lisa@theladiesroom.me"},
  {"name":"THE MARSHALL SHOPPE","address":"PO BOX 156","city":"DOWAGIAC","state":"MI","zip":"49047","lat":41.98421,"lng":-86.10862,"owner":"CATHY FRANZ","phone":"269-782-7445","email":"themarshallshoppe@gmail.com"},
  {"name":"THE MOLE HOLE","address":"150 W MICHIGAN AVE","city":"MARSHALL","state":"MI","zip":"49068","lat":42.27189,"lng":-84.960288,"owner":"KRISTEN & PENNY","phone":"269-781-5923","email":"marshall150@sbcglobal.net"},
  {"name":"THIMBLEBERRY ANTIQUES","address":"PO BOX 183","city":"LINDEN","state":"MI","zip":"48451","lat":42.81447,"lng":-83.78245,"owner":"KIT MALONEY","phone":"810-735-7324","email":"jmaloney@chartermi.net"},
  {"name":"TINKER TAILOR","address":"125 RIVER ST","city":"ELK RAPIDS","state":"MI","zip":"49629","lat":44.898069,"lng":-85.412724,"owner":"RACHELE CUMMINGS","phone":"231-409-7498","email":"tinkertailor.er@gmail.com"},
  {"name":"TREASURE\'S GIFT SHOP","address":"1 ATKINSON DR","city":"LUDINGTON","state":"MI","zip":"49431","lat":43.95768,"lng":-86.43012,"owner":"KAREN POSMA","phone":"231-690-3322","email":"kpedlar@aol.com"},
  {"name":"TRENDS IN FASHION","address":"3207 FARMDALE DR","city":"STERLING HEIGHTS","state":"MI","zip":"48314","lat":42.601375,"lng":-83.077581,"owner":"JUDY LATIMER","phone":"248-202-7337","email":"trendsinfashionmi@gmail.com"},
  {"name":"TRENDZ","address":"PO BOX 69","city":"ALDEN","state":"MI","zip":"49612","lat":44.900641,"lng":-85.232932,"owner":"BRENDA/HARVEY","phone":"231-331-4845","email":"trendzapparel.alden@gmail.com"},
  {"name":"WILLERS SHOES","address":"116 W CHICAGO RD","city":"STURGIS","state":"MI","zip":"49091","lat":41.799138,"lng":-85.419239,"owner":"ELIZABETH DENMAN","phone":"269-651-6066","email":"Willers.shoes@yahoo.com"},
  {"name":"WILLOW","address":"129 E MAIN ST","city":"MIDLAND","state":"MI","zip":"48640","lat":43.613043,"lng":-84.244883,"owner":"LYNNE BLIEK","phone":"989-835-5444","email":"labliek@aol.com"},
  {"name":"WILLOW TREE FASHIONS","address":"2944 BIDDLE AVENUE","city":"WYANDOTTE","state":"MI","zip":"48192","lat":42.203837,"lng":-83.149132,"owner":"ARLENE ROSE","phone":"734-285-7020","email":"janelle@wyan.org"},
  {"name":"WOOLYBUGGERS","address":"695 MURNER ROAD","city":"GAYLORD","state":"MI","zip":"49735","lat":45.038203,"lng":-84.704443,"owner":"LINDA MORGAN","phone":"989-705-1111","email":"wolleybuggers@gmail.com"},
  {"name":"2 DOVES","address":"202 5TH AVE W","city":"ELLENDALE","state":"MN","zip":"56026","lat":43.873191,"lng":-93.301085,"owner":"GWEN REISS","phone":"507-402-0833","email":"lexus.gr59@gmail.com"},
  {"name":"ANGEL  ATTIC GIFT SHOP","address":"200 STATE AVE","city":"FARIBAULT","state":"MN","zip":"55021","lat":44.28911,"lng":-93.256499,"owner":"JULIE GLOVER","phone":"507-497-3073","email":"julie.glover@allina.com"},
  {"name":"BAGLIOS OF AFTON","address":"3290 SOUTH SAINT CROIX TRAIL","city":"AFTON","state":"MN","zip":"55001","lat":44.90088,"lng":-92.783765,"owner":"LISA","phone":"651-436-1506","email":"billisa2005@comcast.net"},
  {"name":"BENDERS SHOES AND SPORT","address":"409 NW 1ST AVE","city":"GRAND RAPIDS","state":"MN","zip":"55744","lat":47.236357,"lng":-93.530272,"owner":"KARA MORSE","phone":"218-326-3029","email":"kara.bendersshoes@gmail.com"},
  {"name":"BETWEEN FRIENDS BOUTIQUE","address":"144 S BROADWAY","city":"ALBERT LEA","state":"MN","zip":"56007","lat":43.649346,"lng":-93.368565,"owner":"BECKY JOHNSON","phone":"507-383-7481","email":"beckyjohnson@betweenfriends.boutique"},
  {"name":"BON JOS","address":"602 BROADWAY","city":"ALEXANDRIA","state":"MN","zip":"56308","lat":45.885836,"lng":-95.377938,"owner":"DENISE DROWN","phone":"320-763-5157","email":"boutique@bonjos.com"},
  {"name":"BOREAL LLC","address":"2276 COMO AVE","city":"SAINT PAUL","state":"MN","zip":"55108","lat":44.981664,"lng":-93.195164,"owner":"PEGGY MERRILL","phone":"651-560-9900","email":"peggy@boreal.life"},
  {"name":"BRITTAS BOUTIQUE","address":"204 S. MAIN ST","city":"STILLWATER","state":"MN","zip":"55082","lat":45.055598,"lng":-92.805849,"owner":"KIM ERICKSON","phone":"952-210-4147","email":"kjenisswa@gmail.com"},
  {"name":"CLOTHIER BY DAWN","address":"110 EAST MAIN","city":"PIPESTONE","state":"MN","zip":"56164","lat":44.008264,"lng":-96.099229,"owner":"DAWN HEIDEBRINK","phone":"507-825-2916","email":"clothier84@gmail.com"},
  {"name":"COLLAGE ST JAMES","address":"502 1ST AVE S","city":"SAINT JAMES","state":"MN","zip":"56081","lat":43.981363,"lng":-94.629129,"owner":"KAREN ALTENBURG","phone":"507-230-0926","email":"collagestjames@gmail.com"},
  {"name":"DIANNE\'S DOCKSIDE","address":"1716 HWY 59","city":"SLAYTON","state":"MN","zip":"56172","lat":44.097061,"lng":-95.742684,"owner":"DIANNE BARSTAD","phone":"507-763-3512","email":"diannebarstad@hotmail.com"},
  {"name":"ELM STREET BOUTIQUE","address":"PO BOX 28","city":"VERGAS","state":"MN","zip":"56587","lat":46.65694,"lng":-95.80361,"owner":"SUSAN JOHNSON","phone":"218-342-3301","email":"sjohnsonrep@yahoo.com"},
  {"name":"ESSENTIA HEALTH GIFT SHOP","address":"901 9TH STREET NORTH","city":"VIRGINIA","state":"MN","zip":"55792","lat":47.531237,"lng":-92.548815,"owner":"NANCY KEARNEY","phone":"218-749-9420","email":"nancy.kearney@essentiahealth.org"},
  {"name":"FAWBUSH\'S","address":"8201 PLEASANT AVE S","city":"BLOOMINGTON","state":"MN","zip":"55420","lat":44.855003,"lng":-93.282996,"owner":"DAVID J. RUTT","phone":"952-922-6220","email":"drutt@fawbushs.com"},
  {"name":"FROM THE GROUND UP","address":"735 HWY 212 WEST","city":"GRANITE FALLS","state":"MN","zip":"56241","lat":44.805762,"lng":-95.549413,"owner":"CATHY YOUNG","phone":"320-226-2904","email":"catyoung1021@hotmail.com"},
  {"name":"GENERAL STORE OF MINNETONKA","address":"14401 HWY 7","city":"MINNETONKA","state":"MN","zip":"55345","lat":44.921829,"lng":-93.463782,"owner":"JENNY BOLLIS","phone":"952-935-7131","email":"jenny@generalstoreofminnetonka.com"},
  {"name":"GOODTHINGS INC","address":"1855 BUERKLE ROAD","city":"WHITE BEAR LAKE","state":"MN","zip":"55110","lat":45.040007,"lng":-93.027491,"owner":"ALEXA SOMMERS","phone":"402-578-5799","email":"alexa@shopgoodthings.com"},
  {"name":"HEARTS DESIRE","address":"51 E 3RD ST","city":"WINONA","state":"MN","zip":"55987","lat":44.052316,"lng":-91.635834,"owner":"MICHELE BREZA","phone":"507-452-0175","email":"heartsdesirefinances@gmail.com"},
  {"name":"HERS","address":"111 SOUTH BROADWAY","city":"ROCHESTER","state":"MN","zip":"55904","lat":44.022421,"lng":-92.462869,"owner":"ANN","phone":"507-281-5585","email":"annburtonmn@msn.com"},
  {"name":"INSPIRED","address":"119 N MINNESOTA ST","city":"NEW ULM","state":"MN","zip":"56073","lat":44.314925,"lng":-94.460639,"owner":"CHRISTINA","phone":"507-233-4350","email":"inspirednewulm@gmail.com"},
  {"name":"JAYNE\'S HALLMARK","address":"1283 PROMENADE PLACE","city":"EAGAN","state":"MN","zip":"55121","lat":44.836349,"lng":-93.155962,"owner":"HIREN","phone":"952-221-5757","email":"h1shah@msn.com"},
  {"name":"KARENS KORNER C/O COLLEEN SEIF","address":"45299 COUNTY HWY 9","city":"PELICAN RAPIDS","state":"MN","zip":"56572","lat":46.619243,"lng":-96.103746,"owner":"COLLEEN SEIFERT","phone":"218-280-5928","email":"colleenseifert73@gmail.com"},
  {"name":"KATHRYN\'S ON MAIN","address":"117 MAIN AVENUE SOUTH","city":"PARK RAPIDS","state":"MN","zip":"56470","lat":46.92143,"lng":-95.060235,"owner":"KATHY PICKAR","phone":"218-366-2231","email":"info@kathrynsonmain.com"},
  {"name":"LESLIE\'S","address":"PO BOX 599","city":"PEQUOT LAKES","state":"MN","zip":"56472","lat":46.616147,"lng":-94.235561,"owner":"TARA L // LESLIE","phone":"218-568-5981","email":"lesliesclothes@hotmail.com"},
  {"name":"MAINSTREAM BOUTIQUE","address":"1306 CLOQUET AVE SUITE 2","city":"CLOQUET","state":"MN","zip":"55720","lat":46.721356,"lng":-92.449778,"owner":"KRISTEN ANVID","phone":"218-879-5544","email":"kanvid@mainstreamboutique.com"},
  {"name":"MAINSTREAM BOUTIQUE","address":"4729 HWY 61","city":"WHITE BEAR LAKE","state":"MN","zip":"55110","lat":45.084943,"lng":-93.011158,"owner":"KELLY ARCAND","phone":"651-209-6790","email":"karcand@mainstreamboutique.com"},
  {"name":"MAINSTREAM BOUTIQUE","address":"1635 COUNTY RD C WEST","city":"ROSEVILLE","state":"MN","zip":"55113","lat":45.023523,"lng":-93.170455,"owner":"PAMELA GRAIKA","phone":"612-723-0453","email":"pgraika@mainstreamboutique.com"},
  {"name":"MARKET MIDWEST","address":"651 PARKSIDE CT","city":"SAINT PAUL","state":"MN","zip":"55123","lat":44.778085,"lng":-93.117966,"owner":"MARK MADL","phone":"763-772-0222","email":"info@marketmidwest.com"},
  {"name":"MASON\'S ON MAIN","address":"339 THIRD ST","city":"INTERNATIONAL FALLS","state":"MN","zip":"56649","lat":48.602617,"lng":-93.404763,"owner":"NANCY IMHOF","phone":"218-283-9750","email":"masonsifalls@gmail.com"},
  {"name":"NORTH BOUND GIRL APPAREL & GIF","address":"808 WASHINGTON AVE # 5","city":"DETROIT LAKES","state":"MN","zip":"56501","lat":46.818176,"lng":-95.845485,"owner":"SHAWNA ROSE","phone":"612-327-4599","email":"nbgirl2021@gmail.com"},
  {"name":"ORTONVILLE MERCANTILE & GALLER","address":"68858 400TH STREET","city":"ORTONVILLE","state":"MN","zip":"56278","lat":45.326577,"lng":-96.340833,"owner":"SUSAN LOCKWOOD","phone":"651-315-5919","email":"ortonvillemercantile@gmail.com"},
  {"name":"PETERSON SHOES","address":"209 E MAIN ST.","city":"ANOKA","state":"MN","zip":"55303","lat":45.198146,"lng":-93.388926,"owner":"SANDRA","phone":"763-421-3433","email":"info@petersonshoes.com"},
  {"name":"SIMPLY BARBARA OF MN INC","address":"12431 278TH AVE NW","city":"ZIMMERMAN","state":"MN","zip":"55398","lat":45.473555,"lng":-93.584734,"owner":"WENDY KUPSER","phone":"763-501-3197","email":"simply.barbara@hotmail.com"},
  {"name":"THE CHARMING LILY","address":"7605 148TH ST W","city":"APPLE VALLEY","state":"MN","zip":"55124","lat":44.733867,"lng":-93.220189,"owner":"JENNIFER KNESEL","phone":"507-696-4300","email":"shopthecharminglily@gmail.com"},
  {"name":"VINTAGE ROSE","address":"11888 ABERDEEN ST NE","city":"BLAINE","state":"MN","zip":"55449","lat":45.186519,"lng":-93.233929,"owner":"CAROL BROWN","phone":"763-757-9900 S","email":"carolsrestaurant.vr@gmail.com"},
  {"name":"WHIMSY\'S BY KRISTA","address":"325 MAIN STREET SUITE #1","city":"RED WING","state":"MN","zip":"55066","lat":44.565875,"lng":-92.534682,"owner":"KRISTA BURKEL","phone":"651-385-8275","email":"kristalynn462@gmail.com"},
  {"name":"WILD GINGER BTQ","address":"320 SOUTH MAIN","city":"ZUMBROTA","state":"MN","zip":"55992","lat":44.293962,"lng":-92.668998,"owner":"ROXANNE BARTSH","phone":"507-732-4123","email":"rbartsh@gmail.com"},
  {"name":"ALISSA\'S FLOWERS & INTERIORS","address":"19321 E US HIGHWAY 40, STE H","city":"INDEPENDENCE","state":"MO","zip":"64055","lat":39.0297,"lng":-94.355545,"owner":"LISA","phone":"816-254-7727","email":"alissa@alissasflowers.com"},
  {"name":"CAROLYN\'S APPAREL","address":"1271 STATE HWY P","city":"NEW MADRID","state":"MO","zip":"63869","lat":36.67139,"lng":-89.515829,"owner":"CAROLYN FOWLER","phone":"573-748-2896","email":"raycarfowler1@gmail.com"},
  {"name":"CHARLOTTE\'S COUNTRY RUFFLE","address":"200 WEST THIRD","city":"SEDALIA","state":"MO","zip":"65301","lat":38.708866,"lng":-93.229442,"owner":"CHARLOTTE EDWARDS","phone":"660-826-9997","email":"charlottescruffle@gmail.com"},
  {"name":"DEOR ELLE","address":"406 E MAIN ST","city":"WARRENTON","state":"MO","zip":"63383","lat":38.628636,"lng":-91.055992,"owner":"DEBBIE LUECKE","phone":"636-359-3113","email":"deorelle406@gmail.com"},
  {"name":"FASHION HOUSE INTERNATIONAL","address":"109 N VETERANS BLVD","city":"BRANSON","state":"MO","zip":"65616","lat":36.644878,"lng":-93.218415,"owner":"ANETTE TUXEN","phone":"417-335-7661","email":"anettetuxen@yahoo.com"},
  {"name":"MERCY WELLNESS SHOP 15-409145","address":"15945 CLAYTON ROAD","city":"BALLWIN","state":"MO","zip":"63011","lat":38.605375,"lng":-90.587647,"owner":"JAN MERIDETH","phone":"314-251-7096","email":"jan.merideth@mercy.net"},
  {"name":"MISSISSIPPI MUD GALLERY & GIFT","address":"PO BOX 92","city":"KIMMSWICK","state":"MO","zip":"63053","lat":38.36533,"lng":-90.3629,"owner":"BETTEANNE SMITH","phone":"636-464-3360","email":"ba@msmudgallery.com"},
  {"name":"MORE EXCUSES BOUTIQUE","address":"2 NORTH MAIN","city":"LIBERTY","state":"MO","zip":"64068","lat":39.246109,"lng":-94.420345,"owner":"SUSAN DONNICI","phone":"816-781-3832","email":"moreexcusesboutique@yahoo.com"},
  {"name":"OUTRAGEOUS ATTIRE","address":"141 RIDGE CREST DR","city":"BRANSON","state":"MO","zip":"65616","lat":36.689526,"lng":-93.276633,"owner":"HOLLY JOHNSON","phone":"417-699-3453","email":"outrageousattire@yahoo.com"},
  {"name":"THE BOARDWALK / FABRIC TOWN IN","address":"1717 E CHEROKEE STREET","city":"SPRINGFIELD","state":"MO","zip":"65804","lat":37.17872,"lng":-93.263659,"owner":"RICK HAIKE","phone":"417-887-1806","email":"fabrictown@att.net"},
  {"name":"UNDER THE SUN","address":"8 SUNSET HILL DR","city":"SUNRISE BEACH","state":"MO","zip":"65079","lat":38.176202,"lng":-92.78599,"owner":"BONNIE RASMUSSEN","phone":"573-374-2001","email":"bonnie@boutiqueunderthesun.com"},
  {"name":"BLISS BOUTIQUE","address":"802 E MAIN","city":"FULTON","state":"MS","zip":"38843","lat":34.273589,"lng":-88.389278,"owner":"SHANNON","phone":"662-401-6125","email":"blissboutique1@hotmail.com"},
  {"name":"BLOSSOMS","address":"556 HWY 6 EAST","city":"BATESVILLE","state":"MS","zip":"38606","lat":34.310299,"lng":-89.935778,"owner":"MARY NELL BRIGHT","phone":"662-561-1678","email":"marynellandwanda@yahoo.com"},
  {"name":"CASTLES","address":"534 BROOKWAY BLVD","city":"BROOKHAVEN","state":"MS","zip":"39601","lat":31.580615,"lng":-90.451955,"owner":"CATHY FRANK","phone":"601-835-2323","email":"cgfranck1@yahoo.com"},
  {"name":"EXPECTATIONS TOO","address":"637 BROOKWAY BLVD","city":"BROOKHAVEN","state":"MS","zip":"39601","lat":31.579602,"lng":-90.45514,"owner":"ANGIE WARREN","phone":"601-833-5303","email":"expectations2too@gmail.com"},
  {"name":"GINGER\'S","address":"401 N FILMORE","city":"CORINTH","state":"MS","zip":"38834","lat":34.934732,"lng":-88.520701,"owner":"GINGER STOCKTON","phone":"662-286-2821","email":"gingersofcorinth@att.net"},
  {"name":"HAMMOND GIFTS","address":"405 N APPLEGATE ST","city":"WINONA","state":"MS","zip":"38967","lat":33.478595,"lng":-89.735875,"owner":"LORI CHAMBLEY","phone":"662-283-4818","email":"Hammondsgifts@yahoo.com"},
  {"name":"LEE ANN SHOPPE","address":"102 N CUMMINGS ST","city":"FULTON","state":"MS","zip":"38843","lat":34.273844,"lng":-88.409286,"owner":"KIM HARTWELL","phone":"662-862-7007","email":"leeannshoppe@gmail.com"},
  {"name":"MELANGE","address":"2311 HWY 45 NORTH","city":"COLUMBUS","state":"MS","zip":"39705","lat":33.530055,"lng":-88.437577,"owner":"DEBRA GARDNER","phone":"662-549-0850","email":"melangeatbrickerton@gmail.com"},
  {"name":"MERLE NORMAN & MORE","address":"118 W BANKHEAD","city":"NEW ALBANY","state":"MS","zip":"38652","lat":34.494217,"lng":-89.008618,"owner":"SHERRI BULLARD","phone":"662-837-8344","email":"merle8344@yahoo.com"},
  {"name":"MONOGRAMS & MORE","address":"313 HOWARD STREET","city":"GREENWOOD","state":"MS","zip":"38930","lat":33.519018,"lng":-90.18185,"owner":"GWEN J PICKETT","phone":"662-455-0006","email":"gwensmm@bellsouth.net"},
  {"name":"UPSTAIRS CLOSET","address":"136 NORFLEET DR","city":"SENATOBIA","state":"MS","zip":"38668","lat":34.623843,"lng":-89.954609,"owner":"BEVERLY MASSEY","phone":"662-562-4294","email":"upstairscloset@att.net"},
  {"name":"CRICKET CLOTHING","address":"2814 2ND AVE NORTH","city":"BILLINGS","state":"MT","zip":"59101","lat":45.782483,"lng":-108.507271,"phone":"406-698-4279","email":"lkroyer50@hotmail.com"},
  {"name":"GUSTS OF BIG TIMBER","address":"PO BOX 1169","city":"BIG TIMBER","state":"MT","zip":"59011","lat":45.834206,"lng":-109.950025,"owner":"DEBBIE","phone":"406-932-5451","email":"gustsbt@gmail.com"},
  {"name":"GYPSY WIND","address":"202 N 29TH","city":"BILLINGS","state":"MT","zip":"59101","lat":45.782428,"lng":-108.50809,"owner":"TESS","phone":"406-252-2007","email":"tess_tescher@yahoo.com"},
  {"name":"KALLY\'S KORNER","address":"102 N MAIN","city":"BUTTE","state":"MT","zip":"59701","lat":46.013745,"lng":-112.53557,"owner":"DEBBIE MCGLOIN","phone":"406-782-7157","email":"kallyskorner@msn.com"},
  {"name":"KITSON\'S","address":"100 1ST ST NORTH","city":"CASCADE","state":"MT","zip":"59421","lat":47.272234,"lng":-111.700064,"owner":"MICHELLE KITSON","phone":"406-468-2721","email":"kitsonsmt@gmail.com"},
  {"name":"ONE ELEVEN","address":"111 N HIGGINS AVE","city":"MISSOULA","state":"MT","zip":"59802","lat":46.870402,"lng":-113.995194,"owner":"PAIGE OR ALISON","phone":"406-541-7376","email":"oneeleven406@gmail.com"},
  {"name":"PALM TREE HAIR & NAIL SALON","address":"329 15TH ST","city":"BLACK EAGLE","state":"MT","zip":"59414","lat":47.52644,"lng":-111.281345,"owner":"JULIE","phone":"406-452-9509","email":"palmtreehair329@gmail.com"},
  {"name":"PLAIN JANES","address":"100 W. MAIN","city":"ENNIS","state":"MT","zip":"59729","lat":45.349018,"lng":-111.730237,"owner":"CINDY MCKITRICK","phone":"406-682-5252","email":"plainjanes@3rivers.net"},
  {"name":"R & R TRADING","address":"P.O BOX 395 / 113 NORTHERN AVE","city":"HUNTLEY","state":"MT","zip":"59037","lat":45.876735,"lng":-108.211535,"owner":"REBECCA ROBISON","phone":"406-348-2649","email":"rebeccarobison24@gmail.com"},
  {"name":"RUSSELL\'S CLOTHING","address":"12 W MONTANA","city":"BAKER","state":"MT","zip":"59313","lat":46.367742,"lng":-104.276348,"owner":"MERRI BECK","phone":"406-778-2427","email":"russells@midrivers.com"},
  {"name":"SILVER SAGE CLOTHING","address":"P.O BOX 46","city":"BROADUS","state":"MT","zip":"59317","lat":45.25719,"lng":-105.256813,"owner":"KAREN PEREEBERG","phone":"406-436-2797","email":"silversageclothing@rangeweb.net"},
  {"name":"SISTERS ON BROADWAY","address":"PO BOX 2211","city":"RED LODGE","state":"MT","zip":"59068","lat":45.241262,"lng":-109.323626,"owner":"SANDY","phone":"406-446-1024","email":"ssjwilliam@aol.com"},
  {"name":"STYLE ALLEY","address":"183 N 9TH AVE","city":"FORSYTH","state":"MT","zip":"59327","lat":46.266237,"lng":-106.679578,"owner":"ANGIE DICKERSON","phone":"406-346-2559","email":"stylealleymt@gmail.com"},
  {"name":"THE GOVERNORS KEEP","address":"1506 FRONT STREET","city":"FORT BENTON","state":"MT","zip":"59442","lat":47.817753,"lng":-110.667397,"owner":"TERRI HALKO","phone":"406-622-5130","email":"thegovernorskeep@gmail.com"},
  {"name":"THE N\' THING","address":"415 S MAIN STREET","city":"CONRAD","state":"MT","zip":"59425","lat":48.168274,"lng":-111.947145,"owner":"BONNIE POSER","phone":"406-278-5408","email":"catherineworkman202@gmail.com"},
  {"name":"108 CHURTON LLC","address":"108 SOUTH CHURTON STREET","city":"HILLSBOROUGH","state":"NC","zip":"27278","lat":36.07508,"lng":-79.099679,"owner":"JANE","phone":"919-732-4500","email":"108churton@gmail.com"},
  {"name":"A DAY IN THE COUNTRY","address":"130 SUGARLOAF RD","city":"HENDERSONVILLE","state":"NC","zip":"28792","lat":35.342354,"lng":-82.435403,"owner":"JENNIFER RHODES","phone":"828-692-7914","email":"jennifer@aditc.com"},
  {"name":"ALLURING ILLUSIONS","address":"3030 RED FOX RD","city":"NEW BERN","state":"NC","zip":"28562","lat":35.082734,"lng":-77.078706,"owner":"LYNN FAULK","phone":"252-633-0747","email":"aillusions5@gmail.com"},
  {"name":"ANNE\'S DRESS SHOP INC.","address":"349 E COPPERFIELD BLVD","city":"CONCORD","state":"NC","zip":"28025","lat":35.447035,"lng":-80.600261,"owner":"MELISSA GARDNER","phone":"704-793-4943","email":"shopannes@yahoo.com"},
  {"name":"BANANA  MOON","address":"330 N MAIN ST","city":"HENDERSONVILLE","state":"NC","zip":"28792","lat":35.31639,"lng":-82.459945,"owner":"NANCY WOOD","phone":"828-697-1941","email":"contact@moononmain.com"},
  {"name":"BIZZY BEEZ","address":"5539-102 HWY 158","city":"BERMUDA RUN","state":"NC","zip":"27006","lat":36.007475,"lng":-80.430028,"owner":"DAHLGREN ETCHISON","phone":"336-998-0341","email":"dahlgren@bizzybeez.com"},
  {"name":"BLISS BY THE LAKE","address":"126 MOORESVILLE COMMONS WAY","city":"MOORESVILLE","state":"NC","zip":"28117","lat":35.585431,"lng":-80.872378,"owner":"CHARLOTTE PARRIS","phone":"704-662-0007","email":"charlotte.parris@yahoo.com"},
  {"name":"CARRIAGE HOUSE","address":"5011 FALLS OF NEUSE STE C","city":"RALEIGH","state":"NC","zip":"27609","lat":35.849791,"lng":-78.615578,"owner":"KATHERINE TOLSON","phone":"919-876-1838","email":"katherinetolson@gmail.com"},
  {"name":"ELITE FASHIONS INC","address":"131 W WALNUT STREET","city":"GOLDSBORO","state":"NC","zip":"27530","lat":35.38359,"lng":-77.998283,"owner":"JORDAN BOGUE","phone":"919-734-6361","email":"lileliteboutique@gmail.com"},
  {"name":"FRALEIGH\'S","address":"P O BOX 245","city":"CLEMMONS","state":"NC","zip":"27012","lat":36.02153,"lng":-80.382,"owner":"DONNA MERRIMAN","phone":"336-766-7440","email":"fraleighsinclemmons@gmail.com"},
  {"name":"GRAPEVINE","address":"11 W MAIN STREET","city":"BURNSVILLE","state":"NC","zip":"28714","lat":35.917137,"lng":-82.300787,"owner":"CATY CARLIN","phone":"828-536-5166","email":"grapevinencinc@gmail.com"},
  {"name":"ISLAND BREEZE","address":"101 SHORELINE DR W","city":"SUNSET BEACH","state":"NC","zip":"28468","lat":33.883234,"lng":-78.513189,"owner":"CLARICE","phone":"910-579-4125","email":"islandbreeze@atmc.net"},
  {"name":"J. GABRIEL","address":"4 N MAIN ST","city":"WAYNESVILLE","state":"NC","zip":"28786","lat":35.489858,"lng":-82.987837,"owner":"JOSE","phone":"828-226-5212","email":"jgabrielliving@gmail.com"},
  {"name":"JULIETTES","address":"230 MIDDLE ST","city":"NEW BERN","state":"NC","zip":"28560","lat":35.105974,"lng":-77.039602,"owner":"SANDRA","phone":"252-671-0063","email":"juliettes2015@yahoo.com"},
  {"name":"LAKE LIFE","address":"2471 EATON FERRY RD","city":"LITTLETON","state":"NC","zip":"27850","lat":36.532758,"lng":-77.937782,"owner":"SHERRY DAIL","phone":"252-586-0838","email":"lakelifecc@hotmail.com"},
  {"name":"LILLY T\'S CLOTHING CO.","address":"14 W MAIN STREET","city":"BREVARD","state":"NC","zip":"28712","lat":35.23399,"lng":-82.734504,"owner":"CHRIS HANSON","phone":"828-884-3444","email":"chrishanson1515@gmail.com"},
  {"name":"LOOKING FOR LINDA","address":"5485 US 1 N","city":"VASS","state":"NC","zip":"28394","lat":35.216376,"lng":-79.327161,"owner":"NORMA BRYANT","phone":"910-695-2622","email":"preachernk1676@gmail.com"},
  {"name":"LOVE WELL BOUTIQUE","address":"110 OAKWOOD DR. SUITE D","city":"WINSTON SALEM","state":"NC","zip":"27103","lat":36.090081,"lng":-80.282874,"owner":"ANITRA MITCHELL","phone":"336-893-6589","email":"lovewellboutique.ws@gmail.com"},
  {"name":"MADISON MARKET PLACE","address":"219 S MADISON BLVD.","city":"ROXBORO","state":"NC","zip":"27573","lat":36.39316,"lng":-78.9883,"owner":"STEPHANIE GRAY","phone":"336-597-3900","email":"madisonmarketplace@embarqmail.com"},
  {"name":"MAGNOLIA \'S","address":"301 N. HOWE ST","city":"SOUTHPORT","state":"NC","zip":"28461","lat":33.920661,"lng":-78.020198,"owner":"LAURIE DRIVER","phone":"910-457-4982","email":"lauriedriver39@gmail.com"},
  {"name":"MARIE & MARCELE","address":"200 NW BROAD ST","city":"SOUTHERN PINES","state":"NC","zip":"28387","lat":35.174969,"lng":-79.390796,"phone":"910-639-9036","email":"mariemarcele@gmail.com"},
  {"name":"MCCLANAHAN\'S","address":"PO BOX 880","city":"BRYSON CITY","state":"NC","zip":"28713","lat":35.38563,"lng":-83.508554,"owner":"SHERRY SMITH","phone":"828-736-2174","email":"stay@aloftinthesmokies.com"},
  {"name":"MISS LIZZIES","address":"3708 N CROATAN HWY #3","city":"KITTY HAWK","state":"NC","zip":"27949","lat":36.059403,"lng":-75.68975,"owner":"BETH WADLE","phone":"252-261-6810","email":"beth@misslizziesobx.com"},
  {"name":"MUSTANG SALLY\'S","address":"790 OCEAN TRAIL # L","city":"COROLLA","state":"NC","zip":"27927","lat":36.323098,"lng":-75.816568,"owner":"SONNY JUNG","phone":"252-453-4749","email":"sonnyobx@gmail.com"},
  {"name":"NAUTICAL WHEELERS","address":"411 BROAD STREET","city":"ORIENTAL","state":"NC","zip":"28571","lat":35.027426,"lng":-76.697142,"owner":"CAMILLA WHEELER","phone":"252-249-0359 O","email":"camilla@nauticalwheelersnc.com"},
  {"name":"PAM\'S UNIQUE BOUTIQUE","address":"PO BOX 1349","city":"WEST JEFFERSON","state":"NC","zip":"28694","lat":36.40374,"lng":-81.49288,"owner":"PAM NEAVES","phone":"336-846-1651","email":"pamsbtq@skybest.com"},
  {"name":"PAPARAZZI","address":"2443 BATTLEGROUND AVE","city":"GREENSBORO","state":"NC","zip":"27418","lat":36.10391,"lng":-79.82662,"owner":"LEIGH ANN SEAWELL","phone":"336-282-5629","email":"spaparazzi1@aol.com"},
  {"name":"PERIWINKLES","address":"102 CHERRY ST","city":"BLACK MOUNTAIN","state":"NC","zip":"28711","lat":35.616902,"lng":-82.320956,"owner":"CONNIE PRUIT","phone":"828-664-1700","email":"periwinklesoncherrystreet@gmail.com"},
  {"name":"RAZBERRY THREADS","address":"530 N MAIN ST","city":"HENDERSONVILLE","state":"NC","zip":"28792","lat":35.318265,"lng":-82.460372,"owner":"SUSAN WEAVER","phone":"828-275-9785C","email":"susanweaver24@hotmail.com"},
  {"name":"SECRET GARDEN","address":"144 W MAIN ST","city":"WASHINGTON","state":"NC","zip":"27889","lat":35.542592,"lng":-77.05582,"owner":"SANDRA WAYT","phone":"252-661-6159","email":"secretgardengallery@gmail.com"},
  {"name":"SHE\'S A LADY","address":"4350 GEORGETOWN DR","city":"WILSON","state":"NC","zip":"27896","lat":35.776912,"lng":-77.94422,"owner":"CAROL BROWN","phone":"252-245-0194","email":"pelicans.selma@gmail.com"},
  {"name":"SISTER\'S BOUTIQUE","address":"4533 FAYETTEVILLE RD","city":"LUMBERTON","state":"NC","zip":"28358","lat":34.655777,"lng":-78.999165,"owner":"ALICIA MOODY","phone":"910-739-1189","email":"aliciamoody@bellsouth.net"},
  {"name":"SPRY CREEK","address":"1122 COROLLA VILLAGE ROAD","city":"COROLLA","state":"NC","zip":"27927","lat":36.37877,"lng":-75.832882,"owner":"KAREN WHITFIELD","phone":"252-453-0199","email":"sprycreek@gmail.com"},
  {"name":"STITCHING POST GIFTS","address":"104 S MAIN ST","city":"SALISBURY","state":"NC","zip":"28144","lat":35.667315,"lng":-80.470364,"owner":"PAM COFFIELD","phone":"704-637-0708","email":"pam@spgifts.com"},
  {"name":"SURFSIDE SPORTSWEAR & GIFT","address":"314 N NEW RIVER DR","city":"SURF CITY","state":"NC","zip":"28445","lat":34.428962,"lng":-77.541628,"owner":"PEGGY/LORI","phone":"910-328-4141","email":"surfsidesportswear@yahoo.com"},
  {"name":"THE COTTON GIN","address":"PO BOX 24","city":"JARVISBURG","state":"NC","zip":"27947","lat":36.171411,"lng":-75.862128,"owner":"CANDIE WRIGHT/ GLORIA","phone":"252-491-2387","email":"libby@cottongin.com"},
  {"name":"THE FIG LEAF, LTD","address":"P.O. BOX 2507","city":"BLOWING ROCK","state":"NC","zip":"28605","lat":36.11374,"lng":-81.66122,"owner":"SHELBY SINK","phone":"828-295-3535","email":"sinkms@bellsouth.net"},
  {"name":"THE LOOK","address":"137 HWY 107 N","city":"CASHIERS","state":"NC","zip":"28717","lat":35.114722,"lng":-83.10252,"owner":"WENDY KING","phone":"904-710-6990","email":"wendy@thelookboutique.shop"},
  {"name":"THE QUALITY SHOP","address":"1022 ROANOKE AVE","city":"ROANOKE RAPIDS","state":"NC","zip":"27870","lat":36.455155,"lng":-77.657226,"owner":"LISA TART SMITH","phone":"252-537-3041","email":"thequalityshop1022@gmail.com"},
  {"name":"VIRGINIA\'S DRESS SHOP","address":"315 SOUTH MAIN STREET","city":"KANNAPOLIS","state":"NC","zip":"28081","lat":35.493205,"lng":-80.626663,"owner":"MELANIE","phone":"704 932-5196","email":"mkeziah@virginiasinc.com"},
  {"name":"XTRA SPECIAL","address":"694 E ARLINGTON BLVD","city":"GREENVILLE","state":"NC","zip":"27858","lat":35.583163,"lng":-77.36851,"owner":"MANZER ROWE","phone":"252-756-1600","email":"manzersr@gmail.com"},
  {"name":"AASEN DRUG","address":"15 MAIN ST E","city":"MAYVILLE","state":"ND","zip":"58257","lat":47.500392,"lng":-97.326127,"owner":"GAIL AASEN","phone":"701-788-2552","email":"aasendrug2@hotmail.com"},
  {"name":"MAINSTEAM BOUTIQUE","address":"931 S WASHINGTON ST., #3","city":"BISMARCK","state":"ND","zip":"58504","lat":46.795396,"lng":-100.793988,"owner":"DOREEN KILDE","phone":"701-751-0203 s","email":"doreenkilde@gmail.com"},
  {"name":"THEODORE ROOSEVELT MEDORA FOUN","address":"P.O BOX 198","city":"MEDORA","state":"ND","zip":"58645","lat":46.9139,"lng":-103.52435,"owner":"ANNA BUSTA","phone":"701-623-4444","email":"annab@medora.com"},
  {"name":"CUMBERLANDS FASHIONS","address":"848 G STREET","city":"GENEVA","state":"NE","zip":"68361","lat":40.526092,"lng":-97.603755,"owner":"PATTY ROPER","phone":"402-759-3813","email":"pattyroseroper@gmail.com"},
  {"name":"FROCKS & FLOWERS","address":"405 COMMERCIAL ST","city":"STROMSBURG","state":"NE","zip":"68666","lat":41.114126,"lng":-97.597089,"owner":"DANA BERGGREN","phone":"402-764-0619","email":"danaa673@aol.com"},
  {"name":"KAJOMAS FASHION BOUTIQUE","address":"104 E 1ST ST","city":"PAPILLION","state":"NE","zip":"68046","lat":41.156614,"lng":-96.042672,"owner":"KIM AHLERS","phone":"402-991-4477","email":"kajomasboutique@yahoo.com"},
  {"name":"MY FAIR LADY","address":"410 WEST AVE","city":"HOLDREGE","state":"NE","zip":"68949","lat":40.438386,"lng":-99.370881,"owner":"MARGARET KRING","phone":"308-995-4520","email":"myfairladysfashions@hotmail.com"},
  {"name":"THIS AND THAT AND OTHER STUFF","address":"2826 N. MAIN ST","city":"ELKHORN","state":"NE","zip":"68022","lat":41.284147,"lng":-96.236684,"owner":"KELLI FUGLSANG","phone":"402-315-9578","email":"kelli@thisandthatandotherstuff.com"},
  {"name":"VICKERIDGE","address":"6140 HAVELOCK AVE STE A","city":"LINCOLN","state":"NE","zip":"68507","lat":40.857303,"lng":-96.636026,"owner":"TAMI SPENCE","phone":"402-466-6763","email":"TAMSPENCE@JUNO.COM"},
  {"name":"VILLAGE DESIGNS","address":"923 CENTRAL AVE","city":"AUBURN","state":"NE","zip":"68305","lat":40.392538,"lng":-95.838616,"owner":"HARRIET CLARK","phone":"402-274-4692","email":"lhclark13@gmail.com"},
  {"name":"ADORNMENTS INC.","address":"158 WAUKEWAN ST","city":"MEREDITH","state":"NH","zip":"03253","lat":43.64307,"lng":-71.522519,"owner":"LORI LOSADA","phone":"603-279-4349","email":"lorilosada09@gmail.com"},
  {"name":"ANNIE\'S HALLMARK &  BALDORIA","address":"203 SOUTH BROADWAY SUITE 5","city":"SALEM","state":"NH","zip":"03079","lat":42.764471,"lng":-71.214927,"owner":"DAWN DEVEAUX","phone":"603-898-1778","email":"Dawn@annieshallmark.com"},
  {"name":"ANYTIME APPAREL","address":"16 DEPOT SQUARE","city":"PETERBOROUGH","state":"NH","zip":"03458","lat":42.877467,"lng":-71.949213,"owner":"MELISSA CARSON","phone":"603-924-5995","email":"NO EMAIL"},
  {"name":"ARTISAN WORKSHOP","address":"PO BOX 124","city":"NEW LONDON","state":"NH","zip":"03257","lat":43.41396,"lng":-71.98508,"owner":"AMY WITMER","phone":"603-526-4227","email":"info@artisansnewlondon.com"},
  {"name":"DESIGNWARES","address":"206 MAIN ST","city":"NASHUA","state":"NH","zip":"03060","lat":42.759771,"lng":-71.464512,"owner":"MARYLOU BLAISDALE","phone":"603-882-5535","email":"designwaresnashua@msn.com"},
  {"name":"DRESSERS UNLIMITED","address":"77 MAIN STREET","city":"PLYMOUTH","state":"NH","zip":"03264","lat":43.761266,"lng":-71.687286,"owner":"CAROL DUNN","phone":"603-536-3066","email":"info@dressersunlimited.com"},
  {"name":"FRESH OF NASHUA","address":"178 MAIN ST","city":"NASHUA","state":"NH","zip":"03060","lat":42.760724,"lng":-71.46496,"owner":"CHERYL PLUNKETT","phone":"978-877-7742","email":"freshofnashua@comcast.net"},
  {"name":"GONDWANA","address":"13 N MAIN ST","city":"CONCORD","state":"NH","zip":"03301","lat":43.204345,"lng":-71.53621,"owner":"AMANDA","phone":"603-228-1101","email":"gondwana@comcast.net"},
  {"name":"IMAGINE","address":"2 CENTRAL STREET","city":"BRISTOL","state":"NH","zip":"03222","lat":43.59073,"lng":-71.73552,"owner":"NANCY SPEARS","phone":"603-744-6172","email":"imagine03222@gmail.com"},
  {"name":"J.M. PRINCEWELL","address":"127 UNION SQUARE","city":"MILFORD","state":"NH","zip":"03055","lat":42.835984,"lng":-71.649991,"owner":"JUNE COSTA","phone":"603-673-0611","email":"jmprincewellllc@gmail.com"},
  {"name":"SPRUCE HURRICANE","address":"2655 WHITE MOUNTAIN HWY","city":"NORTH CONWAY","state":"NH","zip":"03860","lat":44.053991,"lng":-71.12881,"owner":"AMBER DALTON","phone":"603-356-3854","email":"sprucehurricane@yahoo.com"},
  {"name":"BARBARA\'S","address":"14 CENTRAL SQUARE","city":"LINWOOD","state":"NJ","zip":"08221","lat":39.357848,"lng":-74.562842,"owner":"BARBARA","phone":"609-601-0035","email":"barbarasfashionexperience@gmail.com"},
  {"name":"BELLANOVA","address":"222 96TH STREET","city":"STONE HARBOR","state":"NJ","zip":"08247","lat":39.054027,"lng":-74.759041,"owner":"CATHY SCHAFFER","phone":"609-368-0606","email":"cathyschaff@gmail.com"},
  {"name":"DRESSED TO A \" T\"","address":"8107 WESTOVER WAY","city":"SOMERSET","state":"NJ","zip":"08873","lat":40.518592,"lng":-74.535266,"owner":"THERESA FERGUSON","phone":"201-669-9803 c","email":"dressedtoat@verizon.net"},
  {"name":"ISLAND DRESS STORE INC","address":"4205 LONG BEACH BLVD","city":"BRANT BEACH","state":"NJ","zip":"08008","lat":39.630537,"lng":-74.189842,"owner":"JESSICA HOFFMAN","phone":"609-494-2120","email":"lbijessica@yahoo.com"},
  {"name":"LORD IVY LTD","address":"38 BRIDGE ST","city":"FRENCHTOWN","state":"NJ","zip":"08825","lat":40.526259,"lng":-75.061488,"owner":"ROBERT GANNON","phone":"908-656-6583","email":"lordivyltd@aol.com"},
  {"name":"RONNIE\'S PLACE","address":"359 STATE ROUTE 34","city":"MATAWAN","state":"NJ","zip":"07747","lat":40.423952,"lng":-74.269457,"owner":"MS. RONNIE CHAPMAN","phone":"732-290-9092","email":"ronc900@yahoo.com"},
  {"name":"SUN SEEKERS","address":"751 ASBURY AVE","city":"OCEAN CITY","state":"NJ","zip":"08226","lat":39.280573,"lng":-74.574455,"owner":"LYNN CATTS","phone":"609-399-1640","email":"sunseekoc@comcast.net"},
  {"name":"TALK OF THE WALK","address":"PO BOX 3218","city":"MARGATE CITY","state":"NJ","zip":"08402","lat":39.32789,"lng":-74.50349,"owner":"MARC LOVITZ","phone":"609-641-4400","email":"marc@talkofthewalk.com"},
  {"name":"YOU\'RE NOT IN KANSAS ANYMORE","address":"35 PERRY ST","city":"CHESTER","state":"NJ","zip":"07930","lat":40.783793,"lng":-74.696016,"owner":"BARBARA CHUPICK","phone":"973-945-9133","email":"kansasinchester@gmail.com"},
  {"name":"ABIQUIU INN","address":"21120 HWY 84","city":"ABIQUIU","state":"NM","zip":"87510","lat":36.20834,"lng":-106.309509,"owner":"JANET","phone":"505-685-4378 S","email":"jtuten@nhihotels.com"},
  {"name":"ALL SEASONS INC","address":"PO BOX 865","city":"RED RIVER","state":"NM","zip":"87558","lat":36.665925,"lng":-105.469436,"owner":"DANIEL LAMB / MARY","phone":"575-754-2308","email":"allseasonsrrnm@taosnet.com"},
  {"name":"CAPRICHO","address":"228 OLD SANTA FE TR","city":"SANTA FE","state":"NM","zip":"87501","lat":35.685073,"lng":-105.937953,"owner":"LYDIA","phone":"505-988-2404","email":"lycaprichosa@gmail.com"},
  {"name":"DE COLORES","address":"114 1/2 OLD SANTA FE TRAIL","city":"SANTA FE","state":"NM","zip":"87501","lat":35.686528,"lng":-105.938433,"owner":"ALMAR OR HILDA","phone":"505-820-6970","email":"hilda60perez@gmail.com"},
  {"name":"GALLERIA TAMAYA CLOTHING","address":"1300 TUYUNA TRAIL","city":"SANTA ANN PUEBLO","state":"NM","zip":"87004","lat":35.351116,"lng":-106.548394,"owner":"DEBORAH","phone":"505-771-6081","email":"galleriatamaya@gmail.com"},
  {"name":"GUATEMAYA IMPORTS II","address":"115 E WATER STREET","city":"SANTA FE","state":"NM","zip":"87501","lat":35.6865,"lng":-105.939368,"owner":"GALA","phone":"505-986-0234","email":"guatemayaimports@aol.com"},
  {"name":"KIOTI","address":"564 N GUADALUPE ST","city":"SANTA FE","state":"NM","zip":"87501","lat":35.696138,"lng":-105.951103,"owner":"LINDA PRAGER","phone":"505-670-2416","email":"kiotisantafe@gmail.com"},
  {"name":"KOUNTRY KORRAL","address":"521 W NAVAJO DR","city":"HOBBS","state":"NM","zip":"88240","lat":32.739917,"lng":-103.141813,"owner":"KATHY JONES","phone":"505-392-6122","email":"kountrykorral1@gmail.com"},
  {"name":"LUCYBELL","address":"218 GALISTEO STREET","city":"SANTA FE","state":"NM","zip":"87501","lat":35.686205,"lng":-105.941316,"owner":"BLANCA A SICAN","phone":"505-204-4371","email":"araceli.sican@gmail.com"},
  {"name":"MERCADO PLAZA","address":"2004 S PLAZA ST NW","city":"ALBUQUERQUE","state":"NM","zip":"87104","lat":35.095675,"lng":-106.669614,"owner":"CARLOS PEREZ","phone":"505-930-2024","email":"cahape@gmail.com"},
  {"name":"MOXIE FAIR TRADE","address":"216 B PASEO DEL PUEBLO NORTE","city":"TAOS","state":"NM","zip":"87571","lat":36.410191,"lng":-105.571091,"owner":"DIANA KAMALA MARS","phone":"575-758-1256","email":"taosmoxie17@gmail.com"},
  {"name":"RAILYARD REBEL","address":"534 TERRACE AVE","city":"CHAMA","state":"NM","zip":"87520","lat":36.902302,"lng":-106.57916,"owner":"MICHELLE MULKEY","phone":"970-426-8931","email":"railyardrebel@gmail.com"},
  {"name":"SANTA FE HANDWOVEN DESIGNS","address":"125 E PALACE AVE","city":"SANTA FE","state":"NM","zip":"87501","lat":35.687377,"lng":-105.936691,"owner":"TAMMY MEDVEDIK","phone":"505-819-7935 C","email":"sfhwdesigns@gmail.com"},
  {"name":"SOUTHWEST INDIAN FOUNDATION","address":"100 WEST COAL AVENUE","city":"GALLUP","state":"NM","zip":"87301","lat":35.527684,"lng":-108.741457,"owner":"RUBY GURON x12","phone":"505-863-2837","email":"inventory@southwestindian.com"},
  {"name":"TEMPTATIONS OF SANTA FE","address":"112 W. SAN FRANCISCO ST # 201","city":"SANTA FE","state":"NM","zip":"87501","lat":35.687314,"lng":-105.940102,"owner":"LYDIA","phone":"505-988-8916","email":"temptationsofsantafe@gmail.com"},
  {"name":"THE EMERALD ISLE","address":"1701 CALLE DE MERCADO # 2","city":"LAS CRUCES","state":"NM","zip":"88005","lat":32.28077,"lng":-106.795339,"owner":"LOUISE AND KELLI","phone":"505-525-9178","email":"shop@eiboutique.com"},
  {"name":"THE OLD TOWN HAT SHOP","address":"205-C SAN FELIPE ST NW","city":"ALBUQUERQUE","state":"NM","zip":"87104","lat":35.220023,"lng":-106.647958,"owner":"MARLENE PATTERSON","phone":"505-242-4019","email":"owner@oldtownhats.com"},
  {"name":"VISIONS","address":"2801 SUDDERTH DR.","city":"RUIDOSO","state":"NM","zip":"88345","lat":33.332509,"lng":-105.678308,"owner":"CHERYL","phone":"575-257-2363","email":"steppinoutshoes@gmail.com"},
  {"name":"IMPRESA MISTRAL LLC","address":"PO BOX 12219","city":"ZEPHYR COVE","state":"NV","zip":"89448","lat":39.020403,"lng":-119.911397,"owner":"DALI PTAK","phone":"631-943-7828","email":"dali@im-prime.com"},
  {"name":"SOUTH POINT HOTEL AND CASINO","address":"9777 LAS VEGAS BLVD SOUTH","city":"LAS VEGAS","state":"NV","zip":"89183","lat":36.011187,"lng":-115.172266,"owner":"RUTH HALL","phone":"702-796-7111","email":"hallr@southpointcasino.com"},
  {"name":"TAPESTRY BOUTIQUE","address":"45 E WINNEMUCCA BLVD","city":"WINNEMUCCA","state":"NV","zip":"89445","lat":40.974081,"lng":-117.734505,"owner":"TAMI HENDERSON","phone":"775-625-2554","email":"tapestryboutique@gmail.com"},
  {"name":"AS TIME GOES BY","address":"23 HARTFORD MAIN STREET","city":"HARTFORD","state":"NY","zip":"12838","lat":43.362809,"lng":-73.394609,"owner":"BONNIE WILLIAMSON","phone":"518-632-5166","email":"bonniewilliamson38@gmail.com"},
  {"name":"BEV\'S FASHIONS","address":"1-3 S. MAIN ST","city":"HOMER","state":"NY","zip":"13077","lat":42.636659,"lng":-76.178179,"owner":"RENEE C NEIDERMAN","phone":"607-749-2148","email":"bevandcompany@yahoo.com"},
  {"name":"CHARLES DEPARTMENT STORE","address":"113 KATONAH AVE","city":"KATONAH","state":"NY","zip":"10536","lat":41.258088,"lng":-73.684386,"owner":"KELLY RANERI","phone":"914-232-5200","email":"info@charlesdeptstore.com"},
  {"name":"CLOTHES HORSE","address":"396 BROADWAY","city":"SARATOGA SPRINGS","state":"NY","zip":"12866","lat":43.081299,"lng":-73.785356,"owner":"JONI COLLURA","phone":"518-587-9667","email":"jcollura7@msn.com"},
  {"name":"DAFF DRY GOODS","address":"17 WASHINGTON ST","city":"ELLICOTTVILLE","state":"NY","zip":"14731","lat":42.275275,"lng":-78.671657,"owner":"LAURA SOLLY","phone":"716-699-2293","email":"daffevl@yahoo.com"},
  {"name":"DEANNA\'S","address":"P.O BOX 57","city":"WEST SAND LAKE","state":"NY","zip":"12196","lat":42.64022,"lng":-73.60328,"owner":"DIANNE KELDER","phone":"518-283-6252","email":"shopdeannas@gmail.com"},
  {"name":"ETCETERA","address":"5311 13 AVE","city":"BROOKLYN","state":"NY","zip":"11219","lat":40.632424,"lng":-73.994554,"owner":"EVA","phone":"718-435-7666","email":"etcgift@gmail.com"},
  {"name":"FANCY SCHMANCY","address":"641 LOUDON RD","city":"LATHAM","state":"NY","zip":"12110","lat":42.73306,"lng":-73.761876,"owner":"SUSANNE / APRIL","phone":"518-452-1269","email":"susannedura@hotmail.com"},
  {"name":"GG MY LOVE","address":"1 PRATT AVE","city":"CHAUTAUQUA","state":"NY","zip":"14722","lat":42.209626,"lng":-79.466932,"owner":"CHERYL GREENSTEIN","phone":"716-720-1460","email":"cherish1416@msn.com"},
  {"name":"HANDMADE & MORE","address":"6 N FRONT STREET","city":"NEW PALTZ","state":"NY","zip":"12561","lat":41.748771,"lng":-74.0852,"owner":"MELINDA","phone":"845-255-6277","email":"handmade255@gmail.com"},
  {"name":"HEART AND TOLE CREATIONS","address":"244 AIRPORT ROAD","city":"BINGHAMTON","state":"NY","zip":"13901","lat":42.188423,"lng":-75.839699,"owner":"JUDY LOTSMAN","phone":"607-765-5548","email":"judylots@stny.rr.com"},
  {"name":"HILDA\'S PLACE","address":"522 RIVERSIDE DR","city":"CLAYTON","state":"NY","zip":"13624","lat":44.242307,"lng":-76.088963,"owner":"MARTHA WALTS","phone":"315-686-4211","email":"hildasng14@gmail.com"},
  {"name":"HIP & CHIC","address":"123 ROUTE 94 SOUTH","city":"WARWICK","state":"NY","zip":"10990","lat":41.239909,"lng":-74.375808,"owner":"BARBARA SULLIVAN","phone":"845-986-4344","email":"gifts@hipandchic.com"},
  {"name":"KATHY\'S COZY CUPBOARD","address":"155 MAIN ST","city":"ONEONTA","state":"NY","zip":"13820","lat":42.453453,"lng":-75.062851,"owner":"KATHY VERRELLI","phone":"607-435-1465","email":"kathy@jimsflutes.com"},
  {"name":"LANCASTER NEW YORK STORE","address":"16 CENTRAL AVE","city":"LANCASTER","state":"NY","zip":"14086","lat":42.900972,"lng":-78.670678,"owner":"ELAINE WERNER","phone":"716-683-4374","email":"lancasternewyorkstore@gmail.com"},
  {"name":"MAIN ST ICE CREAM PARLOR INC.","address":"P.O BOX 388","city":"CHESTERTOWN","state":"NY","zip":"12817","lat":43.65257,"lng":-73.80096,"owner":"HELENA","phone":"518-494-7940","email":"hrobbins5918@gmail.com"},
  {"name":"MONTESANO\'S CLOUD NINE","address":"4178 LAKEVILLE RD","city":"GENESEO","state":"NY","zip":"14454","lat":42.7953,"lng":-77.792706,"owner":"SUSAN","phone":"585-243-1050","email":"info@cloudninefashions.net"},
  {"name":"OLDE WICKER MILL","address":"7 NEW HARTFORD SHOPPING CENTER","city":"NEW HARTFORD","state":"NY","zip":"13413","lat":43.07829,"lng":-75.291545,"owner":"BRANDON","phone":"315-724-5291","email":"laura@oldewickermill.com"},
  {"name":"PIPS","address":"89 EAST MARKET ST","city":"CORNING","state":"NY","zip":"14830","lat":42.14289,"lng":-77.050944,"owner":"DONNA GRZESICK","phone":"607-962-6301","email":"pipsboutiquecorning@gmail.com"},
  {"name":"SKI HAUS","address":"1611 RT 22","city":"BREWSTER","state":"NY","zip":"10509","lat":41.427735,"lng":-73.577907,"owner":"BEV NICHOLS","phone":"845-279-3100","email":"info@skihausonline.com"},
  {"name":"SPORTS PAGE","address":"138 QUAKER RD","city":"QUEENSBURY","state":"NY","zip":"12804","lat":43.331476,"lng":-73.661232,"phone":"518-792-1304","email":"info@sportspageski.com"},
  {"name":"STYLE COUNCEL","address":"19 MAIN STREET","city":"WARWICK","state":"NY","zip":"10990","lat":41.256776,"lng":-74.360199,"owner":"BOB MAXWELL","phone":"845-986-9588","email":"stylcnsl@warwick.net"},
  {"name":"TRULY RHE - POTENZA","address":"11 2ND ST","city":"TROY","state":"NY","zip":"12180","lat":42.731067,"lng":-73.691446,"owner":"RHE PATENZA","phone":"518-273-1540","email":"trulyrhe@gmail.com"},
  {"name":"WINTER SUN & SUMMER MOON","address":"10 E MARKET STREET","city":"RHINEBECK","state":"NY","zip":"12572","lat":41.92673,"lng":-73.912224,"owner":"LILA","phone":"845-876-3555","email":"contactus@wintersunsummermoon.com"},
  {"name":"BLOSSOMS N BOWS","address":"357 WEST AURORA ROAD","city":"NORTHFIELD","state":"OH","zip":"44067","lat":41.315087,"lng":-81.55132,"owner":"JODY ONDRUS","phone":"330-908-1799","email":"bnbjo@att.net"},
  {"name":"BREEZEWOOD GARDENS & GIFTS","address":"17600 CHILLICOTHE RD","city":"CHAGRIN FALLS","state":"OH","zip":"44023","lat":41.390211,"lng":-81.339397,"owner":"M. WEAVER","phone":"440-543-2124","email":"breezewoodgiftshop@gmail.com"},
  {"name":"CASA BELLA GIFTS","address":"7527 EAST PIKE","city":"NORWICH","state":"OH","zip":"43767","lat":39.973519,"lng":-81.848523,"owner":"TAMMY MATHEWS","phone":"740-455-3040","email":"info@casabellagifts.com"},
  {"name":"GALES GARDEN CENTER","address":"2730 SOM CENTER RD","city":"WILLOUGHBY","state":"OH","zip":"44094","lat":41.490446,"lng":-81.437483,"owner":"SARAH ENGLAND","phone":"440-944-6066","email":"galeswillo@aol.com"},
  {"name":"MISTY BAY BOUTIQUE","address":"210 DELAWARE AVE","city":"PUT IN BAY","state":"OH","zip":"43456","lat":41.652806,"lng":-82.817048,"owner":"MARYANN/ANITA McCANN","phone":"419-285-4595","email":"islandpib60@gmail.com"},
  {"name":"MY FAVORITE THINGS BOUTIQUE","address":"1054 CENTRAL AVE","city":"MIDDLETOWN","state":"OH","zip":"45044","lat":39.516387,"lng":-84.403768,"owner":"ANNE POTTEIGER","phone":"937-232-4191","email":"myfavoritethingsmiddletown@gmail.com"},
  {"name":"NEWPORT CLOTHING & GEAR","address":"4066 EAST HARBOR RD","city":"PORT CLINTON","state":"OH","zip":"43452","lat":41.523269,"lng":-82.854602,"owner":"CINDIE STANFIELD","phone":"419-734-7082","email":"mail@newportdrygoods.com"},
  {"name":"OH SUZANNA","address":"16 SOUTH BROADWAY","city":"LEBANON","state":"OH","zip":"45036","lat":39.43408,"lng":-84.208137,"owner":"SONYA STAFFAN","phone":"513-932-8246","email":"s.sonya@jamandjellylady.com"},
  {"name":"SOPHIA BTQ","address":"7578 FREDLE RD","city":"PAINESVILLE","state":"OH","zip":"44077","lat":41.664728,"lng":-81.241505,"owner":"TERI","phone":"440-488-9233","email":"sophiaboutique.og@gmail.com"},
  {"name":"THE GARDEN GATE","address":"24149 FRONT ST","city":"GRAND RAPIDS","state":"OH","zip":"43522","lat":41.412184,"lng":-83.866918,"owner":"DEBORAH HERTZFELD","phone":"419-832-4283","email":"dlynne.hertzfeld@gmail.com"},
  {"name":"THREADS","address":"2451 W. MARKET STREET","city":"TIFFIN","state":"OH","zip":"44883","lat":41.109634,"lng":-83.217291,"owner":"KELLI DARIANO","phone":"419-448-4054","email":"threads@threadstiffin.com"},
  {"name":"TRE BRI BOUTIQUE","address":"1480 N 21ST ST","city":"NEWARK","state":"OH","zip":"43055","lat":40.087991,"lng":-82.426921,"owner":"TERESA","phone":"740-366-4031","email":"trebriboutique@gmail.com"},
  {"name":"UNIVERSAL SCREEN ARTS, INC","address":"5581 HUDSON INDUSTRIAL PARKWAY","city":"HUDSON","state":"OH","zip":"44236","lat":41.212858,"lng":-81.428191,"phone":"330-650-5000","email":"invpayable@woecatalog.com"},
  {"name":"VITA BOUTIQUE","address":"1289 EDISON ST NW","city":"HARTVILLE","state":"OH","zip":"44632","lat":40.975354,"lng":-81.361892,"owner":"ELIZABETH","phone":"330-877-9227","email":"vitagirls@gmail.com"},
  {"name":"WEATHER VANE","address":"103 SCOTT LANE","city":"GAMBIER","state":"OH","zip":"43022","lat":40.376697,"lng":-82.397811,"owner":"JEAN WYATT","phone":"740-427-3636","email":"jeanwyatt@live.com"},
  {"name":"ZIG ZAG GALLERY","address":"101 E ALEX BELL # 154","city":"DAYTON","state":"OH","zip":"45459","lat":39.442095,"lng":-84.360029,"owner":"KIMBERLY MEGGINSON","phone":"937-434-3565","email":"shop@zigzaggallery.com"},
  {"name":"KRISTA ANNE\'S","address":"7602 N MAY AVE","city":"OKLAHOMA CITY","state":"OK","zip":"73116","lat":35.548285,"lng":-97.565206,"owner":"KRISTA SOUTHER","phone":"828-712-6239","email":"contact@kristaannes.com"},
  {"name":"LA DEE DA","address":"428 FLYNN ST","city":"ALVA","state":"OK","zip":"73717","lat":36.805069,"lng":-98.664548,"owner":"DEE WIEBENER","phone":"580-327-0382","email":"deealvaladeeda@outlook.com"},
  {"name":"LADY AUSTIN\'S","address":"107 W. COMMERCE STREET","city":"ALTUS","state":"OK","zip":"73521","lat":34.638737,"lng":-99.334001,"owner":"LESLIE BRISCOE","phone":"580-477-0122","email":"ladyaustinsofaltus@gmail.com"},
  {"name":"MARIA\'S GARDEN","address":"112 WHEELER ST","city":"ARDMORE","state":"OK","zip":"73401","lat":34.173807,"lng":-97.141309,"owner":"MARIA WILKINSON","phone":"580-223-2500","email":"maria@mariasgarden.net"},
  {"name":"MARIE\'S","address":"134 W MAIN ST, STE-B","city":"DURANT","state":"OK","zip":"74701","lat":33.990982,"lng":-96.376688,"owner":"ANNETTE ARMSTRONG","phone":"580-924-3205","email":"marieandannette@sbcglobal.net"},
  {"name":"MERLE NORMAN","address":"419 NORTH MAIN","city":"GUYMON","state":"OK","zip":"73942","lat":36.682007,"lng":-101.481407,"owner":"RONDA PURVINES","phone":"580-338-3020","email":"mncsok@gmail.com"},
  {"name":"NELSON\'S CLOTHIER","address":"10051 S YALE AVE # 105","city":"TULSA","state":"OK","zip":"74137","lat":36.018025,"lng":-95.921277,"owner":"HAILEY NELSON","phone":"918-299-6565","email":"hailey@nelsonsclothier.com"},
  {"name":"SHARPES #1","address":"PO BOX 328","city":"CHECOTAH","state":"OK","zip":"74426","lat":35.492196,"lng":-95.517816,"owner":"SHELLY DUBOSE","phone":"870-364-3344","email":"support@sharpeclothing.com"},
  {"name":"SHOE BAZAAR","address":"704 S BROADWAY ST","city":"MARLOW","state":"OK","zip":"73055","lat":34.640223,"lng":-97.957682,"owner":"ROVENA BROWN","phone":"580-658-6572","email":"shoebazaar@ymail.com"},
  {"name":"STEPHANIE\'S BEAUTIQUE","address":"207 W MAIN","city":"ARDMORE","state":"OK","zip":"73401","lat":33.937102,"lng":-97.11815,"owner":"STEPHANIE G BAKER","phone":"580-226-2630","email":"stephaniesbeautique@yahoo.com"},
  {"name":"THE AMBER ROSE","address":"1014 MAIN","city":"WOODWARD","state":"OK","zip":"73801","lat":36.436105,"lng":-99.392084,"owner":"AMBER - LORIE","phone":"580-334-2416 C","email":"amberkheflin@gmail.com"},
  {"name":"ZELLA\'S","address":"6967 S LEWIS AVE","city":"TULSA","state":"OK","zip":"74136","lat":36.062697,"lng":-95.957781,"owner":"SUSAN STARLING","phone":"918-794-4444","email":"starling.susan@gmail.com"},
  {"name":"541 TRENDS","address":"190 NE IRVING AVE STE 2","city":"BEND","state":"OR","zip":"97701","lat":44.059126,"lng":-121.304169,"owner":"MATINA","phone":"541-385-8921","email":"matina@541trends.com"},
  {"name":"BELLISMA","address":"708 \"O\" AVE","city":"LA GRANDE","state":"OR","zip":"97850","lat":45.324494,"lng":-118.099764,"owner":"LUCY","phone":"858-705-7403","email":"lucy_frederick@yahoo.com"},
  {"name":"FOLKWAYS","address":"2490 WILLAMETTE STREET","city":"EUGENE","state":"OR","zip":"97405","lat":44.031874,"lng":-123.091232,"owner":"VICKI SINGER","phone":"541-915-3176 C","email":"folkways@comcast.net"},
  {"name":"KIXX","address":"264 E MAIN STREET","city":"ASHLAND","state":"OR","zip":"97520","lat":42.19551,"lng":-122.711944,"owner":"SHELLY KLUG","phone":"541-488-4435","email":"kixxclothing@hotmail.com"},
  {"name":"MINDY\'S","address":"296 E 5TH AVE STE 227","city":"EUGENE","state":"OR","zip":"97401","lat":44.053846,"lng":-123.088594,"owner":"MINDY","phone":"541-344-7132","email":"mindysnpf@aol.com"},
  {"name":"PAINTED FRINGE BOUTIQUE LLC","address":"438 MOUNTAIN VIEW","city":"LAKEVIEW","state":"OR","zip":"97630","lat":42.183864,"lng":-120.35374,"owner":"TILLIE FLYNN","phone":"541-219-0918","email":"contact@paintedfringeboutique.com"},
  {"name":"RHONDA STEELE","address":"1711 WILLAMETTE ST","city":"EUGENE","state":"OR","zip":"97401","lat":44.040752,"lng":-123.09258,"owner":"RHONDA","phone":"541-521-2918","email":"rsteele0824@gmail.com"},
  {"name":"YOUR CLOTHING SOLUTION","address":"15989 SW 129TH TERRACE","city":"PORTLAND","state":"OR","zip":"97224","lat":45.40425,"lng":-122.809741,"owner":"PAMELA WAGNER","phone":"503-453-3285","email":"yourclothingsolution@gmail.com"},
  {"name":"AJ\'S IN THE COLONY PLAZA","address":"2636 W 8TH STREET","city":"ERIE","state":"PA","zip":"16505","lat":42.106119,"lng":-80.142851,"owner":"AJ","phone":"814-838-2643","email":"westlake2636@gmail.com"},
  {"name":"AMY\'S CLOSET","address":"313 13TH STREET","city":"FRANKLIN","state":"PA","zip":"16323","lat":41.398443,"lng":-79.831105,"owner":"AMY WHITEHILL","phone":"814-346-0269","email":"sfelmlee@msn.com"},
  {"name":"ARTISANS ON THE AVENUE","address":"8440 GERMANTOWN AVE","city":"PHILADELPHIA","state":"PA","zip":"19118","lat":40.075657,"lng":-75.206309,"owner":"GEORGIA DOYLE","phone":"215-381-0582","email":"artisansontheave@yahoo.com"},
  {"name":"ARTS FOR HIM AND HER TOO","address":"843 MAIN ST","city":"HONESDALE","state":"PA","zip":"18431","lat":41.572929,"lng":-75.255806,"owner":"KELLY or GAIL","phone":"570-253-3080","email":"tgfasshauer@hotmail.com"},
  {"name":"BETSY\'S OF LIGONIER","address":"131 W MAIN STREET","city":"LIGONIER","state":"PA","zip":"15658","lat":40.243315,"lng":-79.238946,"owner":"DEBBIE SARAULT","phone":"724-238-4770","email":"debbie@betsysofligonier.com"},
  {"name":"CATHY\'S BOUTIQUE","address":"3839 MARSH RD","city":"GARNET VALLEY","state":"PA","zip":"19060","lat":39.832472,"lng":-75.478276,"owner":"CATHY MOLIQUE","phone":"610-202-3639","email":"moliqueboutique@gmail.com"},
  {"name":"CLEMINTINES","address":"25 E MAIN STREET","city":"LITITZ","state":"PA","zip":"17543","lat":40.157278,"lng":-76.306259,"owner":"DONNA GIRVIN","phone":"717-626-6688","email":"dkgirvin@gmail.com"},
  {"name":"COLONY CLASSICS","address":"1605 E. 3RD ST","city":"WILLIAMSPORT","state":"PA","zip":"17701","lat":41.251034,"lng":-76.97459,"owner":"CARL DASKINS","phone":"570-327-1989","email":"colonyclassics@comcast.net"},
  {"name":"CONNIE BARTO","address":"75 OAK TREE RD","city":"HUMMELSTOWN","state":"PA","zip":"17036","lat":40.31374,"lng":-76.715242,"owner":"CONNIE BARTO","phone":"717-576-0407","email":"HEADTOTOE29@YAHOO.COM"},
  {"name":"CROSSROADS BOUTIQUE","address":"24 W 2ND STREET","city":"GREENSBURG","state":"PA","zip":"15601","lat":40.301427,"lng":-79.544447,"owner":"CAROL GAFFEY","phone":"724-832-8900","email":"crossroadscattiva@comcast.net"},
  {"name":"DS NAILS AND JEWELS","address":"377 EDGEHILL RD","city":"YORK","state":"PA","zip":"17403","lat":39.93838,"lng":-76.705951,"owner":"DEB SCHILLING","phone":"717-487-1021","email":"dixie377.ds@gmail.com"},
  {"name":"DUNKELBERGERS","address":"585 MAIN STREET","city":"STROUDSBURG","state":"PA","zip":"18360","lat":40.985877,"lng":-75.192874,"owner":"TRICIA FRITZ","phone":"570-421-7950","email":"dunkwomen@ptd.net"},
  {"name":"ENDLESS SUMMER","address":"232 W CENTRAL AVE","city":"TITUSVILLE","state":"PA","zip":"16354","lat":41.627341,"lng":-79.676636,"owner":"SHANNON NIKOLAISON","phone":"814-827-0119","email":"s.nik12@yahoo.com"},
  {"name":"FASHION SHOP","address":"41 WEST HIGH STREET","city":"WAYNESBURG","state":"PA","zip":"15370","lat":39.896338,"lng":-80.187346,"owner":"CHRIS","phone":"724-627-7407","email":"fashionshop@windstream.net"},
  {"name":"GOLD RUSH JEWELERS INC","address":"3135 NEW GERMANY RD SUITE 38","city":"EBENSBURG","state":"PA","zip":"15931","lat":40.46499,"lng":-78.751081,"owner":"KRISTEN SOSSONG","phone":"814-472-6500","email":"kristen.grd@gmail.com"},
  {"name":"JONESY\'S ACCESSORIES","address":"7916 GERMANTOWN AVE","city":"PHILADELPHIA","state":"PA","zip":"19118","lat":40.069754,"lng":-75.200342,"owner":"JOAN P","phone":"267-972-2042","email":"jonesysaccessories@gmail.com"},
  {"name":"LA BELLA VITA","address":"42 NORTH MAIN STREET","city":"NEW HOPE","state":"PA","zip":"18938","lat":40.365822,"lng":-74.951792,"owner":"CANDACE PARYZER","phone":"215-862-7008","email":"labellavita23@yahoo.com"},
  {"name":"LSL BRANDS","address":"PO BOX 427","city":"LAHASKA","state":"PA","zip":"18931","lat":40.328645,"lng":-75.10278,"owner":"JODI WHARTENBY","phone":"215-794-2948","email":"jw@laceemail.com"},
  {"name":"MAC\'S CLOTHING","address":"2679 INDUSTRIAL PARK","city":"MIFFLINTOWN","state":"PA","zip":"17059","lat":40.581194,"lng":-77.367883,"owner":"COLLEEN WILLIAMS","phone":"717-436-2440","email":"macclo@embarqmail.com"},
  {"name":"N JOY BTQ","address":"96 BUCK ROAD","city":"HOLLAND","state":"PA","zip":"18966","lat":40.169928,"lng":-74.988203,"owner":"ALLA TETELMAN","phone":"215-364-4128","email":"njoyboutique@yahoo.com"},
  {"name":"NATURALLY YOURS","address":"81 BROADWAY, SUITE: 2","city":"JIM THORPE","state":"PA","zip":"18229","lat":40.863684,"lng":-75.740856,"owner":"JUNE GAUDREAU","phone":"484-707-6424","email":"jegaudreau@aol.com"},
  {"name":"POLKADOTS","address":"29 LEOPART RD.","city":"PAOLI","state":"PA","zip":"19301","lat":40.039145,"lng":-75.47563,"owner":"SUSAN","phone":"610-640-2714","email":"info@shopatpolkadots.com"},
  {"name":"PURSUITS","address":"740 FILBERT ST","city":"PITTSBURGH","state":"PA","zip":"15232","lat":40.45162,"lng":-79.9332,"owner":"MARIA MCMANUS","phone":"412-688-8822","email":"maria5284@comcast.net"},
  {"name":"RELIABLE HOME SUPPLY","address":"217 SUNBURY ST","city":"MINERSVILLE","state":"PA","zip":"17954","lat":40.690922,"lng":-76.260943,"owner":"COOKIE","phone":"570-544-5990","email":"reliablehomesupply@comcast.net"},
  {"name":"ROSE STYLE SHOP","address":"906 LIGONIER STREET","city":"LATROBE","state":"PA","zip":"15650","lat":40.31632,"lng":-79.384239,"owner":"RONDA SOETZ","phone":"724-537-6218","email":"rosestyleshoppe32@gmail.com"},
  {"name":"RUTHIE\'S APPAREL","address":"2687 OLD PHILADELPHIA PIKE","city":"BIRD IN HAND","state":"PA","zip":"17505","lat":40.038774,"lng":-76.180782,"owner":"RUTH CARPENTER","phone":"717-392-4848","email":"info@ruthiesapparelllc.com"},
  {"name":"SHIRLEY SHOPPE","address":"659 3RD STREET","city":"BEAVER","state":"PA","zip":"15009","lat":40.694869,"lng":-80.305212,"owner":"ARLENE TARN","phone":"724-774-5340","email":"john@shirleyshoppe.com"},
  {"name":"SOUTH STREET BOTANICAL DESIGNS","address":"130 SOUTH STREET","city":"RIDGWAY","state":"PA","zip":"15853","lat":41.418993,"lng":-78.730117,"owner":"BRANDY BUEHLER","phone":"814-594-2782","email":"floralmasters@windstream.net"},
  {"name":"SUSIE\'S - STALEX INC","address":"2511 S QUEEN ST","city":"YORK","state":"PA","zip":"17402","lat":39.91222,"lng":-76.681906,"owner":"SUE","phone":"717-741-4511","email":"fashionsue@gmail.com"},
  {"name":"SUSIE\'S FASHIONS","address":"PO BOX 266","city":"HYDE","state":"PA","zip":"16843","lat":41.003007,"lng":-78.464189,"owner":"SUSAN SCHULTZ","phone":"814-765-2711","email":"sue.schultz@verizon.net"},
  {"name":"THE FINERY","address":"679 PHILADELPHIA ST","city":"INDIANA","state":"PA","zip":"15701","lat":40.622797,"lng":-79.152705,"owner":"JOHANNA LEACH","phone":"724-349-4091","email":"finery2@comcast.net"},
  {"name":"THE SUNFLOWER SHOP","address":"1660 E STREET ROAD","city":"KENNETT SQUARE","state":"PA","zip":"19348","lat":39.882416,"lng":-75.652883,"owner":"JOAN APPLEGATE","phone":"610-574-0042 C","email":"jjapplelg@verizon.net"},
  {"name":"THE SWEATER MILL","address":"115 S YORK ROAD","city":"HATBORO","state":"PA","zip":"19040","lat":40.175205,"lng":-75.106579,"owner":"JOE KORNFIELD","phone":"215-441-8966","email":"thesweaterlady@comcast.net"},
  {"name":"THE WINNER","address":"32 W STATE ST","city":"SHARON","state":"PA","zip":"16146","lat":41.233263,"lng":-80.509717,"owner":"AMANDA COWAN","phone":"724-346-9466","email":"amandac@thewinneroutlet.com"},
  {"name":"UPPERS & DOWNERS","address":"1201 N MAYFIELD DRIVE","city":"CLARION","state":"PA","zip":"16214","lat":41.195605,"lng":-79.376734,"owner":"DEBBIE MILES","phone":"814-229-8329","email":"dmiles56@gmail.com"},
  {"name":"BAGS BY IRIS","address":"93 MAIN ST","city":"EAST GREENWICH","state":"RI","zip":"02818","lat":41.662669,"lng":-71.450279,"owner":"IRIS GESUALDI","phone":"401-885-3557","email":"bagsbyiris@aol.com"},
  {"name":"COLA RE\'S","address":"1375 MINERAL SPRING AVE","city":"NORTH PROVIDENCE","state":"RI","zip":"02904","lat":41.867374,"lng":-71.439065,"owner":"CORRINE BARBATO-COLA","phone":"401-487-4403","email":"corral67@aol.com"},
  {"name":"FEMININE FANCIES","address":"290 COUNTY ROAD","city":"BARRINGTON","state":"RI","zip":"02806","lat":41.740687,"lng":-71.309374,"owner":"ELAINE FELAG","phone":"401-247-1087","email":"femininefanciesri@gmail.com"},
  {"name":"GREEN INK","address":"89 BROWN STREET","city":"WICKFORD","state":"RI","zip":"02852","lat":41.571065,"lng":-71.452085,"owner":"BETHANY","phone":"401-294-6266","email":"bethany@greeninkboutique.com"},
  {"name":"BEACH DESIGNS","address":"PO BOX 3737","city":"NORTH MYRTLE BEACH","state":"SC","zip":"29582","lat":33.838529,"lng":-78.660551,"owner":"KATHY ROBBINSONS","phone":"843-281-2880","email":"beachdesigns@atmc.net"},
  {"name":"CLASSY COLLECTIONS","address":"1101 3RD AVE","city":"CONWAY","state":"SC","zip":"29526","lat":33.834457,"lng":-79.047177,"owner":"VICTORIA MORGAN","phone":"843-254-7395","email":"victoria@sccoast.net"},
  {"name":"EAST WINDS","address":"134 S MAIN ST","city":"SUMMERVILLE","state":"SC","zip":"29483","lat":33.019551,"lng":-80.176042,"owner":"ANNE SUTTON","phone":"843-875-8985","email":"anne.g.sutton@icloud.com"},
  {"name":"ECHO BOUTIQUE","address":"164 HWY 274","city":"LAKE WYLIE","state":"SC","zip":"29710","lat":35.119935,"lng":-81.080609,"phone":"803-746-5656","email":"shop@echo-boutique.com"},
  {"name":"ELEGANTZ","address":"10880 OCEAN HWY #6","city":"PAWLEYS ISLAND","state":"SC","zip":"29585","lat":33.443311,"lng":-79.123379,"owner":"SAUNDRA CHAPMAN","phone":"843-979-0072 s","email":"schapman1959@gmail.com"},
  {"name":"HARLEY\'S DRESS SHOPPE","address":"122 ALABAMA AVE","city":"CHESNEE","state":"SC","zip":"29323","lat":35.147707,"lng":-81.860756,"owner":"MARGARET MCKINNEY","phone":"864-461-7216","email":"harleysdressshoppe@gmail.com"},
  {"name":"LADY J PETITES","address":"2131 WOODRUFF ROAD","city":"GREENVILLE","state":"SC","zip":"29607","lat":34.82108,"lng":-82.258617,"owner":"JAN STANLEY","phone":"864-234-7766"},
  {"name":"MARIANI\'S BOUTIQUE","address":"3604 B PELHAM ROAD","city":"GREENVILLE","state":"SC","zip":"29615","lat":34.859522,"lng":-82.270449,"owner":"MARY ANN SUDNICK","phone":"864-297-7227","email":"maryann@marianisboutique.com"},
  {"name":"NUANCES","address":"918 8TH STREET","city":"PORT ROYAL","state":"SC","zip":"29935","lat":32.374738,"lng":-80.692407,"owner":"LAURIE THOMPSON","phone":"843-470-1110","email":"nuancesofportroyal@gmail.com"},
  {"name":"THE PINK PINEAPPLE","address":"841 WILLIAM HILTON PARKWAY, #B","city":"HILTON HEAD ISLAND","state":"SC","zip":"29928","lat":32.173191,"lng":-80.732377,"owner":"SUSAN DAVIS","phone":"843-715-0634","email":"support@pinkpineapplehhi.com"},
  {"name":"VICTORIA SUSAN","address":"411 RUTLEDGE ST","city":"CAMDEN","state":"SC","zip":"29020","lat":34.244739,"lng":-80.604441,"owner":"LINDA SOWELL","phone":"803-432-5997","email":"victoriasusanwearableart@gmail.com"},
  {"name":"AL\'S OASIS","address":"1000 EAST SOUTH DAKOTA HWY 16","city":"OACOMA","state":"SD","zip":"57365","lat":43.803334,"lng":-99.381904,"owner":"JOSEE SUESS-CARLIN","phone":"605-234-6051","email":"josee@midstatesd.net"},
  {"name":"FLORAL & FINDS","address":"P.O BOX 198","city":"CLEAR LAKE","state":"SD","zip":"57226","lat":44.761249,"lng":-96.690651,"owner":"MARGIT FRITZ","phone":"605-874-4224","email":"floralsandfinds@gmail.com"},
  {"name":"FOUND BY WEATHERED VANE","address":"719 MOUNTAIN VIEW RD","city":"RAPID CITY","state":"SD","zip":"57702","lat":44.079304,"lng":-103.253596,"owner":"JANET & MARLOW","phone":"605-348-8154","email":"janet@weatheredvane.com"},
  {"name":"IRON CREEK LEATHERS INC","address":"126 WINTER STREET","city":"KEYSTONE","state":"SD","zip":"57751","lat":43.892784,"lng":-103.425524,"owner":"LISA SCHAFFER","phone":"303-817-6808","email":"ironcreek126@gmail.com"},
  {"name":"LAMODE DRESS SHOP","address":"620 N MAIN STREET","city":"SPEARFISH","state":"SD","zip":"57783","lat":44.489398,"lng":-103.858886,"owner":"TANYA CRAGO","phone":"605-642-2530","email":"ctcrago@yahoo.com"},
  {"name":"LIFESTYLES","address":"502 STATE STREET","city":"BELLE FOURCHE","state":"SD","zip":"57717","lat":44.671296,"lng":-103.853183,"owner":"LORI FOOS","phone":"605-892-3736","email":"lrf@rushmore.com"},
  {"name":"LINDA\'S ANGEL CROSSING","address":"1101 BROADWAY AVE #103B","city":"YANKTON","state":"SD","zip":"57078","lat":42.881915,"lng":-97.397033,"owner":"LINDA STEPHENSON","phone":"605-665-0080","email":"lindascrossing@aol.com"},
  {"name":"LINDA\'S INC","address":"101 S MAIN","city":"MILBANK","state":"SD","zip":"57252","lat":45.221322,"lng":-96.63552,"owner":"LINDA BURI","phone":"605-432-5591","email":"lindasfashions5591@gmail.com"},
  {"name":"MARTY\'S","address":"210 S MAIN STREET","city":"WINNER","state":"SD","zip":"57580","lat":43.376223,"lng":-99.856736,"owner":"MARTY FLAKUS","phone":"605-842-3130","email":"martys@goldenwest.net"},
  {"name":"ACCENTS","address":"1238 TAFT HIGHWAY SUITE 106","city":"SIGNAL MOUNTAIN","state":"TN","zip":"37377","lat":35.139904,"lng":-85.327631,"owner":"KARIE HOLMES","phone":"428-886-0062","email":"accentsonsignal@yahoo.com"},
  {"name":"CARRIAGE HOUSE","address":"505 EAST CENTER STREET","city":"KINGSPORT","state":"TN","zip":"37660","lat":36.544755,"lng":-82.555768,"owner":"TERESA WILLIS","phone":"423-247-9091","email":"mail@carriagehousekpt.com"},
  {"name":"CELLAR ON MAIN","address":"344 MAIN STREET","city":"FRANKLIN","state":"TN","zip":"37064","lat":35.924816,"lng":-86.870054,"owner":"MELISSA SWARTZ","phone":"615-790-9803","email":"cellaronmain@gmail.com"},
  {"name":"CREATIVE ACCENTS","address":"1316 MAIN ST.","city":"HUMBOLDT","state":"TN","zip":"38343","lat":35.819721,"lng":-88.917586,"owner":"BETTIE HENSLEY","phone":"731-222-1112","email":"bfhensley2@bellsouth.net"},
  {"name":"FOUR THIRTEEN BOUTIQUE","address":"818 SOUTH HWY 51","city":"TROY","state":"TN","zip":"38260","lat":36.331811,"lng":-89.165264,"owner":"VONDA CARY","phone":"731-536-4130","email":"fourthirteenboutique@outlook.com"},
  {"name":"KAUFMAN SHOES","address":"6515 POPLAR AVE, SUITE 101","city":"MEMPHIS","state":"TN","zip":"38119","lat":35.098843,"lng":-89.846069,"owner":"JESSICA SPIRES","phone":"901-323-2616","email":"kaufman6515@gmail.com"},
  {"name":"KISSING KUZINS","address":"825 EARL BAXTER RD","city":"CHUCKEY","state":"TN","zip":"37641","lat":36.360349,"lng":-82.673483,"owner":"DONNA HANSEN","phone":"423-276-4067","email":"donasarajosh13@gmail.com"},
  {"name":"MERLE NORMAN STUDIO","address":"11664 HWY 51 SOUTH","city":"ATOKA","state":"TN","zip":"38004","lat":35.44051,"lng":-89.791169,"owner":"CAROL SWIFT","phone":"901-482-5879","email":"ctlscs@yahoo.com"},
  {"name":"SHERRY\'S INTERIORS","address":"339 WEST MAIN ST","city":"PARSONS","state":"TN","zip":"38363","lat":35.649567,"lng":-88.132792,"owner":"SHERRY LEITCH","phone":"731-847-9000","email":"sherry@sherrysinteriors.net"},
  {"name":"SIRRABELLE BOUTIQUE","address":"318 LAKESIDE PLAZA","city":"LOUDON","state":"TN","zip":"37774","lat":35.684834,"lng":-84.26471,"owner":"LEAH","phone":"865-408-8124","email":"sirrabelle@gmail.com"},
  {"name":"THE SILK PURSE","address":"4617 JAY WAY","city":"KNOXVILLE","state":"TN","zip":"37909","lat":35.952467,"lng":-83.987045,"owner":"MORT GARDNER","phone":"865-216-4818","email":"thesilkpurse@aol.com"},
  {"name":"VILLAGE TAILOR","address":"2154 AZTEC DR","city":"DYERSBURG","state":"TN","zip":"38024","lat":36.05584,"lng":-89.406718,"owner":"BECKY WALKER","phone":"731-589-0213","email":"beckywalker2154@gmail.com"},
  {"name":"ACCENTS OF BURLESON","address":"100 S COMMERCE","city":"BURLESON","state":"TX","zip":"76028","lat":32.54277,"lng":-97.320358,"owner":"BETSY H","phone":"817-447-3315","email":"accents@digitex.net"},
  {"name":"ARTISAN DESIGNS","address":"2450 TIMES BLVD","city":"HOUSTON","state":"TX","zip":"77005","lat":29.716906,"lng":-95.415854,"owner":"ARLENE / JEAN","phone":"713-533-1923","email":"artisandboutique@att.net"},
  {"name":"BASTILLION\'S BIJOUX BOUTIQUE","address":"104 QUAIL BLVD","city":"AMARILLO","state":"TX","zip":"79124","lat":35.241836,"lng":-101.897599,"owner":"SUSAN STATSER","phone":"806-206-2329 C","email":"bastillionsbb@gmail.com"},
  {"name":"BEAUTY BOUTIQUE","address":"200 CROCKETT ST","city":"HALLETTSVILLE","state":"TX","zip":"77964","lat":29.450268,"lng":-96.94075,"owner":"BECKY MCELROY","phone":"361-798-2831","email":"beautyboutique77964@gmail.com"},
  {"name":"BECKY\'S PLACE","address":"1604 PADRE BLVD","city":"SOUTH PADRE ISLAND","state":"TX","zip":"78597","lat":26.096279,"lng":-97.16525,"owner":"BECKY PARCE","phone":"956-761-4074","email":"beckyparce@yahoo.com"},
  {"name":"BOUTIQUE 2 GO","address":"1207 REBECCA","city":"PASADENA","state":"TX","zip":"77506","lat":29.692206,"lng":-95.190218,"owner":"SUSAN GAEDE","phone":"713-907-0129","email":"btq2go@gmail.com"},
  {"name":"CELESTE","address":"140 S MAIN STREET","city":"BOERNE","state":"TX","zip":"78006","lat":29.793327,"lng":-98.731616,"owner":"BERNIE","phone":"830-249-9660","email":"celeste.boerne@gmail.com"},
  {"name":"CIAO BELLA","address":"809A 12TH STREET","city":"MARBLE FALLS","state":"TX","zip":"78654","lat":30.580431,"lng":-98.271452,"owner":"KIM KIRKLAND","phone":"830-693-5351"},
  {"name":"CLASSY PEACOCK","address":"1860-C TEXAS AVE","city":"BRIDGE CITY","state":"TX","zip":"77611","lat":30.032794,"lng":-93.83328,"owner":"MARCY MESSER","phone":"409-735-3567","email":"messer.marcy@yahoo.com"},
  {"name":"COMPANY ED SHOP","address":"203 W MAIN STREET","city":"PALESTINE","state":"TX","zip":"75801","lat":31.762318,"lng":-95.632798,"owner":"LINDA FOSTER","phone":"903-729-6456","email":"coedshop@gmail.com"},
  {"name":"CYNTHIA ELLIOT BOUTIQUE","address":"107 E VIRGINIA ST","city":"MC KINNEY","state":"TX","zip":"75069","lat":33.198189,"lng":-96.615473,"owner":"CYNTHIA VAN LANDINGHAM","phone":"972-562-8004","email":"cynthiaelliotboutique@gmail.com"},
  {"name":"DARLENE\'S FLOWER & GIFT SHOP","address":"10570 NORTHWEST FWY","city":"HOUSTON","state":"TX","zip":"77092","lat":29.813535,"lng":-95.460593,"owner":"SUSAN TATE","phone":"713-680-2350","email":"darflo10570@aol.com"},
  {"name":"DARLIA HOBBS","address":"8113 ANCHORAGE PLACE","city":"FORT WORTH","state":"TX","zip":"76135","lat":32.871608,"lng":-97.490023,"owner":"DARLIA HOBBS","phone":"817-237-7972","email":"rahobbsj@ymail.com"},
  {"name":"DEBORAH\'S BOUTIQUE","address":"1207 E GRAND","city":"MARSHALL","state":"TX","zip":"75670","lat":32.548319,"lng":-94.356068,"owner":"DEBBIE","phone":"903-927-2330","email":"parker1122@sbcglobal.net"},
  {"name":"DEJA NU","address":"207 E. 2ND ST","city":"LAMPASAS","state":"TX","zip":"76550","lat":31.065985,"lng":-98.181702,"owner":"JAMIE CONNELL","phone":"512-566-6545","email":"dejanujj@gmail.com"},
  {"name":"ELAINE\'S FASHIONS","address":"107 WEST WAY SUITE 3","city":"LAKE JACKSON","state":"TX","zip":"77566","lat":29.042872,"lng":-95.452956,"owner":"JULIE EDWARDS","phone":"979-297-3899","email":"elainesfashions@yahoo.com"},
  {"name":"EN VOGUE","address":"103 W MOORE AVE","city":"TERRELL","state":"TX","zip":"75160","lat":32.736173,"lng":-96.277614,"owner":"DEBBIE","phone":"972-563-8969","email":"ap@lumpyselectric.com"},
  {"name":"FOSTER CREEK STATION","address":"504 E CRESTWOOD DR","city":"VICTORIA","state":"TX","zip":"77901","lat":28.828384,"lng":-97.00047,"owner":"SUSAN FOSTER","phone":"361-576-0100","email":"fostercreekstation@gmail.com"},
  {"name":"FOUR SEASONS BOUTIQUE","address":"1705 FM 517 RD E","city":"DICKINSON","state":"TX","zip":"77539","lat":29.458211,"lng":-95.06274,"owner":"MARY LOU JACKSON","phone":"281-534-2575","email":"fourseasonsboutique1@gmail.com"},
  {"name":"GLAMOUR IN THE GLADES","address":"344 LCR 466","city":"MEXIA","state":"TX","zip":"76667","lat":31.630701,"lng":-96.51935,"owner":"KELLY HARRISON","phone":"254-625-0995","email":"glamourintheglades@gmail.com"},
  {"name":"GLAMOUR SHOP","address":"405-411 CENTER AVE","city":"BROWNWOOD","state":"TX","zip":"76801","lat":31.720203,"lng":-98.982995,"owner":"STEPHANIE WILSON","phone":"325-643-2633","email":"glamourshop51@yahoo.com"},
  {"name":"GRAMMERS","address":"P.O BOX 819","city":"COLEMAN","state":"TX","zip":"76834","lat":31.896653,"lng":-99.400197,"owner":"LIZ JONES","phone":"325-625-4821","email":"bethjonesliz@gmail.com"},
  {"name":"GREENVILLE BOUTIQUE","address":"2903 B LEE ST","city":"GREENVILLE","state":"TX","zip":"75401","lat":33.139616,"lng":-96.110158,"owner":"LOU ANN DICKENSON","phone":"903-408-7477 C","email":"greenvilleboutiquetx@gmail.com"},
  {"name":"GRUENE WITH ENVY","address":"1706 HUNTER ROAD","city":"NEW BRAUNFELS","state":"TX","zip":"78130","lat":29.739514,"lng":-98.102461,"owner":"DEBBIE LYNN","phone":"830-627-0612","email":"debbielynn1113@yahoo.com"},
  {"name":"GYPSY ROSE","address":"100 MIDWAY ST","city":"SPRING","state":"TX","zip":"77373","lat":30.07939,"lng":-95.417795,"owner":"NOEL","phone":"281-907-0911","email":"gypsyrosespring@yahoo.com"},
  {"name":"HARVEST DRUG","address":"4426 KELL BLVD","city":"WICHITA FALLS","state":"TX","zip":"76309","lat":33.871999,"lng":-98.554505,"owner":"JANET","phone":"940-692-7081","email":"janet@harvestdrug.com"},
  {"name":"HELLO AGAIN","address":"511 7TH STREET","city":"WICHITA FALLS","state":"TX","zip":"76301","lat":33.914707,"lng":-98.489312,"owner":"JAN SAVILLE","phone":"940-761-9955","email":"info@helloagainwf.com"},
  {"name":"HELLO BEAUTIFUL BOUTIQUE","address":"3915 WEST DAVIS # 230","city":"CONROE","state":"TX","zip":"77304","lat":30.326425,"lng":-95.499542,"owner":"JUDY BURKS","phone":"936-756-3700","email":"judy@hellobeautifulconroe.com"},
  {"name":"HIP CHIC BOUTIQUE","address":"20 WESTOVER ROAD","city":"FORT WORTH","state":"TX","zip":"76116","lat":32.743517,"lng":-97.405209,"owner":"CHRIS SCHNAU","phone":"469-222-4766c","email":"hipchicboutiquetx@yahoo.com"},
  {"name":"IN-STEP FASHIONS","address":"324 E MAIN STREET","city":"FREDERICKSBURG","state":"TX","zip":"78624","lat":30.272094,"lng":-98.867836,"owner":"MARY ECKERT","phone":"830-997-6121","email":"instepfashions@gmail.com"},
  {"name":"ITS ALL ABOUT YOU 2","address":"14072 MEMORIAL DRIVE","city":"HOUSTON","state":"TX","zip":"77079","lat":29.771141,"lng":-95.591365,"owner":"DERYA POERSCHKE","phone":"281-493-3056","email":"store@itsaaboutyou.com"},
  {"name":"JABBERWOCKY ANTIQS","address":"105 N LLANO ST","city":"FREDERICKSBURG","state":"TX","zip":"78624","lat":30.274404,"lng":-98.869928,"owner":"CHERI","phone":"830-997-7071","email":"jabber105@austin.twcbc.com"},
  {"name":"JAYNE NORWOOD & COMPANY","address":"11700 PRESTON ROAD","city":"DALLAS","state":"TX","zip":"75230","lat":32.907317,"lng":-96.803224,"owner":"JAYNE NORWOOD","phone":"214-850-4623","email":"jaynenorwoodandcompany@gmail.com"},
  {"name":"JEWELS BY JEANETTE","address":"25 WATERFORD OAKS LN.","city":"KEMAH","state":"TX","zip":"77565","lat":29.548594,"lng":-95.045336,"owner":"JEANETTE FAULKNER","phone":"832-692-9966","email":"jewelsbyjeanette@hotmail.com"},
  {"name":"JUDITH\'S OF GEORGETOWN","address":"3303 WILLIAMS DR STE. 107","city":"GEORGETOWN","state":"TX","zip":"78628","lat":30.666291,"lng":-97.694065,"owner":"DALE & JUDITH HART","phone":"512-868-8791","email":"No Email"},
  {"name":"KELLEY PROMOTIONS","address":"5222 COUNCIL GROVE LANE","city":"HOUSTON","state":"TX","zip":"77088","lat":29.879997,"lng":-95.466493,"owner":"JONI WEIR","phone":"832-265-3155","email":"joni@kelleypromo.com"},
  {"name":"L.A. CONNECTION","address":"4427 LOVERS LANE","city":"DALLAS","state":"TX","zip":"75225","lat":32.851439,"lng":-96.834814,"owner":"LESLIE","phone":"214-522-5040","email":"lvassallo@sbcglobal.net"},
  {"name":"LADYBUG JUNGLE","address":"109 EAST BROAD STREET","city":"MINEOLA","state":"TX","zip":"75773","lat":32.663675,"lng":-95.48891,"owner":"SHELIA PARKER","phone":"903-569-8585 S","email":"ladybugjungle@gmail.com"},
  {"name":"LAURA\'S BOUTIQUE","address":"3214 S 27TH STREET","city":"ABILENE","state":"TX","zip":"79605","lat":32.418277,"lng":-99.762589,"owner":"LAURA WEBER","phone":"325-691-0332","email":"laurasbtq.abilene@gmail.com"},
  {"name":"LE FASHION COACH","address":"600 VALLE VISTA COURT","city":"KELLER","state":"TX","zip":"76248","lat":32.951156,"lng":-97.238805,"owner":"DANA YOUNG","phone":"817-223-2426","email":"danay09@ICLOUD.COM"},
  {"name":"LE RAGGE RUGGS - COWGIRLS","address":"1111 HWY 290 WEST","city":"DRIPPING SPRINGS","state":"TX","zip":"78620","lat":30.1951,"lng":-98.103789,"owner":"REBA","phone":"512-858-4186","email":"LRRDS@AUSTIN.RR.COM"},
  {"name":"LEFTOVERS","address":"3900 HWY 290 W","city":"BRENHAM","state":"TX","zip":"77833","lat":30.17449,"lng":-96.454772,"owner":"CINDY","phone":"979-830-8496","email":"leftoversantiqueshome@gmail.com"},
  {"name":"LOU NELL\'S FASHIONS","address":"122 LEE ST","city":"SULPHUR SPRINGS","state":"TX","zip":"75482","lat":33.118772,"lng":-95.59786,"owner":"CARRIE CROWSON","phone":"903-885-0664","email":"lou.nells@yahoo.com"},
  {"name":"MADELINES","address":"221 E BRAZOS AVE","city":"WEST COLUMBIA","state":"TX","zip":"77486","lat":29.143973,"lng":-95.646283,"owner":"CINDY SAVILLE","phone":"979-345-6944","email":"cindy.saville@gmail.com"},
  {"name":"MAYBEN\'S MENSWEAR","address":"103 QUITMAN ST","city":"PITTSBURG","state":"TX","zip":"75686","lat":32.995551,"lng":-94.967302,"owner":"PAUL MAYBENS","phone":"903-856-3218","email":"maybens@aol.com"},
  {"name":"MELVILLE THOMAS INC","address":"8316 PRESTON CENTER PLAZA","city":"DALLAS","state":"TX","zip":"75225","lat":32.86328,"lng":-96.802639,"owner":"BARBARA","phone":"214-368-5440","email":"barb@melcrews.com"},
  {"name":"MERCER STREET CHIC BOUTIQUE","address":"2550 OAK RUN DR","city":"WIMBERLEY","state":"TX","zip":"78676","lat":29.974098,"lng":-98.169096,"owner":"DEBBIE","phone":"203-927-8473","email":"mercerstart@gmail.com"},
  {"name":"MERLE NORMAN","address":"212 DAVIS ST","city":"SULPHUR SPRINGS","state":"TX","zip":"75482","lat":33.13843,"lng":-95.602748,"owner":"MARCIA HINKELDEY","phone":"903-885-7103 s","email":"marciahinkeldey@gmail.com"},
  {"name":"MERLE NORMAN COSMETICS","address":"1270 WILLIAM D TATE AVE, # 200","city":"GRAPEVINE","state":"TX","zip":"76051","lat":32.927404,"lng":-97.088221,"owner":"LYNDA PERKINS","phone":"817-251-0208 s","email":"merlenorman.gvine@verizon.net"},
  {"name":"MERLE NORMAN COSMETICS","address":"407 W BAKER RD SUITE J","city":"BAYTOWN","state":"TX","zip":"77521","lat":29.769271,"lng":-94.96787,"owner":"KATHY YOUNG","phone":"281-421-2314","email":"kathysmn10@comcast.net"},
  {"name":"MERLE NORMAN OF ATLANTA TX","address":"119 E MAIN","city":"ATLANTA","state":"TX","zip":"75551","lat":33.113975,"lng":-94.164327,"owner":"BECKY WILBANKS","phone":"903-244-7042","email":"wilbanksbecky@yahoo.com"},
  {"name":"MORGAN FITZGERALD\'S","address":"3800 S TEXAS AVENUE","city":"BRYAN","state":"TX","zip":"77802","lat":30.636928,"lng":-96.346319,"owner":"NANCY B PRIDE / BRENDA","phone":"979-268-0608","email":"morfitz@yahoo.com"},
  {"name":"O\'SUZANNA\'S","address":"119 COMMERCE ST","city":"TOMBALL","state":"TX","zip":"77375","lat":30.098885,"lng":-95.614742,"owner":"SUZANNE HERMAN","phone":"281-255-9913","email":"sales@osuzannas.com"},
  {"name":"PENNERS INC","address":"311 W COMMERCE","city":"SAN ANTONIO","state":"TX","zip":"78205","lat":29.425338,"lng":-98.496007,"owner":"MITCHELL PENNER","phone":"210-226-2487","email":"mitchell@pennersinc.com"},
  {"name":"PERSONALITY SLIPPER SHOPPE","address":"413 SOUTH 1ST","city":"HASKELL","state":"TX","zip":"79521","lat":33.156465,"lng":-99.733537,"owner":"GLENDA GAYLE RUTKOWSKI","phone":"940-864-2501","email":"ggrutkowski@gmail.com"},
  {"name":"PRAIRIE ROSE EMPORIUM","address":"110 N WASHINGTON ST","city":"EL CAMPO","state":"TX","zip":"77437","lat":29.196933,"lng":-96.268349,"owner":"KAREN J ROSE","phone":"979-543-5772","email":"prc2005@sbcglobal.net"},
  {"name":"RENDEZVOUZ","address":"1303 N. ESPLANADE ST.","city":"CUERO","state":"TX","zip":"77954","lat":29.102137,"lng":-97.285978,"owner":"RHONDA PAKEBUSCH","phone":"361-275-5777","email":"rendezvousboutique1@gmail.com"},
  {"name":"RHINESTONE RANCH","address":"8512 SPRING ST","city":"SAGINAW","state":"TX","zip":"76179","lat":32.879126,"lng":-97.426798,"owner":"LORI GRAWUNDER","phone":"817-319-9226","email":"Lori.12@att.net"},
  {"name":"SALEM\'S FASHIONS","address":"514 N US HWY 281","city":"MARBLE FALLS","state":"TX","zip":"78654","lat":30.574132,"lng":-98.274978,"owner":"SUSAN SALEM JUDICE","phone":"830-693-3250","email":"salemsfashions@yahoo.com"},
  {"name":"SANDI\'S BOUTIQUE","address":"2613 BUTTERFIELD TRAIL","city":"SHERMAN","state":"TX","zip":"75090","lat":33.659094,"lng":-96.643393,"owner":"SANDI KEY","phone":"903-892-4240","email":"sandikkey@msn.com"},
  {"name":"SCHUMANN\'S","address":"P.O BOX 427","city":"EDEN","state":"TX","zip":"76837","lat":31.174061,"lng":-99.876368,"owner":"PAULA DUWE","phone":"325-869-6801","email":"schumannsinc@hotmail.com"},
  {"name":"SHOPPES ON MAIN","address":"PO BOX 656","city":"SALADO","state":"TX","zip":"76571","lat":30.925692,"lng":-97.570057,"owner":"NANCY ISAKSON","phone":"257-947-0888","email":"grandmani10@gmail.com"},
  {"name":"SIMPLY CHARMING","address":"205 E POWER AVE","city":"VICTORIA","state":"TX","zip":"77901-6536","lat":28.801877,"lng":-97.003161,"owner":"VIRGINIA JURICA","phone":"361-550-6310","email":"virginiajurica@gmail.com"},
  {"name":"SISTERS GIFT SHOP","address":"2620 STELLA ST","city":"PORT O CONNOR","state":"TX","zip":"77982","lat":28.432529,"lng":-96.433488,"owner":"KATHY HOSKINS","phone":"361-550-9590","email":"kathyrhoskins@yahoo.com"},
  {"name":"SOUTHWESTERN ELEGANCE","address":"206 OLD INGRAM LOOP","city":"INGRAM","state":"TX","zip":"78025","lat":30.072568,"lng":-99.243718,"owner":"CYNTHIA ANDERSON","phone":"830-367-4749","email":"southwesternelegance@gmail.com"},
  {"name":"STUFF \'N\' NONSENSE","address":"109 E BRIDGE ST","city":"GRANBURY","state":"TX","zip":"76048","lat":32.443297,"lng":-97.78718,"owner":"JANET LOGSDON","phone":"817-573-9060","email":"stuffnnonsenseboutique@gmail.com"},
  {"name":"SUE PATRICK FASHIONS","address":"5222 BURNET RD","city":"AUSTIN","state":"TX","zip":"78756","lat":30.324304,"lng":-97.74021,"owner":"SUE PATRICK","phone":"512-452-7701","email":"jay@suepatrick.com"},
  {"name":"THANKFUL LADIES BOUTIQUE","address":"123 W MAIN ST","city":"BRONTE","state":"TX","zip":"76933","lat":31.887335,"lng":-100.293177,"owner":"LANETTE M FLETCHER","phone":"325-473-2081","email":"thankfulladies@gmail.com"},
  {"name":"THE BLUE HUTCH","address":"8503 NW MILITARY HWY, STE 150","city":"SAN ANTONIO","state":"TX","zip":"78231","lat":29.552933,"lng":-98.534176,"owner":"JENNIFER O\'CONNOR","phone":"210-233-9564","email":"walkingwithhim@yahoo.com"},
  {"name":"THE CASTLE COLLECTION","address":"137 S RIDGEWAY","city":"CLEBURNE","state":"TX","zip":"76033","lat":32.339572,"lng":-97.407284,"owner":"MJ LAURIA","phone":"817-645-5415","email":"castlemk@sbcglobal.net"},
  {"name":"THE CLOTHESHORSE","address":"809 EAST MAIN STREET","city":"LEAGUE CITY","state":"TX","zip":"77573","lat":29.512022,"lng":-95.088633,"owner":"SANDY CARNEY","phone":"281-332-2383","email":"theclotheshorse@verizon.net"},
  {"name":"THE CROSSING LLC","address":"322 W SAN ANTONIO STREET","city":"NEW BRAUNFELS","state":"TX","zip":"78130","lat":29.700857,"lng":-98.126908,"owner":"PAULA HENKEN","phone":"830-625-9639","email":"thecrossingph@gmail.com"},
  {"name":"THE GIFT SOLUTION","address":"2901 CAPITAL OF TEXAS HWY","city":"AUSTIN","state":"TX","zip":"78746","lat":30.25613,"lng":-97.810627,"owner":"SARAH SUMMERS","phone":"512-327-8717","email":"austinboutique@gmail.com"},
  {"name":"THE INSIDE OUT FOUNDATION","address":"4630 50TH STREET","city":"LUBBOCK","state":"TX","zip":"79414","lat":33.549437,"lng":-101.912015,"owner":"KARLA MORGAN","phone":"806-722-0750","email":"theinsideoutfoundation@gmail.com"},
  {"name":"THE STORE IN LAKE HIGHLANDS","address":"9850 WALNUT HILL LANE","city":"DALLAS","state":"TX","zip":"75238","lat":32.877885,"lng":-96.715977,"owner":"CHERYL CALVIN","phone":"214-553-8850","email":"cheryl@thestoreinlh.com"},
  {"name":"THE STYLE SHOP","address":"313 N 5TH STREET","city":"CARRIZO SPRINGS","state":"TX","zip":"78834","lat":28.523823,"lng":-99.859589,"owner":"JEANELLE COLEMAN","phone":"830-876-2112","email":"thestyleshopj313@gmail.com"},
  {"name":"THE WILLOW TREE","address":"211 N. POLK ST","city":"JEFFERSON","state":"TX","zip":"75657","lat":32.757529,"lng":-94.345211,"owner":"PAUL MOREHEAD","phone":"903-601-4515","email":"thewillowtreejefferson@yahoo.com"},
  {"name":"TRENDZ AND TRADITIONS","address":"122 NORTH BALLARD","city":"WYLIE","state":"TX","zip":"75098","lat":33.015017,"lng":-96.538702,"owner":"DONNA WESSON","phone":"214-642-6817","email":"dmwesson@sbcglobal.net"},
  {"name":"TRES CHIC BOUTIQUE","address":"201 E MAIN STREET","city":"BRENHAM","state":"TX","zip":"77833","lat":30.167659,"lng":-96.39728,"owner":"STACEY WALTERS","phone":"979-836-9505","email":"treschic99@yahoo.com"},
  {"name":"TRULY TRENDY BOUTIQUE","address":"1713 BETHEL RD","city":"WEATHERFORD","state":"TX","zip":"76086","lat":32.736973,"lng":-97.798922,"owner":"DIANE","phone":"817-594-2380","email":"trulytrendy@yahoo.com"},
  {"name":"TURK\'S FEMININE APPAREL","address":"1303 S PALESTINE STREET","city":"ATHENS","state":"TX","zip":"75751","lat":32.182284,"lng":-95.849402,"owner":"JOAN TURK","phone":"903-675-2466","email":"joanturk52@icloud.com"},
  {"name":"TWO P\'S & CALLI\'S BOUTIQUE","address":"690 CENTERPOINT RD #205","city":"SAN MARCOS","state":"TX","zip":"78666","lat":29.828621,"lng":-97.987071,"owner":"PAM/ BRANDY","phone":"512-392-8967","email":"twopsandcallis@gmail.com"},
  {"name":"UNIQUELY YOURS","address":"625 N BEATON ST","city":"CORSICANA","state":"TX","zip":"75110","lat":32.099016,"lng":-96.466918,"owner":"CAROL LANGHAM","phone":"214-679-7365","email":"uniqueyou1@gmail.com"},
  {"name":"WESTHOFF MERCANTILE CO","address":"124 E HOUSTON ST","city":"EDNA","state":"TX","zip":"77957","lat":28.978445,"lng":-96.645195,"owner":"JUDY WESTHOFF","phone":"361-782-2451","email":"westgifts1@gmail.com"},
  {"name":"WITT\'S END","address":"3525 LONGMIRE DR STE L","city":"COLLEGE STATION","state":"TX","zip":"77845","lat":30.581706,"lng":-96.285185,"owner":"KAREN KASPER","phone":"979-485-8991","email":"karen@witts-end.com"},
  {"name":"ZOOTY\'S","address":"1401 S 31ST","city":"TEMPLE","state":"TX","zip":"76504","lat":31.087255,"lng":-97.362499,"owner":"AMY OR BILL","phone":"254-770-0904","email":"zootystemple@att.net"},
  {"name":"CHRISTENSEN\'S","address":"39 NORTH MAIN","city":"RICHFIELD","state":"UT","zip":"84701","lat":38.768634,"lng":-112.084966,"owner":"JANA","phone":"435-896-6466","email":"christensensrichfield@yahoo.com"},
  {"name":"COUNTRY FLAIR","address":"15250 WEST 4000 NORTH","city":"ALTAMONT","state":"UT","zip":"84001","lat":40.359536,"lng":-110.280729,"owner":"DANYEL ABBOTT","phone":"435-454-3418","email":"countryflairfashion@gmail.com"},
  {"name":"RAINBOW GARDENS","address":"1851 VALLEY DRIVE","city":"OGDEN","state":"UT","zip":"84401","lat":41.236046,"lng":-111.929473,"owner":"JENNY KING FRANCL","phone":"801-621-0150","email":"office@rainbowgardens.com"},
  {"name":"ANDERSON\'S","address":"11250 JEFFERSON AVE","city":"NEWPORT NEWS","state":"VA","zip":"23601","lat":37.063287,"lng":-76.467549,"owner":"KATHY","phone":"757-599-3510","email":"kathy@loveandersons.com"},
  {"name":"ARIEL\'S","address":"730 EAST CHURCH STREET","city":"MARTINSVILLE","state":"VA","zip":"24112","lat":36.68835,"lng":-79.855316,"owner":"ARIEL MILLNER","phone":"276-632-7484","email":"arielsclothing@gmail.com"},
  {"name":"BIRDCAGE BOUTIQUE LLC","address":"4706 STARKEY RD, STE-B","city":"ROANOKE","state":"VA","zip":"24018","lat":37.22196,"lng":-79.985196,"owner":"GWENOA","phone":"540-556-2421","email":"store@thebirdcage.boutique"},
  {"name":"CATTAILS GIFTS INC","address":"16 CHURCH ST","city":"MATHEWS","state":"VA","zip":"23109","lat":37.433862,"lng":-76.321278,"owner":"MIKE & JESSICA ELKINS","phone":"804-725-2886","email":"info@cattailsfinegifts.com"},
  {"name":"CHRISTY\'S APPAREL","address":"2123 COLONIAL AVE","city":"ROANOKE","state":"VA","zip":"24015","lat":37.255302,"lng":-79.956858,"owner":"ROSA WEEKS","phone":"540-342-2280","email":"rweeks9821@yahoo.com"},
  {"name":"DISTRIBUTION GIFT SHOP","address":"5801 BREMO ROAD","city":"RICHMOND","state":"VA","zip":"23226","lat":37.583955,"lng":-77.512549,"owner":"HOLLY WHEELER","phone":"804-564-3077","email":"holly_wheeler@bshsi.org"},
  {"name":"FABULOUS FINDS BOUTIQUE","address":"98 FELTON RD","city":"DELTAVILLE","state":"VA","zip":"23043","lat":37.565314,"lng":-76.372896,"owner":"AUBRINA","phone":"757-810-6680 c","email":"aubrina@verizon.net"},
  {"name":"HANG UPS","address":"1600 HILL TOP WEST","city":"VIRGINIA BEACH","state":"VA","zip":"23451","lat":36.845259,"lng":-76.016135,"owner":"TRACIE BURLAGE","phone":"757-777-8218","email":"hangupsmail@gmail.com"},
  {"name":"HISTORIC HOPEWELL FOUNDATION","address":"400 WESTON LANE","city":"HOPEWELL","state":"VA","zip":"23860","lat":37.309074,"lng":-77.303993,"owner":"CAROLYN HOAGLAND","phone":"804-334-2684","email":"setiferus@aol.com"},
  {"name":"LAURA\'S BOUTIQUE","address":"P.O BOX 659","city":"HOT SPRINGS","state":"VA","zip":"24445","lat":37.994443,"lng":-79.831593,"owner":"LAURA DUFOUR SHAVER","phone":"540-839-2619","email":"girlnextdoor@tds.net"},
  {"name":"MEG\'S SPECIALTY WOMENSWEAR","address":"1136 E MAIN ST","city":"RADFORD","state":"VA","zip":"24141","lat":37.141047,"lng":-80.557699,"owner":"MEG WEDDLE","phone":"540-639-3841","email":"meg@garrettsinc.com"},
  {"name":"NANCY\'S DOWNTOWN BOUTIQUE","address":"532 VIRGINIA AVENUE","city":"BLUEFIELD","state":"VA","zip":"24605","lat":37.253153,"lng":-81.270429,"owner":"NANCY GRANT","phone":"276-322-7582","email":"nancysdowntownboutique@yahoo.com"},
  {"name":"PONNIE\'S","address":"4005 OLDTOWN ROAD","city":"SHAWSVILLE","state":"VA","zip":"24162","lat":37.16906,"lng":-80.253827,"owner":"PONNIE SHAWVER","phone":"540-268-5404","email":"ponnies@yahoo.com"},
  {"name":"ROANE\'S ANTIQUES","address":"291 MAIN STREET","city":"MATHEWS","state":"VA","zip":"23109","lat":37.432856,"lng":-76.320969,"owner":"JANICE JONES","phone":"804-815-9044","email":"roanesantiques@yahoo.com"},
  {"name":"TAILOR\'S TACKS","address":"110 WEST BLUE RIDGE ST","city":"STUART","state":"VA","zip":"24171","lat":36.643057,"lng":-80.269959,"owner":"(MR) HARLEY","phone":"276-694-3938","email":"tailorstacks110@gmail.com"},
  {"name":"THE CAMELEER INC.","address":"125 E DAVIS ST.","city":"CULPEPER","state":"VA","zip":"22701","lat":38.473129,"lng":-77.995779,"owner":"SUSAN","phone":"540-825-8073","email":"office@thecameleer.com"},
  {"name":"THE CHESAPEAKE","address":"955 HARPERSVILLE RD","city":"NEWPORT NEWS","state":"VA","zip":"23601","lat":37.092444,"lng":-76.452226,"phone":"757-223-1600","email":"probinson@vbh.org"},
  {"name":"THE FASHION GALLERY","address":"PO BOX 586","city":"VERONA","state":"VA","zip":"24482","lat":38.210585,"lng":-78.989369,"owner":"LINDA WILSON HOLDEN","phone":"540-248-4292","email":"fashiongalleryva@gmail.com"},
  {"name":"THE MOLE HOLE OF WILLIAMSBURG","address":"1425 RICHMOND RD","city":"WILLIAMSBURG","state":"VA","zip":"23185","lat":37.288146,"lng":-76.721564,"owner":"REGINA PETIT","phone":"757-220-8609","email":"themoleholeva@gmail.com"},
  {"name":"VINTAGE VAULT","address":"2845 NEW RIDGE RD","city":"SALEM","state":"VA","zip":"24087","lat":37.245975,"lng":-80.271492,"owner":"PAMELA MANN","phone":"540-589-7616","email":"vintagevaultsalem@gmail.com"},
  {"name":"A LITTLE SOMETHING","address":"2989 SHELBURNE ROAD","city":"SHELBURNE","state":"VT","zip":"05482","lat":44.412626,"lng":-73.213681,"owner":"DEIDRE SENIOR","phone":"802-985-9909","email":"littlesomething.das@gmail.com"},
  {"name":"CHESHIRE CAT","address":"17 STATE STREET","city":"MONTPELIER","state":"VT","zip":"05602","lat":44.260392,"lng":-72.57596,"owner":"DAWN MCCONNELL","phone":"802-223-1981","email":"askalice@cheshirecatclothing.com"},
  {"name":"DAFFODIL ENTERPRISES INC.","address":"163 PEARL ST., SUITE # 1","city":"ESSEX JUNCTION","state":"VT","zip":"05452","lat":44.498896,"lng":-73.128168,"owner":"ELKE REICHELT","phone":"802-879-0212","email":"daffodilent@yahoo.com"},
  {"name":"FARM-WAY","address":"286 WAITS RIVER ROAD RT 25","city":"BRADFORD","state":"VT","zip":"05033","lat":43.980868,"lng":-72.116577,"owner":"CAROL METAYER","phone":"800-222-9316","email":"carolmetayer@hotmail.com"},
  {"name":"FAT HAT CLOTHING CO","address":"#1 QUECHEE MAIN STREET","city":"QUECHEE","state":"VT","zip":"05059","lat":43.652643,"lng":-72.391327,"owner":"JENN","phone":"802-296-6646","email":"eckerjenn@aol.com"},
  {"name":"LINDA\'S APPAREL","address":"175 MAIN STREET","city":"VERGENNES","state":"VT","zip":"05491","lat":44.167849,"lng":-73.25147,"owner":"LINDA COOK","phone":"802-877-2320","email":"linda@lindasapparelvt.com"},
  {"name":"SHELBURNE MUSEUM","address":"P.O BOX 10","city":"SHELBURNE","state":"VT","zip":"05482","lat":44.38061,"lng":-73.22763,"owner":"ROB LANDRY","phone":"802-985-3346","email":"rlandry@shelburnemuseum.org"},
  {"name":"THE VERMONT COUNTRY STORE","address":"5650 MAIN ST","city":"MANCHESTER CENTER","state":"VT","zip":"05255","lat":43.183301,"lng":-73.044282,"owner":"RACHEL GROVER","phone":"802-362-5963","email":"rgrover@vermontcountrystore.com"},
  {"name":"ABOUT TIME INC","address":"830 WATER ST.","city":"PORT TOWNSEND","state":"WA","zip":"98368","lat":48.114693,"lng":-122.756279,"owner":"JEANNINE","phone":"360-385-4795","email":"info@abouttimeclothing.com"},
  {"name":"BELLEZA ROPA","address":"101 CAPITOL WAY N","city":"OLYMPIA","state":"WA","zip":"98501","lat":47.045055,"lng":-122.901945,"owner":"JEANNINE KEMPEES","phone":"360-352-7672","email":"info@bellezaropa.com"},
  {"name":"DOOR MOUSE BOUTIQUE","address":"427 CANAL DRIVE NE","city":"OCEAN SHORES","state":"WA","zip":"98569","lat":46.995546,"lng":-124.158378,"owner":"PAT HABECK","phone":"209-606-4239","email":"omapat@yahoo.com"},
  {"name":"EARTH WIND & FIRE","address":"1514 PIKE PLACE # 13","city":"SEATTLE","state":"WA","zip":"98101","lat":47.609094,"lng":-122.340851,"owner":"Debbie Foxman","phone":"206-448-2529","email":"earthwindandfireseattle@gmail.com"},
  {"name":"ENVY","address":"3813 N 26TH ST","city":"TACOMA","state":"WA","zip":"98407","lat":47.271237,"lng":-122.488052,"owner":"SHANNON THOMPSON","phone":"253-226-1332","email":"envytacoma@gmail.com"},
  {"name":"GAEL SONG","address":"7831 196TH ST SW, SUITE 101","city":"EDMONDS","state":"WA","zip":"98026","lat":47.822153,"lng":-122.339633,"owner":"COLLEEN CONNELL","phone":"206-267-9351","email":"colleen@gaelsong.com"},
  {"name":"HEART","address":"PO BOX 11440","city":"BAINBRIDGE IS","state":"WA","zip":"98110","lat":47.647774,"lng":-122.538016,"owner":"SUSAN LAWRENCE","phone":"206-842-0688","email":"heartstores@aol.com"},
  {"name":"JUST BECAUSE","address":"317 S WASHINGTON AVE.","city":"NEWPORT","state":"WA","zip":"99156","lat":48.178604,"lng":-117.044321,"owner":"JILL LINTON","phone":"509-447-2762","email":"justbecausenewport@gmail.com"},
  {"name":"MAJE GALLERY","address":"409 MAIN STREET","city":"EDMONDS","state":"WA","zip":"98020","lat":47.810928,"lng":-122.378033,"owner":"MANYA VEE","phone":"425-776-3778","email":"manya@majegallery.com"},
  {"name":"MCBECKLANDS LADIES BOUTIQUE","address":"3102 JUDSON STREET","city":"GIG HARBOR","state":"WA","zip":"98335","lat":47.327463,"lng":-122.580067,"owner":"LLOYDETTE ROBERTS","phone":"253-851-5525","email":"mcbecklands30@aol.com"},
  {"name":"PLUM","address":"124 WINSLOW WAY EAST","city":"BAINBRIDGE IS","state":"WA","zip":"98110","lat":47.624719,"lng":-122.520736,"owner":"THERESA COLLIER","phone":"206-201-3654","email":"info@plumbainbridge.com"},
  {"name":"SARATOGA ENTERPRISES INC","address":"PO BOX 99","city":"FREELAND","state":"WA","zip":"98249","lat":48.009252,"lng":-122.530507,"owner":"RON & PAM LIND","phone":"360-221-6111","email":"jo.linds@whidbey.com"},
  {"name":"AUNT ESTHER\'S ATTIC","address":"4545 W. PINE ST UNIT O","city":"APPLETON","state":"WI","zip":"54914","lat":44.251044,"lng":-88.470529,"owner":"COLLEEN FLANAGAN","phone":"920-851-9876","email":"flanaganlady@gmail.com"},
  {"name":"B&H","address":"52 S MAIN","city":"CLINTONVILLE","state":"WI","zip":"54929","lat":44.621357,"lng":-88.761804,"owner":"SUE","phone":"715-823-5311","email":"bhfoot@frontiernet.net"},
  {"name":"BLISS BOUTIQUE","address":"620 MILWAUKEE ST","city":"DELAFIELD","state":"WI","zip":"53018","lat":43.061509,"lng":-88.403225,"owner":"SARAH JOHNSON","phone":"262-993-2192","email":"blissboutiquedelafield@gmail.com"},
  {"name":"BRINKLEY\'S BOUTIQUE","address":"419 N. MAIN ST","city":"OSHKOSH","state":"WI","zip":"54901","lat":44.018392,"lng":-88.537662,"owner":"BARB NELSON","phone":"920-479-1680","email":"brinkleysboutique@yahoo.com"},
  {"name":"BROADWAY HOME FLORAL & DESIGN","address":"204 S BROADWAY STREET","city":"STANLEY","state":"WI","zip":"54768","lat":44.958535,"lng":-90.937801,"owner":"HEATHER BRENNER","phone":"715-644-5672","email":"info@broadwayinstanley.com"},
  {"name":"BRYSON REID","address":"333 W. BROWN DEER RD","city":"BAYSIDE","state":"WI","zip":"53217","lat":43.176285,"lng":-87.911006,"owner":"LASHUAN BRYSON","phone":"414-368-3500","email":"lashuan@brysonreid.com"},
  {"name":"COOPERS UPTOWN","address":"2401 60TH ST","city":"KENOSHA","state":"WI","zip":"53140","lat":42.580446,"lng":-87.838344,"owner":"JAKE MCGHEE","phone":"262-653-3781","email":"hello@coopersuptown.com"},
  {"name":"CORNERSTONE","address":"214 BROAD STREET","city":"LAKE GENEVA","state":"WI","zip":"53147","lat":42.591998,"lng":-88.435597,"owner":"BRUCE BENNETT","phone":"262-248-6988","email":"sales@cornerstoneshoppe.com"},
  {"name":"COUNTRY LADY","address":"P.O BOX 253","city":"EGG HARBOR","state":"WI","zip":"54209","lat":45.012261,"lng":-87.266031,"owner":"BRIGITTE","phone":"920-868-1642","email":"b.son3@icloud.com"},
  {"name":"DREIER PHARMACY","address":"117 S MAIN ST","city":"SHAWANO","state":"WI","zip":"54166","lat":44.781542,"lng":-88.610038,"owner":"JESSICA","phone":"715-526-2011","email":"dreierpharmacy@frontiernet.net"},
  {"name":"FRAME OF MIND GALLERY & GIFTS","address":"17180 BIG HILL RD","city":"LAKEWOOD","state":"WI","zip":"54138","lat":45.301081,"lng":-88.528978,"owner":"SANDY DEMILE","phone":"715-276-3400","email":"lakewoodframeofmind@yahoo.com"},
  {"name":"GIFT GALLERY @ WEST ALLIS MEM","address":"8901 W LINCOLN AVE","city":"WEST ALLIS","state":"WI","zip":"53227","lat":43.001253,"lng":-88.023322,"owner":"LYNN DERLEIN","phone":"414-328-7175","email":"lynn.derlein@aurora.org"},
  {"name":"HAMILTON\'S LADIES APPAREL","address":"105W HURON STREET","city":"BERLIN","state":"WI","zip":"54923","lat":43.968581,"lng":-88.947111,"owner":"FAYE GELHAR","phone":"920-361-2829","email":"hamiltonsfashions@yahoo.com"},
  {"name":"HIDDEN TREASURES ON MAIN","address":"280 E MAIN ST","city":"GILMAN","state":"WI","zip":"54433","lat":45.166134,"lng":-90.810852,"owner":"REBECCA MANN","phone":"715-447-5448","email":"hiddentreasuresonmain@gmail.com"},
  {"name":"INSPIRATION INVESTMENTS LLC","address":"817 CLARK STREET","city":"STEVENS POINT","state":"WI","zip":"54481","lat":44.522433,"lng":-89.586449,"owner":"MICHELLE VENZKE","phone":"715-997-9198","email":"stevenspoint@realdeals.net"},
  {"name":"INTENTION BOUTIQUE","address":"2710 CUSTER ST.","city":"MANITOWOC","state":"WI","zip":"54220","lat":44.088599,"lng":-87.682288,"owner":"ANNETTE SCHISEL","phone":"920-973-2244 c","email":"intentionboutique@att.net"},
  {"name":"ISAACS FINE APPAREL","address":"300 NORTH 3RD ST","city":"WAUSAU","state":"WI","zip":"54403","lat":44.959184,"lng":-89.628323,"owner":"TAMMY DAHMS","phone":"715-842-8038","email":"Dtrdahms@charter.net"},
  {"name":"J HAWKINSON CLOTHIERS","address":"5114 WEST MICHAEL\'S DR","city":"APPLETON","state":"WI","zip":"54913","lat":44.268051,"lng":-88.484262,"owner":"LISA MCGINNIS","phone":"920-739-7377","email":"mcginnis.lisa46@gmail.com"},
  {"name":"JOANNE\'S DRESS SHOP","address":"1618 11TH STREET","city":"MONROE","state":"WI","zip":"53566","lat":42.600861,"lng":-89.639182,"owner":"LISA BUOL","phone":"608-325-3900","email":"lisa.joannesdressshop@gmail.com"},
  {"name":"JUNCTION CITY CRAFT CO","address":"4600 ROBIN RD","city":"JUNCTION CITY","state":"WI","zip":"54443","lat":44.584776,"lng":-89.7874,"owner":"CINDY MONIEN","phone":"920-948-2468","email":"junctioncitycraftco@tds.net"},
  {"name":"KATES KLOSET","address":"655 E SUMNER ST","city":"HARTFORD","state":"WI","zip":"53027","lat":43.316451,"lng":-88.369774,"owner":"CATHY ZIVKOVICH (KATE)","phone":"414-303-2523C","email":"katezivkovich@gmail.com"},
  {"name":"KAYLA\'S CLOSET","address":"160 2ND AVE N","city":"PARK FALLS","state":"WI","zip":"54552","lat":45.935875,"lng":-90.448985,"owner":"KAYLA MYERS","phone":"715-762-4474","email":"kaylascloset15@gmail.com"},
  {"name":"LILLIANS OF APPLETON","address":"115 E COLLEGE AVE","city":"APPLETON","state":"WI","zip":"54911","lat":44.261642,"lng":-88.405223,"owner":"KARA MANUEL","phone":"920-738-3004","email":"lilliansofappleton@gmail.com"},
  {"name":"MAGNOLIA\'S","address":"PO BOX 783","city":"OSCEOLA","state":"WI","zip":"54020","lat":45.283783,"lng":-92.535618,"owner":"PAULETTE WENTZLAFF","phone":"715-781-5276 c","email":"magnoliaspaulette@gmail.com"},
  {"name":"MAINSTREAM BOUTIQUE","address":"1506 9TH STREET","city":"MENOMONIE","state":"WI","zip":"54751","lat":44.869177,"lng":-91.919393,"owner":"DIANNA FIERGOLA","phone":"715-309-2246 s","email":"Dfiergola@mainstreamboutique.com"},
  {"name":"MARSHFIELD CLINIC HEALTH SYSTE","address":"3400 MINISTRY PKWY","city":"WESTON","state":"WI","zip":"54476","lat":44.889941,"lng":-89.58025,"owner":"ANNE NELSON","phone":"715-393-3740","email":"nelson.anne@marshfieldclinic.org"},
  {"name":"MAYVILLE ACE HARDWARE #18588","address":"1020 HORICON ST","city":"MAYVILLE","state":"WI","zip":"53050","lat":43.494811,"lng":-88.556764,"owner":"SUSAN PERRY","phone":"920-387-2068","email":"mayville@mayporthdw.com"},
  {"name":"MERITER HOSPITAL GIFT SHOP","address":"202 S PARK ST","city":"MADISON","state":"WI","zip":"53715","lat":43.064729,"lng":-89.40168,"owner":"VICKI KILLIAN","phone":"608-417-6304","email":"vicki.killian@unitypoint.org"},
  {"name":"MOOD","address":"230 MAIN STREET EAST","city":"MENOMONIE","state":"WI","zip":"54751","lat":44.876663,"lng":-91.9278,"owner":"VERONICA SMITH","phone":"715-231-2130","email":"veronica@moodinmenomonie.com"},
  {"name":"NEST EGG GIFTS","address":"816 E GRAND","city":"BELOIT","state":"WI","zip":"53511","lat":42.499371,"lng":-89.028426,"owner":"PATTI HARRER","phone":"608-365-0700","email":"bobharrer@charter.net"},
  {"name":"ON DECK CLOTHING COMPANY","address":"PO BOX 280","city":"FISH CREEK","state":"WI","zip":"54212","lat":45.11038,"lng":-87.209899,"owner":"MITCH LARSON","phone":"920-868-9091","email":"mitch@ondeckclothing.com"},
  {"name":"PENE JENTA BTQ","address":"220 MERCHANT ROW","city":"MILTON","state":"WI","zip":"53563","lat":42.781012,"lng":-88.963478,"owner":"REBECCA HILLMANN","phone":"608-868-1117","email":"penejentaboutique@gmail.com"},
  {"name":"RAE BAXTERS","address":"345 SOUTH CENTRAL AVE","city":"MARSHFIELD","state":"WI","zip":"54449","lat":44.664172,"lng":-90.175135,"owner":"CAROL KNAUF","phone":"715-384-2080","email":"cjknauf@gmail.com"},
  {"name":"ROSS SPORTSWEAR,INC.","address":"P.O.BOX 1050","city":"MINOCQUA","state":"WI","zip":"54548","lat":45.827583,"lng":-89.824294,"owner":"BILL ROSS","phone":"715-356-3861","email":"bill@ross-sportswear.com"},
  {"name":"SANDY\'S","address":"E13298 CIOUNTY RD V STE-1","city":"AUGUSTA","state":"WI","zip":"54722","lat":44.662564,"lng":-91.260985,"owner":"SANDY WAGENER","phone":"715-286-2980","email":"sandy@sandysclothingandart.com"},
  {"name":"SAUK PRAIRIE HOSPITAL","address":"260 26TH ST","city":"PRAIRIE DU SAC","state":"WI","zip":"53578","lat":43.286906,"lng":-89.753528,"owner":"THERESA DOUGLAS","phone":"608-643-7257","email":"theresa.douglas@saukprairiehealthcare.org"},
  {"name":"SCHR0EDERS","address":"1623 WASHINGTON","city":"TWO RIVERS","state":"WI","zip":"54241","lat":44.148496,"lng":-87.568039,"owner":"ANGIE","phone":"920-793-2241","email":"schroedersdeptstore@gmail.com"},
  {"name":"SMART WOMAN","address":"124 W COOK ST","city":"PORTAGE","state":"WI","zip":"53901","lat":43.539534,"lng":-89.460428,"owner":"MEGAN","phone":"608-742-5711","email":"smartwoman@frontier.com"},
  {"name":"SPRING GREEN GENERAL STORE","address":"137 S ALBANY ST","city":"SPRING GREEN","state":"WI","zip":"53588","lat":43.176212,"lng":-90.065117,"owner":"KARIN MILLER","phone":"608-588-7070","email":"karin@springgreengeneralstore.com"},
  {"name":"SUGAR RIVER SHOPPE","address":"5495 CHARLES HAHN DRIVE","city":"SUN PRAIRIE","state":"WI","zip":"53590","lat":43.149268,"lng":-89.173288,"owner":"SARAH REED","phone":"608-216-6995","email":"sarah@sugarrivershoppe.com"},
  {"name":"T-BELLS CLOSET BOUTIQUE LLC","address":"825 MAIN ST","city":"WAUSAUKEE","state":"WI","zip":"54177","lat":45.377205,"lng":-87.953815,"owner":"TINA ROCKWELL","phone":"715-856-4093","email":"tbellscloset825@gmail.com"},
  {"name":"THE BRIAR HOUSE","address":"634 KEENAN ST","city":"RHINELANDER","state":"WI","zip":"54501","lat":45.632352,"lng":-89.411913,"owner":"SANDY BUSS","phone":"715-369-2498","email":"5sisterscoffee@gmail.com"},
  {"name":"THE CLOTHING COMPANY","address":"519 BROADWAY","city":"WISCONSIN DELLS","state":"WI","zip":"53965","lat":43.470113,"lng":-89.744388,"owner":"SHELLY NEWMAN","phone":"608-254-5456","email":"snewman488@gmail.com"},
  {"name":"THE FRONT PORCH-VILL ARTISANS","address":"1530 EAST MORELAND BLVD","city":"WAUKESHA","state":"WI","zip":"53186","lat":43.024633,"lng":-88.206315,"owner":"ANN SCHNEIDER","phone":"262-521-2100","email":"frontporchfun@gmail.com"},
  {"name":"THE GARMENT SHOP","address":"125 W MAIN","city":"CAMBRIDGE","state":"WI","zip":"53523","lat":43.00351,"lng":-89.017452,"owner":"JAN CARPENTER","phone":"608-423-3740","email":"no email"},
  {"name":"THE GIFT BOX BOUTIQUE","address":"791 SUMMIT AVE","city":"OCONOMOWOC","state":"WI","zip":"53066","lat":43.099957,"lng":-88.486755,"owner":"MARCIA RUPP","phone":"262-569-0293","email":"marcia.rupp@phci.org"},
  {"name":"TLC CASUALS","address":"635 RIVERFRONT DRIVE","city":"SHEBOYGAN","state":"WI","zip":"53081","lat":43.747882,"lng":-87.710378,"owner":"TAMI CONARD","phone":"920-451-3084","email":"tlccasuals@gmail.com"},
  {"name":"TODAY\'S TRENDS SALON","address":"6670 UNIVERSITY AVE, SUITE 103","city":"MIDDLETON","state":"WI","zip":"53562","lat":43.097217,"lng":-89.497689,"owner":"TRICIA CHRISLER","phone":"608-225-4732 c","email":"tmachrisler@charter.net"},
  {"name":"TOMAH CASH STORE","address":"914 SUPERIOR AVE","city":"TOMAH","state":"WI","zip":"54660","lat":43.977984,"lng":-90.50449,"owner":"KERRY & SALLY ROSE","phone":"608-372-2171","email":"tomahcashstore@gmail.com"},
  {"name":"TRADING POST INTERNATIONALE","address":"P.O BOX 269","city":"LAND O LAKES","state":"WI","zip":"54540","lat":46.16134,"lng":-89.21875,"owner":"HAROLD & BARBARA NEHRING","phone":"715-547-3525","email":"tradingpostint@gmail.com"},
  {"name":"TRENDZ","address":"143 EAST WISCONSIN AVENUE","city":"OCONOMOWOC","state":"WI","zip":"53066","lat":43.110595,"lng":-88.498225,"owner":"VICTORIA  ARTHUR","phone":"262-366-8258c","email":"vickyvail313@yahoo.com"},
  {"name":"WAUKESHA HOSPITAL GIFT SHOP","address":"725 AMERICAN AVE","city":"WAUKESHA","state":"WI","zip":"53188","lat":43.010723,"lng":-88.243079,"owner":"CONNIE SMITH","phone":"262-501-6477","email":"coco2005@wi.rr.com"},
  {"name":"WHAT NEXT ?","address":"PO BOX 366","city":"FISH CREEK","state":"WI","zip":"54212","lat":45.11038,"lng":-87.209899,"owner":"GINA DEVANEY","phone":"920-868-2993","email":"whatnext.gina@gmail.com"},
  {"name":"WILKINS & OLANDER","address":"120 N 3RD AVE","city":"STURGEON BAY","state":"WI","zip":"54235","lat":44.83538,"lng":-87.377164,"owner":"DAWN FISCHER","phone":"920-743-8718","email":"wogirl1990@gmail.com"},
  {"name":"THE CUTTING ROOM BOUTIQUE","address":"709 BEECHURST AVENUE SUITE 26","city":"MORGANTOWN","state":"WV","zip":"26505","lat":39.641464,"lng":-79.962752,"owner":"SANDY","phone":"304-413-2800","email":"thecuttingroomboutique@gmail.com"},
  {"name":"WISTERIAS GIFTS","address":"147 SOUTH COURT ST","city":"FAYETTEVILLE","state":"WV","zip":"25840","lat":38.051799,"lng":-81.101963,"owner":"DENISE SCALPH","phone":"304-574-3678","email":"deskewscalph@gmail.com"},
  {"name":"CRAZY WOMAN TRADING CO.","address":"3355 ROAD 29","city":"GREYBULL","state":"WY","zip":"82426","lat":44.511823,"lng":-108.014879,"owner":"LORI HARTER","phone":"307-765-2916 S","email":"crazywoman@crazywomantradingpost.com"},
  {"name":"FASHION CROSSROADS","address":"228 EAST 2ND STREET","city":"CASPER","state":"WY","zip":"82601","lat":42.848565,"lng":-106.323401,"owner":"KYLEEN STEVENSON-BRAXTON","phone":"307-237-9221","email":"kyleen@fashioncrossroadsinc.com"},
  {"name":"HOME ON THE RANGE","address":"2016 MAIN ST","city":"TORRINGTON","state":"WY","zip":"82240","lat":42.064578,"lng":-104.184789,"owner":"CHERI STIENMETZ","phone":"307-532-3820","email":"homeontherangewyo@gmail.com"},
  {"name":"JUST DANDY","address":"212 W 17TH STREET","city":"CHEYENNE","state":"WY","zip":"82001","lat":41.133573,"lng":-104.816493,"owner":"VIRGINIA BRINKERHOFF / HEATHER","phone":"307-635-2565","email":"jstdndy1@aol.com"},
  {"name":"MARTINDALES WESTERN STORE","address":"217 E. GRAND AVE","city":"LARAMIE","state":"WY","zip":"82070","lat":41.310965,"lng":-105.594753,"owner":"JOAN MARTINDALE","phone":"307-721-4100","email":"martindales217@gmail.com"},
  {"name":"POWELL VALLEY HEALTHCARE","address":"777 AVENUE H","city":"POWELL","state":"WY","zip":"82435","lat":44.756646,"lng":-108.77107,"owner":"KATIE JENSVOLD","phone":"307-254-0225","email":"jensvoldkatie@gmail.com"},
  {"name":"SPORTSLURE","address":"66 S MAIN STREET","city":"BUFFALO","state":"WY","zip":"82834","lat":44.34579,"lng":-106.699738,"owner":"SANDY TODD","phone":"307-684-8928","email":"splure@vcn.com"}
];

const BoutiqueLocatorMap = () => {
  const [mapInstance, setMapInstance] = useState(null);
  const [markers, setMarkers] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [userLocation, setUserLocation] = useState(null);
  const [selectedState, setSelectedState] = useState('ALL');
  const [sortBy, setSortBy] = useState('name');
  const [selectedStore, setSelectedStore] = useState(null);
  const [showMap, setShowMap] = useState(true);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const [markersLoaded, setMarkersLoaded] = useState(false);

  // Handle window resize with debounce
  useEffect(() => {
    let timeout;
    const handleResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setWindowWidth(window.innerWidth);
      }, 250);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobile = windowWidth <= 768;

  // Calculate distance between two coordinates (Haversine formula)
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 3959; // Earth's radius in miles
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  };

  // Get unique states from boutique data - memoized
  const states = React.useMemo(() => {
    return ['ALL', ...Array.from(new Set(BOUTIQUE_DATA.map(b => b.state))).sort()];
  }, []);

  // Filter and sort boutiques - memoized to prevent re-calculations
  // THIS ALWAYS RETURNS FULL LIST - no limiting here!
  const filteredBoutiques = React.useMemo(() => {
    let filtered = BOUTIQUE_DATA.filter(b => b.lat && b.lng);

    // Filter by state
    if (selectedState !== 'ALL') {
      filtered = filtered.filter(b => b.state === selectedState);
    }

    // Filter by search term
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(b =>
        b.name.toLowerCase().includes(term) ||
        b.city.toLowerCase().includes(term) ||
        b.state.toLowerCase().includes(term) ||
        (b.owner && b.owner.toLowerCase().includes(term))
      );
    }

    // Calculate distances if user location available
    if (userLocation) {
      filtered = filtered.map(b => ({
        ...b,
        distance: calculateDistance(userLocation.lat, userLocation.lng, b.lat, b.lng)
      }));
    }

    // Sort
    if (sortBy === 'distance' && userLocation) {
      filtered.sort((a, b) => (a.distance || 999999) - (b.distance || 999999));
    } else if (sortBy === 'name') {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortBy === 'state') {
      filtered.sort((a, b) => {
        if (a.state === b.state) return a.city.localeCompare(b.city);
        return a.state.localeCompare(b.state);
      });
    }

    return filtered; // FULL LIST - all filtered results
  }, [selectedState, searchTerm, userLocation, sortBy]);

  // Get markers to show on map - THIS is where we limit for mobile performance
  const mapMarkers = React.useMemo(() => {
    // On mobile, intelligently limit map markers for performance
    if (isMobile && filteredBoutiques.length > 300) {
      // If user has location and sorted by distance, show nearest 300
      if (userLocation && sortBy === 'distance') {
        return filteredBoutiques.slice(0, 300);
      }
      // Otherwise, sample evenly across all states
      const stateGroups = {};
      filteredBoutiques.forEach(b => {
        if (!stateGroups[b.state]) stateGroups[b.state] = [];
        stateGroups[b.state].push(b);
      });
      
      const sampled = [];
      const statesArray = Object.keys(stateGroups);
      const perState = Math.ceil(300 / statesArray.length);
      
      statesArray.forEach(state => {
        sampled.push(...stateGroups[state].slice(0, perState));
      });
      
      return sampled.slice(0, 300);
    }
    // Desktop or small list: show all
    return filteredBoutiques;
  }, [filteredBoutiques, isMobile, userLocation, sortBy]);

  // Initialize map - only once
  useEffect(() => {
    if (typeof window === 'undefined' || !window.L || mapInstance) {
      return;
    }

    try {
      const map = window.L.map('boutique-map', {
        preferCanvas: true,
        tap: true,
        tapTolerance: 15
      }).setView([39.8283, -98.5795], 4);

      window.L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19
      }).addTo(map);

      setMapInstance(map);
    } catch (error) {
      console.error('Error initializing map:', error);
    }

    return () => {
      if (mapInstance) {
        try {
          mapInstance.remove();
        } catch (e) {
          console.error('Error removing map:', e);
        }
      }
    };
  }, []);

  // Add markers to map - separate effect with proper cleanup
  useEffect(() => {
    if (!mapInstance || !window.L || markersLoaded) return;

    setIsLoading(true);
    
    try {
      const markerGroup = window.L.markerClusterGroup ? window.L.markerClusterGroup({
        maxClusterRadius: 50,
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        animate: false
      }) : window.L.layerGroup();

      mapMarkers.forEach((boutique) => {
        if (boutique.lat && boutique.lng) {
          try {
            const marker = window.L.marker([boutique.lat, boutique.lng], {
              icon: window.L.divIcon({
                className: 'custom-marker',
                html: '<div style="background-color:#5F6E54;width:12px;height:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 2px 4px rgba(0,0,0,0.3);"></div>',
                iconSize: [16, 16],
                iconAnchor: [8, 8]
              })
            });

            const popupContent = `
              <div style="font-family:Arial,sans-serif;padding:10px;min-width:200px;">
                <div style="font-weight:600;color:#141412;margin-bottom:8px;font-size:15px;border-bottom:1px solid #ddd;padding-bottom:6px;">
                  ${boutique.name}
                </div>
                <div style="color:#666;font-size:12px;margin-bottom:4px;">
                  📍 ${boutique.address}
                </div>
                <div style="color:#666;font-size:12px;margin-bottom:8px;">
                  ${boutique.city}, ${boutique.state} ${boutique.zip}
                </div>
                ${boutique.owner ? `
                <div style="color:#141412;font-size:12px;margin-bottom:4px;">
                  👤 <strong>Owner:</strong> ${boutique.owner}
                </div>
                ` : ''}
                ${boutique.phone ? `
                <div style="color:#141412;font-size:12px;margin-bottom:4px;">
                  📞 <strong>Phone:</strong> <a href="tel:${boutique.phone.replace(/[^0-9]/g, '')}" style="color:#5F6E54;text-decoration:none;">${boutique.phone}</a>
                </div>
                ` : ''}
                ${boutique.distance ? `
                <div style="color:#5F6E54;font-size:12px;font-weight:600;margin-top:8px;">
                  ↗ ${boutique.distance.toFixed(1)} miles away
                </div>
                ` : ''}
              </div>
            `;

            marker.bindPopup(popupContent, { maxWidth: 250 });
            
            marker.on('click', () => {
              setSelectedStore(boutique);
            });

            markerGroup.addLayer(marker);
          } catch (error) {
            console.error(`Error adding marker for ${boutique.name}:`, error);
          }
        }
      });

      if (markers) {
        mapInstance.removeLayer(markers);
      }

      markerGroup.addTo(mapInstance);
      setMarkers(markerGroup);
      setMarkersLoaded(true);
      setIsLoading(false);
    } catch (error) {
      console.error('Error loading markers:', error);
      setIsLoading(false);
    }
  }, [mapInstance]);

  // Update markers when filters change - separate effect
  useEffect(() => {
    if (!mapInstance || !window.L || !markersLoaded) return;

    const timeout = setTimeout(() => {
      try {
        if (markers) {
          mapInstance.removeLayer(markers);
        }

        const markerGroup = window.L.markerClusterGroup ? window.L.markerClusterGroup({
          maxClusterRadius: 50,
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: false,
          zoomToBoundsOnClick: true,
          animate: false
        }) : window.L.layerGroup();

        mapMarkers.forEach((boutique) => {
          if (boutique.lat && boutique.lng) {
            try {
              const marker = window.L.marker([boutique.lat, boutique.lng], {
                icon: window.L.divIcon({
                  className: 'custom-marker',
                  html: '<div style="background-color:#5F6E54;width:12px;height:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 2px 4px rgba(0,0,0,0.3);"></div>',
                  iconSize: [16, 16],
                  iconAnchor: [8, 8]
                })
              });

              const popupContent = `
                <div style="font-family:Arial,sans-serif;padding:10px;min-width:200px;">
                  <div style="font-weight:600;color:#141412;margin-bottom:8px;font-size:15px;">
                    ${boutique.name}
                  </div>
                  <div style="color:#666;font-size:12px;margin-bottom:4px;">
                    📍 ${boutique.address}
                  </div>
                  <div style="color:#666;font-size:12px;">
                    ${boutique.city}, ${boutique.state} ${boutique.zip}
                  </div>
                  ${boutique.distance ? `
                  <div style="color:#5F6E54;font-size:12px;font-weight:600;margin-top:8px;">
                    ↗ ${boutique.distance.toFixed(1)} miles away
                  </div>
                  ` : ''}
                </div>
              `;

              marker.bindPopup(popupContent, { maxWidth: 250 });
              markerGroup.addLayer(marker);
            } catch (error) {
              console.error('Error adding filtered marker:', error);
            }
          }
        });

        markerGroup.addTo(mapInstance);
        setMarkers(markerGroup);
      } catch (error) {
        console.error('Error updating markers:', error);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [mapMarkers, markersLoaded]);

  // Find nearest stores
  const handleFindNearest = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
          setSortBy('distance');
        },
        (error) => {
          alert('Unable to get your location. Please enable location services.');
          console.error('Geolocation error:', error);
        }
      );
    } else {
      alert('Geolocation is not supported by your browser.');
    }
  };

  // Zoom to store on map
  const handleViewOnMap = (boutique) => {
    if (mapInstance && boutique.lat && boutique.lng) {
      try {
        mapInstance.setView([boutique.lat, boutique.lng], 13);
        setSelectedStore(boutique);
        if (isMobile) {
          setShowMap(true);
        }
        
        // If this store isn't in mapMarkers, add a temporary marker
        const isInMapMarkers = mapMarkers.some(m => m.name === boutique.name);
        if (!isInMapMarkers) {
          // Create a temporary marker for this specific store
          const tempMarker = window.L.marker([boutique.lat, boutique.lng], {
            icon: window.L.divIcon({
              className: 'custom-marker',
              html: '<div style="background-color:#5F6E54;width:12px;height:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 2px 4px rgba(0,0,0,0.3);"></div>',
              iconSize: [16, 16],
              iconAnchor: [8, 8]
            })
          }).addTo(mapInstance);
          
          const popupContent = `
            <div style="font-family:Arial,sans-serif;padding:10px;min-width:200px;">
              <div style="font-weight:600;color:#141412;margin-bottom:8px;font-size:15px;">
                ${boutique.name}
              </div>
              <div style="color:#666;font-size:12px;margin-bottom:4px;">
                📍 ${boutique.address}
              </div>
              <div style="color:#666;font-size:12px;">
                ${boutique.city}, ${boutique.state} ${boutique.zip}
              </div>
            </div>
          `;
          
          tempMarker.bindPopup(popupContent).openPopup();
        }
      } catch (error) {
        console.error('Error zooming to store:', error);
      }
    }
  };

  // Get directions
  const handleGetDirections = (boutique) => {
    const destination = `${boutique.address}, ${boutique.city}, ${boutique.state} ${boutique.zip}`;
    const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
    window.open(url, '_blank');
  };

  // Store card component
  const StoreCard = React.memo(({ boutique, index }) => {
    const isSelected = selectedStore && selectedStore.name === boutique.name;
    
    return (
      <div
        style={{
          padding: '15px',
          backgroundColor: isSelected ? '#f5f5f5' : '#fff',
          borderBottom: '1px solid #e0e0e0',
          cursor: 'pointer'
        }}
        onClick={() => handleViewOnMap(boutique)}
      >
        <div style={{ fontWeight: '600', color: '#141412', marginBottom: '6px', fontSize: '14px' }}>
          📍 {boutique.name}
        </div>
        <div style={{ color: '#666', fontSize: '12px', marginBottom: '4px' }}>
          🏢 {boutique.city}, {boutique.state}
        </div>
        {boutique.phone && (
          <div style={{ color: '#666', fontSize: '12px', marginBottom: '4px' }}>
            📞 <a href={`tel:${boutique.phone.replace(/[^0-9]/g, '')}`} style={{ color: '#5F6E54', textDecoration: 'none' }} onClick={(e) => e.stopPropagation()}>
              {boutique.phone}
            </a>
          </div>
        )}
        {boutique.distance !== undefined && (
          <div style={{ color: '#5F6E54', fontSize: '13px', fontWeight: '600', marginTop: '6px' }}>
            ↗ {boutique.distance.toFixed(1)} miles away
          </div>
        )}
        <div style={{ marginTop: '8px', display: 'flex', gap: '8px' }}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleViewOnMap(boutique);
            }}
            style={{
              padding: '6px 12px',
              backgroundColor: '#5F6E54',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '11px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            View
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleGetDirections(boutique);
            }}
            style={{
              padding: '6px 12px',
              backgroundColor: '#fff',
              color: '#5F6E54',
              border: '1px solid #5F6E54',
              borderRadius: '4px',
              fontSize: '11px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Directions →
          </button>
        </div>
      </div>
    );
  });

  return (
    <div style={{ position: 'relative' }}>
      {/* Controls Bar */}
      <div style={{
        backgroundColor: '#505050',
        padding: '15px 20px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        alignItems: 'center',
        justifyContent: isMobile ? 'center' : 'flex-start'
      }}>
        {/* Search */}
        <input
          type="text"
          placeholder="🔍 Search stores..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            flex: isMobile ? '1 1 100%' : '1 1 250px',
            padding: '10px 15px',
            border: '1px solid #666',
            borderRadius: '4px',
            fontSize: '14px',
            backgroundColor: '#fff',
            color: '#333'
          }}
        />

        {/* Find Nearest Button */}
        <button
          onClick={handleFindNearest}
          style={{
            padding: '10px 20px',
            backgroundColor: '#5F6E54',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            whiteSpace: 'nowrap'
          }}
        >
          📍 Find Nearest
        </button>

        {/* State Filter */}
        <select
          value={selectedState}
          onChange={(e) => setSelectedState(e.target.value)}
          style={{
            padding: '10px 15px',
            border: '1px solid #666',
            borderRadius: '4px',
            fontSize: '14px',
            backgroundColor: '#fff',
            color: '#333',
            cursor: 'pointer'
          }}
        >
          {states.map(state => (
            <option key={state} value={state}>
              {state === 'ALL' ? 'All States' : state}
            </option>
          ))}
        </select>

        {/* Sort By */}
        {userLocation && (
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            style={{
              padding: '10px 15px',
              border: '1px solid #666',
              borderRadius: '4px',
              fontSize: '14px',
              backgroundColor: '#fff',
              color: '#333',
              cursor: 'pointer'
            }}
          >
            <option value="distance">Sort: Distance</option>
            <option value="name">Sort: Name</option>
            <option value="state">Sort: State</option>
          </select>
        )}

        {/* Mobile Toggle */}
        {isMobile && (
          <div style={{ display: 'flex', gap: '5px', flex: '1 1 100%', justifyContent: 'center' }}>
            <button
              onClick={() => setShowMap(true)}
              style={{
                flex: 1,
                padding: '10px',
                backgroundColor: showMap ? '#5F6E54' : '#666',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              🗺️ Map
            </button>
            <button
              onClick={() => setShowMap(false)}
              style={{
                flex: 1,
                padding: '10px',
                backgroundColor: !showMap ? '#5F6E54' : '#666',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              📋 List
            </button>
          </div>
        )}
      </div>

      {/* Results Count */}
      <div style={{
        backgroundColor: '#404040',
        padding: '10px 20px',
        color: '#ccc',
        fontSize: '14px',
        textAlign: 'center'
      }}>
        {filteredBoutiques.length} {filteredBoutiques.length === 1 ? 'store' : 'stores'} found
        {isMobile && mapMarkers.length < filteredBoutiques.length && ` (showing ${mapMarkers.length} on map)`}
        {userLocation && sortBy === 'distance' && ' (sorted by distance)'}
      </div>

      {/* Main Content */}
      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        height: '600px',
        backgroundColor: '#404040'
      }}>
        {/* Store List - ALWAYS SHOWS ALL FILTERED BOUTIQUES */}
        {(!isMobile || !showMap) && (
          <div style={{
            width: isMobile ? '100%' : '35%',
            height: '100%',
            overflowY: 'auto',
            backgroundColor: '#fff',
            borderRight: isMobile ? 'none' : '2px solid #555',
            WebkitOverflowScrolling: 'touch'
          }}>
            {filteredBoutiques.map((boutique, index) => (
              <StoreCard key={`${boutique.name}-${index}`} boutique={boutique} index={index} />
            ))}
            {filteredBoutiques.length === 0 && (
              <div style={{
                padding: '40px 20px',
                textAlign: 'center',
                color: '#999'
              }}>
                <div style={{ fontSize: '48px', marginBottom: '10px' }}>🔍</div>
                <div style={{ fontSize: '16px', marginBottom: '5px' }}>No stores found</div>
                <div style={{ fontSize: '14px' }}>Try adjusting your search or filters</div>
              </div>
            )}
          </div>
        )}

        {/* Map - Shows limited markers on mobile for performance */}
        {(!isMobile || showMap) && (
          <div style={{
            width: isMobile ? '100%' : '65%',
            height: '100%',
            position: 'relative'
          }}>
            <div
              id="boutique-map"
              style={{
                width: '100%',
                height: '100%'
              }}
            />
            {isLoading && (
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: '#fff',
                padding: '15px 25px',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                fontSize: '14px',
                color: '#141412'
              }}>
                Loading map...
              </div>
            )}
            {isMobile && mapMarkers.length < filteredBoutiques.length && (
              <div style={{
                position: 'absolute',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'rgba(0,0,0,0.7)',
                color: '#fff',
                padding: '8px 15px',
                borderRadius: '20px',
                fontSize: '12px',
                zIndex: 1000
              }}>
                Showing {mapMarkers.length} of {filteredBoutiques.length} stores on map
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};


// ============================================================
// StatCounter — counts up to a target when scrolled into view.
// Years (e.g. 1995) are shown as-is; other numbers animate 0 -> target.
// ============================================================
// ============================================================
// MarqueeRunway — continuously scrolling strip of collection shots.
// Idle: drifts left at a steady pace (~5s per image).
// On hover: the pointer's horizontal position scrubs the strip —
//   far right = fast forward, far left = rewind, centre = hold still.
// Driven by requestAnimationFrame so direction can reverse smoothly.
// ============================================================
const MarqueeRunway = ({ images, isSmall, bandColor }) => {
  const viewportRef = React.useRef(null);
  const trackRef = React.useRef(null);
  const offsetRef = React.useRef(0);
  const hoverRef = React.useRef(false);
  const factorRef = React.useRef(0);   // -1 (rewind) .. +1 (forward)
  const rafRef = React.useRef(null);

  const SEC_PER_IMAGE = 5;   // idle pace
  const MAX_SCRUB = 5;       // top speed multiplier at the edges
  const DEAD_ZONE = 0.12;    // middle band where the strip holds still

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const reduced = typeof window !== 'undefined' && window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    let last = performance.now();

    const tick = (now) => {
      const dt = Math.min(now - last, 50); // clamp after tab-switches
      last = now;

      const half = (track.scrollWidth / 2) || 1;
      const basePx = half / (images.length * SEC_PER_IMAGE * 1000); // px per ms

      const speed = hoverRef.current
        ? basePx * factorRef.current * MAX_SCRUB
        : basePx;

      let next = offsetRef.current - speed * dt;
      // wrap in both directions so the loop stays seamless either way
      if (next <= -half) next += half;
      if (next > 0) next -= half;
      offsetRef.current = next;

      track.style.transform = `translateX(${next}px)`;
      rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => rafRef.current && cancelAnimationFrame(rafRef.current);
  }, [images.length]);

  const handleMove = (e) => {
    const el = viewportRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const pos = (e.clientX - r.left) / r.width;      // 0 .. 1
    const raw = pos * 2 - 1;                          // -1 .. 1
    const mag = Math.abs(raw);
    factorRef.current = mag < DEAD_ZONE
      ? 0
      : Math.sign(raw) * ((mag - DEAD_ZONE) / (1 - DEAD_ZONE));
  };

  return (
    <div
      ref={viewportRef}
      onMouseEnter={() => { hoverRef.current = true; }}
      onMouseMove={handleMove}
      onMouseLeave={() => { hoverRef.current = false; factorRef.current = 0; }}
      style={{
        width: '100%',
        overflow: 'hidden',
        padding: '4px 0',
        cursor: 'ew-resize',
        animation: 'fadeIn 1.2s ease 0.4s forwards',
        opacity: 0
      }}
    >
      <div
        ref={trackRef}
        style={{ display: 'flex', width: 'max-content', willChange: 'transform' }}
      >
        {[...images, ...images].map((src, i) => (
          <div key={i} style={{
            flex: 'none',
            width: isSmall ? '150px' : '190px',
            height: isSmall ? '200px' : '254px',
            marginRight: isSmall ? '12px' : '16px',
            overflow: 'hidden',
            backgroundColor: bandColor
          }}>
            <img
              src={src}
              alt="Parsley &amp; Sage collection look"
              loading="lazy"
              draggable="false"
              aria-hidden={i >= images.length ? 'true' : undefined}
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', display: 'block' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const StatCounter = ({ target, prefix = '', suffix = '', isYear = false }) => {
  const [display, setDisplay] = useState(isYear ? target : 0);
  const ref = React.useRef(null);
  const startedRef = React.useRef(false);

  useEffect(() => {
    if (isYear) { setDisplay(target); return; }
    const el = ref.current;
    if (!el) return;

    const runCount = () => {
      if (startedRef.current) return;
      startedRef.current = true;
      const duration = 1400;
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        // easeOutCubic
        const eased = 1 - Math.pow(1 - p, 3);
        setDisplay(Math.round(eased * target));
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    if (typeof IntersectionObserver === 'undefined') { runCount(); return; }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) runCount(); });
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [target, isYear]);

  return (
    <div ref={ref} style={{
      fontFamily: "'Cormorant Garamond', serif",
      fontWeight: 300,
      fontSize: window.innerWidth <= 768 ? '40px' : '46px',
      color: '#141412',
      lineHeight: 1
    }}>
      {prefix}{display}{suffix}
    </div>
  );
};

const App = () => {
  const [currentPage, setCurrentPage] = useState('HOME');
  const [showDropdown, setShowDropdown] = useState(false);
  const [showCurrentSubDropdown, setShowCurrentSubDropdown] = useState(false);
  const [showWorkDropdown, setShowWorkDropdown] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [pendingTab, setPendingTab] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageOpacity, setPageOpacity] = useState(1);
  const [isPageEntering, setIsPageEntering] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedYearFilter, setSelectedYearFilter] = useState('All');
  const [selectedSeasonFilter, setSelectedSeasonFilter] = useState('All');
  const [hoverCatalog, setHoverCatalog] = useState(null);

  // ========================================
  // ANIMATION KEYFRAMES INJECTION
  // ========================================
  useEffect(() => {
    const styleId = 'parsley-sage-animations';
    if (document.getElementById(styleId)) return;
    
    const styleSheet = document.createElement('style');
    styleSheet.id = styleId;
    styleSheet.textContent = `
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      
      @keyframes slideInRight {
        from {
          opacity: 0;
          transform: translateX(30px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
      
      @keyframes scaleIn {
        from {
          opacity: 0;
          transform: scale(0.95);
        }
        to {
          opacity: 1;
          transform: scale(1);
        }
      }
      
      @keyframes shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
      
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.7; }
      }
      
      @keyframes float {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
      }
      
      @keyframes drawLine {
        from { width: 0; }
        to { width: 100%; }
      }
      
      @keyframes buttonGlow {
        0%, 100% { box-shadow: 0 8px 32px rgba(95, 110, 84, 0.12); }
        50% { box-shadow: 0 8px 40px rgba(95, 110, 84, 0.2); }
      }
      
      /* Glassmorphism button hover effects */
      .glass-btn {
        position: relative;
        overflow: hidden;
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      }
      
      .glass-btn::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
        transition: left 0.5s ease;
      }
      
      .glass-btn:hover::before {
        left: 100%;
      }
      
      /* Scroll reveal classes */
      .reveal-fade-up {
        opacity: 0;
        transform: translateY(40px);
        transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      }
      
      .reveal-fade-up.revealed {
        opacity: 1;
        transform: translateY(0);
      }
      
      .reveal-scale {
        opacity: 0;
        transform: scale(0.9);
        transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      }
      
      .reveal-scale.revealed {
        opacity: 1;
        transform: scale(1);
      }
      
      /* Page transition */
      .page-content {
        transition: opacity 0.3s ease, transform 0.3s ease;
      }
      
      .page-content.entering {
        animation: fadeInUp 0.5s ease forwards;
      }
      
      /* Stagger children animation */
      .stagger-children > * {
        opacity: 0;
        transform: translateY(20px);
      }
      
      .stagger-children.animate > *:nth-child(1) { animation: fadeInUp 0.5s ease 0.1s forwards; }
      .stagger-children.animate > *:nth-child(2) { animation: fadeInUp 0.5s ease 0.15s forwards; }
      .stagger-children.animate > *:nth-child(3) { animation: fadeInUp 0.5s ease 0.2s forwards; }
      .stagger-children.animate > *:nth-child(4) { animation: fadeInUp 0.5s ease 0.25s forwards; }
      .stagger-children.animate > *:nth-child(5) { animation: fadeInUp 0.5s ease 0.3s forwards; }
      .stagger-children.animate > *:nth-child(6) { animation: fadeInUp 0.5s ease 0.35s forwards; }
      .stagger-children.animate > *:nth-child(7) { animation: fadeInUp 0.5s ease 0.4s forwards; }
      .stagger-children.animate > *:nth-child(8) { animation: fadeInUp 0.5s ease 0.45s forwards; }
      .stagger-children.animate > *:nth-child(9) { animation: fadeInUp 0.5s ease 0.5s forwards; }
      .stagger-children.animate > *:nth-child(10) { animation: fadeInUp 0.5s ease 0.55s forwards; }
      
      /* Nav underline animation */
      .nav-link-animated {
        position: relative;
      }
      
      .nav-link-animated::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 50%;
        width: 0;
        height: 1px;
        background: rgba(95, 110, 84, 0.85);
        transition: all 0.3s ease;
        transform: translateX(-50%);
      }
      
      .nav-link-animated:hover::after {
        width: 80%;
      }
      
      /* Back to top button */
      .back-to-top {
        position: fixed;
        bottom: 30px;
        right: 30px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: rgba(95, 110, 84, 0.15);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.15);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        pointer-events: none;
      }
      
      .back-to-top.visible {
        opacity: 1;
        transform: translateY(0);
        pointer-events: auto;
      }
      
      .back-to-top:hover {
        background: rgba(95, 110, 84, 0.3);
        transform: translateY(-3px);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
      }
    `;
    document.head.appendChild(styleSheet);
    
    return () => {
      const el = document.getElementById(styleId);
      if (el) el.remove();
    };
  }, []);

  // ========================================
  // SCROLL REVEAL OBSERVER
  // ========================================
  useEffect(() => {
    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
        }
      });
    };
    
    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    // Observe elements after a short delay to ensure DOM is ready
    const timeout = setTimeout(() => {
      document.querySelectorAll('.reveal-fade-up, .reveal-scale').forEach(el => {
        observer.observe(el);
      });
    }, 100);
    
    return () => {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, [currentPage]);

  // ========================================
  // BACK TO TOP VISIBILITY
  // ========================================
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const CURRENT_COLLECTION_PASS = "SAGE2026";
  const TABS = ['HOME', 'COLLECTIONS', 'PARSLEY & SAGE BOUTIQUES','TRADE SHOW CALENDAR', 'OUR TEAM', 'OUR STORY', 'WORK WITH US', 'MY ACCOUNT'];

  // ============================================================
  // DESIGN TOKENS — "White canvas, sage punctuation" system
  // White is where you sell (photography/catalogs); sage is where you speak (brand moments).
  // ============================================================
  const C = {
    canvas: '#FFFFFF',        // primary background — where product lives
    ink: '#141412',           // near-black primary text
    inkSoft: '#55554E',       // secondary text
    inkMuted: '#77766E',      // captions, meta
    sageBand: '#EDEFE8',      // light sage surface for brand/story sections
    sageDeep: '#232A22',      // deep sage for footer / dark moments
    sageAccent: '#5F6E54',    // sage accent for links, eyebrows, active states
    sageAccentSoft: 'rgba(95, 110, 84, 0.12)', // tint for hovers/active fills
    hairline: 'rgba(20, 20, 18, 0.12)',  // hairline dividers on white
    hairlineSoft: 'rgba(20, 20, 18, 0.08)',
    onSage: '#F2EFE6',        // ivory text on deep sage
    onSageSoft: '#A8B29E',    // muted text on deep sage
  };
  
  const INSTAGRAM_HANDLE = "parsleyandsageus";
  const FACEBOOK_URL = "https://www.facebook.com/parsley.sage.1";
  const PINTEREST_URL = "https://www.pinterest.com/parsley1085/";
  
  // Google Analytics Tracking ID - REPLACE WITH YOUR ACTUAL GA4 MEASUREMENT ID
  const GA_TRACKING_ID = 'G-RV689KLF4C'; // Google Analytics 4 tracking ID

  // ========================================
  // ENHANCED META TAGS FOR SEO - USA EMPHASIS
  // ========================================
  const ENHANCED_META_TAGS = {
    'HOME': {
      title: 'Parsley & Sage USA | Authentic American Wholesale Clothing Since 1995',
      description: 'Official Parsley & Sage USA wholesale clothing. French embroidered tops, Indian block prints. American family-owned since 1995, based in Georgia. The only authentic Parsley & Sage serving the United States - parsley-sage.com',
      keywords: 'Parsley and Sage USA, Parsley & Sage America, parsley-sage.com, French wholesale clothing USA, Indian wholesale boutique America, authentic Parsley Sage United States, wholesale boutique USA, American wholesale clothing',
      canonical: 'https://www.parsley-sage.com/',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'OUR STORY': {
      title: 'Our Story | Parsley & Sage USA - 30 Years of American Wholesale Excellence',
      description: 'The authentic Parsley & Sage USA story. American family-owned wholesale boutique clothing company established 1995 in Georgia. French embroidery meets Indian block prints. Serving the United States exclusively at parsley-sage.com.',
      keywords: 'Parsley & Sage USA history, American Parsley and Sage, family owned boutique wholesale USA, French Indian clothing America',
      canonical: 'https://www.parsley-sage.com/our-story',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'CURRENT_COLLECTIONS': {
      title: 'Current Collections | Parsley & Sage USA Official Wholesale Catalogs',
      description: 'View authentic Parsley & Sage USA SS26 and FW26 wholesale collections. French embroidered tunics, Indian block print tops. Official American wholesale pricing at parsley-sage.com only.',
      keywords: 'Parsley Sage USA collections, American wholesale catalog, SS26 USA, FW26 America, authentic Parsley and Sage United States',
      canonical: 'https://www.parsley-sage.com/collections',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'SS26': {
      title: 'Spring Summer 2026 | Parsley & Sage USA Wholesale Catalog',
      description: 'View authentic Parsley & Sage USA SS26 wholesale collection. French embroidered tunics, Indian block print tops. Official American wholesale pricing at parsley-sage.com only.',
      keywords: 'Parsley Sage USA SS26, Spring Summer 2026 wholesale, American wholesale catalog SS26, authentic Parsley and Sage United States',
      canonical: 'https://www.parsley-sage.com/ss26',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'FW26': {
      title: 'Fall Winter 2026 | Parsley & Sage USA Wholesale Catalog',
      description: 'View authentic Parsley & Sage USA FW26 wholesale collection. French embroidered tunics, Indian block print tops. Official American wholesale pricing at parsley-sage.com only.',
      keywords: 'Parsley Sage USA FW26, Fall Winter 2026 wholesale, American wholesale catalog FW26, authentic Parsley and Sage United States',
      canonical: 'https://www.parsley-sage.com/fw26',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'SS27': {
      title: 'Spring Summer 2027 | Parsley & Sage USA Wholesale Catalog',
      description: 'View authentic Parsley & Sage USA SS27 wholesale collection. French embroidered tunics, Indian block print tops. Official American wholesale pricing at parsley-sage.com only.',
      keywords: 'Parsley Sage USA SS27, Spring Summer 2027 wholesale, American wholesale catalog SS27, authentic Parsley and Sage United States',
      canonical: 'https://www.parsley-sage.com/ss27',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'PREVIOUS_COLLECTIONS': {
      title: 'Previous Collections | Parsley & Sage USA Archive',
      description: 'Browse archived Parsley & Sage USA collections. Authentic American French and Indian wholesale clothing catalog history from parsley-sage.com.',
      keywords: 'Parsley Sage USA archive, previous collections America, American wholesale catalog history',
      canonical: 'https://www.parsley-sage.com/previous',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'PARSLEY & SAGE BOUTIQUES': {
      title: 'Authorized USA Boutiques | Where to Buy Parsley & Sage in America',
      description: 'Find authorized Parsley & Sage retailers across the United States. Authentic French embroidered and Indian block print clothing from verified American boutiques.',
      keywords: 'Parsley Sage boutiques USA, authorized American retailers, where to buy Parsley and Sage America, authentic USA retailers',
      canonical: 'https://www.parsley-sage.com/boutiques',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'OUR TEAM': {
      title: 'Our Team | Parsley & Sage USA Sales Representatives',
      description: 'Meet the Parsley & Sage USA sales team. Dedicated American wholesale representatives serving boutiques across the United States from parsley-sage.com.',
      keywords: 'Parsley Sage USA sales reps, American wholesale representatives, US boutique sales team',
      canonical: 'https://www.parsley-sage.com/team',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'WORK WITH US': {
      title: 'Work With Us | Partner with Parsley & Sage USA Wholesale',
      description: 'Become an authorized Parsley & Sage USA retailer. View terms, order forms, and contact our American wholesale team at parsley-sage.com.',
      keywords: 'Parsley Sage USA wholesale, become a US retailer, American wholesale partnership, boutique ordering USA',
      canonical: 'https://www.parsley-sage.com/work-with-us',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'MENS': {
      title: 'Limited Edition | Exclusive Parsley & Sage USA Pre-Order Collection',
      description: 'Pre-order exclusive Parsley & Sage USA limited edition pieces. Safari shirts featuring French and Indian craftsmanship. Only 50 available per style in the United States.',
      keywords: 'Parsley Sage USA limited edition, exclusive American wholesale, Safari shirts USA, pre-order clothing America',
      canonical: 'https://www.parsley-sage.com/mens',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'TRADE SHOW CALENDAR': {
      title: 'Trade Show Calendar | Parsley & Sage USA Wholesale Events',
      description: 'Find Parsley & Sage USA at upcoming wholesale trade shows and markets across the United States. Meet our American sales team in person.',
      keywords: 'Parsley Sage trade shows, wholesale markets USA, fashion trade events America',
      canonical: 'https://www.parsley-sage.com/trade-shows',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    },
    'ORDERING DOCS': {
      title: 'Ordering Documents | Parsley & Sage USA Wholesale Forms',
      description: 'Download order forms, credit applications, and wholesale documents for Parsley & Sage USA. American wholesale ordering made easy.',
      keywords: 'Parsley Sage order forms, wholesale documents USA, credit application',
      canonical: 'https://www.parsley-sage.com/ordering-documents',
      ogImage: 'https://www.parsley-sage.com/images/og-logo.png'
    }
  };

  // URL path mapping
  const pageToPath = {
    'HOME': '/',
    'OUR STORY': '/our-story',
    'OUR TEAM': '/our-team',
    'WORK WITH US': '/work-with-us',
    'ORDERING DOCS': '/ordering-documents',
    'PARSLEY & SAGE BOUTIQUES': '/boutiques',
    'TRADE SHOW CALENDAR': '/trade-shows',
    'CURRENT_COLLECTIONS': '/collections/current',
    'SS26': '/ss26',
    'FW26': '/fw26',
    'SS27': '/ss27',
    'PREVIOUS_COLLECTIONS': '/previous',
    'PASSWORD_PROMPT': '/collections/access',
    'F26WP_PDF': '/F26WP.pdf',
    'F26_PDF': '/F26.pdf',
    'SS26WP_PDF': '/SS26WP.pdf',
    'SS27WP_PDF': '/SS27WP.pdf',
    'MENS': '/mens',
    'F26_VIDEOS': '/F26/F26Videos/index.html',
    'SS26_VIDEOS': '/SS26/SS26videos/',
    'SS26_FASHIONSHOTS': '/SS26/SS26fashionshots/',
    'SS26_REELS': '/SS26/SS26Reels/'
  };

  const pathToPage = Object.fromEntries(
    Object.entries(pageToPath).map(([page, path]) => [path, page])
  );

  // Google Analytics - Initialize on mount
  useEffect(() => {
    // Only load if tracking ID is set (not the placeholder)
    if (GA_TRACKING_ID && GA_TRACKING_ID !== 'G-XXXXXXXXXX') {
      // Load Google Analytics script
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
      document.head.appendChild(script1);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', GA_TRACKING_ID);
    }
  }, []);

  // Track page views in Google Analytics
  useEffect(() => {
    if (window.gtag && GA_TRACKING_ID !== 'G-XXXXXXXXXX') {
      window.gtag('event', 'page_view', {
        page_path: pageToPath[currentPage] || '/',
        page_title: currentPage
      });
    }
  }, [currentPage]);

  // Handle initial page load from URL
  useEffect(() => {
    const path = window.location.pathname;
    const page = pathToPage[path] || 'HOME';
    setCurrentPage(page);
  }, []);

  // Handle browser back/forward buttons
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      const page = pathToPage[path] || 'HOME';
      setCurrentPage(page);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // ========================================
  // ENHANCED META TAGS & SEO
  // ========================================
  useEffect(() => {
    const pageData = ENHANCED_META_TAGS[currentPage] || ENHANCED_META_TAGS['HOME'];
    
    // PRICING PAGES - NOINDEX (Keep private from search engines)
    const isPricingPage = currentPage === 'F26WP_PDF' || currentPage === 'SS26WP_PDF' || currentPage === 'SS27WP_PDF';
    
    if (isPricingPage) {
      // Title for pricing pages
      const pricingTitles = {
        'F26WP_PDF': 'Fall Winter 2026 Wholesale Prices | Parsley & Sage USA',
        'SS26WP_PDF': 'Spring Summer 2026 Wholesale Prices | Parsley & Sage USA',
        'SS27WP_PDF': 'Spring Summer 2027 Wholesale Prices | Parsley & Sage USA'
      };
      document.title = pricingTitles[currentPage] || 'Wholesale Prices | Parsley & Sage USA';
      
      // NOINDEX meta tag - prevents search engines from indexing
      let metaRobots = document.querySelector('meta[name="robots"]');
      if (!metaRobots) {
        metaRobots = document.createElement('meta');
        metaRobots.setAttribute('name', 'robots');
        document.head.appendChild(metaRobots);
      }
      metaRobots.content = 'noindex, nofollow';
      
      // Simple description
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = 'Confidential wholesale pricing. For authorized retailers only.';
      
      return; // Don't add other SEO tags for pricing pages
    }
    
    // FOR ALL OTHER PAGES - FULL SEO
    
    // Title
    document.title = pageData.title;
    
    // Meta Description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = pageData.description;
    
    // Meta Keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = pageData.keywords;
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.href = pageData.canonical;
    
    // Open Graph - OG:Title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.content = pageData.title;
    
    // Open Graph - OG:Description
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (!ogDesc) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.appendChild(ogDesc);
    }
    ogDesc.content = pageData.description;
    
    // Open Graph - OG:Image
    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.appendChild(ogImage);
    }
    ogImage.content = pageData.ogImage;
    
    // Open Graph - OG:URL
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.content = pageData.canonical;
    
    // Open Graph - OG:Type
    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      ogType = document.createElement('meta');
      ogType.setAttribute('property', 'og:type');
      document.head.appendChild(ogType);
    }
    ogType.content = 'website';
    
    // Open Graph - OG:Site Name
    let ogSiteName = document.querySelector('meta[property="og:site_name"]');
    if (!ogSiteName) {
      ogSiteName = document.createElement('meta');
      ogSiteName.setAttribute('property', 'og:site_name');
      document.head.appendChild(ogSiteName);
    }
    ogSiteName.content = 'Parsley & Sage USA Official';
    
    // Twitter Card - Card Type
    let twitterCard = document.querySelector('meta[name="twitter:card"]');
    if (!twitterCard) {
      twitterCard = document.createElement('meta');
      twitterCard.setAttribute('name', 'twitter:card');
      document.head.appendChild(twitterCard);
    }
    twitterCard.content = 'summary_large_image';
    
    // Twitter Card - Title
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (!twitterTitle) {
      twitterTitle = document.createElement('meta');
      twitterTitle.setAttribute('name', 'twitter:title');
      document.head.appendChild(twitterTitle);
    }
    twitterTitle.content = pageData.title;
    
    // Twitter Card - Description
    let twitterDesc = document.querySelector('meta[name="twitter:description"]');
    if (!twitterDesc) {
      twitterDesc = document.createElement('meta');
      twitterDesc.setAttribute('name', 'twitter:description');
      document.head.appendChild(twitterDesc);
    }
    twitterDesc.content = pageData.description;
    
    // Twitter Card - Image
    let twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (!twitterImage) {
      twitterImage = document.createElement('meta');
      twitterImage.setAttribute('name', 'twitter:image');
      document.head.appendChild(twitterImage);
    }
    twitterImage.content = pageData.ogImage;
    
    // Author
    let metaAuthor = document.querySelector('meta[name="author"]');
    if (!metaAuthor) {
      metaAuthor = document.createElement('meta');
      metaAuthor.setAttribute('name', 'author');
      document.head.appendChild(metaAuthor);
    }
    metaAuthor.content = 'Parsley & Sage USA';
    
    // Copyright
    let metaCopyright = document.querySelector('meta[name="copyright"]');
    if (!metaCopyright) {
      metaCopyright = document.createElement('meta');
      metaCopyright.setAttribute('name', 'copyright');
      document.head.appendChild(metaCopyright);
    }
    metaCopyright.content = 'Parsley & Sage USA - All Rights Reserved';
    
    // Robots (index, follow for public pages)
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.content = 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1';
    
  }, [currentPage]);

  // ========================================
  // GSAP SCROLL ZOOM ANIMATION - Collections Section
  // ========================================
  useEffect(() => {
    // Only run on homepage
    if (currentPage !== 'HOME') return;

    // Load GSAP and ScrollTrigger scripts
    const loadGSAP = () => {
      // Check if GSAP already loaded
      if (window.gsap && window.ScrollTrigger) {
        initScrollAnimation();
        return;
      }

      // Load GSAP core
      const gsapScript = document.createElement('script');
      gsapScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
      gsapScript.async = true;
      gsapScript.onload = () => {
        // Load ScrollTrigger plugin
        const scrollTriggerScript = document.createElement('script');
        scrollTriggerScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
        scrollTriggerScript.async = true;
        scrollTriggerScript.onload = () => {
          // Register ScrollTrigger
          if (window.gsap && window.ScrollTrigger) {
            window.gsap.registerPlugin(window.ScrollTrigger);
            initScrollAnimation();
          }
        };
        document.head.appendChild(scrollTriggerScript);
      };
      document.head.appendChild(gsapScript);
    };

    // Initialize scroll animation
    const initScrollAnimation = () => {
      const collectionsSection = document.getElementById('collections-zoom-section');
      
      if (!collectionsSection || !window.gsap || !window.ScrollTrigger) return;

      // Kill any existing ScrollTriggers on this element
      window.ScrollTrigger.getAll().forEach(trigger => {
        if (trigger.vars.trigger === collectionsSection) {
          trigger.kill();
        }
      });

      // Create the scroll-triggered zoom animation
      window.gsap.fromTo(
        collectionsSection,
        {
          scale: 0.8,
          opacity: 0.7
        },
        {
          scale: 1,
          opacity: 1,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: collectionsSection,
            start: 'top 80%',      // Start when top of section is 80% down the viewport
            end: 'top 20%',        // End when top of section is 20% down the viewport
            scrub: 1,              // Smooth scrubbing effect (1 second delay)
            markers: false         // Set to true for debugging
          }
        }
      );
    };

    // Small delay to ensure DOM is ready
    const timeoutId = setTimeout(loadGSAP, 100);

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
      // Kill ScrollTriggers when component unmounts or page changes
      if (window.ScrollTrigger) {
        window.ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      }
    };
  }, [currentPage]);

  // ========================================
  // ORGANIZATION STRUCTURED DATA (JSON-LD)
  // Critical for Google Knowledge Graph and AI models
  // ========================================
  useEffect(() => {
    // Remove old structured data if exists
    const oldScript = document.getElementById('structured-data-org');
    if (oldScript) oldScript.remove();
    
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "https://www.parsley-sage.com/#organization",
      "name": "Parsley & Sage USA",
      "alternateName": ["Parsley and Sage USA", "Parsley&Sage America", "Parsley & Sage United States"],
      "legalName": "Parsley & Sage USA Wholesale Clothing",
      "url": "https://www.parsley-sage.com",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.parsley-sage.com/images/logo.png",
        "width": 600,
        "height": 60
      },
      "image": "https://www.parsley-sage.com/images/og-parsley-sage.jpg",
      "description": "Authentic Parsley & Sage USA - American wholesale boutique clothing featuring French embroidery and Indian craftsmanship. Family-owned since 1995, based in Georgia, USA. The only official Parsley & Sage serving the United States. Not affiliated with Canadian or foreign brands. Visit parsley-sage.com",
      "disambiguatingDescription": "American wholesale clothing company based in Georgia, USA. Serving boutiques across the United States since 1995. Not affiliated with Canadian Parsley & Sage or any international brands of similar name.",
      "email": "sales@parsley-sage.com",
      "telephone": "+16782909293",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "808 Pickens Industrial DR.",
        "addressLocality": "Marietta",
        "addressRegion": "GA",
        "postalCode": "30062",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "33.9526",
        "longitude": "-84.5499"
      },
      "foundingDate": "1995",
      "foundingLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Marietta",
          "addressRegion": "Georgia",
          "addressCountry": "United States"
        }
      },
      "numberOfEmployees": {
        "@type": "QuantitativeValue",
        "value": "25"
      },
      "sameAs": [
        "https://www.instagram.com/parsleyandsageus/",
        "https://www.facebook.com/parsley.sage.1"
      ],
      "areaServed": {
        "@type": "Country",
        "name": "United States"
      },
      "serviceArea": {
        "@type": "GeoShape",
        "addressCountry": "US"
      },
      "knowsAbout": [
        "French embroidered clothing",
        "Indian block print textiles",
        "Wholesale boutique apparel USA",
        "Artisan crafted fashion America",
        "American wholesale clothing distribution"
      ],
      "slogan": "Crafted in France & India, Serving America Since 1995"
    };
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'structured-data-org';
    script.textContent = JSON.stringify(structuredData, null, 2);
    document.head.appendChild(script);
    
    return () => {
      const scriptToRemove = document.getElementById('structured-data-org');
      if (scriptToRemove) scriptToRemove.remove();
    };
  }, []);

  // ========================================
  // FAQ STRUCTURED DATA (JSON-LD)
  // Critical for AI models (ChatGPT, Claude, Perplexity)
  // ========================================
  useEffect(() => {
    // Remove old FAQ data if exists
    const oldFAQ = document.getElementById('structured-data-faq');
    if (oldFAQ) oldFAQ.remove();
    
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is the official Parsley & Sage USA website?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The only official and authentic Parsley & Sage USA website serving the United States is parsley-sage.com (with a hyphen and .com extension). We are an American company based in Georgia, USA. Beware of copycat sites without the hyphen or Canadian/international brands with similar names. We have been family-owned and operated in the USA since 1995, serving boutiques across the United States."
          }
        },
        {
          "@type": "Question",
          "name": "Where is Parsley & Sage USA located?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Parsley & Sage USA is headquartered at 808 Pickens Industrial DR., Marietta, Georgia 30062, USA. We are an American company serving wholesale customers throughout the United States. Our phone is 678-290-9293 and email is sales@parsley-sage.com."
          }
        },
        {
          "@type": "Question",
          "name": "Is Parsley & Sage USA the same as the Canadian Parsley & Sage?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No. Parsley & Sage USA (parsley-sage.com) is a separate American company based in Georgia, United States, established in 1995. We are not affiliated with any Canadian brands or international companies of similar name. We exclusively serve the United States market with wholesale clothing featuring French and Indian craftsmanship."
          }
        },
        {
          "@type": "Question",
          "name": "What type of clothing does Parsley & Sage USA sell?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Parsley & Sage USA specializes in wholesale boutique clothing featuring French embroidery and Indian block prints. Our collections include tunics, tops, dresses, and artisan pieces. All clothing is crafted by our partners in France and India, then imported and distributed from our Georgia, USA headquarters to boutiques across America."
          }
        },
        {
          "@type": "Question",
          "name": "Does Parsley & Sage USA ship to Canada?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Parsley & Sage USA (parsley-sage.com) exclusively serves the United States market. We are an American wholesale company based in Georgia. For Canadian customers, there may be a separate Canadian Parsley & Sage brand, but we are not affiliated with them. Contact us at 678-290-9293 for USA wholesale inquiries only."
          }
        },
        {
          "@type": "Question",
          "name": "How can I verify I'm on the real Parsley & Sage USA website?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The authentic Parsley & Sage USA website is parsley-sage.com (with a hyphen, .com domain). Our official phone is 678-290-9293, email is sales@parsley-sage.com, and we're located in Marietta, Georgia, USA. Look for 'USA', 'United States', or 'Georgia' references on the authentic site. Be cautious of similar-sounding domains, sites without the hyphen, or Canadian/international brands - these are not affiliated with Parsley & Sage USA."
          }
        },
        {
          "@type": "Question",
          "name": "When was Parsley & Sage USA founded?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Parsley & Sage USA was founded in 1995 in Georgia as an American family-owned wholesale clothing company. For over 30 years, we have served boutiques across the United States with authentic French and Indian artisan clothing distributed from our Georgia headquarters."
          }
        },
        {
          "@type": "Question",
          "name": "Where is Parsley & Sage USA clothing made?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Parsley & Sage USA clothing is crafted by our artisan partners in France (French embroidery) and India (block prints and hand-crafted pieces). We are a USA-based company headquartered in Georgia that imports, warehouses, and distributes authentic French and Indian artisan clothing exclusively to American retailers."
          }
        }
      ]
    };
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'structured-data-faq';
    script.textContent = JSON.stringify(faqData, null, 2);
    document.head.appendChild(script);
    
    return () => {
      const scriptToRemove = document.getElementById('structured-data-faq');
      if (scriptToRemove) scriptToRemove.remove();
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
      
      // Keep header light on scroll so the dark nav text stays readable;
      // just firm up the background and add a hairline shadow for separation.
      const header = document.querySelector('header');
      if (header) {
        if (window.scrollY > 100) {
          header.style.background = 'rgba(255, 255, 255, 0.97)';
          header.style.backdropFilter = 'blur(12px)';
          header.style.webkitBackdropFilter = 'blur(12px)';
          header.style.boxShadow = '0 1px 12px rgba(20, 20, 18, 0.06)';
        } else {
          header.style.background = 'rgba(255, 255, 255, 0.92)';
          header.style.backdropFilter = 'blur(8px)';
          header.style.webkitBackdropFilter = 'blur(8px)';
          header.style.boxShadow = 'none';
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Load Google Fonts
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Montserrat:wght@300;400;500;600&family=Space+Grotesk:wght@400;500;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    
    return () => {
      // Cleanup if needed
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };
  }, []);

  const handleNavigation = (target) => {
    let pageToNavigate = target;
    
    // Password protection for current collections
    if (target === 'CURRENT_COLLECTIONS' || target === 'SS26' || target === 'FW26' || target === 'SS27') {
      if (isUnlocked) {
        pageToNavigate = target;
      } else {
        setPendingTab(target);
        pageToNavigate = 'PASSWORD_PROMPT';
      }
    }
    
    // Enhanced page transition - fade out with slight scale
    setPageOpacity(0);
    setIsLoading(true);
    setIsPageEntering(false);
    
    setTimeout(() => {
      setCurrentPage(pageToNavigate);
      setFormSubmitted(false);
      setMobileMenuOpen(false);
      
      // Smooth scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // Update URL
      const path = pageToPath[pageToNavigate] || '/';
      window.history.pushState({}, '', path);
      
      // Fade in with stagger animation trigger
      setTimeout(() => {
        setPageOpacity(1);
        setIsLoading(false);
        setIsPageEntering(true);
        
        // Reset entering state after animation completes
        setTimeout(() => {
          setIsPageEntering(false);
        }, 800);
      }, 50);
    }, 350);
  };

  // Scroll to top function for back to top button
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === CURRENT_COLLECTION_PASS) {
      setIsUnlocked(true);
      setCurrentPage(pendingTab);
      // Update URL
      const path = pageToPath[pendingTab] || '/';
      window.history.pushState({}, '', path);
    } else {
      alert("Incorrect Password");
    }
  };

  const Footer = () => (
    <footer style={{...baseStyles.footer, ...responsiveStyles.footer}}>
      <div style={{...baseStyles.footerTop, ...responsiveStyles.footerTop}}>
        <div style={baseStyles.footerCol}>
          <h4 style={baseStyles.footerHeading}>SITE MAP</h4>
          <ul style={baseStyles.footerList}>
            <li 
              style={baseStyles.footerLink} 
              onClick={() => handleNavigation('HOME')}
              onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
            >
              Home
            </li>
            <li 
              style={baseStyles.footerLink} 
              onClick={() => handleNavigation('CURRENT_COLLECTIONS')}
              onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
            >
              Collections
            </li>
            <li 
              style={baseStyles.footerLink} 
              onClick={() => handleNavigation('PARSLEY & SAGE BOUTIQUES')}
              onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
            >
              Parsley & Sage Boutiques
            </li>
            <li 
              style={baseStyles.footerLink} 
              onClick={() => handleNavigation('TRADE SHOW CALENDAR')}
              onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
            >
              Trade Show Calendar
            </li>
            <li 
              style={baseStyles.footerLink} 
              onClick={() => handleNavigation('OUR TEAM')}
              onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
            >
              Our Team
            </li>
            <li 
              style={baseStyles.footerLink} 
              onClick={() => handleNavigation('OUR STORY')}
              onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
            >
              Our Story
            </li>
            <li 
              style={baseStyles.footerLink} 
              onClick={() => handleNavigation('WORK WITH US')}
              onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
            >
              Work With Us
            </li>
            <li 
              style={baseStyles.footerLink} 
              onClick={() => window.open('http://sales.parsley-sage.com:100/view/home.aspx', '_blank', 'noopener,noreferrer')}
              onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
            >
              My Account
            </li>
          </ul>
        </div>
        <div style={baseStyles.footerCol}>
          <h4 style={baseStyles.footerHeading}>CONTACT INFO</h4>
          <p style={baseStyles.footerText}>
            <a 
              href="tel:678-290-9293" 
              style={baseStyles.footerContactLink}
              onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
            >
              678-290-9293
            </a><br/>
            <a 
              href="mailto:sales@parsley-sage.com" 
              style={baseStyles.footerContactLink}
              onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
            >
              sales@parsley-sage.com
            </a><br/>
            808 Pickens Industrial DR., Marietta, GA 30062
          </p>
        </div>
        <div style={baseStyles.footerCol}>
          <h4 style={baseStyles.footerHeading}>FOLLOW US</h4>
          <a 
            href={`https://instagram.com/${INSTAGRAM_HANDLE}`} 
            target="_blank" 
            rel="noopener noreferrer"
            style={baseStyles.instagramLink}
            onMouseEnter={(e) => e.currentTarget.style.color = '#F2EFE6'}
            onMouseLeave={(e) => e.currentTarget.style.color = '#D8D5CC'}
          >
            <svg style={{width: '24px', height: '24px', marginRight: '10px', verticalAlign: 'middle'}} fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
            @{INSTAGRAM_HANDLE}
          </a>
          <a 
            href={FACEBOOK_URL} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{...baseStyles.instagramLink, marginLeft: '20px'}}
          >
            <svg style={{width: '24px', height: '24px', marginRight: '10px', verticalAlign: 'middle'}} fill="#666" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            Facebook
          </a>
          <a 
            href={PINTEREST_URL} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{...baseStyles.instagramLink, marginLeft: '20px'}}
          >
            <svg style={{width: '24px', height: '24px', marginRight: '10px', verticalAlign: 'middle'}} fill="#666" viewBox="0 0 24 24">
              <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/>
            </svg>
            Pinterest
          </a>
          <p style={{...baseStyles.copyright, marginTop: '20px'}}>© Copyright 2026. All rights reserved.</p>
          <div style={baseStyles.smallLogo}>PARSLEY & SAGE</div>
        </div>
      </div>
    </footer>
  );

  const renderContent = () => {
    const isMobile = window.innerWidth <= 768;
    
    switch (currentPage) {
      case 'HOME': {
        // Fall Winter 2026 shots. Filenames contain spaces, so they are
        // URL-encoded (%20) and the extension is lowercase .jpg on the server.
        const f26Shots = [
          '26F523C_RED%203', '26F543F_A_S%205', '26W257E26_A_S',
          '26W255E26_A_S%20REV', '26W255E26_A_S%203', '26W253E36_A_S%20REV',
          '26W253E36_A_S%207', '26W252E26_A_S', '26W251C3_A_S',
          '26W242C25_A_S%202', '26W241C24_RED%204', '26W230E26_A_S',
          '26W223E25_A_S%203', '26W221G24_A_S%203', '26W215E26_A_S',
          '26W215D_A_S%201', '26W213C6_A_S', '26W209D_A_S%205',
          '26W201G24_A_S%202', '26F590C_TEAL%202', '26F588C_SILVER',
          '26F588C_BRICK', '26F587C_VIOLET%202', '26F586AE_A_S',
          '26F568G_BLU', '26F567E_A_S', '26F561C_SILVER',
          '26F560E28_BLK', '26F547G_SILVER%203',
        ].map(id => `https://11a4738.netsolhost.com/F26/F26fashionshots/${id}.jpg`);

        // Spring Summer 2026 shots (uppercase .JPG, no spaces)
        const ss26Shots = [
          '26T47D4_A_S_1', '26T59G_A_S_2', '26T58D_A_S_2', '26T20B_A_S_1',
          '26T45C3_A_S', '26T57D_A_S_1', '26T48B_A_S', '26T53G_A_S',
          '26T56B14_A_S', '26T47D4_A_S', '26T20B_A_S_3', '26T58D_A_S',
        ].map(id => `https://11a4738.netsolhost.com/SS26/SS26fashionshots/${id}.JPG`);

        const marqueeShots = [...f26Shots, ...ss26Shots];
        const isSmall = window.innerWidth <= 768;

        return (
          <div style={{ backgroundColor: C.canvas }}>
            {/* ===================== HERO ===================== */}
            <section style={{
              paddingTop: isSmall ? '120px' : '150px',
              backgroundColor: C.canvas,
              overflow: 'hidden'
            }}>
              <div style={{ textAlign: 'center', padding: isSmall ? '0 20px 34px' : '0 40px 44px' }}>
                <div style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: isSmall ? '9px' : '10px',
                  letterSpacing: isSmall ? '2.5px' : '3.5px',
                  color: C.sageAccent,
                  marginBottom: '20px',
                  textTransform: 'uppercase',
                  animation: 'fadeInUp 0.9s ease forwards',
                  opacity: 0
                }}>
                  Wholesale Women's Apparel — Since 1995
                </div>
                <h1 style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontWeight: 300,
                  fontSize: isSmall ? '46px' : '76px',
                  letterSpacing: isSmall ? '4px' : '7px',
                  lineHeight: 1,
                  margin: 0,
                  color: C.ink,
                  animation: 'fadeInUp 0.9s ease 0.1s forwards',
                  opacity: 0
                }}>
                  PARSLEY <span style={{ fontStyle: 'italic', fontWeight: 300, color: C.sageAccent }}>&amp;</span> SAGE
                </h1>
                <p style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontStyle: 'italic',
                  fontSize: isSmall ? '17px' : '20px',
                  color: C.inkSoft,
                  marginTop: '14px',
                  animation: 'fadeInUp 0.9s ease 0.2s forwards',
                  opacity: 0
                }}>
                  Crafted in France &amp; India
                </p>
              </div>

              {/* Marquee runway — hover and move left/right to scrub */}
              <MarqueeRunway
                images={marqueeShots}
                isSmall={isSmall}
                bandColor={C.sageBand}
              />

              {/* Hero CTA */}
              <div style={{
                textAlign: 'center',
                padding: isSmall ? '26px 20px 40px' : '30px 40px 52px',
                animation: 'fadeIn 1.2s ease 0.6s forwards',
                opacity: 0
              }}>
                <span
                  className="ps-underline"
                  onClick={() => handleNavigation('CURRENT_COLLECTIONS')}
                  style={{
                    fontFamily: "'Space Grotesk', sans-serif",
                    fontSize: '11px',
                    letterSpacing: '2px',
                    color: C.ink,
                    cursor: 'pointer',
                    textTransform: 'uppercase'
                  }}
                >
                  View the SS27 Collection →
                </span>
              </div>
            </section>

            {/* ===================== STORY BAND (sage) ===================== */}
            <section
              className="reveal-fade-up"
              style={{ backgroundColor: C.sageBand, padding: isSmall ? '56px 24px' : '80px 40px', textAlign: 'center' }}
            >
              <div style={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: '10px', letterSpacing: '3px', color: C.sageAccent,
                marginBottom: '18px', textTransform: 'uppercase'
              }}>
                A Family Story
              </div>
              <p style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontWeight: 300,
                fontSize: isSmall ? '24px' : '34px',
                lineHeight: 1.4,
                color: C.sageDeep,
                maxWidth: '760px',
                margin: '0 auto'
              }}>
                A family and a dream — dressing America's independent boutiques with artful, embroidered clothing since 1995.
              </p>
              <div
                className="ps-underline"
                onClick={() => handleNavigation('OUR STORY')}
                style={{
                  display: 'inline-block',
                  marginTop: '28px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: '11px', letterSpacing: '2px', color: C.sageAccent,
                  cursor: 'pointer', textTransform: 'uppercase'
                }}
              >
                Read Our Story →
              </div>
            </section>

            {/* ===================== ANIMATED STATS ===================== */}
            <section className="reveal-fade-up" style={{
              backgroundColor: C.canvas,
              padding: isSmall ? '48px 24px' : '64px 40px',
              borderBottom: `1px solid ${C.hairline}`
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: isSmall ? '32px' : '0'
              }}>
                {[
                  { value: 1995, label: 'Established', prefix: '', suffix: '' },
                  { value: 900, label: 'Boutique Partners', prefix: '', suffix: '+' },
                  { value: 2, label: 'Atelier Countries', prefix: '', suffix: '' },
                ].map((stat, idx) => (
                  <div key={stat.label} style={{
                    textAlign: 'center',
                    padding: isSmall ? '0' : '0 56px',
                    borderRight: (!isSmall && idx < 2) ? `1px solid ${C.hairline}` : 'none',
                    minWidth: isSmall ? '100%' : 'auto'
                  }}>
                    <StatCounter
                      target={stat.value}
                      prefix={stat.prefix}
                      suffix={stat.suffix}
                      isYear={stat.value === 1995}
                    />
                    <div style={{
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontSize: '9px', letterSpacing: '2.5px',
                      color: C.inkMuted, marginTop: '8px', textTransform: 'uppercase'
                    }}>
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* ===================== LOOKBOOK (editorial grid on white) ===================== */}
            <section className="reveal-fade-up" style={{
              maxWidth: '1400px', margin: '0 auto',
              padding: isSmall ? '56px 20px 72px' : '80px 40px 100px'
            }}>
              <div style={{
                display: 'flex', alignItems: 'baseline', justifyContent: 'space-between',
                borderBottom: `1px solid ${C.hairline}`, paddingBottom: '14px', marginBottom: '32px'
              }}>
                <h2 style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontWeight: 300, fontSize: isSmall ? '26px' : '32px',
                  color: C.ink, margin: 0
                }}>
                  Spring / Summer 2026
                </h2>
                <span style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: '10px', letterSpacing: '2px', color: C.sageAccent, textTransform: 'uppercase'
                }}>
                  The Lookbook
                </span>
              </div>

              <div
                id="collections-zoom-section"
                style={{
                  display: 'grid',
                  gridTemplateColumns: isSmall ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
                  gap: isSmall ? '14px' : '22px'
                }}
              >
                {[
                  { id: '26T47D4_A_S_1', name: 'Embroidered Tunic', code: '26T47D4' },
                  { id: '26T59G_A_S_2', name: 'Patchwork Jacket', code: '26T59G' },
                  { id: '26T58D_A_S_2', name: 'Textured Duster', code: '26T58D' },
                  { id: '26T45C3_A_S', name: 'Block-Print Blouse', code: '26T45C3' },
                  { id: '26T57D_A_S_1', name: 'Tiered Maxi', code: '26T57D' },
                  { id: '26T20B_A_S_1', name: 'Linen Set', code: '26T20B' },
                ].map((item) => (
                  <div key={item.id} style={{ cursor: 'pointer' }}
                    onClick={() => handleNavigation('CURRENT_COLLECTIONS')}
                  >
                    <div style={{ overflow: 'hidden', backgroundColor: C.sageBand, aspectRatio: '3 / 4' }}>
                      <img
                        src={`https://11a4738.netsolhost.com/SS26/SS26fashionshots/${item.id}.JPG`}
                        alt={`${item.name} — Parsley & Sage SS26`}
                        loading="lazy"
                        style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', display: 'block', transition: 'transform 0.6s cubic-bezier(0.25,0.46,0.45,0.94)' }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.04)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                      />
                    </div>
                    <div style={{
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontSize: '10px', letterSpacing: '1.2px', color: C.inkSoft,
                      marginTop: '10px', textTransform: 'uppercase'
                    }}>
                      {item.name} · {item.code}
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ textAlign: 'center', marginTop: isSmall ? '44px' : '60px' }}>
                <span
                  className="ps-underline"
                  onClick={() => handleNavigation('CURRENT_COLLECTIONS')}
                  style={{
                    fontFamily: "'Space Grotesk', sans-serif",
                    fontSize: '11px', letterSpacing: '2px', color: C.ink,
                    cursor: 'pointer', textTransform: 'uppercase'
                  }}
                >
                  See the Full Collection →
                </span>
              </div>
            </section>
          </div>
        );
      }

      case 'OUR STORY':
        return (
          <div style={{...baseStyles.storyPage, ...responsiveStyles.storyPage}}>
            <div 
              className="reveal-scale"
              style={{...baseStyles.storyHero, ...responsiveStyles.storyHero}}
            >
              <div style={{...baseStyles.familyPhotoPlaceholder, ...responsiveStyles.familyPhotoPlaceholder}}>
                <img 
                  src="/images/family.jpg" 
                  alt="Parsley & Sage founders - Manjit, Preet, and Sharan - family-owned wholesale clothing business since 1995" 
                  style={{...baseStyles.portraitImage, marginBottom: 0, height: '100%', objectFit: 'cover', objectPosition: 'center 50%'}} 
                />
              </div>
            </div>
            
            <section style={{...baseStyles.storyContent, ...responsiveStyles.storyContent}}>
              <div style={baseStyles.storyColumn}>
                <h2 
                  className="reveal-fade-up"
                  style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}
                >
                  THE AMERICAN DREAM
                </h2>
                <p className="reveal-fade-up" style={baseStyles.storySub}>ESTABLISHED 1995 | MARIETTA, GA</p>
                
                <p className="reveal-fade-up" style={{...baseStyles.storyText, ...responsiveStyles.storyText}}>
                  Parsley & Sage began its journey in 1995 in Marietta, Georgia. What started as a simple family idea has grown into Parsley & Sage, a brand we're all mighty proud of.
                </p>
                
                <p className="reveal-fade-up" style={{...baseStyles.storyText, ...responsiveStyles.storyText}}>
                  We're still family-owned and family-run, just like we began. That means every decision comes from the heart, guided by the same values our parents passed down: hard work, honesty, and a real love for beautiful clothes.
                </p>

                <p className="reveal-fade-up" style={{...baseStyles.storyText, ...responsiveStyles.storyText}}>
                  Our collections blend gorgeous embroidery and artistic details, crafted with care in workshops in India and France. We bring those unique, one-of-a-kind pieces straight to boutiques and retailers across the United States and beyond—those charming downtown "Mom and Pop" shops we grew up loving.
                </p>

                <p className="reveal-fade-up" style={{...baseStyles.storyText, ...responsiveStyles.storyText}}>
                  Today, our family has grown to a dedicated team of 15, supported by 8 experienced sales representatives who share our passion for fashion. Parsley & Sage is a true family story—a little piece of the American Dream, stitched together with love, legacy, and a deep commitment to our boutiques.
                </p>

                <p className="reveal-fade-up" style={{...baseStyles.storyText, ...responsiveStyles.storyText}}>
                  We're grateful for every boutique that carries our line, and we can't wait to keep growing alongside you.
                </p>
              </div>
            </section>
          </div>
        );

      case 'OUR TEAM':
        const salesReps = [
          { region: "MID WEST", name: "Joe N Julie", email: "joeandjulie2009@gmail.com", phone: "989-390-0013", address: "735 N. Harvard Ave, Villa Park, IL 60181" },
          { region: "SOUTH EAST", name: "Teddy Lessner", email: "taxier500@gmail.com", phone: "404-915-0056", address: "Atlanta Mart: 11N-315" },
          { region: "WEST COAST", name: "Rick Sobin", email: "ricksobin@aol.com", phone: "818-425-6997", address: "13629 Erwin St, Valley Glen, CA 91401" },
          { region: "NEW ENGLAND", name: "Ann Marie Brennick", email: "ambrennick@verizon.net", phone: "978-658-6747", address: "22 Hardin St., Wilmington, MA 01887" },
          { region: "SOUTH WEST", name: "B & B Sales", email: "bsweewilly13@aol.com", phone: "972-965-5061", address: "2050 Stemmons Fwy Suite 13456, Dallas, TX 75207" },
          { region: "MID ATLANTIC", name: "Jan Orsini", email: "orsj4@aol.com", phone: "412-780-4996", address: "522 Dogwood Lane, McDonald, PA 15057" },
          { region: "FLORIDA", name: "Anthony Woolf", email: "antzwoolf@hotmail.com", phone: "941-544-6767", address: "1622 NE 34th Court, Oakland Park, FL 33334" },
          { region: "ROCKIES", name: "Laurie Elledge", email: "lelledge1964@gmail.com", phone: "208-867-2349", address: "1413 Marie Elena Drive, Las Vegas, NV 89104" },
        ];

        return (
          <div style={{...baseStyles.storyPage, ...responsiveStyles.storyPage}}>
            <section style={{...baseStyles.storyHero, ...responsiveStyles.storyHero, paddingBottom: '20px'}}>
              <h2 
                className="reveal-fade-up"
                style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}
              >
                MEET THE TEAM
              </h2>
              <p className="reveal-fade-up" style={baseStyles.storySub}>THE HEART OF PARSLEY & SAGE</p>
            </section>

            <section style={{...baseStyles.teamSection, ...responsiveStyles.teamSection}}>
              <div 
                className="stagger-children animate"
                style={{...baseStyles.ownersGrid, ...responsiveStyles.ownersGrid}}
              >
                <div style={baseStyles.teamCard}>
                  <img 
                    src="/images/preet2.png" 
                    alt="Preet - Co-Owner of Parsley & Sage wholesale clothing company" 
                    style={baseStyles.portraitImage} 
                  />
                  <h4 style={baseStyles.teamName}>PREET</h4>
                  <p style={baseStyles.teamRole}>Co-Owner</p>
                </div>
                <div style={baseStyles.teamCard}>
                  <img 
                    src="/images/sharan2.png" 
                    alt="Sharan - Co-Owner of Parsley & Sage wholesale clothing company" 
                    style={baseStyles.portraitImage} 
                  />
                  <h4 style={baseStyles.teamName}>SHARAN</h4>
                  <p style={baseStyles.teamRole}>Co-Owner</p>
                </div>
              </div>

              <hr style={{border: 'none', borderTop: '1px solid rgba(20, 20, 18, 0.1)', margin: '80px 0'}} />

              <div style={{textAlign: 'center', marginBottom: '60px'}}>
                <h3 style={{...baseStyles.sectionTitle, color: '#141412'}}>SALES REPRESENTATIVES</h3>
                <p style={baseStyles.seasonText}>CONTACT YOUR REGIONAL PARTNER</p>
              </div>
              
              <div style={{...baseStyles.repsGrid, ...responsiveStyles.repsGrid}}>
                {salesReps.map((rep, index) => (
                  <div 
                    key={index} 
                    style={baseStyles.repInfoCard}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <p style={baseStyles.repRegion}>{rep.region}</p>
                    <p style={baseStyles.repName}>{rep.name}</p>
                    <div style={baseStyles.repContactInfo}>
                      <a href={`mailto:${rep.email}`} style={baseStyles.repLink}>{rep.email}</a>
                      <br />
                      <a href={`tel:${rep.phone.replace(/\./g, '')}`} style={baseStyles.repLink}>{rep.phone}</a>
                      <br />
                      <span style={baseStyles.repLink}>{rep.address}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        );

      case 'WORK WITH US':
        return (
          <div style={{backgroundColor: '#EDEFE8'}}>
            <div style={{...baseStyles.formContainer, ...responsiveStyles.formContainer}}>
              <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading, color: '#141412'}}>WORK WITH US</h2>
              <p style={baseStyles.formSubtitle}>Send a message to our sales team.</p>
              <form action="https://formspree.io/f/xreegdkd" method="POST" style={baseStyles.workForm}>
                <div style={{...baseStyles.formRow, ...responsiveStyles.formRow}}>
                  <input type="text" name="name" placeholder="Name" style={{...baseStyles.flexInput, ...responsiveStyles.flexInput}} required />
                  <input type="tel" name="phone" placeholder="Phone" style={{...baseStyles.flexInput, ...responsiveStyles.flexInput}} required />
                </div>
                <input type="email" name="email" placeholder="Email" style={baseStyles.formInput} required />
                <textarea name="message" placeholder="Message" style={{...baseStyles.formInput, height: '150px'}} required></textarea>
                <button 
                  type="submit" 
                  style={baseStyles.formSubmitBtn}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#141412';
                    e.currentTarget.style.color = '#FFFFFF';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = '#232A22';
                    e.currentTarget.style.color = '#F2EFE6';
                  }}
                >
                  SEND MESSAGE
                </button>
              </form>
            </div>
            
            <div style={{...baseStyles.termsSection, ...responsiveStyles.termsSection}}>
              <div style={{maxWidth: '900px', margin: '0 auto'}}>
                <h3 style={{...baseStyles.sectionTitle, textAlign: 'center', marginBottom: '40px', color: '#141412'}}>TERMS & CONDITIONS</h3>
                
                <div style={{marginBottom: '30px'}}>
                  <p style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '8px', color: '#141412'}}>ORDERING</p>
                  <p style={{fontSize: '14px', lineHeight: '1.6', color: '#55554E'}}>Please send mail orders to head office address below. Use the attached order form for your convenience. In order to serve you better, we ask you bracket your order when ordering coordinates shipped as a set. Please do not order assorted. If you need help or guidance, our sales staff will be happy to help you. Initial Order: Minimum 4 pieces per color/style. All Styles available in MISSY "S-XL" and WOMEN "1X-3X" sizes. For WOMEN sizes add "P" after the Style # and use PLUS size pricing.</p>
                </div>

                <div style={{marginBottom: '30px'}}>
                  <p style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '8px', color: '#141412'}}>SHIPPING</p>
                  <p style={{fontSize: '14px', lineHeight: '1.6', color: '#55554E'}}>Pending credit approval, items in stock are shipped to you within 4 weeks. If we are out of stock, we will back order and generally ship the balance within 6-8 weeks or at a later date mentioned on your order. Shipping and insurance is paid by the customer.</p>
                </div>

                <div style={{marginBottom: '30px'}}>
                  <p style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '8px', color: '#141412'}}>RETURNS</p>
                  <p style={{fontSize: '14px', lineHeight: '1.6', color: '#55554E'}}>In an event merchandise is defective, write or fax us for a Return Authorization within 5 days of receipt of goods. Information such as style number, size, invoice number and quantity must be provided with a request for returns. We cannot accept items altered or damaged by the customer. No returns shall be accepted without an RA number. Discrepancy in merchandise received, must be notified within 5 (five) days of receipt of goods. Acceptance of goods shall constitute an agreement. Any dispute shall be resolved pursuant to the laws of Georgia state. GA court shall have jurisdiction over all parties to this agreement.</p>
                </div>

                <div style={{marginBottom: '30px'}}>
                  <p style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '8px', color: '#141412'}}>PAYMENTS</p>
                  <p style={{fontSize: '14px', lineHeight: '1.6', marginBottom: '10px', color: '#55554E'}}>We offer 3 methods of payment:</p>
                  <ul style={{fontSize: '14px', lineHeight: '1.6', paddingLeft: '20px', listStyleType: 'disc', color: '#55554E'}}>
                    <li><strong>COD</strong> - You pay the freight and COD charges. Payment is collected and deposited directly by UPS at the time of delivery.</li>
                    <li><strong>NET 30</strong> - Qualified customers who have established credit through The CIT Group/Commercial Services, Inc. have the option of paying within 30 days of the invoice date. An interest rate of 2% monthly over prime rate, computed monthly, will be charged on all past due accounts. All returned checks are liable for $35.00 service charge.</li>
                    <li><strong>CREDIT CARDS</strong> - We accept all major Credit Cards, and will be charged at the time of shipping</li>
                  </ul>
                </div>

                <div>
                  <p style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '8px', color: '#141412'}}>ORDER INQUIRY</p>
                  <p style={{fontSize: '14px', lineHeight: '1.6', color: '#55554E'}}>To inquire the status of your order, please call 678-290-9293, Monday to Friday, between 10:00am to 5:00pm, and request a customer service representative.</p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'ORDERING DOCS':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>ORDERING DOCUMENTS</h2>
            <p style={{fontSize: '16px', color: '#666', marginBottom: '60px'}}>
              Download the forms you need for wholesale ordering
            </p>
            
            <div style={baseStyles.docsGrid}>
              <div 
                style={baseStyles.docCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={baseStyles.docIcon}>
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#5F6E54" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                </div>
                <h3 style={baseStyles.docTitle}>ORDER FORM</h3>
                <p style={baseStyles.docDescription}>
                  Use this form to place your wholesale orders. Include style numbers, sizes, and quantities.
                </p>
                <a 
                  href="/order-form.pdf" 
                  download 
                  style={baseStyles.docDownloadBtn}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#6a7354';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#5F6E54';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  DOWNLOAD ORDER FORM
                </a>
              </div>

              <div 
                style={baseStyles.docCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={baseStyles.docIcon}>
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#5F6E54" strokeWidth="2">
                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                    <line x1="1" y1="10" x2="23" y2="10"></line>
                  </svg>
                </div>
                <h3 style={baseStyles.docTitle}>CREDIT CARD AUTHORIZATION</h3>
                <p style={baseStyles.docDescription}>
                  Authorize credit card payments for your wholesale orders. Required for card transactions.
                </p>
                <a 
                  href="/credit-card-auth.pdf" 
                  download 
                  style={baseStyles.docDownloadBtn}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#6a7354';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#5F6E54';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  DOWNLOAD CC AUTH FORM
                </a>
              </div>

              <div 
                style={baseStyles.docCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={baseStyles.docIcon}>
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#5F6E54" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <path d="M12 18v-6"></path>
                    <path d="M9 15l3 3 3-3"></path>
                  </svg>
                </div>
                <h3 style={baseStyles.docTitle}>CREDIT APPLICATION</h3>
                <p style={baseStyles.docDescription}>
                  Apply for NET 30 terms with Parsley & Sage. Complete this form to establish credit.
                </p>
                <a 
                  href="/credit-application.pdf" 
                  download 
                  style={baseStyles.docDownloadBtn}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#6a7354';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#5F6E54';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  DOWNLOAD CREDIT APP
                </a>
              </div>
            </div>

            <div style={{marginTop: '80px', padding: '40px', backgroundColor: '#f9f9f9', borderRadius: '4px'}}>
              <h3 style={{...baseStyles.sectionTitle, marginBottom: '20px', color: '#141412'}}>NEED HELP?</h3>
              <p style={{fontSize: '16px', lineHeight: '1.8', color: '#666', marginBottom: '20px'}}>
                If you have questions about these forms or need assistance with your order, please contact our sales team.
              </p>
              <p style={{fontSize: '14px', color: '#666'}}>
                <strong>Email:</strong> <a href="mailto:sales@parsley-sage.com" style={{color: '#5F6E54', textDecoration: 'none'}}>sales@parsley-sage.com</a><br/>
                <strong>Phone:</strong> <a href="tel:678-290-9293" style={{color: '#5F6E54', textDecoration: 'none'}}>678-290-9293</a><br/>
                <strong>Hours:</strong> Monday to Friday, 10:00am - 5:00pm EST
              </p>
            </div>

            <div style={{...baseStyles.termsSection, ...responsiveStyles.termsSection, backgroundColor: '#fff', marginTop: '0', paddingTop: '80px'}}>
              <div style={{maxWidth: '900px', margin: '0 auto'}}>
                <h3 style={{...baseStyles.sectionTitle, textAlign: 'center', marginBottom: '40px', color: '#141412'}}>TERMS & CONDITIONS</h3>
                
                <div style={{marginBottom: '30px'}}>
                  <p style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '8px'}}>ORDERING</p>
                  <p style={{fontSize: '14px', lineHeight: '1.6'}}>Please send mail orders to head office address below. Use the attached order form for your convenience. In order to serve you better, we ask you bracket your order when ordering coordinates shipped as a set. Please do not order assorted. If you need help or guidance, our sales staff will be happy to help you. Initial Order: Minimum 4 pieces per color/style. All Styles available in MISSY "S-XL" and WOMEN "1X-3X" sizes. For WOMEN sizes add "P" after the Style # and use PLUS size pricing.</p>
                </div>

                <div style={{marginBottom: '30px'}}>
                  <p style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '8px'}}>SHIPPING</p>
                  <p style={{fontSize: '14px', lineHeight: '1.6'}}>Pending credit approval, items in stock are shipped to you within 4 weeks. If we are out of stock, we will back order and generally ship the balance within 6-8 weeks or at a later date mentioned on your order. Shipping and insurance is paid by the customer.</p>
                </div>

                <div style={{marginBottom: '30px'}}>
                  <p style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '8px'}}>RETURNS</p>
                  <p style={{fontSize: '14px', lineHeight: '1.6'}}>In an event merchandise is defective, write or fax us for a Return Authorization within 5 days of receipt of goods. Information such as style number, size, invoice number and quantity must be provided with a request for returns. We cannot accept items altered or damaged by the customer. No returns shall be accepted without an RA number. Discrepancy in merchandise received, must be notified within 5 (five) days of receipt of goods. Acceptance of goods shall constitute an agreement. Any dispute shall be resolved pursuant to the laws of Georgia state. GA court shall have jurisdiction over all parties to this agreement.</p>
                </div>

                <div style={{marginBottom: '30px'}}>
                  <p style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '8px'}}>PAYMENTS</p>
                  <p style={{fontSize: '14px', lineHeight: '1.6', marginBottom: '10px'}}>We offer 3 methods of payment:</p>
                  <ul style={{fontSize: '14px', lineHeight: '1.6', paddingLeft: '20px', listStyleType: 'disc'}}>
                    <li><strong>COD</strong> - You pay the freight and COD charges. Payment is collected and deposited directly by UPS at the time of delivery.</li>
                    <li><strong>NET 30</strong> - Qualified customers who have established credit through The CIT Group/Commercial Services, Inc. have the option of paying within 30 days of the invoice date. An interest rate of 2% monthly over prime rate, computed monthly, will be charged on all past due accounts. All returned checks are liable for $35.00 service charge.</li>
                    <li><strong>CREDIT CARDS</strong> - We accept all major Credit Cards, and will be charged at the time of shipping</li>
                  </ul>
                </div>

                <div>
                  <p style={{fontWeight: 'bold', fontSize: '14px', marginBottom: '8px'}}>ORDER INQUIRY</p>
                  <p style={{fontSize: '14px', lineHeight: '1.6'}}>To inquire the status of your order, please call 678-290-9293, Monday to Friday, between 10:00am to 5:00pm, and request a customer service representative.</p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'PARSLEY & SAGE BOUTIQUES':
        return (
          <div style={baseStyles.boutiquePage}>
            {/* Section 1: Header + Map */}
            <section style={{...baseStyles.boutiqueHeader, padding: '40px 20px 30px 20px'}}>
              <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>OUR RETAILERS</h2>
              <p style={{...baseStyles.boutiqueSub, marginBottom: '15px'}}>FIND A BOUTIQUE NEAR YOU</p>
              <p style={{fontSize: '14px', color: '#ccc', lineHeight: '1.6', maxWidth: '800px', margin: '0 auto'}}>
                Parsley & Sage is proudly carried by independent boutiques across the United States.
              </p>
            </section>

            <section style={{padding: '40px 5%', backgroundColor: '#404040'}}>
              <div style={{
                maxWidth: '1400px',
                margin: '0 auto'
              }}>
                <BoutiqueLocatorMap />
              </div>
            </section>

            {/* Section 2: Interested in Carrying */}
            <section style={{padding: '80px 10%', textAlign: 'center', backgroundColor: '#505050'}}>
              <h3 style={{...baseStyles.sectionTitle, color: '#fff', fontSize: '28px', marginBottom: '20px'}}>
                INTERESTED IN CARRYING PARSLEY & SAGE?
              </h3>
              <p style={{fontSize: '16px', color: '#ccc', marginBottom: '30px', lineHeight: '1.8', maxWidth: '700px', margin: '0 auto 30px auto'}}>
                We're always looking to partner with quality boutiques who share our passion for beautiful, 
                handcrafted fashion. Join our family of retailers and bring unique pieces to your customers.
              </p>
              <button 
                onClick={() => handleNavigation('WORK WITH US')}
                style={{
                  padding: '15px 40px',
                  backgroundColor: '#5F6E54',
                  color: '#fff',
                  border: 'none',
                  fontSize: '12px',
                  letterSpacing: '2px',
                  cursor: 'pointer',
                  borderRadius: '2px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#6a7354';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(125,132,97,0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#5F6E54';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                BECOME A RETAILER
              </button>
            </section>
          </div>
        );

      case 'TRADE SHOW CALENDAR':
        return (
          <div style={baseStyles.boutiquePage}>
            <div style={baseStyles.boutiqueHeader}>
              <p style={baseStyles.boutiqueSub}>UPCOMING EVENTS</p>
              <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>SHOW CALENDAR</h2>
            </div>
            
            <div style={baseStyles.calendarContainer}>
              <div style={baseStyles.calendarWrapper}>
                <iframe 
                  src="https://calendar.google.com/calendar/embed?src=f683d0dad97233bd276d9575ee3b42d5b78cfcbc63987d60d14c781f1a377464%40group.calendar.google.com&ctz=America%2FNew_York" 
                  style={baseStyles.calendarIframe}
                  frameBorder="0" 
                  scrolling="no"
                loading="lazy"
            />
              </div>
            </div>
          </div>
        );

      case 'PASSWORD_PROMPT':
        return (
          <div style={{...baseStyles.passwordContainer, ...responsiveStyles.passwordContainer}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>SECURE ACCESS</h2>
            <p style={baseStyles.formSubtitle}>Enter the password to view Current Collections.</p>
            <form onSubmit={handlePasswordSubmit} style={baseStyles.workForm}>
              <input 
                type="password" 
                value={passwordInput} 
                onChange={(e) => setPasswordInput(e.target.value)}
                style={baseStyles.formInput}
                placeholder="Password"
              />
              <button 
                type="submit" 
                style={baseStyles.formSubmitBtn}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#141412';
                  e.currentTarget.style.color = '#FFFFFF';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#232A22';
                  e.currentTarget.style.color = '#F2EFE6';
                }}
              >
                UNLOCK CATALOG
              </button>
            </form>
          </div>
        );

      case 'CURRENT_COLLECTIONS':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>CURRENT COLLECTIONS</h2>
            
            <div style={{...baseStyles.catalogGridSideBySide, ...responsiveStyles.catalogGridSideBySide}}>
              
              <div style={{...baseStyles.catalogCardHalf, ...responsiveStyles.catalogCardHalf}}>
                <h3 style={{...baseStyles.sectionTitle, textAlign: 'center', marginBottom: '10px', color: '#141412'}}>FALL WINTER 2026</h3>
                <p style={{...baseStyles.seasonText, textAlign: 'center', marginBottom: '20px'}}>OFFICIAL WHOLESALE CATALOG</p>
                <div style={{...baseStyles.pdfWrapper, cursor: 'pointer'}} 
                  onClick={() => window.open('https://11a4738.netsolhost.com/F26.pdf', '_blank')}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                  <img 
                    src="/images/fall25.png" 
                    alt="Fall Winter 2026 Catalog Cover - Click to View" 
                    style={{
                      width: '100%',
                      height: '600px',
                      objectFit: 'contain',
                      backgroundColor: '#f5f5f5',
                      border: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    loading="lazy"
                  />
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    color: '#fff',
                    padding: '15px 30px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    fontWeight: '600',
                    letterSpacing: '1px',
                    opacity: 0,
                    transition: 'opacity 0.3s ease',
                    pointerEvents: 'none'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                  >
                    CLICK TO VIEW CATALOG
                  </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <a 
                    href="https://11a4738.netsolhost.com/F26.pdf" 
                    download 
                    style={baseStyles.downloadBtn}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                      
                      
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                      
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    DOWNLOAD FW26 CATALOG (PDF)
                  </a>
                </div>
              </div>

              <hr style={{ border: 'none', borderTop: '1px solid rgba(20, 20, 18, 0.1)', margin: '60px 0' }} />

              <div style={{...baseStyles.catalogCardHalf, ...responsiveStyles.catalogCardHalf}}>
                <h3 style={{...baseStyles.sectionTitle, textAlign: 'center', marginBottom: '10px', color: '#141412'}}>SPRING SUMMER 2027</h3>
                <p style={{...baseStyles.seasonText, textAlign: 'center', marginBottom: '20px'}}>OFFICIAL WHOLESALE CATALOG</p>
                <div style={{...baseStyles.pdfWrapper, cursor: 'pointer'}} 
                  onClick={() => window.open('https://11a4738.netsolhost.com/SS27/SS27.pdf', '_blank')}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                  <img 
                    src="/images/SS27.jpg" 
                    alt="Spring Summer 2027 Catalog Cover - Click to View" 
                    style={{
                      width: '100%',
                      height: '600px',
                      objectFit: 'contain',
                      backgroundColor: '#f5f5f5',
                      border: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    loading="lazy"
                  />
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    color: '#fff',
                    padding: '15px 30px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    fontWeight: '600',
                    letterSpacing: '1px',
                    opacity: 0,
                    transition: 'opacity 0.3s ease',
                    pointerEvents: 'none'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                  >
                    CLICK TO VIEW CATALOG
                  </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <a 
                    href="https://11a4738.netsolhost.com/SS27/SS27.pdf" 
                    download 
                    style={baseStyles.downloadBtn}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                      
                      
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                      
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    DOWNLOAD SS27 CATALOG (PDF)
                  </a>
                </div>
              </div>
            </div>

            <div style={{...baseStyles.orderFormContainer, ...responsiveStyles.orderFormContainer}}>
              {!formSubmitted ? (
                <>
                  <h3 style={{...baseStyles.sectionTitle, textAlign: 'center', marginBottom: '10px'}}>PLACE AN ORDER</h3>
                  <p style={{...baseStyles.seasonText, textAlign: 'center', marginBottom: '30px'}}>REQUEST AVAILABILITY FROM OUR SALES TEAM</p>
                  
                  <form action="https://formspree.io/f/xnjjqrvk" method="POST" style={baseStyles.catalogForm}>
                    <input type="text" name="boutique" placeholder="The Boutique Name" style={baseStyles.catalogInput} required />
                    <input type="text" name="name" placeholder="Your Full Name" style={baseStyles.catalogInput} required />
                    <div style={{...baseStyles.formRow, ...responsiveStyles.formRow}}>
                      <input type="tel" name="phone" placeholder="Phone Number" style={{...baseStyles.flexInputLight, ...responsiveStyles.flexInputLight}} required />
                      <input type="email" name="email" placeholder="Email Address" style={{...baseStyles.flexInputLight, ...responsiveStyles.flexInputLight}} required />
                    </div>
                    <textarea 
                      name="order" 
                      placeholder="Type your order details here (Style numbers, sizes, quantities)..." 
                      style={{...baseStyles.catalogInput, height: '200px', resize: 'vertical'}} 
                      required 
                    />
                    <button 
                      type="submit" 
                      style={baseStyles.catalogSubmitBtn}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                        
                        
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                        
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      SUBMIT REQUEST
                    </button>
                  </form>
                </>
              ) : (
                <div style={{textAlign: 'center', padding: '40px 0'}}>
                  <p style={{fontSize: '18px', lineHeight: '1.6', color: '#333'}}>
                    Thanks for placing your order, a representative from our Customer Support Team will reach out to confirm details and availability of goods. For more questions feel free to call at 678.290.9293 - The Parsley & Sage Team
                  </p>
                  <button 
                    onClick={() => setFormSubmitted(false)}
                    style={{...baseStyles.catalogSubmitBtn, width: 'auto', padding: '10px 30px', marginTop: '30px', borderRadius: '50px'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                      
                      
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                      
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    SUBMIT ANOTHER REQUEST
                  </button>
                </div>
              )}
            </div>
          </div>
        );

      case 'SS26':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>SPRING SUMMER 2026</h2>
            <p style={{...baseStyles.seasonText, textAlign: 'center', marginBottom: '40px'}}>OFFICIAL WHOLESALE CATALOG</p>
            
            <div style={{maxWidth: '900px', margin: '0 auto 60px auto'}}>
              <div style={{...baseStyles.pdfWrapper, cursor: 'pointer'}} 
                onClick={() => window.open('https://11a4738.netsolhost.com/SS26.pdf', '_blank')}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                <img 
                  src="/images/SS26.jpg" 
                  alt="Spring Summer 2026 Catalog Cover - Click to View" 
                  style={{
                    width: '100%',
                    height: '600px',
                    objectFit: 'contain',
                    backgroundColor: '#f5f5f5',
                    border: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  loading="lazy"
                />
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  color: '#fff',
                  padding: '15px 30px',
                  borderRadius: '4px',
                  fontSize: '14px',
                  fontWeight: '600',
                  letterSpacing: '1px',
                  opacity: 0,
                  transition: 'opacity 0.3s ease',
                  pointerEvents: 'none'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                >
                  CLICK TO VIEW CATALOG
                </div>
              </div>
              <div style={{ textAlign: 'center', marginTop: '30px' }}>
                <a 
                  href="https://11a4738.netsolhost.com/SS26.pdf" 
                  download 
                  style={baseStyles.downloadBtn}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                    
                    
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                    
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  DOWNLOAD SS26 CATALOG (PDF)
                </a>
              </div>
            </div>

            <div style={{...baseStyles.orderFormContainer, ...responsiveStyles.orderFormContainer}}>
              {!formSubmitted ? (
                <>
                  <h3 style={{...baseStyles.sectionTitle, textAlign: 'center', marginBottom: '10px'}}>PLACE AN ORDER</h3>
                  <p style={{...baseStyles.seasonText, textAlign: 'center', marginBottom: '30px'}}>REQUEST AVAILABILITY FROM OUR SALES TEAM</p>
                  
                  <form action="https://formspree.io/f/xnjjqrvk" method="POST" style={baseStyles.catalogForm}>
                    <input type="text" name="boutique" placeholder="The Boutique Name" style={baseStyles.catalogInput} required />
                    <input type="text" name="name" placeholder="Your Full Name" style={baseStyles.catalogInput} required />
                    <div style={{...baseStyles.formRow, ...responsiveStyles.formRow}}>
                      <input type="tel" name="phone" placeholder="Phone Number" style={{...baseStyles.flexInputLight, ...responsiveStyles.flexInputLight}} required />
                      <input type="email" name="email" placeholder="Email Address" style={{...baseStyles.flexInputLight, ...responsiveStyles.flexInputLight}} required />
                    </div>
                    <textarea 
                      name="order" 
                      placeholder="Type your SS26 order details here (Style numbers, sizes, quantities)..." 
                      style={{...baseStyles.catalogInput, height: '200px', resize: 'vertical'}} 
                      required 
                    />
                    <button 
                      type="submit" 
                      style={baseStyles.catalogSubmitBtn}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                        
                        
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                        
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      SUBMIT REQUEST
                    </button>
                  </form>
                </>
              ) : (
                <div style={{textAlign: 'center', padding: '40px 0'}}>
                  <p style={{fontSize: '18px', lineHeight: '1.6', color: '#333'}}>
                    Thanks for placing your order, a representative from our Customer Support Team will reach out to confirm details and availability of goods. For more questions feel free to call at 678.290.9293 - The Parsley & Sage Team
                  </p>
                  <button 
                    onClick={() => setFormSubmitted(false)}
                    style={{...baseStyles.catalogSubmitBtn, width: 'auto', padding: '10px 30px', marginTop: '30px', borderRadius: '50px'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                      
                      
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                      
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    SUBMIT ANOTHER REQUEST
                  </button>
                </div>
              )}
            </div>
          </div>
        );

      case 'FW26':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>FALL WINTER 2026</h2>
            <p style={{...baseStyles.seasonText, textAlign: 'center', marginBottom: '40px'}}>OFFICIAL WHOLESALE CATALOG</p>
            
            <div style={{maxWidth: '900px', margin: '0 auto 60px auto'}}>
              <div style={{...baseStyles.pdfWrapper, cursor: 'pointer'}} 
                onClick={() => window.open('https://11a4738.netsolhost.com/F26.pdf', '_blank')}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                <img 
                  src="/images/fall25.png" 
                  alt="Fall Winter 2026 Catalog Cover - Click to View" 
                  style={{
                    width: '100%',
                    height: '600px',
                    objectFit: 'contain',
                    backgroundColor: '#f5f5f5',
                    border: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  loading="lazy"
                />
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  color: '#fff',
                  padding: '15px 30px',
                  borderRadius: '4px',
                  fontSize: '14px',
                  fontWeight: '600',
                  letterSpacing: '1px',
                  opacity: 0,
                  transition: 'opacity 0.3s ease',
                  pointerEvents: 'none'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                >
                  CLICK TO VIEW CATALOG
                </div>
              </div>
              <div style={{ textAlign: 'center', marginTop: '30px' }}>
                <a 
                  href="https://11a4738.netsolhost.com/F26.pdf" 
                  download 
                  style={baseStyles.downloadBtn}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                    
                    
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                    
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  DOWNLOAD FW26 CATALOG (PDF)
                </a>
              </div>
            </div>

            <div style={{...baseStyles.orderFormContainer, ...responsiveStyles.orderFormContainer}}>
              {!formSubmitted ? (
                <>
                  <h3 style={{...baseStyles.sectionTitle, textAlign: 'center', marginBottom: '10px'}}>PLACE AN ORDER</h3>
                  <p style={{...baseStyles.seasonText, textAlign: 'center', marginBottom: '30px'}}>REQUEST AVAILABILITY FROM OUR SALES TEAM</p>
                  
                  <form action="https://formspree.io/f/xnjjqrvk" method="POST" style={baseStyles.catalogForm}>
                    <input type="text" name="boutique" placeholder="The Boutique Name" style={baseStyles.catalogInput} required />
                    <input type="text" name="name" placeholder="Your Full Name" style={baseStyles.catalogInput} required />
                    <div style={{...baseStyles.formRow, ...responsiveStyles.formRow}}>
                      <input type="tel" name="phone" placeholder="Phone Number" style={{...baseStyles.flexInputLight, ...responsiveStyles.flexInputLight}} required />
                      <input type="email" name="email" placeholder="Email Address" style={{...baseStyles.flexInputLight, ...responsiveStyles.flexInputLight}} required />
                    </div>
                    <textarea 
                      name="order" 
                      placeholder="Type your FW26 order details here (Style numbers, sizes, quantities)..." 
                      style={{...baseStyles.catalogInput, height: '200px', resize: 'vertical'}} 
                      required 
                    />
                    <button 
                      type="submit" 
                      style={baseStyles.catalogSubmitBtn}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                        
                        
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                        
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      SUBMIT REQUEST
                    </button>
                  </form>
                </>
              ) : (
                <div style={{textAlign: 'center', padding: '40px 0'}}>
                  <p style={{fontSize: '18px', lineHeight: '1.6', color: '#333'}}>
                    Thanks for placing your order, a representative from our Customer Support Team will reach out to confirm details and availability of goods. For more questions feel free to call at 678.290.9293 - The Parsley & Sage Team
                  </p>
                  <button 
                    onClick={() => setFormSubmitted(false)}
                    style={{...baseStyles.catalogSubmitBtn, width: 'auto', padding: '10px 30px', marginTop: '30px', borderRadius: '50px'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                      
                      
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                      
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    SUBMIT ANOTHER REQUEST
                  </button>
                </div>
              )}
            </div>
          </div>
        );

      case 'SS27':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>SPRING SUMMER 2027</h2>
            <p style={{...baseStyles.seasonText, textAlign: 'center', marginBottom: '40px'}}>OFFICIAL WHOLESALE CATALOG</p>
            
            <div style={{maxWidth: '900px', margin: '0 auto 60px auto'}}>
              <div style={{...baseStyles.pdfWrapper, cursor: 'pointer'}} 
                onClick={() => window.open('https://11a4738.netsolhost.com/SS27/SS27.pdf', '_blank')}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                <img 
                  src="/images/SS27.jpg" 
                  alt="Spring Summer 2027 Catalog Cover - Click to View" 
                  style={{
                    width: '100%',
                    height: '600px',
                    objectFit: 'contain',
                    backgroundColor: '#f5f5f5',
                    border: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  loading="lazy"
                />
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  color: '#fff',
                  padding: '15px 30px',
                  borderRadius: '4px',
                  fontSize: '14px',
                  fontWeight: '600',
                  letterSpacing: '1px',
                  opacity: 0,
                  transition: 'opacity 0.3s ease',
                  pointerEvents: 'none'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                >
                  CLICK TO VIEW CATALOG
                </div>
              </div>
              <div style={{ textAlign: 'center', marginTop: '30px' }}>
                <a 
                  href="https://11a4738.netsolhost.com/SS27/SS27.pdf" 
                  download 
                  style={baseStyles.downloadBtn}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                    
                    
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                    
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  DOWNLOAD SS27 CATALOG (PDF)
                </a>
              </div>
            </div>

            <div style={{...baseStyles.orderFormContainer, ...responsiveStyles.orderFormContainer}}>
              {!formSubmitted ? (
                <>
                  <h3 style={{...baseStyles.sectionTitle, textAlign: 'center', marginBottom: '10px'}}>PLACE AN ORDER</h3>
                  <p style={{...baseStyles.seasonText, textAlign: 'center', marginBottom: '30px'}}>REQUEST AVAILABILITY FROM OUR SALES TEAM</p>
                  
                  <form action="https://formspree.io/f/xnjjqrvk" method="POST" style={baseStyles.catalogForm}>
                    <input type="text" name="boutique" placeholder="The Boutique Name" style={baseStyles.catalogInput} required />
                    <input type="text" name="name" placeholder="Your Full Name" style={baseStyles.catalogInput} required />
                    <div style={{...baseStyles.formRow, ...responsiveStyles.formRow}}>
                      <input type="tel" name="phone" placeholder="Phone Number" style={{...baseStyles.flexInputLight, ...responsiveStyles.flexInputLight}} required />
                      <input type="email" name="email" placeholder="Email Address" style={{...baseStyles.flexInputLight, ...responsiveStyles.flexInputLight}} required />
                    </div>
                    <textarea 
                      name="order" 
                      placeholder="Type your SS27 order details here (Style numbers, sizes, quantities)..." 
                      style={{...baseStyles.catalogInput, height: '200px', resize: 'vertical'}} 
                      required 
                    />
                    <button 
                      type="submit" 
                      style={baseStyles.catalogSubmitBtn}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                        
                        
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                        
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      SUBMIT REQUEST
                    </button>
                  </form>
                </>
              ) : (
                <div style={{textAlign: 'center', padding: '40px 0'}}>
                  <p style={{fontSize: '18px', lineHeight: '1.6', color: '#333'}}>
                    Thanks for placing your order, a representative from our Customer Support Team will reach out to confirm details and availability of goods. For more questions feel free to call at 678.290.9293 - The Parsley & Sage Team
                  </p>
                  <button 
                    onClick={() => setFormSubmitted(false)}
                    style={{...baseStyles.catalogSubmitBtn, width: 'auto', padding: '10px 30px', marginTop: '30px', borderRadius: '50px'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#141412'; e.currentTarget.style.color = '#FFFFFF';
                      
                      
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                      
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(95, 110, 84, 0.15)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    SUBMIT ANOTHER REQUEST
                  </button>
                </div>
              )}
            </div>
          </div>
        );

      case 'PREVIOUS_COLLECTIONS':
        // Catalog data - Fall Winter & Spring Summer 2004-2024
        const previousCatalogs = [
          { year: 2004, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F04.pdf' },
          { year: 2005, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS05.pdf' },
          { year: 2005, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F05.pdf' },
          { year: 2006, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS06.pdf' },
          { year: 2006, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F06.pdf' },
          { year: 2007, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS07.pdf' },
          { year: 2007, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F07.pdf' },
          { year: 2008, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS08.pdf' },
          { year: 2008, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F08.pdf' },
          { year: 2009, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS09.pdf' },
          { year: 2009, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F09.pdf' },
          { year: 2010, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS10.pdf' },
          { year: 2010, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F10.pdf' },
          { year: 2011, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS11.pdf' },
          { year: 2011, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F11.pdf' },
          { year: 2012, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS12.pdf' },
          { year: 2012, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F12.pdf' },
          { year: 2013, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS13.pdf' },
          { year: 2014, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS14.pdf' },
          { year: 2014, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F14.pdf' },
          { year: 2015, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS15.pdf' },
          { year: 2015, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F15.pdf' },
          { year: 2016, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS16.pdf' },
          { year: 2016, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F16.pdf' },
          { year: 2017, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS17.pdf' },
          { year: 2017, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F17.pdf' },
          { year: 2018, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS18.pdf' },
          { year: 2018, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F18.pdf' },
          { year: 2019, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS19.pdf' },
          { year: 2019, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F19.pdf' },
          { year: 2020, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS20.pdf' },
          { year: 2020, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F20.pdf' },
          { year: 2021, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS21.pdf' },
          { year: 2021, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F21.pdf' },
          { year: 2022, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS22.pdf' },
          { year: 2022, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F22.pdf' },
          { year: 2023, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS23.pdf' },
          { year: 2023, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F23.pdf' },
          { year: 2024, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/Catalogs/SS24.pdf' },
          { year: 2024, season: 'Fall Winter', url: 'https://11a4738.netsolhost.com/Catalogs/F24.pdf' },
          { year: 2026, season: 'Spring Summer', url: 'https://11a4738.netsolhost.com/SS26.pdf' }
        ];

        // Get unique years for filter (oldest to newest)
        const uniqueYears = [...new Set(previousCatalogs.map(cat => cat.year))].sort((a, b) => a - b);

        // Filter catalogs
        let filteredCatalogs = previousCatalogs;
        if (selectedSeasonFilter !== 'All') {
          filteredCatalogs = filteredCatalogs.filter(cat => cat.season === selectedSeasonFilter);
        }
        if (selectedYearFilter !== 'All') {
          filteredCatalogs = filteredCatalogs.filter(cat => cat.year.toString() === selectedYearFilter);
        }
        // Sort by year ascending (oldest first), then SS before FW
        filteredCatalogs = filteredCatalogs.sort((a, b) => a.year - b.year || (a.season === 'Spring Summer' ? -1 : 1));

        // Group into eras for display
        const getEraLabel = (year) => {
          if (year >= 2025) return '2025 — 2029';
          if (year >= 2020) return '2020 — 2024';
          if (year >= 2015) return '2015 — 2019';
          if (year >= 2010) return '2010 — 2014';
          if (year >= 2005) return '2005 — 2009';
          return '2004';
        };

        // Group filtered catalogs by era
        const catalogsByEra = filteredCatalogs.reduce((acc, cat) => {
          const era = getEraLabel(cat.year);
          if (!acc[era]) acc[era] = [];
          acc[era].push(cat);
          return acc;
        }, {});

        // Era order - oldest first
        const eraOrder = ['2004', '2005 — 2009', '2010 — 2014', '2015 — 2019', '2020 — 2024', '2025 — 2029'];

        // 3D Book Component with artistic cover
        const Book3D = ({ catalog, onClick }) => {
          const [isHovered, setIsHovered] = React.useState(false);
          const isSpring = catalog.season === 'Spring Summer';
          const bookWidth = window.innerWidth <= 768 ? 140 : 180;
          const bookHeight = window.innerWidth <= 768 ? 195 : 250;
          const spineWidth = 24;

          // Cover colors — sage family so books read as objects on the light page
          const coverColors = isSpring
            ? ['#DDE2D4', '#E4E8DC', '#D6DCCB', '#E0E5D8', '#DAE0D0'] // light sage
            : ['#C3CBB4', '#BAC3A9', '#C8CFBA', '#B6BFA4', '#CDD3C1']; // deeper sage
          const coverBg = coverColors[catalog.year % coverColors.length];
          
          // Accent colors for text
          const accentColor = isSpring ? '#5F6E54' : '#4A5741';
          const textColor = isSpring ? '#2D3528' : '#232A22';

          return (
            <div
              onClick={onClick}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{
                position: 'relative',
                width: bookWidth,
                height: bookHeight,
                cursor: 'pointer',
                perspective: '1200px',
                transformStyle: 'preserve-3d'
              }}
            >
              {/* Book Container */}
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  transformStyle: 'preserve-3d',
                  transformOrigin: 'left center',
                  transition: 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                  transform: isHovered 
                    ? 'rotateY(-35deg) translateX(15px)' 
                    : 'rotateY(-18deg)'
                }}
              >
                {/* Back Cover */}
                <div
                  style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    background: isSpring ? '#E8E0D8' : '#D8D0C8',
                    borderRadius: '2px 4px 4px 2px',
                    transform: `translateZ(-${spineWidth}px)`,
                    boxShadow: 'inset 0 0 15px rgba(0,0,0,0.1)'
                  }}
                />

                {/* Pages (right edge) */}
                <div
                  style={{
                    position: 'absolute',
                    top: '4px',
                    bottom: '4px',
                    right: '0',
                    width: `${spineWidth}px`,
                    transform: `rotateY(90deg) translateZ(${bookWidth - spineWidth}px) translateX(-${spineWidth}px)`,
                    transformOrigin: 'left center',
                    background: `repeating-linear-gradient(
                      to right,
                      #faf9f6 0px,
                      #faf9f6 2px,
                      #f0efe8 2px,
                      #f0efe8 3px
                    )`,
                    boxShadow: 'inset 0 0 8px rgba(0,0,0,0.05)',
                    opacity: isHovered ? 1 : 0.5,
                    transition: 'opacity 0.4s ease'
                  }}
                />

                {/* Spine */}
                <div
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: `${spineWidth}px`,
                    height: '100%',
                    background: isSpring
                      ? 'linear-gradient(90deg, #E8DDD4 0%, #DDD2C8 50%, #D4C9BE 100%)'
                      : 'linear-gradient(90deg, #D8CEC4 0%, #CFC5BA 50%, #C8BEB3 100%)',
                    transform: `rotateY(-90deg) translateX(-${spineWidth}px)`,
                    transformOrigin: 'right center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: 'inset -2px 0 6px rgba(0,0,0,0.08), inset 2px 0 6px rgba(255,255,255,0.3)'
                  }}
                >
                  <div
                    style={{
                      transform: 'rotate(-90deg)',
                      whiteSpace: 'nowrap',
                      fontSize: '10px',
                      fontFamily: "'Cormorant Garamond', serif",
                      fontStyle: 'italic',
                      letterSpacing: '1px',
                      color: textColor,
                      fontWeight: '500'
                    }}
                  >
                    {catalog.year}
                  </div>
                </div>

                {/* Front Cover */}
                <div
                  style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    background: coverBg,
                    borderRadius: '2px 4px 4px 2px',
                    overflow: 'hidden',
                    boxShadow: isHovered
                      ? '8px 12px 35px rgba(0,0,0,0.25)'
                      : '4px 6px 20px rgba(0,0,0,0.15)',
                    transition: 'box-shadow 0.4s ease',
                    border: '1px solid rgba(0,0,0,0.04)'
                  }}
                >
                  {/* Subtle linen texture */}
                  <div
                    style={{
                      position: 'absolute',
                      inset: 0,
                      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
                      opacity: 0.03,
                      mixBlendMode: 'multiply'
                    }}
                  />

                  {/* Spine edge shadow */}
                  <div
                    style={{
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      bottom: 0,
                      width: '15px',
                      background: 'linear-gradient(90deg, rgba(0,0,0,0.06) 0%, transparent 100%)'
                    }}
                  />

                  {/* Light reflection */}
                  <div
                    style={{
                      position: 'absolute',
                      inset: 0,
                      background: isHovered
                        ? 'linear-gradient(130deg, rgba(255,255,255,0.4) 0%, transparent 40%)'
                        : 'linear-gradient(130deg, rgba(255,255,255,0.2) 0%, transparent 40%)',
                      transition: 'background 0.4s ease'
                    }}
                  />

                  {/* Cover content - Artistic handwritten style */}
                  <div
                    style={{
                      position: 'absolute',
                      inset: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '20px',
                      textAlign: 'center'
                    }}
                  >
                    {/* Decorative top flourish */}
                    <div style={{
                      fontSize: '18px',
                      color: accentColor,
                      opacity: 0.4,
                      marginBottom: '15px',
                      fontFamily: 'Georgia, serif'
                    }}>
                      ✦
                    </div>

                    {/* Season - Handwritten style */}
                    <div style={{
                      fontFamily: "'Cormorant Garamond', serif",
                      fontStyle: 'italic',
                      fontSize: window.innerWidth <= 768 ? '16px' : '20px',
                      fontWeight: '400',
                      color: textColor,
                      lineHeight: '1.3',
                      marginBottom: '5px',
                      letterSpacing: '1px'
                    }}>
                      {isSpring ? 'Spring Summer' : 'Fall Winter'}
                    </div>

                    {/* Year - Large elegant script */}
                    <div style={{
                      fontFamily: "'Cormorant Garamond', serif",
                      fontStyle: 'italic',
                      fontSize: window.innerWidth <= 768 ? '32px' : '42px',
                      fontWeight: '300',
                      color: textColor,
                      lineHeight: '1',
                      letterSpacing: '2px',
                      marginBottom: '15px'
                    }}>
                      '{catalog.year.toString().slice(-2)}
                    </div>

                    {/* Decorative line */}
                    <div style={{
                      width: '40px',
                      height: '1px',
                      background: accentColor,
                      opacity: 0.3,
                      marginBottom: '15px'
                    }} />

                    {/* Brand name - subtle */}
                    <div style={{
                      fontFamily: "'Cormorant Garamond', serif",
                      fontSize: '9px',
                      letterSpacing: '3px',
                      color: accentColor,
                      textTransform: 'uppercase',
                      opacity: 0.6
                    }}>
                      Parsley & Sage
                    </div>
                  </div>

                  {/* Edge highlight */}
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      bottom: 0,
                      width: '1px',
                      background: 'rgba(255,255,255,0.5)'
                    }}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: '1px',
                      background: 'rgba(255,255,255,0.5)'
                    }}
                  />
                </div>
              </div>

              {/* Shadow */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '-20px',
                  left: '10%',
                  right: '5%',
                  height: '20px',
                  background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.2) 0%, transparent 70%)',
                  transform: isHovered ? 'scale(1.15) translateX(8px)' : 'scale(1)',
                  opacity: isHovered ? 0.6 : 0.4,
                  transition: 'all 0.4s ease',
                  filter: 'blur(8px)'
                }}
              />
            </div>
          );
        };

        return (
          <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #EDEFE8 0%, #FFFFFF 40%, #FFFFFF 100%)',
            paddingTop: '120px',
            paddingBottom: '100px'
          }}>
            {/* Header */}
            <div 
              className="reveal-fade-up"
              style={{ textAlign: 'center', marginBottom: '50px', padding: '0 20px' }}
            >
              <div style={{
                fontSize: '11px',
                fontFamily: "'Space Grotesk', sans-serif",
                letterSpacing: '4px',
                color: '#5F6E54',
                marginBottom: '20px',
                textTransform: 'uppercase',
                animation: 'fadeInUp 0.6s ease forwards'
              }}>
                The Collection
              </div>
              <h2 style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: window.innerWidth <= 768 ? '42px' : '64px',
                color: '#141412',
                fontWeight: '300',
                letterSpacing: '12px',
                marginBottom: '20px',
                textTransform: 'uppercase',
                animation: 'fadeInUp 0.6s ease 0.1s forwards',
                opacity: 0
              }}>
                Archive
              </h2>
              <p style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '14px',
                color: '#55554E',
                letterSpacing: '2px',
                maxWidth: '500px',
                margin: '0 auto',
                lineHeight: '1.8',
                animation: 'fadeInUp 0.6s ease 0.2s forwards',
                opacity: 0
              }}>
                Two decades of artisan fashion
              </p>
            </div>

            {/* Filters */}
            <div 
              className="reveal-fade-up"
              style={{
              maxWidth: '1200px',
              margin: '0 auto 60px auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '25px',
              flexWrap: 'wrap',
              padding: '0 20px'
            }}>
              {/* Season Filter */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <label style={{
                  fontSize: '11px',
                  fontWeight: '500',
                  color: '#77766E',
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  fontFamily: "'Space Grotesk', sans-serif"
                }}>
                  Season
                </label>
                <select 
                  value={selectedSeasonFilter}
                  onChange={(e) => setSelectedSeasonFilter(e.target.value)}
                  style={{
                    padding: '10px 20px',
                    fontSize: '13px',
                    border: '1px solid rgba(20, 20, 18, 0.15)',
                    borderRadius: '4px',
                    backgroundColor: '#FFFFFF',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    color: '#141412',
                    cursor: 'pointer',
                    fontFamily: "'Montserrat', sans-serif",
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    minWidth: '160px'
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = '#5F6E54';
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(20, 20, 18, 0.15)';
                  }}
                >
                  <option value="All">All Seasons</option>
                  <option value="Spring Summer">Spring Summer</option>
                  <option value="Fall Winter">Fall Winter</option>
                </select>
              </div>

              {/* Year Filter */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <label style={{
                  fontSize: '11px',
                  fontWeight: '500',
                  color: '#77766E',
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  fontFamily: "'Space Grotesk', sans-serif"
                }}>
                  Year
                </label>
                <select 
                  value={selectedYearFilter}
                  onChange={(e) => setSelectedYearFilter(e.target.value)}
                  style={{
                    padding: '10px 20px',
                    fontSize: '13px',
                    border: '1px solid rgba(20, 20, 18, 0.15)',
                    borderRadius: '4px',
                    backgroundColor: '#FFFFFF',
                    color: '#141412',
                    cursor: 'pointer',
                    fontFamily: "'Montserrat', sans-serif",
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    minWidth: '120px'
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = '#5F6E54';
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(20, 20, 18, 0.15)';
                  }}
                >
                  <option value="All">All Years</option>
                  {uniqueYears.map(year => (
                    <option key={year} value={year.toString()}>{year}</option>
                  ))}
                </select>
              </div>

              {/* Clear Filters */}
              {(selectedYearFilter !== 'All' || selectedSeasonFilter !== 'All') && (
                <button
                  className="glass-btn"
                  onClick={() => {
                    setSelectedYearFilter('All');
                    setSelectedSeasonFilter('All');
                  }}
                  style={{
                    padding: '12px 24px',
                    fontSize: '11px',
                    backgroundColor: 'rgba(95, 110, 84, 0.12)',
                    border: '1px solid rgba(95, 110, 84, 0.25)',
                    borderRadius: '50px',
                    color: '#141412',
                    cursor: 'pointer',
                    fontFamily: "'Space Grotesk', sans-serif",
                    letterSpacing: '1px',
                    transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                    textTransform: 'uppercase',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(95, 110, 84, 0.25)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 12px 40px rgba(0, 0, 0, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(95, 110, 84, 0.12)';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.15)';
                  }}
                >
                  Clear Filters
                </button>
              )}
            </div>

            {/* Results count */}
            <p style={{
              textAlign: 'center',
              fontSize: '12px',
              color: '#55554E',
              marginBottom: '50px',
              fontFamily: "'Montserrat', sans-serif",
              letterSpacing: '1px',
              animation: 'fadeIn 0.5s ease forwards'
            }}>
              Showing {filteredCatalogs.length} catalog{filteredCatalogs.length !== 1 ? 's' : ''}
            </p>

            {/* Catalogs by Era */}
            <div style={{
              maxWidth: '1400px',
              margin: '0 auto',
              padding: '0 40px'
            }}>
              {eraOrder.map((era) => {
                const eraCatalogs = catalogsByEra[era];
                if (!eraCatalogs || eraCatalogs.length === 0) return null;

                return (
                  <div key={era} style={{ marginBottom: '100px' }}>
                    {/* Era Header */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '50px',
                      gap: '25px'
                    }}>
                      <div style={{
                        flex: '0 0 auto',
                        fontFamily: "'Cormorant Garamond', serif",
                        fontSize: window.innerWidth <= 768 ? '24px' : '30px',
                        color: '#141412',
                        fontWeight: '300',
                        letterSpacing: '4px'
                      }}>
                        {era}
                      </div>
                      <div style={{
                        flex: 1,
                        height: '1px',
                        background: 'linear-gradient(90deg, rgba(95, 110, 84, 0.2) 0%, transparent 100%)'
                      }} />
                      <div style={{
                        fontSize: '11px',
                        fontFamily: "'Montserrat', sans-serif",
                        color: '#55554E',
                        letterSpacing: '1px'
                      }}>
                        {eraCatalogs.length} catalog{eraCatalogs.length !== 1 ? 's' : ''}
                      </div>
                    </div>

                    {/* Books Grid */}
                    <div style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: window.innerWidth <= 768 ? '40px 30px' : '60px 50px',
                      justifyContent: window.innerWidth <= 768 ? 'center' : 'flex-start',
                      paddingLeft: window.innerWidth <= 768 ? '0' : '20px'
                    }}>
                      {eraCatalogs.map((catalog) => (
                        <Book3D
                          key={`${catalog.season}-${catalog.year}`}
                          catalog={catalog}
                          onClick={() => setHoverCatalog(catalog)}
                        />
                      ))}
                    </div>
                  </div>
                );
              })}

              {/* No results */}
              {filteredCatalogs.length === 0 && (
                <div style={{
                  textAlign: 'center',
                  padding: '80px 20px',
                  color: '#666'
                }}>
                  <p style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: '24px',
                    marginBottom: '15px'
                  }}>
                    No catalogs found
                  </p>
                  <p style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: '14px'
                  }}>
                    Try adjusting your filters
                  </p>
                </div>
              )}
            </div>

            {/* Legend */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '50px',
              marginTop: '60px',
              flexWrap: 'wrap',
              padding: '0 20px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '24px',
                  height: '32px',
                  background: '#FDF8F3',
                  borderRadius: '2px',
                  boxShadow: '2px 2px 6px rgba(0,0,0,0.15)',
                  border: '1px solid rgba(0,0,0,0.06)'
                }} />
                <span style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: '12px',
                  color: '#777',
                  letterSpacing: '1px'
                }}>
                  Spring / Summer
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '24px',
                  height: '32px',
                  background: '#F0EBE5',
                  borderRadius: '2px',
                  boxShadow: '2px 2px 6px rgba(0,0,0,0.15)',
                  border: '1px solid rgba(0,0,0,0.06)'
                }} />
                <span style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: '12px',
                  color: '#777',
                  letterSpacing: '1px'
                }}>
                  Fall / Winter
                </span>
              </div>
            </div>

            {/* Hint */}
            <p style={{
              textAlign: 'center',
              marginTop: '35px',
              fontFamily: "'Montserrat', sans-serif",
              fontSize: '13px',
              color: '#444',
              fontStyle: 'italic'
            }}>
              Hover to preview · Click to open catalog
            </p>

            {/* Modal */}
            {hoverCatalog && (
              <div
                style={{
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '90%',
                  maxWidth: '900px',
                  height: '85vh',
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  boxShadow: '0 25px 80px rgba(0, 0, 0, 0.6)',
                  zIndex: 10000,
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {/* Modal Header */}
                <div style={{
                  padding: '20px 30px',
                  borderBottom: '1px solid #E8E6E3',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  backgroundColor: '#FFFFFF'
                }}>
                  <div>
                    <h3 style={{
                      fontFamily: "'Cormorant Garamond', serif",
                      fontSize: '28px',
                      color: '#141412',
                      margin: 0
                    }}>
                      {hoverCatalog.season.toUpperCase()} {hoverCatalog.year}
                    </h3>
                    <p style={{
                      fontSize: '13px',
                      color: '#888',
                      margin: '5px 0 0 0',
                      letterSpacing: '1px',
                      fontFamily: "'Montserrat', sans-serif"
                    }}>
                      Wholesale Collection Catalog
                    </p>
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setHoverCatalog(null);
                    }}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      fontSize: '32px',
                      color: '#888',
                      cursor: 'pointer',
                      padding: '0',
                      width: '40px',
                      height: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f0f0f0';
                      e.currentTarget.style.color = '#141412';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.color = '#888';
                    }}
                  >
                    ×
                  </button>
                </div>

                {/* PDF Viewer */}
                <div style={{
                  flex: 1,
                  overflow: 'auto',
                  backgroundColor: '#f5f5f5'
                }}>
                  <iframe
                    src={hoverCatalog.url}
                    width="100%"
                    height="100%"
                    style={{
                      border: 'none',
                      minHeight: '100%'
                    }}
                    title={`${hoverCatalog.season} ${hoverCatalog.year} Catalog`}
                  />
                </div>

                {/* Modal Footer */}
                <div style={{
                  padding: '15px 30px',
                  borderTop: '1px solid #E8E6E3',
                  backgroundColor: '#FFFFFF',
                  display: 'flex',
                  justifyContent: 'center'
                }}>
                  <a
                    href={hoverCatalog.url}
                    download
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      padding: '12px 40px',
                      backgroundColor: '#141412',
                      color: '#fff',
                      textDecoration: 'none',
                      borderRadius: '50px',
                      fontSize: '13px',
                      fontWeight: '600',
                      letterSpacing: '1.5px',
                      textTransform: 'uppercase',
                      transition: 'all 0.3s ease',
                      fontFamily: "'Space Grotesk', sans-serif"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#2D2520';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(74, 63, 53, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#141412';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    Download Full Catalog
                  </a>
                </div>
              </div>
            )}

            {/* Dark Overlay */}
            {hoverCatalog && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.85)',
                  zIndex: 9999,
                  backdropFilter: 'blur(8px)'
                }}
                onClick={() => setHoverCatalog(null)}
              />
            )}
          </div>
        );

      case 'F26WP_PDF':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>FALL WINTER 2026 - WHOLESALE PRICES</h2>
            <p style={{fontSize: '14px', color: '#666', marginBottom: '40px'}}>
              Confidential wholesale pricing catalog
            </p>
            
            <div style={{maxWidth: '1200px', margin: '0 auto'}}>
              <div style={baseStyles.pdfWrapper}>
                <iframe 
                  src="https://11a4738.netsolhost.com/F26WP.pdf" 
                  width="100%" 
                  height="800px" 
                  style={{ border: 'none' }}
                  title="F26 Wholesale Prices"
                loading="lazy"
            />
              </div>
              
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <a href="https://11a4738.netsolhost.com/F26WP.pdf" download style={baseStyles.downloadBtn}>
                  DOWNLOAD PDF
                </a>
              </div>
            </div>
          </div>
        );

      case 'F26_PDF':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>FALL WINTER 2026</h2>
            <p style={{fontSize: '14px', color: '#666', marginBottom: '40px'}}>
              Official wholesale catalog
            </p>
            
            <div style={{maxWidth: '1200px', margin: '0 auto'}}>
              <div style={baseStyles.pdfWrapper}>
                <iframe 
                  src="https://11a4738.netsolhost.com/F26.pdf" 
                  width="100%" 
                  height="800px" 
                  style={{ border: 'none' }}
                  title="Fall Winter 2026"
                loading="lazy"
            />
              </div>
              
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <a href="https://11a4738.netsolhost.com/F26.pdf" download style={baseStyles.downloadBtn}>
                  DOWNLOAD FW26 CATALOG (PDF)
                </a>
              </div>
            </div>
          </div>
        );

      case 'SS26WP_PDF':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>SPRING SUMMER 2026 - WHOLESALE PRICES</h2>
            <p style={{fontSize: '14px', color: '#666', marginBottom: '40px'}}>
              Confidential wholesale pricing catalog
            </p>
            
            <div style={{maxWidth: '1200px', margin: '0 auto'}}>
              <div style={baseStyles.pdfWrapper}>
                <iframe 
                  src="https://11a4738.netsolhost.com/SS26WP.pdf" 
                  width="100%" 
                  height="800px" 
                  style={{ border: 'none' }}
                  title="SS26 Wholesale Prices"
                loading="lazy"
            />
              </div>
              
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <a href="https://11a4738.netsolhost.com/SS26WP.pdf" download style={baseStyles.downloadBtn}>
                  DOWNLOAD PDF
                </a>
              </div>
            </div>
          </div>
        );

      case 'SS27WP_PDF':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>SPRING SUMMER 2027 - WHOLESALE PRICES</h2>
            <p style={{fontSize: '14px', color: '#666', marginBottom: '40px'}}>
              Confidential wholesale pricing catalog
            </p>
            
            <div style={{maxWidth: '1200px', margin: '0 auto'}}>
              <div style={baseStyles.pdfWrapper}>
                <iframe 
                  src="https://11a4738.netsolhost.com/SS27/SS27WP.pdf" 
                  width="100%" 
                  height="800px" 
                  style={{ border: 'none' }}
                  title="SS27 Wholesale Prices"
                loading="lazy"
            />
              </div>
              
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <a href="https://11a4738.netsolhost.com/SS27/SS27WP.pdf" download style={baseStyles.downloadBtn}>
                  DOWNLOAD PDF
                </a>
              </div>
            </div>
          </div>
        );

      case 'MENS':
        const limitedProducts = [
          {
            id: 1,
            name: 'Terracotta Paisley Safari Shirt',
            styleNumber: 'LE-003',
            price: 128.00,
            image: '/images/terracotta.png',
            shortDescription: 'Indian-inspired safari shirt in warm terracotta and cream paisley with geometric accents. Natural coconut buttons.',
            fullDescription: 'Rich earth tones meet artisan craftsmanship in this exclusive limited edition safari shirt. The intricate paisley pattern in warm terracottas, creams, and browns is complemented by geometric diamond lattice details, creating a sophisticated bohemian aesthetic. Hand-selected natural coconut buttons add authentic character while the relaxed, slightly cropped silhouette delivers contemporary styling with classic camp shirt appeal. Each piece celebrates traditional Indian textile artistry reimagined for the modern wardrobe.',
            fitInfo: [
              'Crop fit falling right on the hip',
              'Camp collar styling',
              'Short sleeves'
            ],
            details: [
              '100% cotton',
              'Coconut buttons',
              'Machine washable',
              'Made in India'
            ],
            availableSizes: ['M', 'L', 'XL'],
            inventory: {
              'M': 6,
              'L': 28,
              'XL': 31
            },
            inStock: true,
            stripeLinksBySize: {
              'M': 'https://buy.stripe.com/terracotta-shirt-m-REPLACE-WITH-ACTUAL',
              'L': 'https://buy.stripe.com/terracotta-shirt-l-REPLACE-WITH-ACTUAL',
              'XL': 'https://buy.stripe.com/terracotta-shirt-xl-REPLACE-WITH-ACTUAL'
            }
          },
          {
            id: 2,
            name: 'Sage Paisley Safari Shirt',
            styleNumber: 'LE-011',
            price: 128.00,
            image: '/images/sage.png',
            shortDescription: 'Indian-inspired safari shirt featuring intricate sage and cream paisley with geometric diamond motifs. Natural coconut buttons.',
            fullDescription: 'A sophisticated blend of traditional Indian craftsmanship and modern safari styling. This exclusive short-sleeve shirt features an intricate hand-block-inspired paisley pattern in sage greens, creams, and earth tones, interwoven with geometric diamond lattice details. Each natural coconut button is hand-selected, adding authentic artisan character. The relaxed, slightly cropped silhouette offers contemporary styling while honoring classic camp shirt heritage. Perfect for the fashion-forward boutique customer seeking unique, globally-inspired menswear.',
            fitInfo: [
              'Crop fit falling right on the hip',
              'Camp collar styling',
              'Short sleeves'
            ],
            details: [
              '100% cotton',
              'Coconut buttons',
              'Machine washable',
              'Made in India'
            ],
            availableSizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            stripeLinksBySize: {
              'XS': 'https://buy.stripe.com/sage-shirt-xs-REPLACE-WITH-ACTUAL',
              'S': 'https://buy.stripe.com/sage-shirt-s-REPLACE-WITH-ACTUAL',
              'M': 'https://buy.stripe.com/sage-shirt-m-REPLACE-WITH-ACTUAL',
              'L': 'https://buy.stripe.com/sage-shirt-l-REPLACE-WITH-ACTUAL',
              'XL': 'https://buy.stripe.com/sage-shirt-xl-REPLACE-WITH-ACTUAL',
              'XXL': 'https://buy.stripe.com/sage-shirt-xxl-REPLACE-WITH-ACTUAL'
            },
            currentOrders: 0,
            minimumOrders: 85
          }
        ];

        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage, backgroundColor: '#FFFFFF'}}>
            <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading, color: '#141412'}}>LIMITED EDITION</h2>
            <p style={{fontSize: '14px', color: '#5F6E54', marginBottom: '10px', letterSpacing: '2px', textTransform: 'uppercase', fontFamily: "'Space Grotesk', sans-serif"}}>
              EXCLUSIVE COLLECTION
            </p>
            <p style={{fontSize: '16px', color: '#666', marginBottom: '60px', lineHeight: '1.8', maxWidth: '700px', margin: '0 auto 60px auto', fontFamily: "'Montserrat', sans-serif"}}>
              Handcrafted artisan pieces. Some available now, some on pre-order—see details below.
            </p>
            
            {/* Product Grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : window.innerWidth <= 1024 ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
              gap: '40px',
              maxWidth: '1400px',
              margin: '0 auto 80px auto'
            }}>
              {limitedProducts.map(product => {
                const percentComplete = (product.currentOrders / product.minimumOrders) * 100;
                const ordersRemaining = product.minimumOrders - product.currentOrders;
                
                return (
                  <div 
                    key={product.id}
                    style={{
                      ...baseStyles.limitedItemCard,
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => {
                      setSelectedItem(product);
                      setSelectedSize(''); // Reset size when opening new product
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.12)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)';
                    }}
                  >
                    <div style={baseStyles.limitedImageWrapper}>
                      <img src={product.image} alt={product.name} style={baseStyles.limitedImage} loading="lazy"/>
                    </div>
                    <div style={{padding: '25px'}}>
                      <h3 style={baseStyles.limitedItemTitle}>{product.name}</h3>
                      <p style={{...baseStyles.limitedItemNumber, color: '#5F6E54', fontSize: '18px', fontWeight: '600', marginBottom: '12px'}}>
                        ${product.price.toFixed(2)}
                      </p>
                      <p style={baseStyles.limitedItemDescription}>
                        {product.shortDescription}
                      </p>
                      
                      <button 
                        style={{
                          ...baseStyles.limitedRequestBtn,
                          width: '100%',
                          textAlign: 'center',
                          marginTop: '20px'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(95, 110, 84, 0.85)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#5F6E54';
                        }}
                      >
                        {product.inStock ? 'ORDER' : 'PREORDER'}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Returns Policy & Pre-Order Info */}
            <div style={{
              marginTop: '60px',
              padding: '40px',
              backgroundColor: '#fff',
              borderRadius: '4px',
              maxWidth: '900px',
              margin: '0 auto',
              border: '1px solid #E8E6E3'
            }}>
              <h3 style={{...baseStyles.sectionTitle, marginBottom: '25px', textAlign: 'center', color: '#141412', fontSize: '28px'}}>PRE-ORDER DETAILS</h3>
              <div style={{textAlign: 'left'}}>
                <p style={{fontSize: '15px', lineHeight: '1.8', color: '#666', marginBottom: '15px', fontFamily: "'Montserrat', sans-serif"}}>
                  <strong>How It Works:</strong> Reserve your piece with a secure pre-order payment. Your card will be authorized but not charged until your item ships (typically 6-8 weeks after minimum orders are met).
                </p>
                <p style={{fontSize: '15px', lineHeight: '1.8', color: '#666', marginBottom: '15px', fontFamily: "'Montserrat', sans-serif"}}>
                  <strong>Production Timeline:</strong> Once the minimum of 85 orders is reached, production begins. You'll receive email updates throughout the process.
                </p>
                <p style={{fontSize: '15px', lineHeight: '1.8', color: '#666', marginBottom: '15px', fontFamily: "'Montserrat', sans-serif"}}>
                  <strong>Returns:</strong> All limited edition pieces are final sale. However, if your item arrives damaged or defective, we'll provide a full refund or replacement. Buyer is responsible for return shipping costs.
                </p>
                <p style={{fontSize: '15px', lineHeight: '1.8', color: '#666', marginBottom: '15px', fontFamily: "'Montserrat', sans-serif"}}>
                  <strong>Secure Payment:</strong> All payments are processed securely through Stripe. We never see or store your payment information.
                </p>
              </div>
              <p style={{fontSize: '14px', color: '#666', marginTop: '30px', textAlign: 'center', borderTop: '1px solid #E8E6E3', paddingTop: '20px', fontFamily: "'Montserrat', sans-serif"}}>
                <strong>Questions?</strong> Contact us at <a href="mailto:sales@parsley-sage.com" style={{color: '#5F6E54', textDecoration: 'none'}}>sales@parsley-sage.com</a> or <a href="tel:678-290-9293" style={{color: '#5F6E54', textDecoration: 'none'}}>678-290-9293</a>
              </p>
            </div>

            {/* Product Detail Modal */}
            {selectedItem && (
              <div 
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10000,
                  padding: '20px',
                  overflowY: 'auto'
                }}
                onClick={() => {
                  setSelectedItem(null);
                  setSelectedSize('');
                }}
              >
                <div 
                  style={{
                    backgroundColor: '#fff',
                    maxWidth: '900px',
                    width: '100%',
                    borderRadius: '8px',
                    position: 'relative',
                    maxHeight: '90vh',
                    overflowY: 'auto'
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Close Button */}
                  <button
                    onClick={() => {
                      setSelectedItem(null);
                      setSelectedSize('');
                    }}
                    style={{
                      position: 'absolute',
                      top: '20px',
                      right: '20px',
                      background: 'none',
                      border: 'none',
                      fontSize: '32px',
                      cursor: 'pointer',
                      color: '#666',
                      zIndex: 1,
                      width: '40px',
                      height: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f0f0f0';
                      e.currentTarget.style.color = '#333';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.color = '#77766E';
                    }}
                  >
                    ×
                  </button>

                  {/* Modal Content */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : '1fr 1fr',
                    gap: '40px',
                    padding: '40px'
                  }}>
                    {/* Left: Product Image + Progress + Size Selection + Order Button */}
                    <div>
                      <img 
                        src={selectedItem.image} 
                        alt={selectedItem.name}
                        style={{
                          width: '100%',
                          height: 'auto',
                          borderRadius: '4px',
                          marginBottom: '25px'
                        }}
                      />
                      
                      {/* Progress Bar - Only show for pre-order items */}
                      {selectedItem.currentOrders !== undefined && selectedItem.minimumOrders !== undefined && (
                        <div style={{marginBottom: '20px'}}>
                          <div style={{
                            width: '100%',
                            height: '10px',
                            backgroundColor: '#E8E6E3',
                            borderRadius: '5px',
                            overflow: 'hidden',
                            marginBottom: '12px'
                          }}>
                            <div style={{
                              width: `${(selectedItem.currentOrders / selectedItem.minimumOrders) * 100}%`,
                              height: '100%',
                              backgroundColor: '#5F6E54',
                              transition: 'width 0.3s ease'
                            }} />
                          </div>
                          <p style={{
                            fontSize: '14px',
                            color: '#666',
                            fontFamily: "'Montserrat', sans-serif"
                          }}>
                            <strong>{selectedItem.currentOrders}</strong> of <strong>{selectedItem.minimumOrders}</strong> orders reserved
                          </p>
                          {(selectedItem.minimumOrders - selectedItem.currentOrders) <= 10 && (
                            <p style={{
                              fontSize: '13px',
                              color: '#5F6E54',
                              fontWeight: '600',
                              marginTop: '8px',
                              letterSpacing: '0.5px',
                              fontFamily: "'Space Grotesk', sans-serif"
                            }}>
                              ◊ Exclusive offering - Limited availability
                            </p>
                          )}
                        </div>
                      )}

                      {/* Size Selection */}
                      <div style={{marginBottom: '25px'}}>
                        <h3 style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#141412',
                          marginBottom: '15px',
                          letterSpacing: '0.5px',
                          textTransform: 'uppercase',
                          fontFamily: "'Space Grotesk', sans-serif"
                        }}>
                          Select Size <span style={{color: '#ff0000'}}>*</span>
                        </h3>
                        
                        <div style={{
                          display: 'flex',
                          gap: '10px',
                          flexWrap: 'wrap'
                        }}>
                          {selectedItem.availableSizes.map(size => {
                            const isInStock = selectedItem.inStock;
                            const inventoryCount = isInStock && selectedItem.inventory ? selectedItem.inventory[size] : null;
                            const isAvailable = !isInStock || (inventoryCount && inventoryCount > 0);
                            
                            return (
                              <button
                                key={size}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (isAvailable) {
                                    setSelectedSize(size);
                                  }
                                }}
                                disabled={!isAvailable}
                                style={{
                                  padding: '12px 20px',
                                  minWidth: '60px',
                                  border: selectedSize === size ? '2px solid #5F6E54' : !isAvailable ? '1px solid #ddd' : '1px solid #E8E6E3',
                                  backgroundColor: selectedSize === size ? '#FFF9F5' : !isAvailable ? '#f5f5f5' : '#fff',
                                  borderRadius: '4px',
                                  cursor: isAvailable ? 'pointer' : 'not-allowed',
                                  fontSize: '14px',
                                  fontWeight: selectedSize === size ? '600' : '400',
                                  color: !isAvailable ? '#ccc' : selectedSize === size ? '#141412' : '#666',
                                  transition: 'all 0.3s ease',
                                  fontFamily: "'Space Grotesk', sans-serif",
                                  letterSpacing: '0.5px',
                                  opacity: !isAvailable ? 0.5 : 1,
                                  position: 'relative'
                                }}
                                onMouseEnter={(e) => {
                                  if (selectedSize !== size && isAvailable) {
                                    e.currentTarget.style.borderColor = '#5F6E54';
                                    e.currentTarget.style.backgroundColor = '#FFFFFF';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (selectedSize !== size && isAvailable) {
                                    e.currentTarget.style.borderColor = '#E8E6E3';
                                    e.currentTarget.style.backgroundColor = '#fff';
                                  }
                                }}
                              >
                                <div style={{textAlign: 'center'}}>
                                  <div>{size}</div>
                                  {inventoryCount && (
                                    <div style={{
                                      fontSize: '10px',
                                      color: inventoryCount < 10 ? '#d4622a' : '#5F6E54',
                                      marginTop: '2px',
                                      fontWeight: '500'
                                    }}>
                                      {inventoryCount} left
                                    </div>
                                  )}
                                  {!isAvailable && (
                                    <div style={{
                                      fontSize: '10px',
                                      color: '#999',
                                      marginTop: '2px'
                                    }}>
                                      Sold Out
                                    </div>
                                  )}
                                </div>
                              </button>
                            );
                          })}
                        </div>
                      </div>

                      {/* Order/Pre-Order Button */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          
                          // Validate size is selected
                          if (!selectedSize) {
                            alert(selectedItem.inStock ? 'Please select a size before ordering' : 'Please select a size before pre-ordering');
                            return;
                          }
                          
                          // Get Stripe link for selected size
                          const stripeLink = selectedItem.stripeLinksBySize[selectedSize];
                          
                          if (!stripeLink) {
                            alert('This size is currently unavailable. Please contact us at sales@parsley-sage.com');
                            return;
                          }
                          
                          // Track in Google Analytics if available
                          if (window.gtag) {
                            window.gtag('event', 'begin_checkout', {
                              item_id: selectedItem.styleNumber,
                              item_name: selectedItem.name,
                              item_variant: selectedSize,
                              value: selectedItem.price,
                              currency: 'USD'
                            });
                          }
                          
                          // Redirect to Stripe
                          window.location.href = stripeLink;
                        }}
                        style={{
                          width: '100%',
                          padding: '18px',
                          backgroundColor: selectedSize ? '#5F6E54' : '#ccc',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '50px',
                          fontSize: '14px',
                          fontWeight: '600',
                          cursor: selectedSize ? 'pointer' : 'not-allowed',
                          letterSpacing: '2px',
                          textTransform: 'uppercase',
                          transition: 'all 0.4s ease',
                          marginBottom: '15px',
                          fontFamily: "'Space Grotesk', sans-serif",
                          opacity: selectedSize ? 1 : 0.6
                        }}
                        onMouseEnter={(e) => {
                          if (selectedSize) {
                            e.currentTarget.style.backgroundColor = 'rgba(95, 110, 84, 0.85)';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = selectedSize ? '#5F6E54' : '#ccc';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {selectedSize 
                          ? selectedItem.inStock 
                            ? `ORDER NOW - SIZE ${selectedSize}` 
                            : `PRE-ORDER NOW - SIZE ${selectedSize}` 
                          : 'SELECT A SIZE TO CONTINUE'
                        }
                      </button>
                      
                      <p style={{
                        fontSize: '12px',
                        color: '#888',
                        textAlign: 'center',
                        lineHeight: '1.6',
                        fontFamily: "'Montserrat', sans-serif"
                      }}>
                        Secure payment via Stripe • {selectedItem.inStock ? 'Ships within 2-3 business days' : 'Card authorized now, charged when shipped'}
                      </p>
                    </div>

                    {/* Right: Product Details */}
                    <div>
                      <h2 style={{
                        fontFamily: "'Cormorant Garamond', serif",
                        fontSize: '32px',
                        color: '#141412',
                        marginBottom: '10px',
                        lineHeight: '1.2'
                      }}>
                        {selectedItem.name}
                      </h2>
                      <p style={{
                        fontSize: '28px',
                        color: '#5F6E54',
                        fontWeight: '600',
                        marginBottom: '30px'
                      }}>
                        ${selectedItem.price.toFixed(2)}
                      </p>

                      <div style={{marginBottom: '30px'}}>
                        <h3 style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#141412',
                          marginBottom: '12px',
                          letterSpacing: '0.5px',
                          textTransform: 'uppercase',
                          fontFamily: "'Space Grotesk', sans-serif"
                        }}>
                          Description
                        </h3>
                        <p style={{
                          fontSize: '15px',
                          lineHeight: '1.8',
                          color: '#666',
                          fontFamily: "'Montserrat', sans-serif"
                        }}>
                          {selectedItem.fullDescription}
                        </p>
                      </div>

                      <div style={{marginBottom: '30px'}}>
                        <h3 style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#141412',
                          marginBottom: '12px',
                          letterSpacing: '0.5px',
                          textTransform: 'uppercase',
                          fontFamily: "'Space Grotesk', sans-serif"
                        }}>
                          Fit & Sizing
                        </h3>
                        <ul style={{
                          listStyle: 'none',
                          padding: 0,
                          margin: 0
                        }}>
                          {selectedItem.fitInfo.map((info, index) => (
                            <li key={index} style={{
                              fontSize: '14px',
                              color: '#666',
                              marginBottom: '8px',
                              paddingLeft: '20px',
                              position: 'relative',
                              fontFamily: "'Montserrat', sans-serif"
                            }}>
                              <span style={{
                                position: 'absolute',
                                left: 0,
                                color: '#5F6E54'
                              }}>•</span>
                              {info}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div style={{marginBottom: '30px'}}>
                        <h3 style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#141412',
                          marginBottom: '12px',
                          letterSpacing: '0.5px',
                          textTransform: 'uppercase',
                          fontFamily: "'Space Grotesk', sans-serif"
                        }}>
                          Details
                        </h3>
                        <ul style={{
                          listStyle: 'none',
                          padding: 0,
                          margin: 0
                        }}>
                          {selectedItem.details.map((detail, index) => (
                            <li key={index} style={{
                              fontSize: '14px',
                              color: '#666',
                              marginBottom: '8px',
                              paddingLeft: '20px',
                              position: 'relative',
                              fontFamily: "'Montserrat', sans-serif"
                            }}>
                              <span style={{
                                position: 'absolute',
                                left: 0,
                                color: '#5F6E54'
                              }}>•</span>
                              {detail}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );

      case 'F26_VIDEOS':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage, backgroundColor: '#FFFFFF', minHeight: '100vh'}}>
            <div style={{maxWidth: '1200px', margin: '0 auto', padding: '20px'}}>
              <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading, color: '#141412', textAlign: 'center', marginBottom: '20px'}}>
                FALL WINTER 2026 COLLECTION VIDEOS
              </h2>
              <p style={{fontSize: '16px', color: '#141412', textAlign: 'center', marginBottom: '30px', fontFamily: "'Montserrat', sans-serif"}}>
                Please click on the style to play video
              </p>
            </div>
            <iframe 
              src="https://11a4738.netsolhost.com/F26/F26Videos/index.html" 
              style={{
                width: '100%',
                height: 'calc(100vh - 280px)',
                border: 'none',
                display: 'block'
              }}
              title="Fall Winter 2026 Collection Videos"
              loading="lazy"
              allowFullScreen
            />
          </div>
        );

      case 'SS26_VIDEOS':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage, backgroundColor: '#FFFFFF', minHeight: '100vh'}}>
            <div style={{maxWidth: '1200px', margin: '0 auto', padding: '20px'}}>
              <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading, color: '#141412', textAlign: 'center', marginBottom: '20px'}}>
                SPRING SUMMER 2026 COLLECTION VIDEOS
              </h2>
              <p style={{fontSize: '16px', color: '#141412', textAlign: 'center', marginBottom: '30px', fontFamily: "'Montserrat', sans-serif"}}>
                Please click on the style to play video
              </p>
            </div>
            <iframe 
              src="https://11a4738.netsolhost.com/SS26/SS26videos/index.html" 
              style={{
                width: '100%',
                height: 'calc(100vh - 280px)',
                border: 'none',
                display: 'block'
              }}
              title="Spring Summer 2026 Collection Videos"
              allowFullScreen
            loading="lazy"
            />
          </div>
        );

      case 'SS26_FASHIONSHOTS':
        // Exact list of fashion shot images - provided by user
        const fashionShots = [
          { name: 'Style 20B - View A - Shot 1', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T20B_A_S_1.JPG' },
          { name: 'Style 20B - View A - Shot 2', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T20B_A_S_2.JPG' },
          { name: 'Style 20B - View A - Shot 3', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T20B_A_S_3.JPG' },
          { name: 'Style 45C3 - View A', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T45C3_A_S.JPG' },
          { name: 'Style 45C3 - View A - Shot 2', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T45C3_A_S_2.JPG' },
          { name: 'Style 47D4 - View A', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T47D4_A_S.JPG' },
          { name: 'Style 47D4 - View A - Shot 1', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T47D4_A_S_1.JPG' },
          { name: 'Style 47D4 - View A - Shot 2', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T47D4_A_S_2.JPG' },
          { name: 'Style 48B - View A', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T48B_A_S.JPG' },
          { name: 'Style 48B - View A - Shot 1', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T48B_A_S_1.JPG' },
          { name: 'Style 48B - View A - Shot 2', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T48B_A_S_2.JPG' },
          { name: 'Style 48B - View A - Shot 3', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T48B_A_S_3.JPG' },
          { name: 'Style 53G - View A', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T53G_A_S.JPG' },
          { name: 'Style 53G - View A - Shot 1', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T53G_A_S_1.JPG' },
          { name: 'Style 53G - View A - Shot 3', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T53G_A_S_3.JPG' },
          { name: 'Style 53G - View A - Shot 4', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T53G_A_S_4.JPG' },
          { name: 'Style 56B14 - View A', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T56B14_A_S.JPG' },
          { name: 'Style 56B14 - View A - Shot 1', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T56B14_A_S_1.JPG' },
          { name: 'Style 56B14 - View A - Shot 3', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T56B14_A_S_3.JPG' },
          { name: 'Style 56B14 - View A - Shot 4', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T56B14_A_S_4.JPG' },
          { name: 'Style 57D - View A', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T57D_A_S.JPG' },
          { name: 'Style 57D - View A - Shot 1', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T57D_A_S_1.JPG' },
          { name: 'Style 57D - View A - Shot 2', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T57D_A_S_2.JPG' },
          { name: 'Style 58D - View A', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T58D_A_S.JPG' },
          { name: 'Style 58D - View A - Shot 1', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T58D_A_S_1.JPG' },
          { name: 'Style 58D - View A - Shot 2', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T58D_A_S_2.JPG' },
          { name: 'Style 59G - View A', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T59G_A_S.JPG' },
          { name: 'Style 59G - View A - Shot 1', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T59G_A_S_1.JPG' },
          { name: 'Style 59G - View A - Shot 2', url: 'https://11a4738.netsolhost.com/SS26/SS26fashionshots/26T59G_A_S_2.JPG' },
        ];

        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage, backgroundColor: '#FFFFFF', minHeight: '100vh'}}>
            <div style={{maxWidth: '1400px', margin: '0 auto', padding: '40px 20px'}}>
              <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading, color: '#141412', textAlign: 'center', marginBottom: '15px'}}>
                SPRING SUMMER 2026 FASHION SHOTS
              </h2>
              <p style={{fontSize: '16px', color: '#666', textAlign: 'center', marginBottom: '10px', fontFamily: "'Montserrat', sans-serif"}}>
                Click any image to view full size and download
              </p>
              <p style={{fontSize: '14px', color: '#5F6E54', textAlign: 'center', marginBottom: '40px', fontFamily: "'Montserrat', sans-serif"}}>
                {fashionShots.length} images available
              </p>

              {/* Image Grid */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: window.innerWidth <= 768 ? 'repeat(2, 1fr)' : window.innerWidth <= 1024 ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)',
                gap: '20px',
                marginBottom: '60px'
              }}>
                {fashionShots.map((image, index) => (
                  <div
                    key={index}
                    style={{
                      position: 'relative',
                      cursor: 'pointer',
                      overflow: 'hidden',
                      borderRadius: '8px',
                      aspectRatio: '3/4',
                      backgroundColor: '#E8E6E3',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => setSelectedImage(image)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.03)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <img
                      src={image.url}
                      alt={image.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }}
                      loading="lazy"
                    />
                    {/* Hover Overlay */}
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)',
                      padding: '15px',
                      opacity: 0,
                      transition: 'opacity 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                    onMouseLeave={(e) => e.currentTarget.style.opacity = '0'}>
                      <p style={{
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: '600',
                        fontFamily: "'Space Grotesk', sans-serif",
                        margin: 0
                      }}>
                        {image.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Lightbox Modal */}
              {selectedImage && (
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.95)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10000,
                    padding: '20px'
                  }}
                  onClick={() => setSelectedImage(null)}
                >
                  {/* Close Button */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedImage(null);
                    }}
                    style={{
                      position: 'absolute',
                      top: '20px',
                      right: '20px',
                      background: 'rgba(255,255,255,0.1)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      color: '#fff',
                      fontSize: '32px',
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease',
                      zIndex: 10002
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                      e.currentTarget.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  >
                    ×
                  </button>

                  {/* Download Button */}
                  <a
                    href={selectedImage.url}
                    download
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      position: 'absolute',
                      top: '20px',
                      right: '90px',
                      background: 'rgba(95, 110, 84, 0.9)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      color: '#fff',
                      fontSize: '14px',
                      padding: '12px 24px',
                      borderRadius: '50px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease',
                      zIndex: 10002,
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontWeight: '600',
                      letterSpacing: '1px',
                      textTransform: 'uppercase'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(95, 110, 84, 1)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(95, 110, 84, 0.35)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(95, 110, 84, 0.9)';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <span style={{fontSize: '18px'}}>⬇</span>
                    Download
                  </a>

                  {/* Image Container */}
                  <div
                    style={{
                      maxWidth: '90vw',
                      maxHeight: '90vh',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '20px'
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* Image */}
                    <img
                      src={selectedImage.url}
                      alt={selectedImage.name}
                      style={{
                        maxWidth: '90vw',
                        maxHeight: '85vh',
                        width: 'auto',
                        height: 'auto',
                        objectFit: 'contain',
                        borderRadius: '4px',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
                      }}
                    />
                    
                    {/* Image Info */}
                    <div style={{
                      textAlign: 'center',
                      color: '#fff'
                    }}>
                      <p style={{
                        fontSize: '18px',
                        fontWeight: '600',
                        marginBottom: '5px',
                        fontFamily: "'Space Grotesk', sans-serif",
                        letterSpacing: '0.5px'
                      }}>
                        {selectedImage.name}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        );

      case 'SS26_REELS':
        return (
          <div style={{...baseStyles.catalogPage, ...responsiveStyles.catalogPage, backgroundColor: '#FFFFFF', minHeight: '100vh'}}>
            <div style={{maxWidth: '1200px', margin: '0 auto', padding: '20px'}}>
              <h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading, color: '#141412', textAlign: 'center', marginBottom: '20px'}}>
                SPRING SUMMER 2026 REELS
              </h2>
              <p style={{fontSize: '16px', color: '#141412', textAlign: 'center', marginBottom: '30px', fontFamily: "'Montserrat', sans-serif"}}>
                Watch our collection reels and social media content
              </p>
            </div>
            <iframe 
              src="https://11a4738.netsolhost.com/SS26/SS26Reels/index.html" 
              style={{
                width: '100%',
                height: 'calc(100vh - 280px)',
                border: 'none',
                display: 'block'
              }}
              title="Spring Summer 2026 Reels"
              allowFullScreen
            loading="lazy"
            />
          </div>
        );

      default:
        return <div style={baseStyles.placeholderPage}><h2 style={{...baseStyles.serifHeading, ...responsiveStyles.serifHeading}}>{currentPage}</h2></div>;
    }
  };

  const isMobile = window.innerWidth <= 768;
    
  return (
    <div style={baseStyles.appWrapper}>
      {/* CSS Animation for Spinner and Enhanced Effects */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Marquee runway — continuous horizontal scroll of collection shots */
        @keyframes psMarquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .ps-marquee-track {
          display: flex;
          width: max-content;
          animation: psMarquee 60s linear infinite;
        }
        .ps-marquee-viewport:hover .ps-marquee-track {
          animation-play-state: paused;
        }

        /* Count-up stat reveal */
        @keyframes psStatReveal {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Link hover effects */
        a { transition: color 0.3s ease; }

        /* Smooth scrolling */
        html { scroll-behavior: smooth; }

        /* Focus states for accessibility */
        button:focus-visible, a:focus-visible {
          outline: 2px solid ${C.sageAccent};
          outline-offset: 3px;
        }

        /* Selection styling */
        ::selection {
          background: ${C.sageAccentSoft};
          color: inherit;
        }

        /* Underline-grow link used across the new design */
        .ps-underline {
          position: relative;
          display: inline-block;
          padding-bottom: 4px;
        }
        .ps-underline::after {
          content: '';
          position: absolute;
          left: 0; bottom: 0;
          width: 100%; height: 1px;
          background: currentColor;
          transform: scaleX(1);
          transform-origin: left;
          transition: transform 0.4s cubic-bezier(0.25,0.46,0.45,0.94);
        }
        .ps-nav-link {
          position: relative;
        }
        .ps-nav-link::after {
          content: '';
          position: absolute;
          left: 0; bottom: -4px;
          width: 100%; height: 1px;
          background: ${C.sageAccent};
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94);
        }
        .ps-nav-link:hover::after,
        .ps-nav-link.active::after {
          transform: scaleX(1);
        }

        /* Dropdown hover bridge - invisible area to prevent gap */
        .nav-dropdown-wrapper { position: relative; }
        .nav-dropdown-wrapper::after {
          content: '';
          position: absolute;
          top: 100%; left: 0; right: 0;
          height: 15px;
          background: transparent;
        }

        @media (prefers-reduced-motion: reduce) {
          .ps-marquee-track { animation: none; }
          html { scroll-behavior: auto; }
        }
      `}</style>
      
      {/* Loading Indicator */}
      {isLoading && (
        <div style={baseStyles.loadingOverlay}>
          <div style={baseStyles.spinner}></div>
        </div>
      )}
      
      <header style={baseStyles.header}>
        <div style={baseStyles.miniLogo} onClick={() => handleNavigation('HOME')}>
          PARSLEY <span style={{fontStyle: 'italic', color: '#5F6E54'}}>&amp;</span> SAGE
        </div>
        
        {isMobile && (
          <div 
            style={baseStyles.hamburger}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <div style={baseStyles.hamburgerLine}></div>
            <div style={baseStyles.hamburgerLine}></div>
            <div style={baseStyles.hamburgerLine}></div>
          </div>
        )}

        {!isMobile && (
          <nav style={baseStyles.nav}>
            {TABS.map((tab) => (
              <div 
                key={tab} 
                className={(tab === 'COLLECTIONS' || tab === 'WORK WITH US') ? 'nav-dropdown-wrapper' : ''}
                style={{ position: 'relative', paddingBottom: (tab === 'COLLECTIONS' || tab === 'WORK WITH US') ? '10px' : '0', marginBottom: (tab === 'COLLECTIONS' || tab === 'WORK WITH US') ? '-10px' : '0' }}
                onMouseEnter={() => {
                  if (tab === 'COLLECTIONS') setShowDropdown(true);
                  if (tab === 'WORK WITH US') setShowWorkDropdown(true);
                }}
                onMouseLeave={() => {
                  if (tab === 'COLLECTIONS') setShowDropdown(false);
                  if (tab === 'WORK WITH US') setShowWorkDropdown(false);
                }}
              >
                <button
                  className={`ps-nav-link${currentPage === tab || (tab === 'COLLECTIONS' && currentPage.includes('COLLECTIONS')) || (tab === 'WORK WITH US' && (currentPage === 'WORK WITH US' || currentPage === 'ORDERING DOCS')) ? ' active' : ''}`}
                  onClick={() => {
                    if (tab === 'MY ACCOUNT') {
                      window.open('http://sales.parsley-sage.com:100/view/home.aspx', '_blank', 'noopener,noreferrer');
                    } else if (tab !== 'COLLECTIONS' && tab !== 'WORK WITH US') {
                      handleNavigation(tab);
                    } else if (tab === 'WORK WITH US') {
                      handleNavigation(tab);
                    }
                  }}
                  style={{ 
                    ...baseStyles.navBtn, 
                    background: 'transparent',
                    border: 'none',
                    boxShadow: 'none',
                    color: (currentPage === tab || (tab === 'COLLECTIONS' && currentPage.includes('COLLECTIONS')) || (tab === 'WORK WITH US' && (currentPage === 'WORK WITH US' || currentPage === 'ORDERING DOCS')))
                      ? C.sageAccent : C.inkSoft
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = C.sageAccent;
                  }}
                  onMouseLeave={(e) => {
                    const isActive = currentPage === tab || (tab === 'COLLECTIONS' && currentPage.includes('COLLECTIONS')) || (tab === 'WORK WITH US' && (currentPage === 'WORK WITH US' || currentPage === 'ORDERING DOCS'));
                    e.currentTarget.style.color = isActive ? C.sageAccent : C.inkSoft;
                  }}
                >
                  {tab}
                </button>
                {tab === 'COLLECTIONS' && showDropdown && (
                  <div style={baseStyles.dropdown}>
                    <div 
                      style={{...baseStyles.dropdownItem, position: 'relative', paddingRight: '30px'}}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                        e.currentTarget.style.color = '#5F6E54';
                        setShowCurrentSubDropdown(true);
                      }}
                      onMouseLeave={(e) => {
                        // Check if we're moving to the sub-dropdown
                        const relatedTarget = e.relatedTarget;
                        const currentTarget = e.currentTarget;
                        if (currentTarget.contains(relatedTarget)) {
                          return; // Don't close if moving to child element
                        }
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.color = '#141412';
                        setShowCurrentSubDropdown(false);
                      }}
                    >
                      Current Collections ▶
                      
                      {/* Sub-dropdown for Current Collections */}
                      {showCurrentSubDropdown && (
                        <div style={{
                          ...baseStyles.dropdown,
                          left: '100%',
                          top: '-12px',
                          marginLeft: '0'
                        }}>
                          <div 
                            style={baseStyles.dropdownItem}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNavigation('FW26');
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                              
                              e.currentTarget.style.color = '#5F6E54';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = 'transparent';
                              
                              e.currentTarget.style.color = '#141412';
                            }}
                          >
                            Fall Winter 26
                          </div>
                          <div 
                            style={baseStyles.dropdownItem}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNavigation('SS27');
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                              
                              e.currentTarget.style.color = '#5F6E54';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = 'transparent';
                              
                              e.currentTarget.style.color = '#141412';
                            }}
                          >
                            Spring Summer 27
                          </div>
                        </div>
                      )}
                    </div>
                    <div 
                      style={baseStyles.dropdownItem} 
                      onClick={() => handleNavigation('PREVIOUS_COLLECTIONS')}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                        
                        e.currentTarget.style.color = '#5F6E54';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent';
                        
                        e.currentTarget.style.color = '#141412';
                      }}
                    >
                      Previous Collections
                    </div>
                  </div>
                )}
                {tab === 'WORK WITH US' && showWorkDropdown && (
                  <div style={baseStyles.dropdown}>
                    <div 
                      style={baseStyles.dropdownItem} 
                      onClick={() => handleNavigation('WORK WITH US')}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                        
                        e.currentTarget.style.color = '#5F6E54';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent';
                        
                        e.currentTarget.style.color = '#141412';
                      }}
                    >
                      Contact Sales Team
                    </div>
                    <div 
                      style={baseStyles.dropdownItem} 
                      onClick={() => handleNavigation('ORDERING DOCS')}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#141412';
                        
                        e.currentTarget.style.color = '#5F6E54';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent';
                        
                        e.currentTarget.style.color = '#141412';
                      }}
                    >
                      Ordering Documents
                    </div>
                  </div>
                )}
              </div>
            ))}
          </nav>
        )}

        {mobileMenuOpen && isMobile && (
          <div style={baseStyles.mobileNav}>
            {TABS.map((tab) => (
              <div key={tab}>
                {tab === 'COLLECTIONS' ? (
                  <>
                    <div style={baseStyles.mobileNavItem}>COLLECTIONS</div>
                    <div style={{...baseStyles.mobileSubItem, paddingLeft: '30px', fontSize: '13px', color: '#77766E'}}>
                      Current Collections:
                    </div>
                    <div style={{...baseStyles.mobileSubItem, paddingLeft: '40px'}} onClick={() => handleNavigation('FW26')}>
                      Fall Winter 26
                    </div>
                    <div style={{...baseStyles.mobileSubItem, paddingLeft: '40px'}} onClick={() => handleNavigation('SS27')}>
                      Spring Summer 27
                    </div>
                    <div style={baseStyles.mobileSubItem} onClick={() => handleNavigation('PREVIOUS_COLLECTIONS')}>
                      Previous Collections
                    </div>
                  </>
                ) : tab === 'WORK WITH US' ? (
                  <>
                    <div style={baseStyles.mobileNavItem}>WORK WITH US</div>
                    <div style={baseStyles.mobileSubItem} onClick={() => handleNavigation('WORK WITH US')}>
                      Contact Sales Team
                    </div>
                    <div style={baseStyles.mobileSubItem} onClick={() => handleNavigation('ORDERING DOCS')}>
                      Ordering Documents
                    </div>
                  </>
                ) : tab === 'MY ACCOUNT' ? (
                  <div 
                    style={baseStyles.mobileNavItem}
                    onClick={() => window.open('http://sales.parsley-sage.com:100/view/home.aspx', '_blank', 'noopener,noreferrer')}
                  >
                    {tab}
                  </div>
                ) : (
                  <div 
                    style={baseStyles.mobileNavItem}
                    onClick={() => handleNavigation(tab)}
                  >
                    {tab}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </header>
      <main 
        className={`page-content ${isPageEntering ? 'entering' : ''}`}
        style={{
          ...baseStyles.mainContent, 
          opacity: pageOpacity, 
          transition: 'opacity 0.35s ease, transform 0.35s ease',
          transform: pageOpacity === 0 ? 'translateY(10px) scale(0.99)' : 'translateY(0) scale(1)'
        }}
      >
        {renderContent()}
      </main>
      
      {/* Glassmorphism Back to Top Button */}
      <button 
        className={`back-to-top ${showBackToTop ? 'visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Back to top"
        style={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          background: '#232A22',
          border: 'none',
          boxShadow: '0 6px 20px rgba(20, 20, 18, 0.18)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          color: '#F2EFE6',
          fontSize: '18px',
          opacity: showBackToTop ? 1 : 0,
          transform: showBackToTop ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          pointerEvents: showBackToTop ? 'auto' : 'none'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#141412';
          e.currentTarget.style.transform = 'translateY(-3px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#232A22';
          e.currentTarget.style.transform = showBackToTop ? 'translateY(0)' : 'translateY(20px)';
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 15l-6-6-6 6"/>
        </svg>
      </button>
      
      <Footer />
    </div>
  );
};

const baseStyles = {
  appWrapper: { backgroundColor: '#FFFFFF', minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: "'Montserrat', sans-serif", position: 'relative' },
  loadingOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  },
  spinner: {
    width: '50px',
    height: '50px',
    border: '4px solid rgba(20, 20, 18, 0.1)',
    borderTop: '4px solid #5F6E54',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 40px', backgroundColor: 'rgba(255, 255, 255, 0.92)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', borderBottom: '1px solid rgba(20, 20, 18, 0.1)', position: 'fixed', width: '100%', boxSizing: 'border-box', zIndex: 1000, transition: 'all 0.3s ease' },
  miniLogo: { fontFamily: "'Cormorant Garamond', serif", fontSize: '22px', fontWeight: '400', letterSpacing: '2.5px', color: '#141412', cursor: 'pointer', border: 'none', padding: '0' },
  nav: { display: 'flex', gap: '28px', alignItems: 'center' },
  navBtn: { 
    fontFamily: "'Space Grotesk', sans-serif", 
    background: 'transparent', 
    color: '#55554E', 
    border: 'none', 
    cursor: 'pointer', 
    fontSize: '10.5px', 
    fontWeight: '400', 
    letterSpacing: '1.5px', 
    padding: '6px 2px', 
    transition: 'color 0.3s ease', 
    textTransform: 'uppercase', 
    position: 'relative'
  },
  mainContent: { flex: 1 },
  hamburger: { display: 'flex', flexDirection: 'column', gap: '5px', cursor: 'pointer', zIndex: 1001 },
  hamburgerLine: { width: '25px', height: '2px', backgroundColor: '#141412' },
  mobileNav: { position: 'fixed', top: '72px', left: 0, right: 0, backgroundColor: 'rgba(255, 255, 255, 0.98)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(20, 20, 18, 0.1)', padding: '20px', maxHeight: 'calc(100vh - 72px)', overflowY: 'auto', zIndex: 999 },
  mobileNavItem: { fontFamily: "'Space Grotesk', sans-serif", color: '#141412', padding: '15px 10px', borderBottom: '1px solid rgba(20, 20, 18, 0.08)', fontSize: '13px', letterSpacing: '1px', cursor: 'pointer', textTransform: 'uppercase' },
  mobileSubItem: { fontFamily: "'Montserrat', sans-serif", color: '#55554E', padding: '12px 25px', fontSize: '12px', letterSpacing: '1px', cursor: 'pointer', borderBottom: '1px solid rgba(20, 20, 18, 0.06)' },
  catalogCoverImage: { width: '100%', height: '550px', objectFit: 'contain', objectPosition: 'center', backgroundColor: '#fff', display: 'block', borderRadius: '2px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', marginBottom: '20px' },
  storyPage: { backgroundColor: '#FFFFFF', color: '#141412', minHeight: '100vh', paddingTop: '80px' },
  storyHero: { padding: '80px 10% 40px 10%', textAlign: 'center' },
  familyPhotoPlaceholder: { width: '100%', maxWidth: '900px', height: '500px', backgroundColor: '#EDEFE8', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(20, 20, 18, 0.1)' },
  storyContent: { padding: '40px 10% 120px 10%', display: 'flex', justifyContent: 'center' },
  storyColumn: { maxWidth: '800px', textAlign: 'center' },
  storySub: { fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '3px', fontSize: '11px', color: '#5F6E54', marginBottom: '30px', textTransform: 'uppercase', fontWeight: '500' },
  storyText: { fontFamily: "'Montserrat', sans-serif", fontSize: '16px', fontWeight: '300', lineHeight: '1.9', marginBottom: '25px', color: '#141412' },
  repInfoCard: { padding: '35px 20px', backgroundColor: '#FFFFFF', border: '1px solid rgba(20, 20, 18, 0.1)', textAlign: 'center', borderRadius: '2px', transition: 'all 0.3s ease', boxShadow: 'none' },
  repRegion: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '10px', color: '#5F6E54', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '10px', fontWeight: '500' },
  repName: { fontFamily: "'Cormorant Garamond', serif", fontSize: '20px', letterSpacing: '1px', color: '#141412', marginBottom: '15px', fontWeight: '400' },
  repContactInfo: { fontFamily: "'Montserrat', sans-serif", fontSize: '13px', lineHeight: '1.8', fontWeight: '300' },
  repLink: { color: '#5F6E54', textDecoration: 'none', letterSpacing: '0.5px', transition: 'color 0.3s ease' },
  teamSection: { padding: '0 10% 80px 10%' },
  ownersGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 300px))', justifyContent: 'center', gap: '60px', margin: '0 auto' },
  repsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '30px', maxWidth: '1200px', margin: '0 auto' },
  teamCard: { textAlign: 'center' },
  portraitImage: { width: '100%', aspectRatio: 'auto', objectPosition: 'top', border: '1px solid rgba(20, 20, 18, 0.1)', marginBottom: '20px', display: 'block' },
  teamName: { fontFamily: "'Cormorant Garamond', serif", fontSize: '22px', letterSpacing: '2px', margin: '10px 0 5px 0', color: '#141412', fontWeight: '400' },
  teamRole: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '11px', color: '#5F6E54', letterSpacing: '1px', textTransform: 'uppercase', fontWeight: '400' },
  hero: { minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#141412', background: '#FFFFFF', marginTop: '0', position: 'relative', overflow: 'hidden' },
  mainLogoText: { fontFamily: "'Cormorant Garamond', serif", fontSize: '76px', letterSpacing: '7px', fontWeight: '300', margin: '0', textAlign: 'center', padding: '0 20px', color: '#141412' },
  tagline: { fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic', fontSize: '20px', letterSpacing: '0.5px', marginTop: '14px', color: '#55554E', textTransform: 'none' },
  collectionsSection: { backgroundColor: '#FFFFFF', padding: '100px 10% 80px 10%', color: '#141412' },
  collectionHeader: { textAlign: 'center', marginBottom: '60px' },
  imageRow: { display: 'flex', justifyContent: 'center', gap: '60px', flexWrap: 'wrap', maxWidth: '1200px', margin: '0 auto' },
  collectionCard: { maxWidth: '400px', width: '100%', transition: 'all 0.4s ease', position: 'relative', overflow: 'hidden' },
  seasonText: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '11px', color: '#5F6E54', marginBottom: '40px', letterSpacing: '2px', textTransform: 'uppercase', fontWeight: '400' },
  sectionTitle: { fontFamily: "'Cormorant Garamond', serif", fontSize: '42px', letterSpacing: '4px', marginBottom: '15px', fontWeight: '300', color: '#141412' },
  seasonTextSmall: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '11px', color: '#5F6E54', marginBottom: '15px', textAlign: 'center', letterSpacing: '2px', textTransform: 'uppercase', fontWeight: '500' },
  boutiquePage: { backgroundColor: '#FFFFFF', color: '#141412', minHeight: '100vh', paddingTop: '100px' },
  boutiqueHeader: { textAlign: 'center', padding: '60px 20px' },
  boutiqueSub: { fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '4px', fontSize: '11px', color: '#5F6E54', textTransform: 'uppercase', fontWeight: '400' },
  mapSection: { padding: '0 5% 80px 5%' },
  mapContainer: { border: '1px solid #5F6E54', borderRadius: '2px', overflow: 'hidden' },
  mapIframe: { width: '100%', height: '650px', border: '0' },
  calendarContainer: { maxWidth: '1200px', margin: '0 auto', padding: '0 20px 100px 20px' },
  calendarWrapper: { position: 'relative', paddingBottom: '75%', height: 0, overflow: 'hidden', border: '1px solid rgba(20, 20, 18, 0.12)' },
  calendarIframe: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 },
  formContainer: { minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#141412', padding: '120px 20px 80px', backgroundColor: '#EDEFE8' },
  passwordContainer: { height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#141412', padding: '20px', backgroundColor: '#EDEFE8' },
  workForm: { display: 'flex', flexDirection: 'column', gap: '15px', width: '100%', maxWidth: '600px', marginTop: '20px' },
  formRow: { display: 'flex', gap: '15px', width: '100%' },
  formInput: { fontFamily: "'Montserrat', sans-serif", padding: '15px', background: '#FFFFFF', border: '1px solid rgba(20, 20, 18, 0.15)', color: '#141412', outline: 'none', width: '100%', boxSizing: 'border-box', fontSize: '14px', fontWeight: '300' },
  flexInput: { fontFamily: "'Montserrat', sans-serif", flex: 1, padding: '15px', background: '#FFFFFF', border: '1px solid rgba(20, 20, 18, 0.15)', color: '#141412', outline: 'none', minWidth: '200px', fontSize: '14px', fontWeight: '300' },
  formSubmitBtn: { 
    fontFamily: "'Space Grotesk', sans-serif", 
    padding: '16px 44px', 
    border: 'none', 
    background: '#232A22', 
    color: '#F2EFE6', 
    cursor: 'pointer', 
    letterSpacing: '2px', 
    transition: 'all 0.3s ease', 
    textTransform: 'uppercase', 
    fontSize: '11px', 
    fontWeight: '500', 
    position: 'relative', 
    overflow: 'hidden',
    marginTop: '8px'
  },
  formSubtitle: { fontFamily: "'Montserrat', sans-serif", fontSize: '14px', letterSpacing: '1px', color: '#55554E', textAlign: 'center', fontWeight: '300' },
  termsSection: { backgroundColor: '#FFFFFF', padding: '100px 10%', color: '#141412' },
  flexInputLight: { fontFamily: "'Montserrat', sans-serif", flex: 1, padding: '15px', background: '#fff', border: '1px solid #E8E6E3', color: '#141412', outline: 'none', minWidth: '200px', fontSize: '14px', fontWeight: '300' },
  catalogInput: { fontFamily: "'Montserrat', sans-serif", padding: '15px', background: '#fff', border: '1px solid #E8E6E3', color: '#141412', outline: 'none', fontSize: '14px', width: '100%', boxSizing: 'border-box', fontWeight: '300' },
  catalogGridSideBySide: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', gap: '40px', width: '100%', maxWidth: '1400px', margin: '0 auto' },
  catalogCardHalf: { flex: '1', minWidth: '300px', maxWidth: '550px', marginBottom: '60px' },
  catalogPage: { padding: '150px 10% 80px 10%', backgroundColor: '#FFFFFF', color: '#141412', minHeight: '100vh', textAlign: 'center' },
  orderFormContainer: { maxWidth: '800px', margin: '0 auto', padding: '60px 40px', backgroundColor: '#fff', border: '1px solid #E8E6E3', textAlign: 'left' },
  catalogForm: { display: 'flex', flexDirection: 'column', gap: '15px' },
  catalogPage: { padding: '150px 10% 80px 10%', backgroundColor: '#FFFFFF', color: '#141412', minHeight: '100vh', textAlign: 'center' },
  catalogPagePad: {},
  catalogSubmitBtn: { 
    fontFamily: "'Space Grotesk', sans-serif", 
    padding: '18px 44px', 
    backgroundColor: '#232A22', 
    color: '#F2EFE6', 
    border: 'none', 
    cursor: 'pointer', 
    letterSpacing: '2px', 
    fontSize: '11px', 
    fontWeight: '500', 
    textTransform: 'uppercase', 
    transition: 'all 0.3s ease'
  },
  pdfWrapper: { margin: '20px auto', border: '1px solid rgba(20, 20, 18, 0.1)', overflow: 'hidden', backgroundColor: '#FFFFFF', position: 'relative', transition: 'all 0.3s ease' },
  downloadBtn: { 
    fontFamily: "'Space Grotesk', sans-serif", 
    display: 'inline-block', 
    padding: '14px 34px', 
    backgroundColor: 'transparent', 
    color: '#141412', 
    textDecoration: 'none', 
    fontSize: '11px', 
    letterSpacing: '2px', 
    marginTop: '10px', 
    transition: 'all 0.3s ease', 
    fontWeight: '500', 
    cursor: 'pointer', 
    textTransform: 'uppercase',
    border: '1px solid rgba(20, 20, 18, 0.25)'
  },
  dropdown: { 
    position: 'absolute', 
    top: '100%', 
    left: '0',
    background: '#FFFFFF', 
    minWidth: '230px', 
    boxShadow: '0 12px 40px rgba(20, 20, 18, 0.12)', 
    paddingTop: '10px',
    paddingBottom: '10px',
    border: '1px solid rgba(20, 20, 18, 0.1)',
    borderRadius: '4px',
    marginTop: '0',
    animation: 'fadeInUp 0.2s ease forwards'
  },
  dropdownItem: { 
    fontFamily: "'Space Grotesk', sans-serif", 
    padding: '11px 20px', 
    fontSize: '10.5px', 
    color: '#141412', 
    cursor: 'pointer', 
    letterSpacing: '1px', 
    transition: 'all 0.2s ease',
    margin: '1px 6px',
    textTransform: 'uppercase'
  },
  footer: { background: '#232A22', padding: '70px 10% 40px', color: '#F2EFE6' },
  footerTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '40px' },
  footerCol: { flex: '1', minWidth: '200px' },
  footerHeading: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '11px', fontWeight: '500', color: '#A8B29E', marginBottom: '22px', letterSpacing: '2.5px', textTransform: 'uppercase' },
  footerList: { listStyle: 'none', padding: '0', fontSize: '12px', lineHeight: '2.6' },
  footerLink: { fontFamily: "'Montserrat', sans-serif", fontSize: '13px', fontWeight: '300', cursor: 'pointer', transition: 'color 0.3s ease', color: '#D8D5CC' },
  footerText: { fontFamily: "'Montserrat', sans-serif", fontSize: '13px', fontWeight: '300', lineHeight: '1.9', color: '#D8D5CC' },
  footerContactLink: {
    fontFamily: "'Montserrat', sans-serif",
    fontSize: '13px',
    fontWeight: '300',
    color: '#D8D5CC',
    textDecoration: 'none',
    transition: 'color 0.3s ease',
    cursor: 'pointer'
  },
  smallLogo: { fontFamily: "'Cormorant Garamond', serif", fontSize: '22px', fontWeight: '400', letterSpacing: '2.5px', marginTop: '30px', marginBottom: '10px', color: '#F2EFE6' },
  copyright: { fontFamily: "'Montserrat', sans-serif", fontSize: '11px', color: '#8B958279', fontWeight: '300' },
  serifHeading: { fontFamily: "'Cormorant Garamond', serif", fontSize: '44px', fontWeight: '300', letterSpacing: '2px' },
  placeholderPage: { height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#141412', backgroundColor: '#FFFFFF' },
  docsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '40px',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px'
  },
  docCard: {
    backgroundColor: '#fbfaf8',
    border: '1px solid rgba(20, 20, 18, 0.1)',
    borderRadius: '4px',
    padding: '40px 30px',
    textAlign: 'center',
    transition: 'all 0.3s ease'
  },
  docIcon: {
    marginBottom: '20px'
  },
  docTitle: {
    fontSize: '18px',
    letterSpacing: '1px',
    color: '#333',
    marginBottom: '15px',
    fontFamily: 'serif'
  },
  docDescription: {
    fontSize: '14px',
    lineHeight: '1.6',
    color: '#666',
    marginBottom: '25px'
  },
  docDownloadBtn: {
    display: 'inline-block',
    padding: '12px 24px',
    backgroundColor: '#5F6E54',
    color: '#fff',
    textDecoration: 'none',
    fontSize: '11px',
    letterSpacing: '2px',
    borderRadius: '2px',
    transition: 'all 0.3s ease',
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  instagramLink: {
    display: 'inline-flex',
    alignItems: 'center',
    color: '#666',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'all 0.3s ease',
    cursor: 'pointer'
  },
  backToTopBtn: {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    width: '50px',
    height: '50px',
    backgroundColor: '#5F6E54',
    color: '#fff',
    border: 'none',
    borderRadius: '50%',
    fontSize: '24px',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
    transition: 'all 0.3s ease',
    zIndex: 1000,
    fontWeight: 'bold'
  },
  boutiqueCard: {
    backgroundColor: '#505050',
    borderRadius: '4px',
    overflow: 'hidden',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    border: '1px solid #666'
  },
  boutiqueImagePlaceholder: {
    width: '100%',
    height: '250px',
    backgroundColor: '#606060',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden'
  },
  boutiqueImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  boutiqueName: {
    fontSize: '16px',
    letterSpacing: '2px',
    color: '#fff',
    margin: '20px 0 8px 0',
    padding: '0 20px',
    fontWeight: 'bold'
  },
  boutiqueLocation: {
    fontSize: '12px',
    color: '#5F6E54',
    letterSpacing: '1px',
    marginBottom: '12px',
    padding: '0 20px'
  },
  boutiqueDescription: {
    fontSize: '13px',
    color: '#ccc',
    lineHeight: '1.6',
    padding: '0 20px 25px 20px'
  },
  boutiqueCardCompact: {
    backgroundColor: '#505050',
    borderRadius: '4px',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    border: '1px solid #666',
    height: 'fit-content'
  },
  boutiqueImageCompact: {
    width: '100%',
    height: '150px',
    backgroundColor: '#606060',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden'
  },
  boutiqueNameCompact: {
    fontSize: '14px',
    letterSpacing: '1px',
    color: '#fff',
    margin: '0 0 5px 0',
    fontWeight: 'bold'
  },
  boutiqueLocationCompact: {
    fontSize: '11px',
    color: '#5F6E54',
    letterSpacing: '0.5px',
    marginBottom: '8px'
  },
  boutiqueDescriptionCompact: {
    fontSize: '12px',
    color: '#ccc',
    lineHeight: '1.5'
  },
  visitWebsiteLink: {
    fontSize: '11px',
    color: '#5F6E54',
    marginTop: '10px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    transition: 'color 0.3s ease'
  },
  limitedItemCard: {
    backgroundColor: '#fff',
    border: '1px solid rgba(20, 20, 18, 0.1)',
    borderRadius: '4px',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
  },
  limitedImageWrapper: {
    position: 'relative',
    width: '100%',
    height: '400px',
    backgroundColor: '#f5f5f5',
    overflow: 'hidden'
  },
  limitedImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  limitedBadge: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    backgroundColor: '#5F6E54',
    color: '#fff',
    padding: '8px 16px',
    fontSize: '10px',
    letterSpacing: '2px',
    fontWeight: 'bold',
    borderRadius: '2px'
  },
  limitedItemTitle: {
    fontSize: '20px',
    letterSpacing: '1px',
    color: '#333',
    marginBottom: '8px',
    fontFamily: 'serif'
  },
  limitedItemNumber: {
    fontSize: '12px',
    color: '#5F6E54',
    letterSpacing: '1px',
    marginBottom: '15px',
    fontWeight: 'bold'
  },
  limitedItemDescription: {
    fontSize: '14px',
    lineHeight: '1.6',
    color: '#666',
    marginBottom: '15px'
  },
  limitedItemAvailability: {
    fontSize: '13px',
    color: '#999',
    fontStyle: 'italic',
    borderTop: '1px solid rgba(20, 20, 18, 0.1)',
    paddingTop: '15px',
    marginTop: '15px',
    marginBottom: '15px'
  },
  limitedRequestBtn: {
    width: '100%',
    padding: '15px',
    backgroundColor: '#5F6E54',
    color: '#fff',
    border: 'none',
    fontSize: '12px',
    letterSpacing: '2px',
    cursor: 'pointer',
    borderRadius: '2px',
    fontWeight: 'bold',
    transition: 'all 0.3s ease'
  },
  archiveHeader: {
    textAlign: 'center',
    marginBottom: '30px'
  },
  archiveSeasonTitle: {
    fontSize: '24px',
    letterSpacing: '2px',
    marginBottom: '8px',
    color: '#333',
    fontFamily: 'serif'
  },
  archiveSeasonSubtitle: {
    fontSize: '11px',
    color: '#888',
    letterSpacing: '2px',
    textTransform: 'uppercase'
  },
  galleryItem: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '2px',
    transition: 'transform 0.3s ease'
  },
  galleryImageWrapper: {
    width: '100%',
    height: '400px',
    overflow: 'hidden',
    backgroundColor: '#f5f5f5',
    border: '1px solid rgba(20, 20, 18, 0.1)'
  },
  galleryImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.5s ease'
  }
};

const responsiveStyles = window.innerWidth <= 768 ? {
  mainLogoText: { fontSize: '36px', letterSpacing: '6px' },
  tagline: { fontSize: '22px', marginTop: '15px' },
  hero: { padding: '0 20px' },
  collectionsSection: { padding: '80px 5% 60px 5%' },
  imageRow: { flexDirection: 'column', alignItems: 'center', gap: '30px' },
  catalogCoverImage: { height: '450px' },
  storyHero: { padding: '60px 5% 30px 5%' },
  familyPhotoPlaceholder: { height: '300px' },
  storyContent: { padding: '30px 5% 80px 5%' },
  storyText: { fontSize: '16px' },
  serifHeading: { fontSize: '28px' },
  mapIframe: { height: '400px' },
  formRow: { flexDirection: 'column' },
  flexInput: { minWidth: '100%' },
  flexInputLight: { minWidth: '100%' },
  catalogPage: { padding: '120px 5% 60px 5%' },
  orderFormContainer: { padding: '40px 20px' },
  catalogCardHalf: { minWidth: '100%' },
  termsSection: { padding: '60px 5%' },
  teamSection: { padding: '0 5% 60px 5%' },
  ownersGrid: { gridTemplateColumns: '1fr', gap: '40px' },
  repsGrid: { gridTemplateColumns: '1fr' },
  formContainer: { padding: '40px 20px' },
  passwordContainer: { padding: '40px 20px' },
  storyPage: { paddingTop: '80px' },
  catalogGridSideBySide: { gap: '20px' },
  footerTop: { flexDirection: 'column' },
  footer: { padding: '40px 5%' }
} : {};

export default App;
